webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(26)('wks')
	  , uid        = __webpack_require__(29)
	  , Symbol     = __webpack_require__(2).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 2 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(11)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 6 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(8)
	  , createDesc = __webpack_require__(14);
	module.exports = __webpack_require__(5) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(3)
	  , IE8_DOM_DEFINE = __webpack_require__(46)
	  , toPrimitive    = __webpack_require__(63)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(2)
	  , core      = __webpack_require__(4)
	  , ctx       = __webpack_require__(20)
	  , hide      = __webpack_require__(7)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(26)('keys')
	  , uid    = __webpack_require__(29);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(9);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(37);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(41);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12)
	  , document = __webpack_require__(2).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(19);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(58)
	  , enumBugKeys = __webpack_require__(22);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(8).f
	  , has = __webpack_require__(6)
	  , TAG = __webpack_require__(1)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(2)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(23)
	  , defined = __webpack_require__(9);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(16)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Vue.js v2.1.8
	 * (c) 2014-2016 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	/*  */
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function _toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val, 10);
	  return (n || n === 0) ? n : val
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Remove an item from an array
	 */
	function remove$1 (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return typeof value === 'string' || typeof value === 'number'
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delmited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /([^-])([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str
	    .replace(hyphenateRE, '$1-$2')
	    .replace(hyphenateRE, '$1-$2')
	    .toLowerCase()
	});
	
	/**
	 * Simple bind, faster than native
	 */
	function bind$1 (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	  // record original fn length
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	function isPlainObject (obj) {
	  return toString.call(obj) === OBJECT_STRING
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 */
	function noop () {}
	
	/**
	 * Always return false.
	 */
	var no = function () { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
	    return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    return JSON.stringify(a) === JSON.stringify(b)
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/*  */
	
	var config = {
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: ("production") !== 'production',
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * List of asset types that a component can own.
	   */
	  _assetTypes: [
	    'component',
	    'directive',
	    'filter'
	  ],
	
	  /**
	   * List of lifecycle hooks.
	   */
	  _lifecycleHooks: [
	    'beforeCreate',
	    'created',
	    'beforeMount',
	    'mounted',
	    'beforeUpdate',
	    'updated',
	    'beforeDestroy',
	    'destroyed',
	    'activated',
	    'deactivated'
	  ],
	
	  /**
	   * Max circular updates allowed in a scheduler flush cycle.
	   */
	  _maxUpdateCount: 100
	};
	
	/*  */
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  } else {
	    var segments = path.split('.');
	    return function (obj) {
	      for (var i = 0; i < segments.length; i++) {
	        if (!obj) { return }
	        obj = obj[segments[i]];
	      }
	      return obj
	    }
	  }
	}
	
	/*  */
	/* globals MutationObserver */
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return /native code/.test(Ctor.toString())
	}
	
	/**
	 * Defer a task to execute it asynchronously.
	 */
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc;
	
	  function nextTickHandler () {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var logError = function (err) { console.error(err); };
	    timerFunc = function () {
	      p.then(nextTickHandler).catch(logError);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) { setTimeout(noop); }
	    };
	  } else if (typeof MutationObserver !== 'undefined' && (
	    isNative(MutationObserver) ||
	    // PhantomJS and iOS 7.x
	    MutationObserver.toString() === '[object MutationObserverConstructor]'
	  )) {
	    // use MutationObserver where native Promise is not available,
	    // e.g. PhantomJS IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = function () {
	      setTimeout(nextTickHandler, 0);
	    };
	  }
	
	  return function queueNextTick (cb, ctx) {
	    var _resolve;
	    callbacks.push(function () {
	      if (cb) { cb.call(ctx); }
	      if (_resolve) { _resolve(ctx); }
	    });
	    if (!pending) {
	      pending = true;
	      timerFunc();
	    }
	    if (!cb && typeof Promise !== 'undefined') {
	      return new Promise(function (resolve) {
	        _resolve = resolve;
	      })
	    }
	  }
	})();
	
	var _Set;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	var warn = noop;
	var formatComponentName;
	
	if (false) {
	  var hasConsole = typeof console !== 'undefined';
	
	  warn = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.error("[Vue warn]: " + msg + " " + (
	        vm ? formatLocation(formatComponentName(vm)) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm) {
	    if (vm.$root === vm) {
	      return 'root instance'
	    }
	    var name = vm._isVue
	      ? vm.$options.name || vm.$options._componentTag
	      : vm.name;
	    return (
	      (name ? ("component <" + name + ">") : "anonymous component") +
	      (vm._isVue && vm.$options.__file ? (" at " + (vm.$options.__file)) : '')
	    )
	  };
	
	  var formatLocation = function (str) {
	    if (str === 'anonymous component') {
	      str += " - use the \"name\" option for better debugging messages.";
	    }
	    return ("\n(found in " + str + ")")
	  };
	}
	
	/*  */
	
	
	var uid$1 = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid$1++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove$1(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stablize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);[
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	]
	.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var arguments$1 = arguments;
	
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments$1[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However when passing down props,
	 * we don't want to force conversion because the value may be a nested value
	 * under a frozen data structure. Converting it would defeat the optimization.
	 */
	var observerState = {
	  shouldConvert: true,
	  isSettingProps: false
	};
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive$$1(obj, keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value)) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    observerState.shouldConvert &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive$$1 (
	  obj,
	  key,
	  val,
	  customSetter
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (Array.isArray(value)) {
	          dependArray(value);
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if (false) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set$1 (obj, key, val) {
	  if (Array.isArray(obj)) {
	    obj.length = Math.max(obj.length, key);
	    obj.splice(key, 1, val);
	    return val
	  }
	  if (hasOwn(obj, key)) {
	    obj[key] = val;
	    return
	  }
	  var ob = obj.__ob__;
	  if (obj._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return
	  }
	  if (!ob) {
	    obj[key] = val;
	    return
	  }
	  defineReactive$$1(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (obj, key) {
	  var ob = obj.__ob__;
	  if (obj._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(obj, key)) {
	    return
	  }
	  delete obj[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	if (false) {
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set$1(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (typeof childVal !== 'function') {
	      ("production") !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        childVal.call(this),
	        parentVal.call(this)
	      )
	    }
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm)
	        : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	};
	
	/**
	 * Hooks and param attributes are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	config._lifecycleHooks.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal
	    ? extend(res, childVal)
	    : res
	}
	
	config._assetTypes.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (parentVal, childVal) {
	  /* istanbul ignore if */
	  if (!childVal) { return parentVal }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent
	      ? parent.concat(child)
	      : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.computed = function (parentVal, childVal) {
	  if (!childVal) { return parentVal }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret
	};
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    var lower = key.toLowerCase();
	    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
	      warn(
	        'Do not use built-in or reserved HTML elements as component ' +
	        'id: ' + key
	      );
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else if (false) {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  if (false) {
	    checkComponents(child);
	  }
	  normalizeProps(child);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = typeof extendsFrom === 'function'
	      ? mergeOptions(parent, extendsFrom.options, vm)
	      : mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      var mixin = child.mixins[i];
	      if (mixin.prototype instanceof Vue$2) {
	        mixin = mixin.options;
	      }
	      parent = mergeOptions(parent, mixin, vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if (false) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // handle boolean props
	  if (isType(Boolean, prop.type)) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
	      value = true;
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldConvert = observerState.shouldConvert;
	    observerState.shouldConvert = true;
	    observe(value);
	    observerState.shouldConvert = prevShouldConvert;
	  }
	  if (false) {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (isObject(def)) {
	    ("production") !== 'production' && warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm[key] !== undefined) {
	    return vm[key]
	  }
	  // call factory function for non-Function types
	  return typeof def === 'function' && prop.type !== Function
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      'Invalid prop: type check failed for prop "' + name + '".' +
	      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
	      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	/**
	 * Assert the type of a value
	 */
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (expectedType === 'String') {
	    valid = typeof value === (expectedType = 'string');
	  } else if (expectedType === 'Number') {
	    valid = typeof value === (expectedType = 'number');
	  } else if (expectedType === 'Boolean') {
	    valid = typeof value === (expectedType = 'boolean');
	  } else if (expectedType === 'Function') {
	    valid = typeof value === (expectedType = 'function');
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match && match[1]
	}
	
	function isType (type, fn) {
	  if (!Array.isArray(fn)) {
	    return getType(fn) === getType(type)
	  }
	  for (var i = 0, len = fn.length; i < len; i++) {
	    if (getType(fn[i]) === getType(type)) {
	      return true
	    }
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	
	
	var util = Object.freeze({
		defineReactive: defineReactive$$1,
		_toString: _toString,
		toNumber: toNumber,
		makeMap: makeMap,
		isBuiltInTag: isBuiltInTag,
		remove: remove$1,
		hasOwn: hasOwn,
		isPrimitive: isPrimitive,
		cached: cached,
		camelize: camelize,
		capitalize: capitalize,
		hyphenate: hyphenate,
		bind: bind$1,
		toArray: toArray,
		extend: extend,
		isObject: isObject,
		isPlainObject: isPlainObject,
		toObject: toObject,
		noop: noop,
		no: no,
		identity: identity,
		genStaticKeys: genStaticKeys,
		looseEqual: looseEqual,
		looseIndexOf: looseIndexOf,
		isReserved: isReserved,
		def: def,
		parsePath: parsePath,
		hasProto: hasProto,
		inBrowser: inBrowser,
		UA: UA,
		isIE: isIE,
		isIE9: isIE9,
		isEdge: isEdge,
		isAndroid: isAndroid,
		isIOS: isIOS,
		isServerRendering: isServerRendering,
		devtools: devtools,
		nextTick: nextTick,
		get _Set () { return _Set; },
		mergeOptions: mergeOptions,
		resolveAsset: resolveAsset,
		get warn () { return warn; },
		get formatComponentName () { return formatComponentName; },
		validateProp: validateProp
	});
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	if (false) {
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      "referenced during render. Make sure to declare reactive data " +
	      "properties in the data option.",
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' &&
	    Proxy.toString().match(/native code/);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	
	var queue = [];
	var has$1 = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  queue.length = 0;
	  has$1 = {};
	  if (false) {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    var watcher = queue[index];
	    var id = watcher.id;
	    has$1[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > config._maxUpdateCount) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	
	  resetSchedulerState();
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has$1[id] == null) {
	    has$1[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i >= 0 && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(Math.max(i, index) + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options
	) {
	  this.vm = vm;
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression =  false
	    ? expOrFn.toString()
	    : '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      ("production") !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value = this.getter.call(this.vm, this.vm);
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  popTarget();
	  this.cleanupDeps();
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          /* istanbul ignore else */
	          if (config.errorHandler) {
	            config.errorHandler.call(null, e, this.vm);
	          } else {
	            ("production") !== 'production' && warn(
	              ("Error in watcher \"" + (this.expression) + "\""),
	              this.vm
	            );
	            throw e
	          }
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove$1(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	var seenObjects = new _Set();
	function traverse (val) {
	  seenObjects.clear();
	  _traverse(val, seenObjects);
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	/*  */
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch) { initWatch(vm, opts.watch); }
	}
	
	var isReservedProp = { key: 1, ref: 1, slot: 1 };
	
	function initProps (vm, props) {
	  var propsData = vm.$options.propsData || {};
	  var keys = vm.$options._propKeys = Object.keys(props);
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  observerState.shouldConvert = isRoot;
	  var loop = function ( i ) {
	    var key = keys[i];
	    /* istanbul ignore else */
	    if (false) {
	      if (isReservedProp[key]) {
	        warn(
	          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive$$1(vm, key, validateProp(key, props, propsData, vm), function () {
	        if (vm.$parent && !observerState.isSettingProps) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    } else {
	      defineReactive$$1(vm, key, validateProp(key, props, propsData, vm));
	    }
	  };
	
	  for (var i = 0; i < keys.length; i++) loop( i );
	  observerState.shouldConvert = true;
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? data.call(vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    ("production") !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var i = keys.length;
	  while (i--) {
	    if (props && hasOwn(props, keys[i])) {
	      ("production") !== 'production' && warn(
	        "The data property \"" + (keys[i]) + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else {
	      proxy(vm, keys[i]);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	var computedSharedDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function initComputed (vm, computed) {
	  for (var key in computed) {
	    /* istanbul ignore if */
	    if (false) {
	      warn(
	        "existing instance property \"" + key + "\" will be " +
	        "overwritten by a computed property with the same name.",
	        vm
	      );
	    }
	    var userDef = computed[key];
	    if (typeof userDef === 'function') {
	      computedSharedDefinition.get = makeComputedGetter(userDef, vm);
	      computedSharedDefinition.set = noop;
	    } else {
	      computedSharedDefinition.get = userDef.get
	        ? userDef.cache !== false
	          ? makeComputedGetter(userDef.get, vm)
	          : bind$1(userDef.get, vm)
	        : noop;
	      computedSharedDefinition.set = userDef.set
	        ? bind$1(userDef.set, vm)
	        : noop;
	    }
	    Object.defineProperty(vm, key, computedSharedDefinition);
	  }
	}
	
	function makeComputedGetter (getter, owner) {
	  var watcher = new Watcher(owner, getter, noop, {
	    lazy: true
	  });
	  return function computedGetter () {
	    if (watcher.dirty) {
	      watcher.evaluate();
	    }
	    if (Dep.target) {
	      watcher.depend();
	    }
	    return watcher.value
	  }
	}
	
	function initMethods (vm, methods) {
	  for (var key in methods) {
	    vm[key] = methods[key] == null ? noop : bind$1(methods[key], vm);
	    if (false) {
	      warn(
	        "method \"" + key + "\" has an undefined value in the component definition. " +
	        "Did you reference the function correctly?",
	        vm
	      );
	    }
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (vm, key, handler) {
	  var options;
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  vm.$watch(key, handler, options);
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () {
	    return this._data
	  };
	  if (false) {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	
	  Vue.prototype.$set = set$1;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	function proxy (vm, key) {
	  if (!isReserved(key)) {
	    Object.defineProperty(vm, key, {
	      configurable: true,
	      enumerable: true,
	      get: function proxyGetter () {
	        return vm._data[key]
	      },
	      set: function proxySetter (val) {
	        vm._data[key] = val;
	      }
	    });
	  }
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.functionalContext = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.child = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	};
	
	var createEmptyVNode = function () {
	  var node = new VNode();
	  node.text = '';
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isCloned = true;
	  return cloned
	}
	
	function cloneVNodes (vnodes) {
	  var res = new Array(vnodes.length);
	  for (var i = 0; i < vnodes.length; i++) {
	    res[i] = cloneVNode(vnodes[i]);
	  }
	  return res
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook, key) {
	  key = key + hookKey;
	  var injectedHash = def.__injected || (def.__injected = {});
	  if (!injectedHash[key]) {
	    injectedHash[key] = true;
	    var oldHook = def[hookKey];
	    if (oldHook) {
	      def[hookKey] = function () {
	        oldHook.apply(this, arguments);
	        hook.apply(this, arguments);
	      };
	    } else {
	      def[hookKey] = hook;
	    }
	  }
	}
	
	/*  */
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, cur, old, fn, event, capture, once;
	  for (name in on) {
	    cur = on[name];
	    old = oldOn[name];
	    if (!cur) {
	      ("production") !== 'production' && warn(
	        "Invalid handler for event \"" + name + "\": got " + String(cur),
	        vm
	      );
	    } else if (!old) {
	      once = name.charAt(0) === '~'; // Prefixed last, checked first
	      event = once ? name.slice(1) : name;
	      capture = event.charAt(0) === '!';
	      event = capture ? event.slice(1) : event;
	      if (Array.isArray(cur)) {
	        add(event, (cur.invoker = arrInvoker(cur)), once, capture);
	      } else {
	        if (!cur.invoker) {
	          fn = cur;
	          cur = on[name] = {};
	          cur.fn = fn;
	          cur.invoker = fnInvoker(cur);
	        }
	        add(event, cur.invoker, once, capture);
	      }
	    } else if (cur !== old) {
	      if (Array.isArray(old)) {
	        old.length = cur.length;
	        for (var i = 0; i < old.length; i++) { old[i] = cur[i]; }
	        on[name] = old;
	      } else {
	        old.fn = cur;
	        on[name] = old;
	      }
	    }
	  }
	  for (name in oldOn) {
	    if (!on[name]) {
	      once = name.charAt(0) === '~'; // Prefixed last, checked first
	      event = once ? name.slice(1) : name;
	      capture = event.charAt(0) === '!';
	      event = capture ? event.slice(1) : event;
	      remove$$1(event, oldOn[name].invoker, capture);
	    }
	  }
	}
	
	function arrInvoker (arr) {
	  return function (ev) {
	    var arguments$1 = arguments;
	
	    var single = arguments.length === 1;
	    for (var i = 0; i < arr.length; i++) {
	      single ? arr[i](ev) : arr[i].apply(null, arguments$1);
	    }
	  }
	}
	
	function fnInvoker (o) {
	  return function (ev) {
	    var single = arguments.length === 1;
	    single ? o.fn(ev) : o.fn.apply(null, arguments);
	  }
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// nomralization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constrcuts that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (c == null || typeof c === 'boolean') { continue }
	    last = res[res.length - 1];
	    //  nested
	    if (Array.isArray(c)) {
	      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
	    } else if (isPrimitive(c)) {
	      if (last && last.text) {
	        last.text += String(c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (c.text && last && last.text) {
	        res[res.length - 1] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (c.tag && c.key == null && nestedIndex != null) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  return children && children.filter(function (c) { return c && c.componentOptions; })[0]
	}
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add$1 (event, fn, once) {
	  if (once) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$2 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add$1, remove$2, vm);
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var vm = this;(vm._events[event] || (vm._events[event] = [])).push(fn);
	    // optimize hook:event cost by using a boolean flag marked at registration
	    // instead of a hash lookup
	    if (hookRE.test(event)) {
	      vm._hasHookEvent = true;
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (arguments.length === 1) {
	      vm._events[event] = null;
	      return vm
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        cbs.splice(i, 1);
	        break
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        cbs[i].apply(vm, args);
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	var activeInstance = null;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._mount = function (
	    el,
	    hydrating
	  ) {
	    var vm = this;
	    vm.$el = el;
	    if (!vm.$options.render) {
	      vm.$options.render = createEmptyVNode;
	      if (false) {
	        /* istanbul ignore if */
	        if (vm.$options.template && vm.$options.template.charAt(0) !== '#') {
	          warn(
	            'You are using the runtime-only build of Vue where the template ' +
	            'option is not available. Either pre-compile the templates into ' +
	            'render functions, or use the compiler-included build.',
	            vm
	          );
	        } else {
	          warn(
	            'Failed to mount component: template or render function not defined.',
	            vm
	          );
	        }
	      }
	    }
	    callHook(vm, 'beforeMount');
	    vm._watcher = new Watcher(vm, function () {
	      vm._update(vm._render(), hydrating);
	    }, noop);
	    hydrating = false;
	    // manually mounted instance, call mounted on self
	    // mounted is called for render-created child components in its inserted hook
	    if (vm.$vnode == null) {
	      vm._isMounted = true;
	      callHook(vm, 'mounted');
	    }
	    return vm
	  };
	
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    if (vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  };
	
	  Vue.prototype._updateFromParent = function (
	    propsData,
	    listeners,
	    parentVnode,
	    renderChildren
	  ) {
	    var vm = this;
	    var hasChildren = !!(vm.$options._renderChildren || renderChildren);
	    vm.$options._parentVnode = parentVnode;
	    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	    if (vm._vnode) { // update child tree's parent
	      vm._vnode.parent = parentVnode;
	    }
	    vm.$options._renderChildren = renderChildren;
	    // update props
	    if (propsData && vm.$options.props) {
	      observerState.shouldConvert = false;
	      if (false) {
	        observerState.isSettingProps = true;
	      }
	      var propKeys = vm.$options._propKeys || [];
	      for (var i = 0; i < propKeys.length; i++) {
	        var key = propKeys[i];
	        vm[key] = validateProp(key, vm.$options.props, propsData, vm);
	      }
	      observerState.shouldConvert = true;
	      if (false) {
	        observerState.isSettingProps = false;
	      }
	      vm.$options.propsData = propsData;
	    }
	    // update listeners
	    if (listeners) {
	      var oldListeners = vm.$options._parentListeners;
	      vm.$options._parentListeners = listeners;
	      updateComponentListeners(vm, listeners, oldListeners);
	    }
	    // resolve slots + force update if has children
	    if (hasChildren) {
	      vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	      vm.$forceUpdate();
	    }
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove$1(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	  };
	}
	
	function callHook (vm, hook) {
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      handlers[i].call(vm);
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	}
	
	/*  */
	
	var hooks = { init: init, prepatch: prepatch, insert: insert, destroy: destroy$1 };
	var hooksToMerge = Object.keys(hooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (!Ctor) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  if (typeof Ctor !== 'function') {
	    if (false) {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  if (!Ctor.cid) {
	    if (Ctor.resolved) {
	      Ctor = Ctor.resolved;
	    } else {
	      Ctor = resolveAsyncComponent(Ctor, baseCtor, function () {
	        // it's ok to queue this on every render because
	        // $forceUpdate is buffered by the scheduler.
	        context.$forceUpdate();
	      });
	      if (!Ctor) {
	        // return nothing if this is indeed an async component
	        // wait for the callback to trigger parent update.
	        return
	      }
	    }
	  }
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  data = data || {};
	
	  // extract props
	  var propsData = extractProps(data, Ctor);
	
	  // functional component
	  if (Ctor.options.functional) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  data.on = data.nativeOn;
	
	  if (Ctor.options.abstract) {
	    // abstract components do not keep anything
	    // other than props & listeners
	    data = {};
	  }
	
	  // merge component management hooks onto the placeholder node
	  mergeHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }
	  );
	  return vnode
	}
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  context,
	  children
	) {
	  var props = {};
	  var propOptions = Ctor.options.props;
	  if (propOptions) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData);
	    }
	  }
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var _context = Object.create(context);
	  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
	  var vnode = Ctor.options.render.call(null, h, {
	    props: props,
	    data: data,
	    parent: context,
	    children: children,
	    slots: function () { return resolveSlots(children, context); }
	  });
	  if (vnode instanceof VNode) {
	    vnode.functionalContext = context;
	    if (data.slot) {
	      (vnode.data || (vnode.data = {})).slot = data.slot;
	    }
	  }
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var vnodeComponentOptions = vnode.componentOptions;
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    propsData: vnodeComponentOptions.propsData,
	    _componentTag: vnodeComponentOptions.tag,
	    _parentVnode: vnode,
	    _parentListeners: vnodeComponentOptions.listeners,
	    _renderChildren: vnodeComponentOptions.children,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (inlineTemplate) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnodeComponentOptions.Ctor(options)
	}
	
	function init (
	  vnode,
	  hydrating,
	  parentElm,
	  refElm
	) {
	  if (!vnode.child || vnode.child._isDestroyed) {
	    var child = vnode.child = createComponentInstanceForVnode(
	      vnode,
	      activeInstance,
	      parentElm,
	      refElm
	    );
	    child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	  } else if (vnode.data.keepAlive) {
	    // kept-alive components, treat as a patch
	    var mountedNode = vnode; // work around flow
	    prepatch(mountedNode, mountedNode);
	  }
	}
	
	function prepatch (
	  oldVnode,
	  vnode
	) {
	  var options = vnode.componentOptions;
	  var child = vnode.child = oldVnode.child;
	  child._updateFromParent(
	    options.propsData, // updated props
	    options.listeners, // updated listeners
	    vnode, // new parent vnode
	    options.children // new children
	  );
	}
	
	function insert (vnode) {
	  if (!vnode.child._isMounted) {
	    vnode.child._isMounted = true;
	    callHook(vnode.child, 'mounted');
	  }
	  if (vnode.data.keepAlive) {
	    vnode.child._inactive = false;
	    callHook(vnode.child, 'activated');
	  }
	}
	
	function destroy$1 (vnode) {
	  if (!vnode.child._isDestroyed) {
	    if (!vnode.data.keepAlive) {
	      vnode.child.$destroy();
	    } else {
	      vnode.child._inactive = true;
	      callHook(vnode.child, 'deactivated');
	    }
	  }
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  cb
	) {
	  if (factory.requested) {
	    // pool callbacks
	    factory.pendingCallbacks.push(cb);
	  } else {
	    factory.requested = true;
	    var cbs = factory.pendingCallbacks = [cb];
	    var sync = true;
	
	    var resolve = function (res) {
	      if (isObject(res)) {
	        res = baseCtor.extend(res);
	      }
	      // cache resolved
	      factory.resolved = res;
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        for (var i = 0, l = cbs.length; i < l; i++) {
	          cbs[i](res);
	        }
	      }
	    };
	
	    var reject = function (reason) {
	      ("production") !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	    };
	
	    var res = factory(resolve, reject);
	
	    // handle promise
	    if (res && typeof res.then === 'function' && !factory.resolved) {
	      res.then(resolve, reject);
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.resolved
	  }
	}
	
	function extractProps (data, Ctor) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (!propOptions) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  var domProps = data.domProps;
	  if (attrs || props || domProps) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey) ||
	      checkProp(res, domProps, key, altKey);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (hash) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	function mergeHooks (data) {
	  if (!data.hook) {
	    data.hook = {};
	  }
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    var fromParent = data.hook[key];
	    var ours = hooks[key];
	    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
	  }
	}
	
	function mergeHook$1 (one, two) {
	  return function (a, b, c, d) {
	    one(a, b, c, d);
	    two(a, b, c, d);
	  }
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (alwaysNormalize) { normalizationType = ALWAYS_NORMALIZE; }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (data && data.__ob__) {
	    ("production") !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	      typeof children[0] === 'function') {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if ((Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (vnode) {
	    if (ns) { applyNS(vnode, ns); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    return
	  }
	  if (vnode.children) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (child.tag && !child.ns) {
	        applyNS(child, ns);
	      }
	    }
	  }
	}
	
	/*  */
	
	function initRender (vm) {
	  vm.$vnode = null; // the placeholder node in parent tree
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null;
	  var parentVnode = vm.$options._parentVnode;
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
	  vm.$scopedSlots = {};
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	  if (vm.$options.el) {
	    vm.$mount(vm.$options.el);
	  }
	}
	
	function renderMixin (Vue) {
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var staticRenderFns = ref.staticRenderFns;
	    var _parentVnode = ref._parentVnode;
	
	    if (vm._isMounted) {
	      // clone slot nodes on re-renders
	      for (var key in vm.$slots) {
	        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
	      }
	    }
	
	    if (_parentVnode && _parentVnode.data.scopedSlots) {
	      vm.$scopedSlots = _parentVnode.data.scopedSlots;
	    }
	
	    if (staticRenderFns && !vm._staticTrees) {
	      vm._staticTrees = [];
	    }
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      /* istanbul ignore else */
	      if (config.errorHandler) {
	        config.errorHandler.call(null, e, vm);
	      } else {
	        if (false) {
	          warn(("Error when rendering " + (formatComponentName(vm)) + ":"));
	        }
	        throw e
	      }
	      // return previous vnode to prevent render error causing blank component
	      vnode = vm._vnode;
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if (false) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	
	  // toString for mustaches
	  Vue.prototype._s = _toString;
	  // convert text to vnode
	  Vue.prototype._v = createTextVNode;
	  // number conversion
	  Vue.prototype._n = toNumber;
	  // empty vnode
	  Vue.prototype._e = createEmptyVNode;
	  // loose equal
	  Vue.prototype._q = looseEqual;
	  // loose indexOf
	  Vue.prototype._i = looseIndexOf;
	
	  // render static tree by index
	  Vue.prototype._m = function renderStatic (
	    index,
	    isInFor
	  ) {
	    var tree = this._staticTrees[index];
	    // if has already-rendered static tree and not inside v-for,
	    // we can reuse the same tree by doing a shallow clone.
	    if (tree && !isInFor) {
	      return Array.isArray(tree)
	        ? cloneVNodes(tree)
	        : cloneVNode(tree)
	    }
	    // otherwise, render a fresh tree.
	    tree = this._staticTrees[index] = this.$options.staticRenderFns[index].call(this._renderProxy);
	    markStatic(tree, ("__static__" + index), false);
	    return tree
	  };
	
	  // mark node as static (v-once)
	  Vue.prototype._o = function markOnce (
	    tree,
	    index,
	    key
	  ) {
	    markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	    return tree
	  };
	
	  function markStatic (tree, key, isOnce) {
	    if (Array.isArray(tree)) {
	      for (var i = 0; i < tree.length; i++) {
	        if (tree[i] && typeof tree[i] !== 'string') {
	          markStaticNode(tree[i], (key + "_" + i), isOnce);
	        }
	      }
	    } else {
	      markStaticNode(tree, key, isOnce);
	    }
	  }
	
	  function markStaticNode (node, key, isOnce) {
	    node.isStatic = true;
	    node.key = key;
	    node.isOnce = isOnce;
	  }
	
	  // filter resolution helper
	  Vue.prototype._f = function resolveFilter (id) {
	    return resolveAsset(this.$options, 'filters', id, true) || identity
	  };
	
	  // render v-for
	  Vue.prototype._l = function renderList (
	    val,
	    render
	  ) {
	    var ret, i, l, keys, key;
	    if (Array.isArray(val) || typeof val === 'string') {
	      ret = new Array(val.length);
	      for (i = 0, l = val.length; i < l; i++) {
	        ret[i] = render(val[i], i);
	      }
	    } else if (typeof val === 'number') {
	      ret = new Array(val);
	      for (i = 0; i < val; i++) {
	        ret[i] = render(i + 1, i);
	      }
	    } else if (isObject(val)) {
	      keys = Object.keys(val);
	      ret = new Array(keys.length);
	      for (i = 0, l = keys.length; i < l; i++) {
	        key = keys[i];
	        ret[i] = render(val[key], key, i);
	      }
	    }
	    return ret
	  };
	
	  // renderSlot
	  Vue.prototype._t = function (
	    name,
	    fallback,
	    props,
	    bindObject
	  ) {
	    var scopedSlotFn = this.$scopedSlots[name];
	    if (scopedSlotFn) { // scoped slot
	      props = props || {};
	      if (bindObject) {
	        extend(props, bindObject);
	      }
	      return scopedSlotFn(props) || fallback
	    } else {
	      var slotNodes = this.$slots[name];
	      // warn duplicate slot usage
	      if (slotNodes && ("production") !== 'production') {
	        slotNodes._rendered && warn(
	          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	          "- this will likely cause render errors.",
	          this
	        );
	        slotNodes._rendered = true;
	      }
	      return slotNodes || fallback
	    }
	  };
	
	  // apply v-bind object
	  Vue.prototype._b = function bindProps (
	    data,
	    tag,
	    value,
	    asProp
	  ) {
	    if (value) {
	      if (!isObject(value)) {
	        ("production") !== 'production' && warn(
	          'v-bind without argument expects an Object or Array value',
	          this
	        );
	      } else {
	        if (Array.isArray(value)) {
	          value = toObject(value);
	        }
	        for (var key in value) {
	          if (key === 'class' || key === 'style') {
	            data[key] = value[key];
	          } else {
	            var hash = asProp || config.mustUseProp(tag, key)
	              ? data.domProps || (data.domProps = {})
	              : data.attrs || (data.attrs = {});
	            hash[key] = value[key];
	          }
	        }
	      }
	    }
	    return data
	  };
	
	  // check v-on keyCodes
	  Vue.prototype._k = function checkKeyCodes (
	    eventKeyCode,
	    key,
	    builtInAlias
	  ) {
	    var keyCodes = config.keyCodes[key] || builtInAlias;
	    if (Array.isArray(keyCodes)) {
	      return keyCodes.indexOf(eventKeyCode) === -1
	    } else {
	      return keyCodes !== eventKeyCode
	    }
	  };
	}
	
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  var defaultSlot = [];
	  var name, child;
	  for (var i = 0, l = children.length; i < l; i++) {
	    child = children[i];
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.functionalContext === context) &&
	        child.data && (name = child.data.slot)) {
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      defaultSlot.push(child);
	    }
	  }
	  // ignore single whitespace
	  if (defaultSlot.length && !(
	    defaultSlot.length === 1 &&
	    (defaultSlot[0].text === ' ' || defaultSlot[0].isComment)
	  )) {
	    slots.default = defaultSlot;
	  }
	  return slots
	}
	
	/*  */
	
	var uid = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid++;
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    if (false) {
	      initProxy(vm);
	    } else {
	      vm._renderProxy = vm;
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    callHook(vm, 'beforeCreate');
	    initState(vm);
	    callHook(vm, 'created');
	    initRender(vm);
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  opts.parent = options.parent;
	  opts.propsData = options.propsData;
	  opts._parentVnode = options._parentVnode;
	  opts._parentListeners = options._parentListeners;
	  opts._renderChildren = options._renderChildren;
	  opts._componentTag = options._componentTag;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = Ctor.super.options;
	    var cachedSuperOptions = Ctor.superOptions;
	    var extendOptions = Ctor.extendOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed
	      Ctor.superOptions = superOptions;
	      extendOptions.render = options.render;
	      extendOptions.staticRenderFns = options.staticRenderFns;
	      extendOptions._scopeId = options._scopeId;
	      options = Ctor.options = mergeOptions(superOptions, extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function Vue$2 (options) {
	  if (false) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue$2);
	stateMixin(Vue$2);
	eventsMixin(Vue$2);
	lifecycleMixin(Vue$2);
	renderMixin(Vue$2);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn(
	          'Invalid component name: "' + name + '". Component names ' +
	          'can only contain alphanumeric characters and the hyphen, ' +
	          'and must start with a letter.'
	        );
	      }
	    }
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    config._assetTypes.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  config._assetTypes.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          if (type === 'component' && config.isReservedTag(id)) {
	            warn(
	              'Do not use built-in or reserved HTML elements as component ' +
	              'id: ' + id
	            );
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	var patternTypes = [String, RegExp];
	
	function matches (pattern, name) {
	  if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else {
	    return pattern.test(name)
	  }
	}
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	  props: {
	    include: patternTypes,
	    exclude: patternTypes
	  },
	  created: function created () {
	    this.cache = Object.create(null);
	  },
	  render: function render () {
	    var vnode = getFirstComponentChild(this.$slots.default);
	    if (vnode && vnode.componentOptions) {
	      var opts = vnode.componentOptions;
	      // check pattern
	      var name = opts.Ctor.options.name || opts.tag;
	      if (name && (
	        (this.include && !matches(this.include, name)) ||
	        (this.exclude && matches(this.exclude, name))
	      )) {
	        return vnode
	      }
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? opts.Ctor.cid + (opts.tag ? ("::" + (opts.tag)) : '')
	        : vnode.key;
	      if (this.cache[key]) {
	        vnode.child = this.cache[key].child;
	      } else {
	        this.cache[key] = vnode;
	      }
	      vnode.data.keepAlive = true;
	    }
	    return vnode
	  },
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this.cache) {
	      var vnode = this$1.cache[key];
	      callHook(vnode.child, 'deactivated');
	      vnode.child.$destroy();
	    }
	  }
	};
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	};
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  if (false) {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	  Vue.util = util;
	  Vue.set = set$1;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  config._assetTypes.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue$2);
	
	Object.defineProperty(Vue$2.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Vue$2.version = '2.1.8';
	
	/*  */
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select');
	var mustUseProp = function (tag, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (childNode.child) {
	    childNode = childNode.child._vnode;
	    if (childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return genClassFromData(data)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: child.class
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function genClassFromData (data) {
	  var dynamicClass = data.class;
	  var staticClass = data.staticClass;
	  if (staticClass || dynamicClass) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  var res = '';
	  if (!value) {
	    return res
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  if (Array.isArray(value)) {
	    var stringified;
	    for (var i = 0, l = value.length; i < l; i++) {
	      if (value[i]) {
	        if ((stringified = stringifyClass(value[i]))) {
	          res += stringified + ' ';
	        }
	      }
	    }
	    return res.slice(0, -1)
	  }
	  if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) { res += key + ' '; }
	    }
	    return res.slice(0, -1)
	  }
	  /* istanbul ignore next */
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,' +
	  'font-face,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selector = el;
	    el = document.querySelector(el);
	    if (!el) {
	      ("production") !== 'production' && warn(
	        'Cannot find element: ' + selector
	      );
	      return document.createElement('div')
	    }
	  }
	  return el
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  if (vnode.data && vnode.data.attrs && 'multiple' in vnode.data.attrs) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setAttribute (node, key, val) {
	  node.setAttribute(key, val);
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setAttribute: setAttribute
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	};
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!key) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.child || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove$1(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (Array.isArray(refs[key]) && refs[key].indexOf(ref) < 0) {
	        refs[key].push(ref);
	      } else {
	        refs[key] = [ref];
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	
	/*
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks$1 = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function isUndef (s) {
	  return s == null
	}
	
	function isDef (s) {
	  return s != null
	}
	
	function sameVnode (vnode1, vnode2) {
	  return (
	    vnode1.key === vnode2.key &&
	    vnode1.tag === vnode2.tag &&
	    vnode1.isComment === vnode2.isComment &&
	    !vnode1.data === !vnode2.data
	  )
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks$1.length; ++i) {
	    cbs[hooks$1[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (modules[j][hooks$1[i]] !== undefined) { cbs[hooks$1[i]].push(modules[j][hooks$1[i]]); }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove$$1 () {
	      if (--remove$$1.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove$$1.listeners = listeners;
	    return remove$$1
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (parent) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  var inPre = 0;
	  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      if (false) {
	        if (data && data.pre) {
	          inPre++;
	        }
	        if (
	          !inPre &&
	          !vnode.ns &&
	          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
	          config.isUnknownElement(tag)
	        ) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if (false) {
	        inPre--;
	      }
	    } else if (vnode.isComment) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.child) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.child)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isReactivated) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.child) {
	      innerNode = innerNode.child._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref) {
	    if (parent) {
	      if (ref) {
	        nodeOps.insertBefore(parent, elm, ref);
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.child) {
	      vnode = vnode.child._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (i.create) { i.create(emptyNode, vnode); }
	      if (i.insert) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (vnode.data.pendingInsert) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	    }
	    vnode.elm = vnode.child.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.context) && isDef(i = i.$options._scopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	    if (isDef(i = activeInstance) &&
	        i !== vnode.context &&
	        isDef(i = i.$options._scopeId)) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (rm || isDef(vnode.data)) {
	      var listeners = cbs.remove.length + 1;
	      if (!rm) {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      } else {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.child) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, elmToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	          newStartVnode = newCh[++newStartIdx];
	        } else {
	          elmToMove = oldCh[idxInOld];
	          /* istanbul ignore if */
	          if (false) {
	            warn(
	              'It seems there are duplicate keys that is causing an update error. ' +
	              'Make sure each v-for item has a unique key.'
	            );
	          }
	          if (sameVnode(elmToMove, newStartVnode)) {
	            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, newStartVnode.elm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          }
	        }
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (vnode.isStatic &&
	        oldVnode.isStatic &&
	        vnode.key === oldVnode.key &&
	        (vnode.isCloned || vnode.isOnce)) {
	      vnode.elm = oldVnode.elm;
	      vnode.child = oldVnode.child;
	      return
	    }
	    var i;
	    var data = vnode.data;
	    var hasData = isDef(data);
	    if (hasData && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	    var elm = vnode.elm = oldVnode.elm;
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (hasData && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (hasData) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (initial && vnode.parent) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var bailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue) {
	    if (false) {
	      if (!assertNodeMatch(elm, vnode)) {
	        return false
	      }
	    }
	    vnode.elm = elm;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.child)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          var childrenMatch = true;
	          var childNode = elm.firstChild;
	          for (var i$1 = 0; i$1 < children.length; i$1++) {
	            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
	              childrenMatch = false;
	              break
	            }
	            childNode = childNode.nextSibling;
	          }
	          // if childNode is not null, it means the actual childNodes list is
	          // longer than the virtual children list.
	          if (!childrenMatch || childNode) {
	            if (false) {
	              bailed = true;
	              console.warn('Parent: ', elm);
	              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	            }
	            return false
	          }
	        }
	      }
	      if (isDef(data)) {
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode) {
	    if (vnode.tag) {
	      return (
	        vnode.tag.indexOf('vue-component') === 0 ||
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (!vnode) {
	      if (oldVnode) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var elm, parent;
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (!oldVnode) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute('server-rendered')) {
	            oldVnode.removeAttribute('server-rendered');
	            hydrating = true;
	          }
	          if (hydrating) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else if (false) {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	        // replacing existing element
	        elm = oldVnode.elm;
	        parent = nodeOps.parentNode(elm);
	        createElm(vnode, insertedVnodeQueue, parent, nodeOps.nextSibling(elm));
	
	        if (vnode.parent) {
	          // component root element replaced.
	          // update parent placeholder node element, recursively
	          var ancestor = vnode.parent;
	          while (ancestor) {
	            ancestor.elm = vnode.elm;
	            ancestor = ancestor.parent;
	          }
	          if (isPatchable(vnode)) {
	            for (var i = 0; i < cbs.create.length; ++i) {
	              cbs.create[i](emptyNode, vnode.parent);
	            }
	          }
	        }
	
	        if (parent !== null) {
	          removeVnodes(parent, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	};
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert, 'dir-insert');
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    }, 'dir-postpatch');
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	];
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  if (!oldVnode.data.attrs && !vnode.data.attrs) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (attrs.__ob__) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  /* istanbul ignore if */
	  if (isIE9 && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (attrs[key] == null) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, key);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, value);
	    }
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (!data.staticClass && !data.class &&
	      (!oldData || (!oldData.staticClass && !oldData.class))) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (transitionClass) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	};
	
	/*  */
	
	var target$1;
	
	function add$2 (event, handler, once, capture) {
	  if (once) {
	    var oldHandler = handler;
	    handler = function (ev) {
	      remove$3(event, handler, capture);
	      arguments.length === 1
	        ? oldHandler(ev)
	        : oldHandler.apply(null, arguments);
	    };
	  }
	  target$1.addEventListener(event, handler, capture);
	}
	
	function remove$3 (event, handler, capture) {
	  target$1.removeEventListener(event, handler, capture);
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (!oldVnode.data.on && !vnode.data.on) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  updateListeners(on, oldOn, add$2, remove$3, vnode.context);
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (!oldVnode.data.domProps && !vnode.data.domProps) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (props.__ob__) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (props[key] == null) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	    }
	    // #4521: if a click event triggers update before the change event is
	    // dispatched on a checkbox/radio input, the input's checked state will
	    // be reset and fail to trigger another update.
	    /* istanbul ignore next */
	    if (key === 'checked' && !isDirty(elm, cur)) {
	      continue
	    }
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = cur == null ? '' : String(cur);
	      if (shouldUpdateValue(elm, vnode, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (
	  elm,
	  vnode,
	  checkVal
	) {
	  if (!elm.composing && (
	    vnode.tag === 'option' ||
	    isDirty(elm, checkVal) ||
	    isInputChanged(vnode, checkVal)
	  )) {
	    return true
	  }
	  return false
	}
	
	function isDirty (elm, checkVal) {
	  return document.activeElement !== elm && elm.value !== checkVal
	}
	
	function isInputChanged (vnode, newVal) {
	  var value = vnode.elm.value;
	  var modifiers = vnode.elm._vModifiers; // injected by v-model runtime
	  if ((modifiers && modifiers.number) || vnode.elm.type === 'number') {
	    return toNumber(value) !== toNumber(newVal)
	  }
	  if (modifiers && modifiers.trim) {
	    return value.trim() !== newVal.trim()
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.child) {
	      childNode = childNode.child._vnode;
	      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    el.style[normalize(name)] = val;
	  }
	};
	
	var prefixes = ['Webkit', 'Moz', 'ms'];
	
	var testEl;
	var normalize = cached(function (prop) {
	  testEl = testEl || document.createElement('div');
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in testEl.style)) {
	    return prop
	  }
	  var upper = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefixed = prefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return prefixed
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (!data.staticStyle && !data.style &&
	      !oldData.staticStyle && !oldData.style) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldVnode.data.staticStyle;
	  var oldStyleBinding = oldVnode.data.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  vnode.data.style = style.__ob__ ? extend({}, style) : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (newStyle[name] == null) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	};
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !cls.trim()) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = ' ' + el.getAttribute('class') + ' ';
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !cls.trim()) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	  } else {
	    var cur = ' ' + el.getAttribute('class') + ' ';
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    el.setAttribute('class', cur.trim());
	  }
	}
	
	/*  */
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	var raf = (inBrowser && window.requestAnimationFrame) || setTimeout;
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  (el._transitionClasses || (el._transitionClasses = [])).push(cls);
	  addClass(el, cls);
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove$1(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitioneDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitioneDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (el._leaveCb) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (!data) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (el._enterCb || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear ? appearClass : enterClass;
	  var activeClass = isAppear ? appearActiveClass : enterActiveClass;
	  var toClass = isAppear ? appearToClass : enterToClass;
	  var beforeEnterHook = isAppear ? (beforeAppear || beforeEnter) : beforeEnter;
	  var enterHook = isAppear ? (typeof appear === 'function' ? appear : enter) : enter;
	  var afterEnterHook = isAppear ? (afterAppear || afterEnter) : afterEnter;
	  var enterCancelledHook = isAppear ? (appearCancelled || enterCancelled) : enterCancelled;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl =
	    enterHook &&
	    // enterHook may be a bound method which exposes
	    // the length of original fn as _length
	    (enterHook._length || enterHook.length) > 1;
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	          pendingNode.context === vnode.context &&
	          pendingNode.tag === vnode.tag &&
	          pendingNode.elm._leaveCb) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    }, 'transition-insert');
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      addTransitionClass(el, toClass);
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled && !userWantsControl) {
	        whenTransitionEnds(el, type, cb);
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (el._enterCb) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (!data) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (el._leaveCb || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl =
	    leave &&
	    // leave hook may be a bound method which exposes
	    // the length of original fn as _length
	    (leave._length || leave.length) > 1;
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        addTransitionClass(el, leaveToClass);
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled && !userWantsControl) {
	          whenTransitionEnds(el, type, cb);
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	function resolveTransition (def$$1) {
	  if (!def$$1) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def$$1 === 'object') {
	    var res = {};
	    if (def$$1.css !== false) {
	      extend(res, autoCssTransition(def$$1.name || 'v'));
	    }
	    extend(res, def$$1);
	    return res
	  } else if (typeof def$$1 === 'string') {
	    return autoCssTransition(def$$1)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    leaveClass: (name + "-leave"),
	    appearClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    leaveToClass: (name + "-leave-to"),
	    appearToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveActiveClass: (name + "-leave-active"),
	    appearActiveClass: (name + "-enter-active")
	  }
	});
	
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn();
	    }
	  }
	}
	
	function _enter (_, vnode) {
	  if (!vnode.data.show) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove (vnode, rm) {
	    /* istanbul ignore else */
	    if (!vnode.data.show) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {};
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch$1 = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	var modelableTagRE = /^input|select|textarea|vue-component-[0-9]+(-[0-9a-zA-Z_-]*)?$/;
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var model = {
	  inserted: function inserted (el, binding, vnode) {
	    if (false) {
	      if (!modelableTagRE.test(vnode.tag)) {
	        warn(
	          "v-model is not supported on element type: <" + (vnode.tag) + ">. " +
	          'If you are working with contenteditable, it\'s recommended to ' +
	          'wrap a library dedicated for that purpose inside a custom component.',
	          vnode.context
	        );
	      }
	    }
	    if (vnode.tag === 'select') {
	      var cb = function () {
	        setSelected(el, binding, vnode.context);
	      };
	      cb();
	      /* istanbul ignore if */
	      if (isIE || isEdge) {
	        setTimeout(cb, 0);
	      }
	    } else if (vnode.tag === 'textarea' || el.type === 'text') {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        if (!isAndroid) {
	          el.addEventListener('compositionstart', onCompositionStart);
	          el.addEventListener('compositionend', onCompositionEnd);
	        }
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var needReset = el.multiple
	        ? binding.value.some(function (v) { return hasNoMatchingOption(v, el.options); })
	        : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, el.options);
	      if (needReset) {
	        trigger(el, 'change');
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    ("production") !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  for (var i = 0, l = options.length; i < l; i++) {
	    if (looseEqual(getValue(options[i]), value)) {
	      return false
	    }
	  }
	  return true
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.child && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.child._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition && !isIE9) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (value === oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    if (transition && !isIE9) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	};
	
	var platformDirectives = {
	  model: model,
	  show: show
	};
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1].fn;
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  return /\d-keep-alive$/.test(rawChild.tag)
	    ? h('keep-alive')
	    : null
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag; });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if (false) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if (false) {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    var key = child.key = child.key == null || child.isStatic
	      ? ("__v" + (child.tag + this._uid) + "__")
	      : child.key;
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (oldChild && oldChild.data && !isSameChild(child, oldChild)) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        }, key);
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave, key);
	        mergeVNodeHook(data, 'enterCancelled', performLeave, key);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) {
	          delayedLeave = leave;
	        }, key);
	      }
	    }
	
	    return rawChild
	  }
	};
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final disired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else if (false) {
	          var opts = c.componentOptions;
	          var name = opts
	            ? (opts.Ctor.options.name || opts.tag)
	            : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important, avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    var f = document.body.offsetHeight; // eslint-disable-line
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      if (this._hasMove != null) {
	        return this._hasMove
	      }
	      addTransitionClass(el, moveClass);
	      var info = getTransitionInfo(el);
	      removeTransitionClass(el, moveClass);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	};
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};
	
	/*  */
	
	// install platform specific utils
	Vue$2.config.isUnknownElement = isUnknownElement;
	Vue$2.config.isReservedTag = isReservedTag;
	Vue$2.config.getTagNamespace = getTagNamespace;
	Vue$2.config.mustUseProp = mustUseProp;
	
	// install platform runtime directives & components
	extend(Vue$2.options.directives, platformDirectives);
	extend(Vue$2.options.components, platformComponents);
	
	// install platform patch function
	Vue$2.prototype.__patch__ = inBrowser ? patch$1 : noop;
	
	// wrap mount
	Vue$2.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return this._mount(el, hydrating)
	};
	
	if (false) {
	  console[console.info ? 'info' : 'log'](
	    "You are running Vue in development mode.\n" +
	    "Make sure to turn on production mode when deploying for production.\n" +
	    "See more tips at https://vuejs.org/guide/deployment.html"
	  );
	}
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue$2);
	    } else if (
	      false
	    ) {
	      console[console.info ? 'info' : 'log'](
	        'Download the Vue Devtools extension for a better development experience:\n' +
	        'https://github.com/vuejs/vue-devtools'
	      );
	    }
	  }
	}, 0);
	
	module.exports = Vue$2;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * vuex v2.1.1
	 * (c) 2016 Evan You
	 * @license MIT
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Vuex = factory());
	}(this, (function () { 'use strict';
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook
	
	  devtoolHook.emit('vuex:init', store)
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState)
	  })
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state)
	  })
	}
	
	function applyMixin (Vue) {
	  var version = Number(Vue.version.split('.')[0])
	
	  if (version >= 2) {
	    var usesInit = Vue.config._lifecycleHooks.indexOf('init') > -1
	    Vue.mixin(usesInit ? { init: vuexInit } : { beforeCreate: vuexInit })
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit
	      _init.call(this, options)
	    }
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options
	    // store injection
	    if (options.store) {
	      this.$store = options.store
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store
	    }
	  }
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {}
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state
	      var getters = this.$store.getters
	      if (namespace) {
	        var module = this.$store._modulesNamespaceMap[namespace]
	        if (!module) {
	          warnNamespace('mapState', namespace)
	          return
	        }
	        state = module.state
	        getters = module.context.getters
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    }
	  })
	  return res
	})
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {}
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      return this.$store.commit.apply(this.$store, [val].concat(args))
	    }
	  })
	  return res
	})
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {}
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val
	    res[key] = function mappedGetter () {
	      if (!(val in this.$store.getters)) {
	        console.error(("[vuex] unknown getter: " + val))
	      }
	      return this.$store.getters[val]
	    }
	  })
	  return res
	})
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {}
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      return this.$store.dispatch.apply(this.$store, [val].concat(args))
	    }
	  })
	  return res
	})
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace
	      namespace = ''
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/'
	    }
	    return fn(namespace, map)
	  }
	}
	
	function warnNamespace (helper, namespace) {
	  console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace))
	}
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); })
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime
	  this._children = Object.create(null)
	  this._rawModule = rawModule
	};
	
	var prototypeAccessors$1 = { state: {},namespaced: {} };
	
	prototypeAccessors$1.state.get = function () {
	  return this._rawModule.state || {}
	};
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key]
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn)
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn)
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn)
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn)
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  var this$1 = this;
	
	  // register root module (Vuex.Store options)
	  this.root = new Module(rawRootModule, false)
	
	  // register all nested modules
	  if (rawRootModule.modules) {
	    forEachValue(rawRootModule.modules, function (rawModule, key) {
	      this$1.register([key], rawModule, false)
	    })
	  }
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key)
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update(this.root, rawRootModule)
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  var parent = this.get(path.slice(0, -1))
	  var newModule = new Module(rawModule, runtime)
	  parent.addChild(path[path.length - 1], newModule)
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime)
	    })
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1))
	  var key = path[path.length - 1]
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key)
	};
	
	function update (targetModule, newModule) {
	  // update target module
	  targetModule.update(newModule)
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        console.warn(
	          "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	          'manual reload is needed'
	        )
	        return
	      }
	      update(targetModule.getChild(key), newModule.modules[key])
	    }
	  }
	}
	
	var Vue // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  assert(Vue, "must call Vue.use(Vuex) before creating a store instance.")
	  assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.")
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  // store internal state
	  this._committing = false
	  this._actions = Object.create(null)
	  this._mutations = Object.create(null)
	  this._wrappedGetters = Object.create(null)
	  this._modules = new ModuleCollection(options)
	  this._modulesNamespaceMap = Object.create(null)
	  this._subscribers = []
	  this._watcherVM = new Vue()
	
	  // bind commit and dispatch to self
	  var store = this
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	    this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  }
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	    }
	
	    // strict mode
	  this.strict = strict
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root)
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state)
	
	  // apply plugins
	  plugins.concat(devtoolPlugin).forEach(function (plugin) { return plugin(this$1); })
	};
	
	var prototypeAccessors = { state: {} };
	
	prototypeAccessors.state.get = function () {
	  return this._vm.$data.state
	};
	
	prototypeAccessors.state.set = function (v) {
	  assert(false, "Use store.replaceState() to explicit replace store state.")
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload }
	  var entry = this._mutations[type]
	  if (!entry) {
	    console.error(("[vuex] unknown mutation type: " + type))
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload)
	    })
	  })
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); })
	
	  if (options && options.silent) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    )
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var entry = this._actions[type]
	  if (!entry) {
	    console.error(("[vuex] unknown action type: " + type))
	    return
	  }
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  var subs = this._subscribers
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn)
	  }
	  return function () {
	    var i = subs.indexOf(fn)
	    if (i > -1) {
	      subs.splice(i, 1)
	    }
	  }
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  assert(typeof getter === 'function', "store.watch only accepts a function.")
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm.state = state
	  })
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule) {
	  if (typeof path === 'string') { path = [path] }
	  assert(Array.isArray(path), "module path must be a string or an Array.")
	  this._modules.register(path, rawModule)
	  installModule(this, this.state, path, this._modules.get(path))
	  // reset store to update getters...
	  resetStoreVM(this, this.state)
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path] }
	  assert(Array.isArray(path), "module path must be a string or an Array.")
	    this._modules.unregister(path)
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1))
	    Vue.delete(parentState, path[path.length - 1])
	  })
	  resetStore(this)
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions)
	  resetStore(this)
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing
	  this._committing = true
	  fn()
	  this._committing = committing
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function resetStore (store) {
	  store._actions = Object.create(null)
	  store._mutations = Object.create(null)
	  store._wrappedGetters = Object.create(null)
	  store._modulesNamespaceMap = Object.create(null)
	  var state = store.state
	  // init all modules
	  installModule(store, state, [], store._modules.root, true)
	  // reset vm
	  resetStoreVM(store, state)
	}
	
	function resetStoreVM (store, state) {
	  var oldVm = store._vm
	
	  // bind store public getters
	  store.getters = {}
	  var wrappedGetters = store._wrappedGetters
	  var computed = {}
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); }
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    })
	  })
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent
	  Vue.config.silent = true
	  store._vm = new Vue({
	    data: { state: state },
	    computed: computed
	  })
	  Vue.config.silent = silent
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store)
	  }
	
	  if (oldVm) {
	    // dispatch changes in all subscribed watchers
	    // to force getter re-evaluation.
	    store._withCommit(function () {
	      oldVm.state = null
	    })
	    Vue.nextTick(function () { return oldVm.$destroy(); })
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length
	  var namespace = store._modules.getNamespace(path)
	
	  // register in namespace map
	  if (namespace) {
	    store._modulesNamespaceMap[namespace] = module
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1))
	    var moduleName = path[path.length - 1]
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state)
	    })
	  }
	
	  var local = module.context = makeLocalContext(store, namespace)
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key
	    registerMutation(store, namespacedType, mutation, path)
	  })
	
	  module.forEachAction(function (action, key) {
	    var namespacedType = namespace + key
	    registerAction(store, namespacedType, action, local, path)
	  })
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key
	    registerGetter(store, namespacedType, getter, local, path)
	  })
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot)
	  })
	}
	
	/**
	 * make localized dispatch, commit and getters
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace) {
	  var noNamespace = namespace === ''
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options)
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type
	        if (!store._actions[type]) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type))
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options)
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type
	        if (!store._mutations[type]) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type))
	          return
	        }
	      }
	
	      store.commit(type, payload, options)
	    }
	  }
	
	  // getters object must be gotten lazily
	  // because store.getters will be changed by vm update
	  Object.defineProperty(local, 'getters', {
	    get: noNamespace ? function () { return store.getters; } : function () { return makeLocalGetters(store, namespace); }
	  })
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {}
	
	  var splitPos = namespace.length
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos)
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    })
	  })
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, path) {
	  var entry = store._mutations[type] || (store._mutations[type] = [])
	  entry.push(function wrappedMutationHandler (payload) {
	    handler(getNestedState(store.state, path), payload)
	  })
	}
	
	function registerAction (store, type, handler, local, path) {
	  var entry = store._actions[type] || (store._actions[type] = [])
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler({
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: getNestedState(store.state, path),
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb)
	    if (!isPromise(res)) {
	      res = Promise.resolve(res)
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err)
	        throw err
	      })
	    } else {
	      return res
	    }
	  })
	}
	
	function registerGetter (store, type, rawGetter, local, path) {
	  if (store._wrappedGetters[type]) {
	    console.error(("[vuex] duplicate getter key: " + type))
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      getNestedState(store.state, path), // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  }
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch('state', function () {
	    assert(store._committing, "Do not mutate vuex store state outside mutation handlers.")
	  }, { deep: true, sync: true })
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload
	    payload = type
	    type = type.type
	  }
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue) {
	    console.error(
	      '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	    )
	    return
	  }
	  Vue = _Vue
	  applyMixin(Vue)
	}
	
	// auto install in dist mode
	if (typeof window !== 'undefined' && window.Vue) {
	  install(window.Vue)
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '2.1.1',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions
	}
	
	return index;
	
	})));

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(39), __esModule: true };

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(36);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67);
	__webpack_require__(65);
	module.exports = __webpack_require__(4).Array.from;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(66);
	module.exports = __webpack_require__(4).Object.assign;

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(27)
	  , toLength  = __webpack_require__(28)
	  , toIndex   = __webpack_require__(62);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(19)
	  , TAG = __webpack_require__(1)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(8)
	  , createDesc      = __webpack_require__(14);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2).document && document.documentElement;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(5) && !__webpack_require__(11)(function(){
	  return Object.defineProperty(__webpack_require__(21)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(13)
	  , ITERATOR   = __webpack_require__(1)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(3);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(54)
	  , descriptor     = __webpack_require__(14)
	  , setToStringTag = __webpack_require__(25)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(7)(IteratorPrototype, __webpack_require__(1)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(52)
	  , $export        = __webpack_require__(10)
	  , redefine       = __webpack_require__(60)
	  , hide           = __webpack_require__(7)
	  , has            = __webpack_require__(6)
	  , Iterators      = __webpack_require__(13)
	  , $iterCreate    = __webpack_require__(49)
	  , setToStringTag = __webpack_require__(25)
	  , getPrototypeOf = __webpack_require__(57)
	  , ITERATOR       = __webpack_require__(1)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(1)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(24)
	  , gOPS     = __webpack_require__(56)
	  , pIE      = __webpack_require__(59)
	  , toObject = __webpack_require__(17)
	  , IObject  = __webpack_require__(23)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(11)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(3)
	  , dPs         = __webpack_require__(55)
	  , enumBugKeys = __webpack_require__(22)
	  , IE_PROTO    = __webpack_require__(15)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(21)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(45).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(8)
	  , anObject = __webpack_require__(3)
	  , getKeys  = __webpack_require__(24);
	
	module.exports = __webpack_require__(5) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(6)
	  , toObject    = __webpack_require__(17)
	  , IE_PROTO    = __webpack_require__(15)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(6)
	  , toIObject    = __webpack_require__(27)
	  , arrayIndexOf = __webpack_require__(42)(false)
	  , IE_PROTO     = __webpack_require__(15)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 59 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(16)
	  , defined   = __webpack_require__(9);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(16)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(12);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(43)
	  , ITERATOR  = __webpack_require__(1)('iterator')
	  , Iterators = __webpack_require__(13);
	module.exports = __webpack_require__(4).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(20)
	  , $export        = __webpack_require__(10)
	  , toObject       = __webpack_require__(17)
	  , call           = __webpack_require__(48)
	  , isArrayIter    = __webpack_require__(47)
	  , toLength       = __webpack_require__(28)
	  , createProperty = __webpack_require__(44)
	  , getIterFn      = __webpack_require__(64);
	
	$export($export.S + $export.F * !__webpack_require__(51)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(10);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(53)});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(61)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(50)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 68 */,
/* 69 */,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// Fine Uploader 5.11.10 - (c) 2013-present Widen Enterprises, Inc. MIT licensed. http://fineuploader.com
	(function(global) {
	    var qq = function(element) {
	        "use strict";
	        return {
	            hide: function() {
	                element.style.display = "none";
	                return this;
	            },
	            attach: function(type, fn) {
	                if (element.addEventListener) {
	                    element.addEventListener(type, fn, false);
	                } else if (element.attachEvent) {
	                    element.attachEvent("on" + type, fn);
	                }
	                return function() {
	                    qq(element).detach(type, fn);
	                };
	            },
	            detach: function(type, fn) {
	                if (element.removeEventListener) {
	                    element.removeEventListener(type, fn, false);
	                } else if (element.attachEvent) {
	                    element.detachEvent("on" + type, fn);
	                }
	                return this;
	            },
	            contains: function(descendant) {
	                if (!descendant) {
	                    return false;
	                }
	                if (element === descendant) {
	                    return true;
	                }
	                if (element.contains) {
	                    return element.contains(descendant);
	                } else {
	                    return !!(descendant.compareDocumentPosition(element) & 8);
	                }
	            },
	            insertBefore: function(elementB) {
	                elementB.parentNode.insertBefore(element, elementB);
	                return this;
	            },
	            remove: function() {
	                element.parentNode.removeChild(element);
	                return this;
	            },
	            css: function(styles) {
	                if (element.style == null) {
	                    throw new qq.Error("Can't apply style to node as it is not on the HTMLElement prototype chain!");
	                }
	                if (styles.opacity != null) {
	                    if (typeof element.style.opacity !== "string" && typeof element.filters !== "undefined") {
	                        styles.filter = "alpha(opacity=" + Math.round(100 * styles.opacity) + ")";
	                    }
	                }
	                qq.extend(element.style, styles);
	                return this;
	            },
	            hasClass: function(name, considerParent) {
	                var re = new RegExp("(^| )" + name + "( |$)");
	                return re.test(element.className) || !!(considerParent && re.test(element.parentNode.className));
	            },
	            addClass: function(name) {
	                if (!qq(element).hasClass(name)) {
	                    element.className += " " + name;
	                }
	                return this;
	            },
	            removeClass: function(name) {
	                var re = new RegExp("(^| )" + name + "( |$)");
	                element.className = element.className.replace(re, " ").replace(/^\s+|\s+$/g, "");
	                return this;
	            },
	            getByClass: function(className, first) {
	                var candidates, result = [];
	                if (first && element.querySelector) {
	                    return element.querySelector("." + className);
	                } else if (element.querySelectorAll) {
	                    return element.querySelectorAll("." + className);
	                }
	                candidates = element.getElementsByTagName("*");
	                qq.each(candidates, function(idx, val) {
	                    if (qq(val).hasClass(className)) {
	                        result.push(val);
	                    }
	                });
	                return first ? result[0] : result;
	            },
	            getFirstByClass: function(className) {
	                return qq(element).getByClass(className, true);
	            },
	            children: function() {
	                var children = [], child = element.firstChild;
	                while (child) {
	                    if (child.nodeType === 1) {
	                        children.push(child);
	                    }
	                    child = child.nextSibling;
	                }
	                return children;
	            },
	            setText: function(text) {
	                element.innerText = text;
	                element.textContent = text;
	                return this;
	            },
	            clearText: function() {
	                return qq(element).setText("");
	            },
	            hasAttribute: function(attrName) {
	                var attrVal;
	                if (element.hasAttribute) {
	                    if (!element.hasAttribute(attrName)) {
	                        return false;
	                    }
	                    return /^false$/i.exec(element.getAttribute(attrName)) == null;
	                } else {
	                    attrVal = element[attrName];
	                    if (attrVal === undefined) {
	                        return false;
	                    }
	                    return /^false$/i.exec(attrVal) == null;
	                }
	            }
	        };
	    };
	    (function() {
	        "use strict";
	        qq.canvasToBlob = function(canvas, mime, quality) {
	            return qq.dataUriToBlob(canvas.toDataURL(mime, quality));
	        };
	        qq.dataUriToBlob = function(dataUri) {
	            var arrayBuffer, byteString, createBlob = function(data, mime) {
	                var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder, blobBuilder = BlobBuilder && new BlobBuilder();
	                if (blobBuilder) {
	                    blobBuilder.append(data);
	                    return blobBuilder.getBlob(mime);
	                } else {
	                    return new Blob([ data ], {
	                        type: mime
	                    });
	                }
	            }, intArray, mimeString;
	            if (dataUri.split(",")[0].indexOf("base64") >= 0) {
	                byteString = atob(dataUri.split(",")[1]);
	            } else {
	                byteString = decodeURI(dataUri.split(",")[1]);
	            }
	            mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
	            arrayBuffer = new ArrayBuffer(byteString.length);
	            intArray = new Uint8Array(arrayBuffer);
	            qq.each(byteString, function(idx, character) {
	                intArray[idx] = character.charCodeAt(0);
	            });
	            return createBlob(arrayBuffer, mimeString);
	        };
	        qq.log = function(message, level) {
	            if (window.console) {
	                if (!level || level === "info") {
	                    window.console.log(message);
	                } else {
	                    if (window.console[level]) {
	                        window.console[level](message);
	                    } else {
	                        window.console.log("<" + level + "> " + message);
	                    }
	                }
	            }
	        };
	        qq.isObject = function(variable) {
	            return variable && !variable.nodeType && Object.prototype.toString.call(variable) === "[object Object]";
	        };
	        qq.isFunction = function(variable) {
	            return typeof variable === "function";
	        };
	        qq.isArray = function(value) {
	            return Object.prototype.toString.call(value) === "[object Array]" || value && window.ArrayBuffer && value.buffer && value.buffer.constructor === ArrayBuffer;
	        };
	        qq.isItemList = function(maybeItemList) {
	            return Object.prototype.toString.call(maybeItemList) === "[object DataTransferItemList]";
	        };
	        qq.isNodeList = function(maybeNodeList) {
	            return Object.prototype.toString.call(maybeNodeList) === "[object NodeList]" || maybeNodeList.item && maybeNodeList.namedItem;
	        };
	        qq.isString = function(maybeString) {
	            return Object.prototype.toString.call(maybeString) === "[object String]";
	        };
	        qq.trimStr = function(string) {
	            if (String.prototype.trim) {
	                return string.trim();
	            }
	            return string.replace(/^\s+|\s+$/g, "");
	        };
	        qq.format = function(str) {
	            var args = Array.prototype.slice.call(arguments, 1), newStr = str, nextIdxToReplace = newStr.indexOf("{}");
	            qq.each(args, function(idx, val) {
	                var strBefore = newStr.substring(0, nextIdxToReplace), strAfter = newStr.substring(nextIdxToReplace + 2);
	                newStr = strBefore + val + strAfter;
	                nextIdxToReplace = newStr.indexOf("{}", nextIdxToReplace + val.length);
	                if (nextIdxToReplace < 0) {
	                    return false;
	                }
	            });
	            return newStr;
	        };
	        qq.isFile = function(maybeFile) {
	            return window.File && Object.prototype.toString.call(maybeFile) === "[object File]";
	        };
	        qq.isFileList = function(maybeFileList) {
	            return window.FileList && Object.prototype.toString.call(maybeFileList) === "[object FileList]";
	        };
	        qq.isFileOrInput = function(maybeFileOrInput) {
	            return qq.isFile(maybeFileOrInput) || qq.isInput(maybeFileOrInput);
	        };
	        qq.isInput = function(maybeInput, notFile) {
	            var evaluateType = function(type) {
	                var normalizedType = type.toLowerCase();
	                if (notFile) {
	                    return normalizedType !== "file";
	                }
	                return normalizedType === "file";
	            };
	            if (window.HTMLInputElement) {
	                if (Object.prototype.toString.call(maybeInput) === "[object HTMLInputElement]") {
	                    if (maybeInput.type && evaluateType(maybeInput.type)) {
	                        return true;
	                    }
	                }
	            }
	            if (maybeInput.tagName) {
	                if (maybeInput.tagName.toLowerCase() === "input") {
	                    if (maybeInput.type && evaluateType(maybeInput.type)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        };
	        qq.isBlob = function(maybeBlob) {
	            if (window.Blob && Object.prototype.toString.call(maybeBlob) === "[object Blob]") {
	                return true;
	            }
	        };
	        qq.isXhrUploadSupported = function() {
	            var input = document.createElement("input");
	            input.type = "file";
	            return input.multiple !== undefined && typeof File !== "undefined" && typeof FormData !== "undefined" && typeof qq.createXhrInstance().upload !== "undefined";
	        };
	        qq.createXhrInstance = function() {
	            if (window.XMLHttpRequest) {
	                return new XMLHttpRequest();
	            }
	            try {
	                return new ActiveXObject("MSXML2.XMLHTTP.3.0");
	            } catch (error) {
	                qq.log("Neither XHR or ActiveX are supported!", "error");
	                return null;
	            }
	        };
	        qq.isFolderDropSupported = function(dataTransfer) {
	            return dataTransfer.items && dataTransfer.items.length > 0 && dataTransfer.items[0].webkitGetAsEntry;
	        };
	        qq.isFileChunkingSupported = function() {
	            return !qq.androidStock() && qq.isXhrUploadSupported() && (File.prototype.slice !== undefined || File.prototype.webkitSlice !== undefined || File.prototype.mozSlice !== undefined);
	        };
	        qq.sliceBlob = function(fileOrBlob, start, end) {
	            var slicer = fileOrBlob.slice || fileOrBlob.mozSlice || fileOrBlob.webkitSlice;
	            return slicer.call(fileOrBlob, start, end);
	        };
	        qq.arrayBufferToHex = function(buffer) {
	            var bytesAsHex = "", bytes = new Uint8Array(buffer);
	            qq.each(bytes, function(idx, byt) {
	                var byteAsHexStr = byt.toString(16);
	                if (byteAsHexStr.length < 2) {
	                    byteAsHexStr = "0" + byteAsHexStr;
	                }
	                bytesAsHex += byteAsHexStr;
	            });
	            return bytesAsHex;
	        };
	        qq.readBlobToHex = function(blob, startOffset, length) {
	            var initialBlob = qq.sliceBlob(blob, startOffset, startOffset + length), fileReader = new FileReader(), promise = new qq.Promise();
	            fileReader.onload = function() {
	                promise.success(qq.arrayBufferToHex(fileReader.result));
	            };
	            fileReader.onerror = promise.failure;
	            fileReader.readAsArrayBuffer(initialBlob);
	            return promise;
	        };
	        qq.extend = function(first, second, extendNested) {
	            qq.each(second, function(prop, val) {
	                if (extendNested && qq.isObject(val)) {
	                    if (first[prop] === undefined) {
	                        first[prop] = {};
	                    }
	                    qq.extend(first[prop], val, true);
	                } else {
	                    first[prop] = val;
	                }
	            });
	            return first;
	        };
	        qq.override = function(target, sourceFn) {
	            var super_ = {}, source = sourceFn(super_);
	            qq.each(source, function(srcPropName, srcPropVal) {
	                if (target[srcPropName] !== undefined) {
	                    super_[srcPropName] = target[srcPropName];
	                }
	                target[srcPropName] = srcPropVal;
	            });
	            return target;
	        };
	        qq.indexOf = function(arr, elt, from) {
	            if (arr.indexOf) {
	                return arr.indexOf(elt, from);
	            }
	            from = from || 0;
	            var len = arr.length;
	            if (from < 0) {
	                from += len;
	            }
	            for (;from < len; from += 1) {
	                if (arr.hasOwnProperty(from) && arr[from] === elt) {
	                    return from;
	                }
	            }
	            return -1;
	        };
	        qq.getUniqueId = function() {
	            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
	                var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
	                return v.toString(16);
	            });
	        };
	        qq.ie = function() {
	            return navigator.userAgent.indexOf("MSIE") !== -1 || navigator.userAgent.indexOf("Trident") !== -1;
	        };
	        qq.ie7 = function() {
	            return navigator.userAgent.indexOf("MSIE 7") !== -1;
	        };
	        qq.ie8 = function() {
	            return navigator.userAgent.indexOf("MSIE 8") !== -1;
	        };
	        qq.ie10 = function() {
	            return navigator.userAgent.indexOf("MSIE 10") !== -1;
	        };
	        qq.ie11 = function() {
	            return qq.ie() && navigator.userAgent.indexOf("rv:11") !== -1;
	        };
	        qq.edge = function() {
	            return navigator.userAgent.indexOf("Edge") >= 0;
	        };
	        qq.safari = function() {
	            return navigator.vendor !== undefined && navigator.vendor.indexOf("Apple") !== -1;
	        };
	        qq.chrome = function() {
	            return navigator.vendor !== undefined && navigator.vendor.indexOf("Google") !== -1;
	        };
	        qq.opera = function() {
	            return navigator.vendor !== undefined && navigator.vendor.indexOf("Opera") !== -1;
	        };
	        qq.firefox = function() {
	            return !qq.edge() && !qq.ie11() && navigator.userAgent.indexOf("Mozilla") !== -1 && navigator.vendor !== undefined && navigator.vendor === "";
	        };
	        qq.windows = function() {
	            return navigator.platform === "Win32";
	        };
	        qq.android = function() {
	            return navigator.userAgent.toLowerCase().indexOf("android") !== -1;
	        };
	        qq.androidStock = function() {
	            return qq.android() && navigator.userAgent.toLowerCase().indexOf("chrome") < 0;
	        };
	        qq.ios6 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 6_") !== -1;
	        };
	        qq.ios7 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 7_") !== -1;
	        };
	        qq.ios8 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 8_") !== -1;
	        };
	        qq.ios800 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 8_0 ") !== -1;
	        };
	        qq.ios = function() {
	            return navigator.userAgent.indexOf("iPad") !== -1 || navigator.userAgent.indexOf("iPod") !== -1 || navigator.userAgent.indexOf("iPhone") !== -1;
	        };
	        qq.iosChrome = function() {
	            return qq.ios() && navigator.userAgent.indexOf("CriOS") !== -1;
	        };
	        qq.iosSafari = function() {
	            return qq.ios() && !qq.iosChrome() && navigator.userAgent.indexOf("Safari") !== -1;
	        };
	        qq.iosSafariWebView = function() {
	            return qq.ios() && !qq.iosChrome() && !qq.iosSafari();
	        };
	        qq.preventDefault = function(e) {
	            if (e.preventDefault) {
	                e.preventDefault();
	            } else {
	                e.returnValue = false;
	            }
	        };
	        qq.toElement = function() {
	            var div = document.createElement("div");
	            return function(html) {
	                div.innerHTML = html;
	                var element = div.firstChild;
	                div.removeChild(element);
	                return element;
	            };
	        }();
	        qq.each = function(iterableItem, callback) {
	            var keyOrIndex, retVal;
	            if (iterableItem) {
	                if (window.Storage && iterableItem.constructor === window.Storage) {
	                    for (keyOrIndex = 0; keyOrIndex < iterableItem.length; keyOrIndex++) {
	                        retVal = callback(iterableItem.key(keyOrIndex), iterableItem.getItem(iterableItem.key(keyOrIndex)));
	                        if (retVal === false) {
	                            break;
	                        }
	                    }
	                } else if (qq.isArray(iterableItem) || qq.isItemList(iterableItem) || qq.isNodeList(iterableItem)) {
	                    for (keyOrIndex = 0; keyOrIndex < iterableItem.length; keyOrIndex++) {
	                        retVal = callback(keyOrIndex, iterableItem[keyOrIndex]);
	                        if (retVal === false) {
	                            break;
	                        }
	                    }
	                } else if (qq.isString(iterableItem)) {
	                    for (keyOrIndex = 0; keyOrIndex < iterableItem.length; keyOrIndex++) {
	                        retVal = callback(keyOrIndex, iterableItem.charAt(keyOrIndex));
	                        if (retVal === false) {
	                            break;
	                        }
	                    }
	                } else {
	                    for (keyOrIndex in iterableItem) {
	                        if (Object.prototype.hasOwnProperty.call(iterableItem, keyOrIndex)) {
	                            retVal = callback(keyOrIndex, iterableItem[keyOrIndex]);
	                            if (retVal === false) {
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	        qq.bind = function(oldFunc, context) {
	            if (qq.isFunction(oldFunc)) {
	                var args = Array.prototype.slice.call(arguments, 2);
	                return function() {
	                    var newArgs = qq.extend([], args);
	                    if (arguments.length) {
	                        newArgs = newArgs.concat(Array.prototype.slice.call(arguments));
	                    }
	                    return oldFunc.apply(context, newArgs);
	                };
	            }
	            throw new Error("first parameter must be a function!");
	        };
	        qq.obj2url = function(obj, temp, prefixDone) {
	            var uristrings = [], prefix = "&", add = function(nextObj, i) {
	                var nextTemp = temp ? /\[\]$/.test(temp) ? temp : temp + "[" + i + "]" : i;
	                if (nextTemp !== "undefined" && i !== "undefined") {
	                    uristrings.push(typeof nextObj === "object" ? qq.obj2url(nextObj, nextTemp, true) : Object.prototype.toString.call(nextObj) === "[object Function]" ? encodeURIComponent(nextTemp) + "=" + encodeURIComponent(nextObj()) : encodeURIComponent(nextTemp) + "=" + encodeURIComponent(nextObj));
	                }
	            };
	            if (!prefixDone && temp) {
	                prefix = /\?/.test(temp) ? /\?$/.test(temp) ? "" : "&" : "?";
	                uristrings.push(temp);
	                uristrings.push(qq.obj2url(obj));
	            } else if (Object.prototype.toString.call(obj) === "[object Array]" && typeof obj !== "undefined") {
	                qq.each(obj, function(idx, val) {
	                    add(val, idx);
	                });
	            } else if (typeof obj !== "undefined" && obj !== null && typeof obj === "object") {
	                qq.each(obj, function(prop, val) {
	                    add(val, prop);
	                });
	            } else {
	                uristrings.push(encodeURIComponent(temp) + "=" + encodeURIComponent(obj));
	            }
	            if (temp) {
	                return uristrings.join(prefix);
	            } else {
	                return uristrings.join(prefix).replace(/^&/, "").replace(/%20/g, "+");
	            }
	        };
	        qq.obj2FormData = function(obj, formData, arrayKeyName) {
	            if (!formData) {
	                formData = new FormData();
	            }
	            qq.each(obj, function(key, val) {
	                key = arrayKeyName ? arrayKeyName + "[" + key + "]" : key;
	                if (qq.isObject(val)) {
	                    qq.obj2FormData(val, formData, key);
	                } else if (qq.isFunction(val)) {
	                    formData.append(key, val());
	                } else {
	                    formData.append(key, val);
	                }
	            });
	            return formData;
	        };
	        qq.obj2Inputs = function(obj, form) {
	            var input;
	            if (!form) {
	                form = document.createElement("form");
	            }
	            qq.obj2FormData(obj, {
	                append: function(key, val) {
	                    input = document.createElement("input");
	                    input.setAttribute("name", key);
	                    input.setAttribute("value", val);
	                    form.appendChild(input);
	                }
	            });
	            return form;
	        };
	        qq.parseJson = function(json) {
	            if (window.JSON && qq.isFunction(JSON.parse)) {
	                return JSON.parse(json);
	            } else {
	                return eval("(" + json + ")");
	            }
	        };
	        qq.getExtension = function(filename) {
	            var extIdx = filename.lastIndexOf(".") + 1;
	            if (extIdx > 0) {
	                return filename.substr(extIdx, filename.length - extIdx);
	            }
	        };
	        qq.getFilename = function(blobOrFileInput) {
	            if (qq.isInput(blobOrFileInput)) {
	                return blobOrFileInput.value.replace(/.*(\/|\\)/, "");
	            } else if (qq.isFile(blobOrFileInput)) {
	                if (blobOrFileInput.fileName !== null && blobOrFileInput.fileName !== undefined) {
	                    return blobOrFileInput.fileName;
	                }
	            }
	            return blobOrFileInput.name;
	        };
	        qq.DisposeSupport = function() {
	            var disposers = [];
	            return {
	                dispose: function() {
	                    var disposer;
	                    do {
	                        disposer = disposers.shift();
	                        if (disposer) {
	                            disposer();
	                        }
	                    } while (disposer);
	                },
	                attach: function() {
	                    var args = arguments;
	                    this.addDisposer(qq(args[0]).attach.apply(this, Array.prototype.slice.call(arguments, 1)));
	                },
	                addDisposer: function(disposeFunction) {
	                    disposers.push(disposeFunction);
	                }
	            };
	        };
	    })();
	    (function() {
	        "use strict";
	        if (true) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                return qq;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (typeof module !== "undefined" && module.exports) {
	            module.exports = qq;
	        } else {
	            global.qq = qq;
	        }
	    })();
	    (function() {
	        "use strict";
	        qq.Error = function(message) {
	            this.message = "[Fine Uploader " + qq.version + "] " + message;
	        };
	        qq.Error.prototype = new Error();
	    })();
	    qq.version = "5.11.10";
	    qq.supportedFeatures = function() {
	        "use strict";
	        var supportsUploading, supportsUploadingBlobs, supportsFileDrop, supportsAjaxFileUploading, supportsFolderDrop, supportsChunking, supportsResume, supportsUploadViaPaste, supportsUploadCors, supportsDeleteFileXdr, supportsDeleteFileCorsXhr, supportsDeleteFileCors, supportsFolderSelection, supportsImagePreviews, supportsUploadProgress;
	        function testSupportsFileInputElement() {
	            var supported = true, tempInput;
	            try {
	                tempInput = document.createElement("input");
	                tempInput.type = "file";
	                qq(tempInput).hide();
	                if (tempInput.disabled) {
	                    supported = false;
	                }
	            } catch (ex) {
	                supported = false;
	            }
	            return supported;
	        }
	        function isChrome21OrHigher() {
	            return (qq.chrome() || qq.opera()) && navigator.userAgent.match(/Chrome\/[2][1-9]|Chrome\/[3-9][0-9]/) !== undefined;
	        }
	        function isChrome14OrHigher() {
	            return (qq.chrome() || qq.opera()) && navigator.userAgent.match(/Chrome\/[1][4-9]|Chrome\/[2-9][0-9]/) !== undefined;
	        }
	        function isCrossOriginXhrSupported() {
	            if (window.XMLHttpRequest) {
	                var xhr = qq.createXhrInstance();
	                return xhr.withCredentials !== undefined;
	            }
	            return false;
	        }
	        function isXdrSupported() {
	            return window.XDomainRequest !== undefined;
	        }
	        function isCrossOriginAjaxSupported() {
	            if (isCrossOriginXhrSupported()) {
	                return true;
	            }
	            return isXdrSupported();
	        }
	        function isFolderSelectionSupported() {
	            return document.createElement("input").webkitdirectory !== undefined;
	        }
	        function isLocalStorageSupported() {
	            try {
	                return !!window.localStorage && qq.isFunction(window.localStorage.setItem);
	            } catch (error) {
	                return false;
	            }
	        }
	        function isDragAndDropSupported() {
	            var span = document.createElement("span");
	            return ("draggable" in span || "ondragstart" in span && "ondrop" in span) && !qq.android() && !qq.ios();
	        }
	        supportsUploading = testSupportsFileInputElement();
	        supportsAjaxFileUploading = supportsUploading && qq.isXhrUploadSupported();
	        supportsUploadingBlobs = supportsAjaxFileUploading && !qq.androidStock();
	        supportsFileDrop = supportsAjaxFileUploading && isDragAndDropSupported();
	        supportsFolderDrop = supportsFileDrop && isChrome21OrHigher();
	        supportsChunking = supportsAjaxFileUploading && qq.isFileChunkingSupported();
	        supportsResume = supportsAjaxFileUploading && supportsChunking && isLocalStorageSupported();
	        supportsUploadViaPaste = supportsAjaxFileUploading && isChrome14OrHigher();
	        supportsUploadCors = supportsUploading && (window.postMessage !== undefined || supportsAjaxFileUploading);
	        supportsDeleteFileCorsXhr = isCrossOriginXhrSupported();
	        supportsDeleteFileXdr = isXdrSupported();
	        supportsDeleteFileCors = isCrossOriginAjaxSupported();
	        supportsFolderSelection = isFolderSelectionSupported();
	        supportsImagePreviews = supportsAjaxFileUploading && window.FileReader !== undefined;
	        supportsUploadProgress = function() {
	            if (supportsAjaxFileUploading) {
	                return !qq.androidStock() && !qq.iosChrome();
	            }
	            return false;
	        }();
	        return {
	            ajaxUploading: supportsAjaxFileUploading,
	            blobUploading: supportsUploadingBlobs,
	            canDetermineSize: supportsAjaxFileUploading,
	            chunking: supportsChunking,
	            deleteFileCors: supportsDeleteFileCors,
	            deleteFileCorsXdr: supportsDeleteFileXdr,
	            deleteFileCorsXhr: supportsDeleteFileCorsXhr,
	            dialogElement: !!window.HTMLDialogElement,
	            fileDrop: supportsFileDrop,
	            folderDrop: supportsFolderDrop,
	            folderSelection: supportsFolderSelection,
	            imagePreviews: supportsImagePreviews,
	            imageValidation: supportsImagePreviews,
	            itemSizeValidation: supportsAjaxFileUploading,
	            pause: supportsChunking,
	            progressBar: supportsUploadProgress,
	            resume: supportsResume,
	            scaling: supportsImagePreviews && supportsUploadingBlobs,
	            tiffPreviews: qq.safari(),
	            unlimitedScaledImageSize: !qq.ios(),
	            uploading: supportsUploading,
	            uploadCors: supportsUploadCors,
	            uploadCustomHeaders: supportsAjaxFileUploading,
	            uploadNonMultipart: supportsAjaxFileUploading,
	            uploadViaPaste: supportsUploadViaPaste
	        };
	    }();
	    qq.isGenericPromise = function(maybePromise) {
	        "use strict";
	        return !!(maybePromise && maybePromise.then && qq.isFunction(maybePromise.then));
	    };
	    qq.Promise = function() {
	        "use strict";
	        var successArgs, failureArgs, successCallbacks = [], failureCallbacks = [], doneCallbacks = [], state = 0;
	        qq.extend(this, {
	            then: function(onSuccess, onFailure) {
	                if (state === 0) {
	                    if (onSuccess) {
	                        successCallbacks.push(onSuccess);
	                    }
	                    if (onFailure) {
	                        failureCallbacks.push(onFailure);
	                    }
	                } else if (state === -1) {
	                    onFailure && onFailure.apply(null, failureArgs);
	                } else if (onSuccess) {
	                    onSuccess.apply(null, successArgs);
	                }
	                return this;
	            },
	            done: function(callback) {
	                if (state === 0) {
	                    doneCallbacks.push(callback);
	                } else {
	                    callback.apply(null, failureArgs === undefined ? successArgs : failureArgs);
	                }
	                return this;
	            },
	            success: function() {
	                state = 1;
	                successArgs = arguments;
	                if (successCallbacks.length) {
	                    qq.each(successCallbacks, function(idx, callback) {
	                        callback.apply(null, successArgs);
	                    });
	                }
	                if (doneCallbacks.length) {
	                    qq.each(doneCallbacks, function(idx, callback) {
	                        callback.apply(null, successArgs);
	                    });
	                }
	                return this;
	            },
	            failure: function() {
	                state = -1;
	                failureArgs = arguments;
	                if (failureCallbacks.length) {
	                    qq.each(failureCallbacks, function(idx, callback) {
	                        callback.apply(null, failureArgs);
	                    });
	                }
	                if (doneCallbacks.length) {
	                    qq.each(doneCallbacks, function(idx, callback) {
	                        callback.apply(null, failureArgs);
	                    });
	                }
	                return this;
	            }
	        });
	    };
	    qq.BlobProxy = function(referenceBlob, onCreate) {
	        "use strict";
	        qq.extend(this, {
	            referenceBlob: referenceBlob,
	            create: function() {
	                return onCreate(referenceBlob);
	            }
	        });
	    };
	    qq.UploadButton = function(o) {
	        "use strict";
	        var self = this, disposeSupport = new qq.DisposeSupport(), options = {
	            acceptFiles: null,
	            element: null,
	            focusClass: "qq-upload-button-focus",
	            folders: false,
	            hoverClass: "qq-upload-button-hover",
	            ios8BrowserCrashWorkaround: false,
	            multiple: false,
	            name: "qqfile",
	            onChange: function(input) {},
	            title: null
	        }, input, buttonId;
	        qq.extend(options, o);
	        buttonId = qq.getUniqueId();
	        function createInput() {
	            var input = document.createElement("input");
	            input.setAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME, buttonId);
	            input.setAttribute("title", options.title);
	            self.setMultiple(options.multiple, input);
	            if (options.folders && qq.supportedFeatures.folderSelection) {
	                input.setAttribute("webkitdirectory", "");
	            }
	            if (options.acceptFiles) {
	                input.setAttribute("accept", options.acceptFiles);
	            }
	            input.setAttribute("type", "file");
	            input.setAttribute("name", options.name);
	            qq(input).css({
	                position: "absolute",
	                right: 0,
	                top: 0,
	                fontFamily: "Arial",
	                fontSize: qq.ie() && !qq.ie8() ? "3500px" : "118px",
	                margin: 0,
	                padding: 0,
	                cursor: "pointer",
	                opacity: 0
	            });
	            !qq.ie7() && qq(input).css({
	                height: "100%"
	            });
	            options.element.appendChild(input);
	            disposeSupport.attach(input, "change", function() {
	                options.onChange(input);
	            });
	            disposeSupport.attach(input, "mouseover", function() {
	                qq(options.element).addClass(options.hoverClass);
	            });
	            disposeSupport.attach(input, "mouseout", function() {
	                qq(options.element).removeClass(options.hoverClass);
	            });
	            disposeSupport.attach(input, "focus", function() {
	                qq(options.element).addClass(options.focusClass);
	            });
	            disposeSupport.attach(input, "blur", function() {
	                qq(options.element).removeClass(options.focusClass);
	            });
	            return input;
	        }
	        qq(options.element).css({
	            position: "relative",
	            overflow: "hidden",
	            direction: "ltr"
	        });
	        qq.extend(this, {
	            getInput: function() {
	                return input;
	            },
	            getButtonId: function() {
	                return buttonId;
	            },
	            setMultiple: function(isMultiple, optInput) {
	                var input = optInput || this.getInput();
	                if (options.ios8BrowserCrashWorkaround && qq.ios8() && (qq.iosChrome() || qq.iosSafariWebView())) {
	                    input.setAttribute("multiple", "");
	                } else {
	                    if (isMultiple) {
	                        input.setAttribute("multiple", "");
	                    } else {
	                        input.removeAttribute("multiple");
	                    }
	                }
	            },
	            setAcceptFiles: function(acceptFiles) {
	                if (acceptFiles !== options.acceptFiles) {
	                    input.setAttribute("accept", acceptFiles);
	                }
	            },
	            reset: function() {
	                if (input.parentNode) {
	                    qq(input).remove();
	                }
	                qq(options.element).removeClass(options.focusClass);
	                input = null;
	                input = createInput();
	            }
	        });
	        input = createInput();
	    };
	    qq.UploadButton.BUTTON_ID_ATTR_NAME = "qq-button-id";
	    qq.UploadData = function(uploaderProxy) {
	        "use strict";
	        var data = [], byUuid = {}, byStatus = {}, byProxyGroupId = {}, byBatchId = {};
	        function getDataByIds(idOrIds) {
	            if (qq.isArray(idOrIds)) {
	                var entries = [];
	                qq.each(idOrIds, function(idx, id) {
	                    entries.push(data[id]);
	                });
	                return entries;
	            }
	            return data[idOrIds];
	        }
	        function getDataByUuids(uuids) {
	            if (qq.isArray(uuids)) {
	                var entries = [];
	                qq.each(uuids, function(idx, uuid) {
	                    entries.push(data[byUuid[uuid]]);
	                });
	                return entries;
	            }
	            return data[byUuid[uuids]];
	        }
	        function getDataByStatus(status) {
	            var statusResults = [], statuses = [].concat(status);
	            qq.each(statuses, function(index, statusEnum) {
	                var statusResultIndexes = byStatus[statusEnum];
	                if (statusResultIndexes !== undefined) {
	                    qq.each(statusResultIndexes, function(i, dataIndex) {
	                        statusResults.push(data[dataIndex]);
	                    });
	                }
	            });
	            return statusResults;
	        }
	        qq.extend(this, {
	            addFile: function(spec) {
	                var status = spec.status || qq.status.SUBMITTING, id = data.push({
	                    name: spec.name,
	                    originalName: spec.name,
	                    uuid: spec.uuid,
	                    size: spec.size == null ? -1 : spec.size,
	                    status: status
	                }) - 1;
	                if (spec.batchId) {
	                    data[id].batchId = spec.batchId;
	                    if (byBatchId[spec.batchId] === undefined) {
	                        byBatchId[spec.batchId] = [];
	                    }
	                    byBatchId[spec.batchId].push(id);
	                }
	                if (spec.proxyGroupId) {
	                    data[id].proxyGroupId = spec.proxyGroupId;
	                    if (byProxyGroupId[spec.proxyGroupId] === undefined) {
	                        byProxyGroupId[spec.proxyGroupId] = [];
	                    }
	                    byProxyGroupId[spec.proxyGroupId].push(id);
	                }
	                data[id].id = id;
	                byUuid[spec.uuid] = id;
	                if (byStatus[status] === undefined) {
	                    byStatus[status] = [];
	                }
	                byStatus[status].push(id);
	                uploaderProxy.onStatusChange(id, null, status);
	                return id;
	            },
	            retrieve: function(optionalFilter) {
	                if (qq.isObject(optionalFilter) && data.length) {
	                    if (optionalFilter.id !== undefined) {
	                        return getDataByIds(optionalFilter.id);
	                    } else if (optionalFilter.uuid !== undefined) {
	                        return getDataByUuids(optionalFilter.uuid);
	                    } else if (optionalFilter.status) {
	                        return getDataByStatus(optionalFilter.status);
	                    }
	                } else {
	                    return qq.extend([], data, true);
	                }
	            },
	            reset: function() {
	                data = [];
	                byUuid = {};
	                byStatus = {};
	                byBatchId = {};
	            },
	            setStatus: function(id, newStatus) {
	                var oldStatus = data[id].status, byStatusOldStatusIndex = qq.indexOf(byStatus[oldStatus], id);
	                byStatus[oldStatus].splice(byStatusOldStatusIndex, 1);
	                data[id].status = newStatus;
	                if (byStatus[newStatus] === undefined) {
	                    byStatus[newStatus] = [];
	                }
	                byStatus[newStatus].push(id);
	                uploaderProxy.onStatusChange(id, oldStatus, newStatus);
	            },
	            uuidChanged: function(id, newUuid) {
	                var oldUuid = data[id].uuid;
	                data[id].uuid = newUuid;
	                byUuid[newUuid] = id;
	                delete byUuid[oldUuid];
	            },
	            updateName: function(id, newName) {
	                data[id].name = newName;
	            },
	            updateSize: function(id, newSize) {
	                data[id].size = newSize;
	            },
	            setParentId: function(targetId, parentId) {
	                data[targetId].parentId = parentId;
	            },
	            getIdsInProxyGroup: function(id) {
	                var proxyGroupId = data[id].proxyGroupId;
	                if (proxyGroupId) {
	                    return byProxyGroupId[proxyGroupId];
	                }
	                return [];
	            },
	            getIdsInBatch: function(id) {
	                var batchId = data[id].batchId;
	                return byBatchId[batchId];
	            }
	        });
	    };
	    qq.status = {
	        SUBMITTING: "submitting",
	        SUBMITTED: "submitted",
	        REJECTED: "rejected",
	        QUEUED: "queued",
	        CANCELED: "canceled",
	        PAUSED: "paused",
	        UPLOADING: "uploading",
	        UPLOAD_RETRYING: "retrying upload",
	        UPLOAD_SUCCESSFUL: "upload successful",
	        UPLOAD_FAILED: "upload failed",
	        DELETE_FAILED: "delete failed",
	        DELETING: "deleting",
	        DELETED: "deleted"
	    };
	    (function() {
	        "use strict";
	        qq.basePublicApi = {
	            addBlobs: function(blobDataOrArray, params, endpoint) {
	                this.addFiles(blobDataOrArray, params, endpoint);
	            },
	            addInitialFiles: function(cannedFileList) {
	                var self = this;
	                qq.each(cannedFileList, function(index, cannedFile) {
	                    self._addCannedFile(cannedFile);
	                });
	            },
	            addFiles: function(data, params, endpoint) {
	                this._maybeHandleIos8SafariWorkaround();
	                var batchId = this._storedIds.length === 0 ? qq.getUniqueId() : this._currentBatchId, processBlob = qq.bind(function(blob) {
	                    this._handleNewFile({
	                        blob: blob,
	                        name: this._options.blobs.defaultName
	                    }, batchId, verifiedFiles);
	                }, this), processBlobData = qq.bind(function(blobData) {
	                    this._handleNewFile(blobData, batchId, verifiedFiles);
	                }, this), processCanvas = qq.bind(function(canvas) {
	                    var blob = qq.canvasToBlob(canvas);
	                    this._handleNewFile({
	                        blob: blob,
	                        name: this._options.blobs.defaultName + ".png"
	                    }, batchId, verifiedFiles);
	                }, this), processCanvasData = qq.bind(function(canvasData) {
	                    var normalizedQuality = canvasData.quality && canvasData.quality / 100, blob = qq.canvasToBlob(canvasData.canvas, canvasData.type, normalizedQuality);
	                    this._handleNewFile({
	                        blob: blob,
	                        name: canvasData.name
	                    }, batchId, verifiedFiles);
	                }, this), processFileOrInput = qq.bind(function(fileOrInput) {
	                    if (qq.isInput(fileOrInput) && qq.supportedFeatures.ajaxUploading) {
	                        var files = Array.prototype.slice.call(fileOrInput.files), self = this;
	                        qq.each(files, function(idx, file) {
	                            self._handleNewFile(file, batchId, verifiedFiles);
	                        });
	                    } else {
	                        this._handleNewFile(fileOrInput, batchId, verifiedFiles);
	                    }
	                }, this), normalizeData = function() {
	                    if (qq.isFileList(data)) {
	                        data = Array.prototype.slice.call(data);
	                    }
	                    data = [].concat(data);
	                }, self = this, verifiedFiles = [];
	                this._currentBatchId = batchId;
	                if (data) {
	                    normalizeData();
	                    qq.each(data, function(idx, fileContainer) {
	                        if (qq.isFileOrInput(fileContainer)) {
	                            processFileOrInput(fileContainer);
	                        } else if (qq.isBlob(fileContainer)) {
	                            processBlob(fileContainer);
	                        } else if (qq.isObject(fileContainer)) {
	                            if (fileContainer.blob && fileContainer.name) {
	                                processBlobData(fileContainer);
	                            } else if (fileContainer.canvas && fileContainer.name) {
	                                processCanvasData(fileContainer);
	                            }
	                        } else if (fileContainer.tagName && fileContainer.tagName.toLowerCase() === "canvas") {
	                            processCanvas(fileContainer);
	                        } else {
	                            self.log(fileContainer + " is not a valid file container!  Ignoring!", "warn");
	                        }
	                    });
	                    this.log("Received " + verifiedFiles.length + " files.");
	                    this._prepareItemsForUpload(verifiedFiles, params, endpoint);
	                }
	            },
	            cancel: function(id) {
	                this._handler.cancel(id);
	            },
	            cancelAll: function() {
	                var storedIdsCopy = [], self = this;
	                qq.extend(storedIdsCopy, this._storedIds);
	                qq.each(storedIdsCopy, function(idx, storedFileId) {
	                    self.cancel(storedFileId);
	                });
	                this._handler.cancelAll();
	            },
	            clearStoredFiles: function() {
	                this._storedIds = [];
	            },
	            continueUpload: function(id) {
	                var uploadData = this._uploadData.retrieve({
	                    id: id
	                });
	                if (!qq.supportedFeatures.pause || !this._options.chunking.enabled) {
	                    return false;
	                }
	                if (uploadData.status === qq.status.PAUSED) {
	                    this.log(qq.format("Paused file ID {} ({}) will be continued.  Not paused.", id, this.getName(id)));
	                    this._uploadFile(id);
	                    return true;
	                } else {
	                    this.log(qq.format("Ignoring continue for file ID {} ({}).  Not paused.", id, this.getName(id)), "error");
	                }
	                return false;
	            },
	            deleteFile: function(id) {
	                return this._onSubmitDelete(id);
	            },
	            doesExist: function(fileOrBlobId) {
	                return this._handler.isValid(fileOrBlobId);
	            },
	            drawThumbnail: function(fileId, imgOrCanvas, maxSize, fromServer, customResizeFunction) {
	                var promiseToReturn = new qq.Promise(), fileOrUrl, options;
	                if (this._imageGenerator) {
	                    fileOrUrl = this._thumbnailUrls[fileId];
	                    options = {
	                        customResizeFunction: customResizeFunction,
	                        maxSize: maxSize > 0 ? maxSize : null,
	                        scale: maxSize > 0
	                    };
	                    if (!fromServer && qq.supportedFeatures.imagePreviews) {
	                        fileOrUrl = this.getFile(fileId);
	                    }
	                    if (fileOrUrl == null) {
	                        promiseToReturn.failure({
	                            container: imgOrCanvas,
	                            error: "File or URL not found."
	                        });
	                    } else {
	                        this._imageGenerator.generate(fileOrUrl, imgOrCanvas, options).then(function success(modifiedContainer) {
	                            promiseToReturn.success(modifiedContainer);
	                        }, function failure(container, reason) {
	                            promiseToReturn.failure({
	                                container: container,
	                                error: reason || "Problem generating thumbnail"
	                            });
	                        });
	                    }
	                } else {
	                    promiseToReturn.failure({
	                        container: imgOrCanvas,
	                        error: "Missing image generator module"
	                    });
	                }
	                return promiseToReturn;
	            },
	            getButton: function(fileId) {
	                return this._getButton(this._buttonIdsForFileIds[fileId]);
	            },
	            getEndpoint: function(fileId) {
	                return this._endpointStore.get(fileId);
	            },
	            getFile: function(fileOrBlobId) {
	                return this._handler.getFile(fileOrBlobId) || null;
	            },
	            getInProgress: function() {
	                return this._uploadData.retrieve({
	                    status: [ qq.status.UPLOADING, qq.status.UPLOAD_RETRYING, qq.status.QUEUED ]
	                }).length;
	            },
	            getName: function(id) {
	                return this._uploadData.retrieve({
	                    id: id
	                }).name;
	            },
	            getParentId: function(id) {
	                var uploadDataEntry = this.getUploads({
	                    id: id
	                }), parentId = null;
	                if (uploadDataEntry) {
	                    if (uploadDataEntry.parentId !== undefined) {
	                        parentId = uploadDataEntry.parentId;
	                    }
	                }
	                return parentId;
	            },
	            getResumableFilesData: function() {
	                return this._handler.getResumableFilesData();
	            },
	            getSize: function(id) {
	                return this._uploadData.retrieve({
	                    id: id
	                }).size;
	            },
	            getNetUploads: function() {
	                return this._netUploaded;
	            },
	            getRemainingAllowedItems: function() {
	                var allowedItems = this._currentItemLimit;
	                if (allowedItems > 0) {
	                    return allowedItems - this._netUploadedOrQueued;
	                }
	                return null;
	            },
	            getUploads: function(optionalFilter) {
	                return this._uploadData.retrieve(optionalFilter);
	            },
	            getUuid: function(id) {
	                return this._uploadData.retrieve({
	                    id: id
	                }).uuid;
	            },
	            log: function(str, level) {
	                if (this._options.debug && (!level || level === "info")) {
	                    qq.log("[Fine Uploader " + qq.version + "] " + str);
	                } else if (level && level !== "info") {
	                    qq.log("[Fine Uploader " + qq.version + "] " + str, level);
	                }
	            },
	            pauseUpload: function(id) {
	                var uploadData = this._uploadData.retrieve({
	                    id: id
	                });
	                if (!qq.supportedFeatures.pause || !this._options.chunking.enabled) {
	                    return false;
	                }
	                if (qq.indexOf([ qq.status.UPLOADING, qq.status.UPLOAD_RETRYING ], uploadData.status) >= 0) {
	                    if (this._handler.pause(id)) {
	                        this._uploadData.setStatus(id, qq.status.PAUSED);
	                        return true;
	                    } else {
	                        this.log(qq.format("Unable to pause file ID {} ({}).", id, this.getName(id)), "error");
	                    }
	                } else {
	                    this.log(qq.format("Ignoring pause for file ID {} ({}).  Not in progress.", id, this.getName(id)), "error");
	                }
	                return false;
	            },
	            reset: function() {
	                this.log("Resetting uploader...");
	                this._handler.reset();
	                this._storedIds = [];
	                this._autoRetries = [];
	                this._retryTimeouts = [];
	                this._preventRetries = [];
	                this._thumbnailUrls = [];
	                qq.each(this._buttons, function(idx, button) {
	                    button.reset();
	                });
	                this._paramsStore.reset();
	                this._endpointStore.reset();
	                this._netUploadedOrQueued = 0;
	                this._netUploaded = 0;
	                this._uploadData.reset();
	                this._buttonIdsForFileIds = [];
	                this._pasteHandler && this._pasteHandler.reset();
	                this._options.session.refreshOnReset && this._refreshSessionData();
	                this._succeededSinceLastAllComplete = [];
	                this._failedSinceLastAllComplete = [];
	                this._totalProgress && this._totalProgress.reset();
	            },
	            retry: function(id) {
	                return this._manualRetry(id);
	            },
	            scaleImage: function(id, specs) {
	                var self = this;
	                return qq.Scaler.prototype.scaleImage(id, specs, {
	                    log: qq.bind(self.log, self),
	                    getFile: qq.bind(self.getFile, self),
	                    uploadData: self._uploadData
	                });
	            },
	            setCustomHeaders: function(headers, id) {
	                this._customHeadersStore.set(headers, id);
	            },
	            setDeleteFileCustomHeaders: function(headers, id) {
	                this._deleteFileCustomHeadersStore.set(headers, id);
	            },
	            setDeleteFileEndpoint: function(endpoint, id) {
	                this._deleteFileEndpointStore.set(endpoint, id);
	            },
	            setDeleteFileParams: function(params, id) {
	                this._deleteFileParamsStore.set(params, id);
	            },
	            setEndpoint: function(endpoint, id) {
	                this._endpointStore.set(endpoint, id);
	            },
	            setForm: function(elementOrId) {
	                this._updateFormSupportAndParams(elementOrId);
	            },
	            setItemLimit: function(newItemLimit) {
	                this._currentItemLimit = newItemLimit;
	            },
	            setName: function(id, newName) {
	                this._uploadData.updateName(id, newName);
	            },
	            setParams: function(params, id) {
	                this._paramsStore.set(params, id);
	            },
	            setUuid: function(id, newUuid) {
	                return this._uploadData.uuidChanged(id, newUuid);
	            },
	            uploadStoredFiles: function() {
	                if (this._storedIds.length === 0) {
	                    this._itemError("noFilesError");
	                } else {
	                    this._uploadStoredFiles();
	                }
	            }
	        };
	        qq.basePrivateApi = {
	            _addCannedFile: function(sessionData) {
	                var id = this._uploadData.addFile({
	                    uuid: sessionData.uuid,
	                    name: sessionData.name,
	                    size: sessionData.size,
	                    status: qq.status.UPLOAD_SUCCESSFUL
	                });
	                sessionData.deleteFileEndpoint && this.setDeleteFileEndpoint(sessionData.deleteFileEndpoint, id);
	                sessionData.deleteFileParams && this.setDeleteFileParams(sessionData.deleteFileParams, id);
	                if (sessionData.thumbnailUrl) {
	                    this._thumbnailUrls[id] = sessionData.thumbnailUrl;
	                }
	                this._netUploaded++;
	                this._netUploadedOrQueued++;
	                return id;
	            },
	            _annotateWithButtonId: function(file, associatedInput) {
	                if (qq.isFile(file)) {
	                    file.qqButtonId = this._getButtonId(associatedInput);
	                }
	            },
	            _batchError: function(message) {
	                this._options.callbacks.onError(null, null, message, undefined);
	            },
	            _createDeleteHandler: function() {
	                var self = this;
	                return new qq.DeleteFileAjaxRequester({
	                    method: this._options.deleteFile.method.toUpperCase(),
	                    maxConnections: this._options.maxConnections,
	                    uuidParamName: this._options.request.uuidName,
	                    customHeaders: this._deleteFileCustomHeadersStore,
	                    paramsStore: this._deleteFileParamsStore,
	                    endpointStore: this._deleteFileEndpointStore,
	                    cors: this._options.cors,
	                    log: qq.bind(self.log, self),
	                    onDelete: function(id) {
	                        self._onDelete(id);
	                        self._options.callbacks.onDelete(id);
	                    },
	                    onDeleteComplete: function(id, xhrOrXdr, isError) {
	                        self._onDeleteComplete(id, xhrOrXdr, isError);
	                        self._options.callbacks.onDeleteComplete(id, xhrOrXdr, isError);
	                    }
	                });
	            },
	            _createPasteHandler: function() {
	                var self = this;
	                return new qq.PasteSupport({
	                    targetElement: this._options.paste.targetElement,
	                    callbacks: {
	                        log: qq.bind(self.log, self),
	                        pasteReceived: function(blob) {
	                            self._handleCheckedCallback({
	                                name: "onPasteReceived",
	                                callback: qq.bind(self._options.callbacks.onPasteReceived, self, blob),
	                                onSuccess: qq.bind(self._handlePasteSuccess, self, blob),
	                                identifier: "pasted image"
	                            });
	                        }
	                    }
	                });
	            },
	            _createStore: function(initialValue, _readOnlyValues_) {
	                var store = {}, catchall = initialValue, perIdReadOnlyValues = {}, readOnlyValues = _readOnlyValues_, copy = function(orig) {
	                    if (qq.isObject(orig)) {
	                        return qq.extend({}, orig);
	                    }
	                    return orig;
	                }, getReadOnlyValues = function() {
	                    if (qq.isFunction(readOnlyValues)) {
	                        return readOnlyValues();
	                    }
	                    return readOnlyValues;
	                }, includeReadOnlyValues = function(id, existing) {
	                    if (readOnlyValues && qq.isObject(existing)) {
	                        qq.extend(existing, getReadOnlyValues());
	                    }
	                    if (perIdReadOnlyValues[id]) {
	                        qq.extend(existing, perIdReadOnlyValues[id]);
	                    }
	                };
	                return {
	                    set: function(val, id) {
	                        if (id == null) {
	                            store = {};
	                            catchall = copy(val);
	                        } else {
	                            store[id] = copy(val);
	                        }
	                    },
	                    get: function(id) {
	                        var values;
	                        if (id != null && store[id]) {
	                            values = store[id];
	                        } else {
	                            values = copy(catchall);
	                        }
	                        includeReadOnlyValues(id, values);
	                        return copy(values);
	                    },
	                    addReadOnly: function(id, values) {
	                        if (qq.isObject(store)) {
	                            if (id === null) {
	                                if (qq.isFunction(values)) {
	                                    readOnlyValues = values;
	                                } else {
	                                    readOnlyValues = readOnlyValues || {};
	                                    qq.extend(readOnlyValues, values);
	                                }
	                            } else {
	                                perIdReadOnlyValues[id] = perIdReadOnlyValues[id] || {};
	                                qq.extend(perIdReadOnlyValues[id], values);
	                            }
	                        }
	                    },
	                    remove: function(fileId) {
	                        return delete store[fileId];
	                    },
	                    reset: function() {
	                        store = {};
	                        perIdReadOnlyValues = {};
	                        catchall = initialValue;
	                    }
	                };
	            },
	            _createUploadDataTracker: function() {
	                var self = this;
	                return new qq.UploadData({
	                    getName: function(id) {
	                        return self.getName(id);
	                    },
	                    getUuid: function(id) {
	                        return self.getUuid(id);
	                    },
	                    getSize: function(id) {
	                        return self.getSize(id);
	                    },
	                    onStatusChange: function(id, oldStatus, newStatus) {
	                        self._onUploadStatusChange(id, oldStatus, newStatus);
	                        self._options.callbacks.onStatusChange(id, oldStatus, newStatus);
	                        self._maybeAllComplete(id, newStatus);
	                        if (self._totalProgress) {
	                            setTimeout(function() {
	                                self._totalProgress.onStatusChange(id, oldStatus, newStatus);
	                            }, 0);
	                        }
	                    }
	                });
	            },
	            _createUploadButton: function(spec) {
	                var self = this, acceptFiles = spec.accept || this._options.validation.acceptFiles, allowedExtensions = spec.allowedExtensions || this._options.validation.allowedExtensions, button;
	                function allowMultiple() {
	                    if (qq.supportedFeatures.ajaxUploading) {
	                        if (self._options.workarounds.iosEmptyVideos && qq.ios() && !qq.ios6() && self._isAllowedExtension(allowedExtensions, ".mov")) {
	                            return false;
	                        }
	                        if (spec.multiple === undefined) {
	                            return self._options.multiple;
	                        }
	                        return spec.multiple;
	                    }
	                    return false;
	                }
	                button = new qq.UploadButton({
	                    acceptFiles: acceptFiles,
	                    element: spec.element,
	                    focusClass: this._options.classes.buttonFocus,
	                    folders: spec.folders,
	                    hoverClass: this._options.classes.buttonHover,
	                    ios8BrowserCrashWorkaround: this._options.workarounds.ios8BrowserCrash,
	                    multiple: allowMultiple(),
	                    name: this._options.request.inputName,
	                    onChange: function(input) {
	                        self._onInputChange(input);
	                    },
	                    title: spec.title == null ? this._options.text.fileInputTitle : spec.title
	                });
	                this._disposeSupport.addDisposer(function() {
	                    button.dispose();
	                });
	                self._buttons.push(button);
	                return button;
	            },
	            _createUploadHandler: function(additionalOptions, namespace) {
	                var self = this, lastOnProgress = {}, options = {
	                    debug: this._options.debug,
	                    maxConnections: this._options.maxConnections,
	                    cors: this._options.cors,
	                    paramsStore: this._paramsStore,
	                    endpointStore: this._endpointStore,
	                    chunking: this._options.chunking,
	                    resume: this._options.resume,
	                    blobs: this._options.blobs,
	                    log: qq.bind(self.log, self),
	                    preventRetryParam: this._options.retry.preventRetryResponseProperty,
	                    onProgress: function(id, name, loaded, total) {
	                        if (loaded < 0 || total < 0) {
	                            return;
	                        }
	                        if (lastOnProgress[id]) {
	                            if (lastOnProgress[id].loaded !== loaded || lastOnProgress[id].total !== total) {
	                                self._onProgress(id, name, loaded, total);
	                                self._options.callbacks.onProgress(id, name, loaded, total);
	                            }
	                        } else {
	                            self._onProgress(id, name, loaded, total);
	                            self._options.callbacks.onProgress(id, name, loaded, total);
	                        }
	                        lastOnProgress[id] = {
	                            loaded: loaded,
	                            total: total
	                        };
	                    },
	                    onComplete: function(id, name, result, xhr) {
	                        delete lastOnProgress[id];
	                        var status = self.getUploads({
	                            id: id
	                        }).status, retVal;
	                        if (status === qq.status.UPLOAD_SUCCESSFUL || status === qq.status.UPLOAD_FAILED) {
	                            return;
	                        }
	                        retVal = self._onComplete(id, name, result, xhr);
	                        if (retVal instanceof qq.Promise) {
	                            retVal.done(function() {
	                                self._options.callbacks.onComplete(id, name, result, xhr);
	                            });
	                        } else {
	                            self._options.callbacks.onComplete(id, name, result, xhr);
	                        }
	                    },
	                    onCancel: function(id, name, cancelFinalizationEffort) {
	                        var promise = new qq.Promise();
	                        self._handleCheckedCallback({
	                            name: "onCancel",
	                            callback: qq.bind(self._options.callbacks.onCancel, self, id, name),
	                            onFailure: promise.failure,
	                            onSuccess: function() {
	                                cancelFinalizationEffort.then(function() {
	                                    self._onCancel(id, name);
	                                });
	                                promise.success();
	                            },
	                            identifier: id
	                        });
	                        return promise;
	                    },
	                    onUploadPrep: qq.bind(this._onUploadPrep, this),
	                    onUpload: function(id, name) {
	                        self._onUpload(id, name);
	                        self._options.callbacks.onUpload(id, name);
	                    },
	                    onUploadChunk: function(id, name, chunkData) {
	                        self._onUploadChunk(id, chunkData);
	                        self._options.callbacks.onUploadChunk(id, name, chunkData);
	                    },
	                    onUploadChunkSuccess: function(id, chunkData, result, xhr) {
	                        self._options.callbacks.onUploadChunkSuccess.apply(self, arguments);
	                    },
	                    onResume: function(id, name, chunkData) {
	                        return self._options.callbacks.onResume(id, name, chunkData);
	                    },
	                    onAutoRetry: function(id, name, responseJSON, xhr) {
	                        return self._onAutoRetry.apply(self, arguments);
	                    },
	                    onUuidChanged: function(id, newUuid) {
	                        self.log("Server requested UUID change from '" + self.getUuid(id) + "' to '" + newUuid + "'");
	                        self.setUuid(id, newUuid);
	                    },
	                    getName: qq.bind(self.getName, self),
	                    getUuid: qq.bind(self.getUuid, self),
	                    getSize: qq.bind(self.getSize, self),
	                    setSize: qq.bind(self._setSize, self),
	                    getDataByUuid: function(uuid) {
	                        return self.getUploads({
	                            uuid: uuid
	                        });
	                    },
	                    isQueued: function(id) {
	                        var status = self.getUploads({
	                            id: id
	                        }).status;
	                        return status === qq.status.QUEUED || status === qq.status.SUBMITTED || status === qq.status.UPLOAD_RETRYING || status === qq.status.PAUSED;
	                    },
	                    getIdsInProxyGroup: self._uploadData.getIdsInProxyGroup,
	                    getIdsInBatch: self._uploadData.getIdsInBatch
	                };
	                qq.each(this._options.request, function(prop, val) {
	                    options[prop] = val;
	                });
	                options.customHeaders = this._customHeadersStore;
	                if (additionalOptions) {
	                    qq.each(additionalOptions, function(key, val) {
	                        options[key] = val;
	                    });
	                }
	                return new qq.UploadHandlerController(options, namespace);
	            },
	            _fileOrBlobRejected: function(id) {
	                this._netUploadedOrQueued--;
	                this._uploadData.setStatus(id, qq.status.REJECTED);
	            },
	            _formatSize: function(bytes) {
	                var i = -1;
	                do {
	                    bytes = bytes / 1e3;
	                    i++;
	                } while (bytes > 999);
	                return Math.max(bytes, .1).toFixed(1) + this._options.text.sizeSymbols[i];
	            },
	            _generateExtraButtonSpecs: function() {
	                var self = this;
	                this._extraButtonSpecs = {};
	                qq.each(this._options.extraButtons, function(idx, extraButtonOptionEntry) {
	                    var multiple = extraButtonOptionEntry.multiple, validation = qq.extend({}, self._options.validation, true), extraButtonSpec = qq.extend({}, extraButtonOptionEntry);
	                    if (multiple === undefined) {
	                        multiple = self._options.multiple;
	                    }
	                    if (extraButtonSpec.validation) {
	                        qq.extend(validation, extraButtonOptionEntry.validation, true);
	                    }
	                    qq.extend(extraButtonSpec, {
	                        multiple: multiple,
	                        validation: validation
	                    }, true);
	                    self._initExtraButton(extraButtonSpec);
	                });
	            },
	            _getButton: function(buttonId) {
	                var extraButtonsSpec = this._extraButtonSpecs[buttonId];
	                if (extraButtonsSpec) {
	                    return extraButtonsSpec.element;
	                } else if (buttonId === this._defaultButtonId) {
	                    return this._options.button;
	                }
	            },
	            _getButtonId: function(buttonOrFileInputOrFile) {
	                var inputs, fileInput, fileBlobOrInput = buttonOrFileInputOrFile;
	                if (fileBlobOrInput instanceof qq.BlobProxy) {
	                    fileBlobOrInput = fileBlobOrInput.referenceBlob;
	                }
	                if (fileBlobOrInput && !qq.isBlob(fileBlobOrInput)) {
	                    if (qq.isFile(fileBlobOrInput)) {
	                        return fileBlobOrInput.qqButtonId;
	                    } else if (fileBlobOrInput.tagName.toLowerCase() === "input" && fileBlobOrInput.type.toLowerCase() === "file") {
	                        return fileBlobOrInput.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);
	                    }
	                    inputs = fileBlobOrInput.getElementsByTagName("input");
	                    qq.each(inputs, function(idx, input) {
	                        if (input.getAttribute("type") === "file") {
	                            fileInput = input;
	                            return false;
	                        }
	                    });
	                    if (fileInput) {
	                        return fileInput.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);
	                    }
	                }
	            },
	            _getNotFinished: function() {
	                return this._uploadData.retrieve({
	                    status: [ qq.status.UPLOADING, qq.status.UPLOAD_RETRYING, qq.status.QUEUED, qq.status.SUBMITTING, qq.status.SUBMITTED, qq.status.PAUSED ]
	                }).length;
	            },
	            _getValidationBase: function(buttonId) {
	                var extraButtonSpec = this._extraButtonSpecs[buttonId];
	                return extraButtonSpec ? extraButtonSpec.validation : this._options.validation;
	            },
	            _getValidationDescriptor: function(fileWrapper) {
	                if (fileWrapper.file instanceof qq.BlobProxy) {
	                    return {
	                        name: qq.getFilename(fileWrapper.file.referenceBlob),
	                        size: fileWrapper.file.referenceBlob.size
	                    };
	                }
	                return {
	                    name: this.getUploads({
	                        id: fileWrapper.id
	                    }).name,
	                    size: this.getUploads({
	                        id: fileWrapper.id
	                    }).size
	                };
	            },
	            _getValidationDescriptors: function(fileWrappers) {
	                var self = this, fileDescriptors = [];
	                qq.each(fileWrappers, function(idx, fileWrapper) {
	                    fileDescriptors.push(self._getValidationDescriptor(fileWrapper));
	                });
	                return fileDescriptors;
	            },
	            _handleCameraAccess: function() {
	                if (this._options.camera.ios && qq.ios()) {
	                    var acceptIosCamera = "image/*;capture=camera", button = this._options.camera.button, buttonId = button ? this._getButtonId(button) : this._defaultButtonId, optionRoot = this._options;
	                    if (buttonId && buttonId !== this._defaultButtonId) {
	                        optionRoot = this._extraButtonSpecs[buttonId];
	                    }
	                    optionRoot.multiple = false;
	                    if (optionRoot.validation.acceptFiles === null) {
	                        optionRoot.validation.acceptFiles = acceptIosCamera;
	                    } else {
	                        optionRoot.validation.acceptFiles += "," + acceptIosCamera;
	                    }
	                    qq.each(this._buttons, function(idx, button) {
	                        if (button.getButtonId() === buttonId) {
	                            button.setMultiple(optionRoot.multiple);
	                            button.setAcceptFiles(optionRoot.acceptFiles);
	                            return false;
	                        }
	                    });
	                }
	            },
	            _handleCheckedCallback: function(details) {
	                var self = this, callbackRetVal = details.callback();
	                if (qq.isGenericPromise(callbackRetVal)) {
	                    this.log(details.name + " - waiting for " + details.name + " promise to be fulfilled for " + details.identifier);
	                    return callbackRetVal.then(function(successParam) {
	                        self.log(details.name + " promise success for " + details.identifier);
	                        details.onSuccess(successParam);
	                    }, function() {
	                        if (details.onFailure) {
	                            self.log(details.name + " promise failure for " + details.identifier);
	                            details.onFailure();
	                        } else {
	                            self.log(details.name + " promise failure for " + details.identifier);
	                        }
	                    });
	                }
	                if (callbackRetVal !== false) {
	                    details.onSuccess(callbackRetVal);
	                } else {
	                    if (details.onFailure) {
	                        this.log(details.name + " - return value was 'false' for " + details.identifier + ".  Invoking failure callback.");
	                        details.onFailure();
	                    } else {
	                        this.log(details.name + " - return value was 'false' for " + details.identifier + ".  Will not proceed.");
	                    }
	                }
	                return callbackRetVal;
	            },
	            _handleNewFile: function(file, batchId, newFileWrapperList) {
	                var self = this, uuid = qq.getUniqueId(), size = -1, name = qq.getFilename(file), actualFile = file.blob || file, handler = this._customNewFileHandler ? this._customNewFileHandler : qq.bind(self._handleNewFileGeneric, self);
	                if (!qq.isInput(actualFile) && actualFile.size >= 0) {
	                    size = actualFile.size;
	                }
	                handler(actualFile, name, uuid, size, newFileWrapperList, batchId, this._options.request.uuidName, {
	                    uploadData: self._uploadData,
	                    paramsStore: self._paramsStore,
	                    addFileToHandler: function(id, file) {
	                        self._handler.add(id, file);
	                        self._netUploadedOrQueued++;
	                        self._trackButton(id);
	                    }
	                });
	            },
	            _handleNewFileGeneric: function(file, name, uuid, size, fileList, batchId) {
	                var id = this._uploadData.addFile({
	                    uuid: uuid,
	                    name: name,
	                    size: size,
	                    batchId: batchId
	                });
	                this._handler.add(id, file);
	                this._trackButton(id);
	                this._netUploadedOrQueued++;
	                fileList.push({
	                    id: id,
	                    file: file
	                });
	            },
	            _handlePasteSuccess: function(blob, extSuppliedName) {
	                var extension = blob.type.split("/")[1], name = extSuppliedName;
	                if (name == null) {
	                    name = this._options.paste.defaultName;
	                }
	                name += "." + extension;
	                this.addFiles({
	                    name: name,
	                    blob: blob
	                });
	            },
	            _initExtraButton: function(spec) {
	                var button = this._createUploadButton({
	                    accept: spec.validation.acceptFiles,
	                    allowedExtensions: spec.validation.allowedExtensions,
	                    element: spec.element,
	                    folders: spec.folders,
	                    multiple: spec.multiple,
	                    title: spec.fileInputTitle
	                });
	                this._extraButtonSpecs[button.getButtonId()] = spec;
	            },
	            _initFormSupportAndParams: function() {
	                this._formSupport = qq.FormSupport && new qq.FormSupport(this._options.form, qq.bind(this.uploadStoredFiles, this), qq.bind(this.log, this));
	                if (this._formSupport && this._formSupport.attachedToForm) {
	                    this._paramsStore = this._createStore(this._options.request.params, this._formSupport.getFormInputsAsObject);
	                    this._options.autoUpload = this._formSupport.newAutoUpload;
	                    if (this._formSupport.newEndpoint) {
	                        this._options.request.endpoint = this._formSupport.newEndpoint;
	                    }
	                } else {
	                    this._paramsStore = this._createStore(this._options.request.params);
	                }
	            },
	            _isDeletePossible: function() {
	                if (!qq.DeleteFileAjaxRequester || !this._options.deleteFile.enabled) {
	                    return false;
	                }
	                if (this._options.cors.expected) {
	                    if (qq.supportedFeatures.deleteFileCorsXhr) {
	                        return true;
	                    }
	                    if (qq.supportedFeatures.deleteFileCorsXdr && this._options.cors.allowXdr) {
	                        return true;
	                    }
	                    return false;
	                }
	                return true;
	            },
	            _isAllowedExtension: function(allowed, fileName) {
	                var valid = false;
	                if (!allowed.length) {
	                    return true;
	                }
	                qq.each(allowed, function(idx, allowedExt) {
	                    if (qq.isString(allowedExt)) {
	                        var extRegex = new RegExp("\\." + allowedExt + "$", "i");
	                        if (fileName.match(extRegex) != null) {
	                            valid = true;
	                            return false;
	                        }
	                    }
	                });
	                return valid;
	            },
	            _itemError: function(code, maybeNameOrNames, item) {
	                var message = this._options.messages[code], allowedExtensions = [], names = [].concat(maybeNameOrNames), name = names[0], buttonId = this._getButtonId(item), validationBase = this._getValidationBase(buttonId), extensionsForMessage, placeholderMatch;
	                function r(name, replacement) {
	                    message = message.replace(name, replacement);
	                }
	                qq.each(validationBase.allowedExtensions, function(idx, allowedExtension) {
	                    if (qq.isString(allowedExtension)) {
	                        allowedExtensions.push(allowedExtension);
	                    }
	                });
	                extensionsForMessage = allowedExtensions.join(", ").toLowerCase();
	                r("{file}", this._options.formatFileName(name));
	                r("{extensions}", extensionsForMessage);
	                r("{sizeLimit}", this._formatSize(validationBase.sizeLimit));
	                r("{minSizeLimit}", this._formatSize(validationBase.minSizeLimit));
	                placeholderMatch = message.match(/(\{\w+\})/g);
	                if (placeholderMatch !== null) {
	                    qq.each(placeholderMatch, function(idx, placeholder) {
	                        r(placeholder, names[idx]);
	                    });
	                }
	                this._options.callbacks.onError(null, name, message, undefined);
	                return message;
	            },
	            _manualRetry: function(id, callback) {
	                if (this._onBeforeManualRetry(id)) {
	                    this._netUploadedOrQueued++;
	                    this._uploadData.setStatus(id, qq.status.UPLOAD_RETRYING);
	                    if (callback) {
	                        callback(id);
	                    } else {
	                        this._handler.retry(id);
	                    }
	                    return true;
	                }
	            },
	            _maybeAllComplete: function(id, status) {
	                var self = this, notFinished = this._getNotFinished();
	                if (status === qq.status.UPLOAD_SUCCESSFUL) {
	                    this._succeededSinceLastAllComplete.push(id);
	                } else if (status === qq.status.UPLOAD_FAILED) {
	                    this._failedSinceLastAllComplete.push(id);
	                }
	                if (notFinished === 0 && (this._succeededSinceLastAllComplete.length || this._failedSinceLastAllComplete.length)) {
	                    setTimeout(function() {
	                        self._onAllComplete(self._succeededSinceLastAllComplete, self._failedSinceLastAllComplete);
	                    }, 0);
	                }
	            },
	            _maybeHandleIos8SafariWorkaround: function() {
	                var self = this;
	                if (this._options.workarounds.ios8SafariUploads && qq.ios800() && qq.iosSafari()) {
	                    setTimeout(function() {
	                        window.alert(self._options.messages.unsupportedBrowserIos8Safari);
	                    }, 0);
	                    throw new qq.Error(this._options.messages.unsupportedBrowserIos8Safari);
	                }
	            },
	            _maybeParseAndSendUploadError: function(id, name, response, xhr) {
	                if (!response.success) {
	                    if (xhr && xhr.status !== 200 && !response.error) {
	                        this._options.callbacks.onError(id, name, "XHR returned response code " + xhr.status, xhr);
	                    } else {
	                        var errorReason = response.error ? response.error : this._options.text.defaultResponseError;
	                        this._options.callbacks.onError(id, name, errorReason, xhr);
	                    }
	                }
	            },
	            _maybeProcessNextItemAfterOnValidateCallback: function(validItem, items, index, params, endpoint) {
	                var self = this;
	                if (items.length > index) {
	                    if (validItem || !this._options.validation.stopOnFirstInvalidFile) {
	                        setTimeout(function() {
	                            var validationDescriptor = self._getValidationDescriptor(items[index]), buttonId = self._getButtonId(items[index].file), button = self._getButton(buttonId);
	                            self._handleCheckedCallback({
	                                name: "onValidate",
	                                callback: qq.bind(self._options.callbacks.onValidate, self, validationDescriptor, button),
	                                onSuccess: qq.bind(self._onValidateCallbackSuccess, self, items, index, params, endpoint),
	                                onFailure: qq.bind(self._onValidateCallbackFailure, self, items, index, params, endpoint),
	                                identifier: "Item '" + validationDescriptor.name + "', size: " + validationDescriptor.size
	                            });
	                        }, 0);
	                    } else if (!validItem) {
	                        for (;index < items.length; index++) {
	                            self._fileOrBlobRejected(items[index].id);
	                        }
	                    }
	                }
	            },
	            _onAllComplete: function(successful, failed) {
	                this._totalProgress && this._totalProgress.onAllComplete(successful, failed, this._preventRetries);
	                this._options.callbacks.onAllComplete(qq.extend([], successful), qq.extend([], failed));
	                this._succeededSinceLastAllComplete = [];
	                this._failedSinceLastAllComplete = [];
	            },
	            _onAutoRetry: function(id, name, responseJSON, xhr, callback) {
	                var self = this;
	                self._preventRetries[id] = responseJSON[self._options.retry.preventRetryResponseProperty];
	                if (self._shouldAutoRetry(id, name, responseJSON)) {
	                    var retryWaitPeriod = self._options.retry.autoAttemptDelay * 1e3;
	                    self._maybeParseAndSendUploadError.apply(self, arguments);
	                    self._options.callbacks.onAutoRetry(id, name, self._autoRetries[id]);
	                    self._onBeforeAutoRetry(id, name);
	                    self._uploadData.setStatus(id, qq.status.UPLOAD_RETRYING);
	                    self._retryTimeouts[id] = setTimeout(function() {
	                        self.log("Starting retry for " + name + "...");
	                        if (callback) {
	                            callback(id);
	                        } else {
	                            self._handler.retry(id);
	                        }
	                    }, retryWaitPeriod);
	                    return true;
	                }
	            },
	            _onBeforeAutoRetry: function(id, name) {
	                this.log("Waiting " + this._options.retry.autoAttemptDelay + " seconds before retrying " + name + "...");
	            },
	            _onBeforeManualRetry: function(id) {
	                var itemLimit = this._currentItemLimit, fileName;
	                if (this._preventRetries[id]) {
	                    this.log("Retries are forbidden for id " + id, "warn");
	                    return false;
	                } else if (this._handler.isValid(id)) {
	                    fileName = this.getName(id);
	                    if (this._options.callbacks.onManualRetry(id, fileName) === false) {
	                        return false;
	                    }
	                    if (itemLimit > 0 && this._netUploadedOrQueued + 1 > itemLimit) {
	                        this._itemError("retryFailTooManyItems");
	                        return false;
	                    }
	                    this.log("Retrying upload for '" + fileName + "' (id: " + id + ")...");
	                    return true;
	                } else {
	                    this.log("'" + id + "' is not a valid file ID", "error");
	                    return false;
	                }
	            },
	            _onCancel: function(id, name) {
	                this._netUploadedOrQueued--;
	                clearTimeout(this._retryTimeouts[id]);
	                var storedItemIndex = qq.indexOf(this._storedIds, id);
	                if (!this._options.autoUpload && storedItemIndex >= 0) {
	                    this._storedIds.splice(storedItemIndex, 1);
	                }
	                this._uploadData.setStatus(id, qq.status.CANCELED);
	            },
	            _onComplete: function(id, name, result, xhr) {
	                if (!result.success) {
	                    this._netUploadedOrQueued--;
	                    this._uploadData.setStatus(id, qq.status.UPLOAD_FAILED);
	                    if (result[this._options.retry.preventRetryResponseProperty] === true) {
	                        this._preventRetries[id] = true;
	                    }
	                } else {
	                    if (result.thumbnailUrl) {
	                        this._thumbnailUrls[id] = result.thumbnailUrl;
	                    }
	                    this._netUploaded++;
	                    this._uploadData.setStatus(id, qq.status.UPLOAD_SUCCESSFUL);
	                }
	                this._maybeParseAndSendUploadError(id, name, result, xhr);
	                return result.success ? true : false;
	            },
	            _onDelete: function(id) {
	                this._uploadData.setStatus(id, qq.status.DELETING);
	            },
	            _onDeleteComplete: function(id, xhrOrXdr, isError) {
	                var name = this.getName(id);
	                if (isError) {
	                    this._uploadData.setStatus(id, qq.status.DELETE_FAILED);
	                    this.log("Delete request for '" + name + "' has failed.", "error");
	                    if (xhrOrXdr.withCredentials === undefined) {
	                        this._options.callbacks.onError(id, name, "Delete request failed", xhrOrXdr);
	                    } else {
	                        this._options.callbacks.onError(id, name, "Delete request failed with response code " + xhrOrXdr.status, xhrOrXdr);
	                    }
	                } else {
	                    this._netUploadedOrQueued--;
	                    this._netUploaded--;
	                    this._handler.expunge(id);
	                    this._uploadData.setStatus(id, qq.status.DELETED);
	                    this.log("Delete request for '" + name + "' has succeeded.");
	                }
	            },
	            _onInputChange: function(input) {
	                var fileIndex;
	                if (qq.supportedFeatures.ajaxUploading) {
	                    for (fileIndex = 0; fileIndex < input.files.length; fileIndex++) {
	                        this._annotateWithButtonId(input.files[fileIndex], input);
	                    }
	                    this.addFiles(input.files);
	                } else if (input.value.length > 0) {
	                    this.addFiles(input);
	                }
	                qq.each(this._buttons, function(idx, button) {
	                    button.reset();
	                });
	            },
	            _onProgress: function(id, name, loaded, total) {
	                this._totalProgress && this._totalProgress.onIndividualProgress(id, loaded, total);
	            },
	            _onSubmit: function(id, name) {},
	            _onSubmitCallbackSuccess: function(id, name) {
	                this._onSubmit.apply(this, arguments);
	                this._uploadData.setStatus(id, qq.status.SUBMITTED);
	                this._onSubmitted.apply(this, arguments);
	                if (this._options.autoUpload) {
	                    this._options.callbacks.onSubmitted.apply(this, arguments);
	                    this._uploadFile(id);
	                } else {
	                    this._storeForLater(id);
	                    this._options.callbacks.onSubmitted.apply(this, arguments);
	                }
	            },
	            _onSubmitDelete: function(id, onSuccessCallback, additionalMandatedParams) {
	                var uuid = this.getUuid(id), adjustedOnSuccessCallback;
	                if (onSuccessCallback) {
	                    adjustedOnSuccessCallback = qq.bind(onSuccessCallback, this, id, uuid, additionalMandatedParams);
	                }
	                if (this._isDeletePossible()) {
	                    this._handleCheckedCallback({
	                        name: "onSubmitDelete",
	                        callback: qq.bind(this._options.callbacks.onSubmitDelete, this, id),
	                        onSuccess: adjustedOnSuccessCallback || qq.bind(this._deleteHandler.sendDelete, this, id, uuid, additionalMandatedParams),
	                        identifier: id
	                    });
	                    return true;
	                } else {
	                    this.log("Delete request ignored for ID " + id + ", delete feature is disabled or request not possible " + "due to CORS on a user agent that does not support pre-flighting.", "warn");
	                    return false;
	                }
	            },
	            _onSubmitted: function(id) {},
	            _onTotalProgress: function(loaded, total) {
	                this._options.callbacks.onTotalProgress(loaded, total);
	            },
	            _onUploadPrep: function(id) {},
	            _onUpload: function(id, name) {
	                this._uploadData.setStatus(id, qq.status.UPLOADING);
	            },
	            _onUploadChunk: function(id, chunkData) {},
	            _onUploadStatusChange: function(id, oldStatus, newStatus) {
	                if (newStatus === qq.status.PAUSED) {
	                    clearTimeout(this._retryTimeouts[id]);
	                }
	            },
	            _onValidateBatchCallbackFailure: function(fileWrappers) {
	                var self = this;
	                qq.each(fileWrappers, function(idx, fileWrapper) {
	                    self._fileOrBlobRejected(fileWrapper.id);
	                });
	            },
	            _onValidateBatchCallbackSuccess: function(validationDescriptors, items, params, endpoint, button) {
	                var errorMessage, itemLimit = this._currentItemLimit, proposedNetFilesUploadedOrQueued = this._netUploadedOrQueued;
	                if (itemLimit === 0 || proposedNetFilesUploadedOrQueued <= itemLimit) {
	                    if (items.length > 0) {
	                        this._handleCheckedCallback({
	                            name: "onValidate",
	                            callback: qq.bind(this._options.callbacks.onValidate, this, validationDescriptors[0], button),
	                            onSuccess: qq.bind(this._onValidateCallbackSuccess, this, items, 0, params, endpoint),
	                            onFailure: qq.bind(this._onValidateCallbackFailure, this, items, 0, params, endpoint),
	                            identifier: "Item '" + items[0].file.name + "', size: " + items[0].file.size
	                        });
	                    } else {
	                        this._itemError("noFilesError");
	                    }
	                } else {
	                    this._onValidateBatchCallbackFailure(items);
	                    errorMessage = this._options.messages.tooManyItemsError.replace(/\{netItems\}/g, proposedNetFilesUploadedOrQueued).replace(/\{itemLimit\}/g, itemLimit);
	                    this._batchError(errorMessage);
	                }
	            },
	            _onValidateCallbackFailure: function(items, index, params, endpoint) {
	                var nextIndex = index + 1;
	                this._fileOrBlobRejected(items[index].id, items[index].file.name);
	                this._maybeProcessNextItemAfterOnValidateCallback(false, items, nextIndex, params, endpoint);
	            },
	            _onValidateCallbackSuccess: function(items, index, params, endpoint) {
	                var self = this, nextIndex = index + 1, validationDescriptor = this._getValidationDescriptor(items[index]);
	                this._validateFileOrBlobData(items[index], validationDescriptor).then(function() {
	                    self._upload(items[index].id, params, endpoint);
	                    self._maybeProcessNextItemAfterOnValidateCallback(true, items, nextIndex, params, endpoint);
	                }, function() {
	                    self._maybeProcessNextItemAfterOnValidateCallback(false, items, nextIndex, params, endpoint);
	                });
	            },
	            _prepareItemsForUpload: function(items, params, endpoint) {
	                if (items.length === 0) {
	                    this._itemError("noFilesError");
	                    return;
	                }
	                var validationDescriptors = this._getValidationDescriptors(items), buttonId = this._getButtonId(items[0].file), button = this._getButton(buttonId);
	                this._handleCheckedCallback({
	                    name: "onValidateBatch",
	                    callback: qq.bind(this._options.callbacks.onValidateBatch, this, validationDescriptors, button),
	                    onSuccess: qq.bind(this._onValidateBatchCallbackSuccess, this, validationDescriptors, items, params, endpoint, button),
	                    onFailure: qq.bind(this._onValidateBatchCallbackFailure, this, items),
	                    identifier: "batch validation"
	                });
	            },
	            _preventLeaveInProgress: function() {
	                var self = this;
	                this._disposeSupport.attach(window, "beforeunload", function(e) {
	                    if (self.getInProgress()) {
	                        e = e || window.event;
	                        e.returnValue = self._options.messages.onLeave;
	                        return self._options.messages.onLeave;
	                    }
	                });
	            },
	            _refreshSessionData: function() {
	                var self = this, options = this._options.session;
	                if (qq.Session && this._options.session.endpoint != null) {
	                    if (!this._session) {
	                        qq.extend(options, {
	                            cors: this._options.cors
	                        });
	                        options.log = qq.bind(this.log, this);
	                        options.addFileRecord = qq.bind(this._addCannedFile, this);
	                        this._session = new qq.Session(options);
	                    }
	                    setTimeout(function() {
	                        self._session.refresh().then(function(response, xhrOrXdr) {
	                            self._sessionRequestComplete();
	                            self._options.callbacks.onSessionRequestComplete(response, true, xhrOrXdr);
	                        }, function(response, xhrOrXdr) {
	                            self._options.callbacks.onSessionRequestComplete(response, false, xhrOrXdr);
	                        });
	                    }, 0);
	                }
	            },
	            _sessionRequestComplete: function() {},
	            _setSize: function(id, newSize) {
	                this._uploadData.updateSize(id, newSize);
	                this._totalProgress && this._totalProgress.onNewSize(id);
	            },
	            _shouldAutoRetry: function(id, name, responseJSON) {
	                var uploadData = this._uploadData.retrieve({
	                    id: id
	                });
	                if (!this._preventRetries[id] && this._options.retry.enableAuto && uploadData.status !== qq.status.PAUSED) {
	                    if (this._autoRetries[id] === undefined) {
	                        this._autoRetries[id] = 0;
	                    }
	                    if (this._autoRetries[id] < this._options.retry.maxAutoAttempts) {
	                        this._autoRetries[id] += 1;
	                        return true;
	                    }
	                }
	                return false;
	            },
	            _storeForLater: function(id) {
	                this._storedIds.push(id);
	            },
	            _trackButton: function(id) {
	                var buttonId;
	                if (qq.supportedFeatures.ajaxUploading) {
	                    buttonId = this._handler.getFile(id).qqButtonId;
	                } else {
	                    buttonId = this._getButtonId(this._handler.getInput(id));
	                }
	                if (buttonId) {
	                    this._buttonIdsForFileIds[id] = buttonId;
	                }
	            },
	            _updateFormSupportAndParams: function(formElementOrId) {
	                this._options.form.element = formElementOrId;
	                this._formSupport = qq.FormSupport && new qq.FormSupport(this._options.form, qq.bind(this.uploadStoredFiles, this), qq.bind(this.log, this));
	                if (this._formSupport && this._formSupport.attachedToForm) {
	                    this._paramsStore.addReadOnly(null, this._formSupport.getFormInputsAsObject);
	                    this._options.autoUpload = this._formSupport.newAutoUpload;
	                    if (this._formSupport.newEndpoint) {
	                        this.setEndpoint(this._formSupport.newEndpoint);
	                    }
	                }
	            },
	            _upload: function(id, params, endpoint) {
	                var name = this.getName(id);
	                if (params) {
	                    this.setParams(params, id);
	                }
	                if (endpoint) {
	                    this.setEndpoint(endpoint, id);
	                }
	                this._handleCheckedCallback({
	                    name: "onSubmit",
	                    callback: qq.bind(this._options.callbacks.onSubmit, this, id, name),
	                    onSuccess: qq.bind(this._onSubmitCallbackSuccess, this, id, name),
	                    onFailure: qq.bind(this._fileOrBlobRejected, this, id, name),
	                    identifier: id
	                });
	            },
	            _uploadFile: function(id) {
	                if (!this._handler.upload(id)) {
	                    this._uploadData.setStatus(id, qq.status.QUEUED);
	                }
	            },
	            _uploadStoredFiles: function() {
	                var idToUpload, stillSubmitting, self = this;
	                while (this._storedIds.length) {
	                    idToUpload = this._storedIds.shift();
	                    this._uploadFile(idToUpload);
	                }
	                stillSubmitting = this.getUploads({
	                    status: qq.status.SUBMITTING
	                }).length;
	                if (stillSubmitting) {
	                    qq.log("Still waiting for " + stillSubmitting + " files to clear submit queue. Will re-parse stored IDs array shortly.");
	                    setTimeout(function() {
	                        self._uploadStoredFiles();
	                    }, 1e3);
	                }
	            },
	            _validateFileOrBlobData: function(fileWrapper, validationDescriptor) {
	                var self = this, file = function() {
	                    if (fileWrapper.file instanceof qq.BlobProxy) {
	                        return fileWrapper.file.referenceBlob;
	                    }
	                    return fileWrapper.file;
	                }(), name = validationDescriptor.name, size = validationDescriptor.size, buttonId = this._getButtonId(fileWrapper.file), validationBase = this._getValidationBase(buttonId), validityChecker = new qq.Promise();
	                validityChecker.then(function() {}, function() {
	                    self._fileOrBlobRejected(fileWrapper.id, name);
	                });
	                if (qq.isFileOrInput(file) && !this._isAllowedExtension(validationBase.allowedExtensions, name)) {
	                    this._itemError("typeError", name, file);
	                    return validityChecker.failure();
	                }
	                if (size === 0) {
	                    this._itemError("emptyError", name, file);
	                    return validityChecker.failure();
	                }
	                if (size > 0 && validationBase.sizeLimit && size > validationBase.sizeLimit) {
	                    this._itemError("sizeError", name, file);
	                    return validityChecker.failure();
	                }
	                if (size > 0 && size < validationBase.minSizeLimit) {
	                    this._itemError("minSizeError", name, file);
	                    return validityChecker.failure();
	                }
	                if (qq.ImageValidation && qq.supportedFeatures.imagePreviews && qq.isFile(file)) {
	                    new qq.ImageValidation(file, qq.bind(self.log, self)).validate(validationBase.image).then(validityChecker.success, function(errorCode) {
	                        self._itemError(errorCode + "ImageError", name, file);
	                        validityChecker.failure();
	                    });
	                } else {
	                    validityChecker.success();
	                }
	                return validityChecker;
	            },
	            _wrapCallbacks: function() {
	                var self, safeCallback, prop;
	                self = this;
	                safeCallback = function(name, callback, args) {
	                    var errorMsg;
	                    try {
	                        return callback.apply(self, args);
	                    } catch (exception) {
	                        errorMsg = exception.message || exception.toString();
	                        self.log("Caught exception in '" + name + "' callback - " + errorMsg, "error");
	                    }
	                };
	                for (prop in this._options.callbacks) {
	                    (function() {
	                        var callbackName, callbackFunc;
	                        callbackName = prop;
	                        callbackFunc = self._options.callbacks[callbackName];
	                        self._options.callbacks[callbackName] = function() {
	                            return safeCallback(callbackName, callbackFunc, arguments);
	                        };
	                    })();
	                }
	            }
	        };
	    })();
	    (function() {
	        "use strict";
	        qq.FineUploaderBasic = function(o) {
	            var self = this;
	            this._options = {
	                debug: false,
	                button: null,
	                multiple: true,
	                maxConnections: 3,
	                disableCancelForFormUploads: false,
	                autoUpload: true,
	                request: {
	                    customHeaders: {},
	                    endpoint: "/server/upload",
	                    filenameParam: "qqfilename",
	                    forceMultipart: true,
	                    inputName: "qqfile",
	                    method: "POST",
	                    params: {},
	                    paramsInBody: true,
	                    totalFileSizeName: "qqtotalfilesize",
	                    uuidName: "qquuid"
	                },
	                validation: {
	                    allowedExtensions: [],
	                    sizeLimit: 0,
	                    minSizeLimit: 0,
	                    itemLimit: 0,
	                    stopOnFirstInvalidFile: true,
	                    acceptFiles: null,
	                    image: {
	                        maxHeight: 0,
	                        maxWidth: 0,
	                        minHeight: 0,
	                        minWidth: 0
	                    }
	                },
	                callbacks: {
	                    onSubmit: function(id, name) {},
	                    onSubmitted: function(id, name) {},
	                    onComplete: function(id, name, responseJSON, maybeXhr) {},
	                    onAllComplete: function(successful, failed) {},
	                    onCancel: function(id, name) {},
	                    onUpload: function(id, name) {},
	                    onUploadChunk: function(id, name, chunkData) {},
	                    onUploadChunkSuccess: function(id, chunkData, responseJSON, xhr) {},
	                    onResume: function(id, fileName, chunkData) {},
	                    onProgress: function(id, name, loaded, total) {},
	                    onTotalProgress: function(loaded, total) {},
	                    onError: function(id, name, reason, maybeXhrOrXdr) {},
	                    onAutoRetry: function(id, name, attemptNumber) {},
	                    onManualRetry: function(id, name) {},
	                    onValidateBatch: function(fileOrBlobData) {},
	                    onValidate: function(fileOrBlobData) {},
	                    onSubmitDelete: function(id) {},
	                    onDelete: function(id) {},
	                    onDeleteComplete: function(id, xhrOrXdr, isError) {},
	                    onPasteReceived: function(blob) {},
	                    onStatusChange: function(id, oldStatus, newStatus) {},
	                    onSessionRequestComplete: function(response, success, xhrOrXdr) {}
	                },
	                messages: {
	                    typeError: "{file} has an invalid extension. Valid extension(s): {extensions}.",
	                    sizeError: "{file} is too large, maximum file size is {sizeLimit}.",
	                    minSizeError: "{file} is too small, minimum file size is {minSizeLimit}.",
	                    emptyError: "{file} is empty, please select files again without it.",
	                    noFilesError: "No files to upload.",
	                    tooManyItemsError: "Too many items ({netItems}) would be uploaded.  Item limit is {itemLimit}.",
	                    maxHeightImageError: "Image is too tall.",
	                    maxWidthImageError: "Image is too wide.",
	                    minHeightImageError: "Image is not tall enough.",
	                    minWidthImageError: "Image is not wide enough.",
	                    retryFailTooManyItems: "Retry failed - you have reached your file limit.",
	                    onLeave: "The files are being uploaded, if you leave now the upload will be canceled.",
	                    unsupportedBrowserIos8Safari: "Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari.  Please use iOS8 Chrome until Apple fixes these issues."
	                },
	                retry: {
	                    enableAuto: false,
	                    maxAutoAttempts: 3,
	                    autoAttemptDelay: 5,
	                    preventRetryResponseProperty: "preventRetry"
	                },
	                classes: {
	                    buttonHover: "qq-upload-button-hover",
	                    buttonFocus: "qq-upload-button-focus"
	                },
	                chunking: {
	                    enabled: false,
	                    concurrent: {
	                        enabled: false
	                    },
	                    mandatory: false,
	                    paramNames: {
	                        partIndex: "qqpartindex",
	                        partByteOffset: "qqpartbyteoffset",
	                        chunkSize: "qqchunksize",
	                        totalFileSize: "qqtotalfilesize",
	                        totalParts: "qqtotalparts"
	                    },
	                    partSize: 2e6,
	                    success: {
	                        endpoint: null
	                    }
	                },
	                resume: {
	                    enabled: false,
	                    recordsExpireIn: 7,
	                    paramNames: {
	                        resuming: "qqresume"
	                    }
	                },
	                formatFileName: function(fileOrBlobName) {
	                    return fileOrBlobName;
	                },
	                text: {
	                    defaultResponseError: "Upload failure reason unknown",
	                    fileInputTitle: "file input",
	                    sizeSymbols: [ "kB", "MB", "GB", "TB", "PB", "EB" ]
	                },
	                deleteFile: {
	                    enabled: false,
	                    method: "DELETE",
	                    endpoint: "/server/upload",
	                    customHeaders: {},
	                    params: {}
	                },
	                cors: {
	                    expected: false,
	                    sendCredentials: false,
	                    allowXdr: false
	                },
	                blobs: {
	                    defaultName: "misc_data"
	                },
	                paste: {
	                    targetElement: null,
	                    defaultName: "pasted_image"
	                },
	                camera: {
	                    ios: false,
	                    button: null
	                },
	                extraButtons: [],
	                session: {
	                    endpoint: null,
	                    params: {},
	                    customHeaders: {},
	                    refreshOnReset: true
	                },
	                form: {
	                    element: "qq-form",
	                    autoUpload: false,
	                    interceptSubmit: true
	                },
	                scaling: {
	                    customResizer: null,
	                    sendOriginal: true,
	                    orient: true,
	                    defaultType: null,
	                    defaultQuality: 80,
	                    failureText: "Failed to scale",
	                    includeExif: false,
	                    sizes: []
	                },
	                workarounds: {
	                    iosEmptyVideos: true,
	                    ios8SafariUploads: true,
	                    ios8BrowserCrash: false
	                }
	            };
	            qq.extend(this._options, o, true);
	            this._buttons = [];
	            this._extraButtonSpecs = {};
	            this._buttonIdsForFileIds = [];
	            this._wrapCallbacks();
	            this._disposeSupport = new qq.DisposeSupport();
	            this._storedIds = [];
	            this._autoRetries = [];
	            this._retryTimeouts = [];
	            this._preventRetries = [];
	            this._thumbnailUrls = [];
	            this._netUploadedOrQueued = 0;
	            this._netUploaded = 0;
	            this._uploadData = this._createUploadDataTracker();
	            this._initFormSupportAndParams();
	            this._customHeadersStore = this._createStore(this._options.request.customHeaders);
	            this._deleteFileCustomHeadersStore = this._createStore(this._options.deleteFile.customHeaders);
	            this._deleteFileParamsStore = this._createStore(this._options.deleteFile.params);
	            this._endpointStore = this._createStore(this._options.request.endpoint);
	            this._deleteFileEndpointStore = this._createStore(this._options.deleteFile.endpoint);
	            this._handler = this._createUploadHandler();
	            this._deleteHandler = qq.DeleteFileAjaxRequester && this._createDeleteHandler();
	            if (this._options.button) {
	                this._defaultButtonId = this._createUploadButton({
	                    element: this._options.button,
	                    title: this._options.text.fileInputTitle
	                }).getButtonId();
	            }
	            this._generateExtraButtonSpecs();
	            this._handleCameraAccess();
	            if (this._options.paste.targetElement) {
	                if (qq.PasteSupport) {
	                    this._pasteHandler = this._createPasteHandler();
	                } else {
	                    this.log("Paste support module not found", "error");
	                }
	            }
	            this._preventLeaveInProgress();
	            this._imageGenerator = qq.ImageGenerator && new qq.ImageGenerator(qq.bind(this.log, this));
	            this._refreshSessionData();
	            this._succeededSinceLastAllComplete = [];
	            this._failedSinceLastAllComplete = [];
	            this._scaler = qq.Scaler && new qq.Scaler(this._options.scaling, qq.bind(this.log, this)) || {};
	            if (this._scaler.enabled) {
	                this._customNewFileHandler = qq.bind(this._scaler.handleNewFile, this._scaler);
	            }
	            if (qq.TotalProgress && qq.supportedFeatures.progressBar) {
	                this._totalProgress = new qq.TotalProgress(qq.bind(this._onTotalProgress, this), function(id) {
	                    var entry = self._uploadData.retrieve({
	                        id: id
	                    });
	                    return entry && entry.size || 0;
	                });
	            }
	            this._currentItemLimit = this._options.validation.itemLimit;
	        };
	        qq.FineUploaderBasic.prototype = qq.basePublicApi;
	        qq.extend(qq.FineUploaderBasic.prototype, qq.basePrivateApi);
	    })();
	    qq.AjaxRequester = function(o) {
	        "use strict";
	        var log, shouldParamsBeInQueryString, queue = [], requestData = {}, options = {
	            acceptHeader: null,
	            validMethods: [ "PATCH", "POST", "PUT" ],
	            method: "POST",
	            contentType: "application/x-www-form-urlencoded",
	            maxConnections: 3,
	            customHeaders: {},
	            endpointStore: {},
	            paramsStore: {},
	            mandatedParams: {},
	            allowXRequestedWithAndCacheControl: true,
	            successfulResponseCodes: {
	                DELETE: [ 200, 202, 204 ],
	                PATCH: [ 200, 201, 202, 203, 204 ],
	                POST: [ 200, 201, 202, 203, 204 ],
	                PUT: [ 200, 201, 202, 203, 204 ],
	                GET: [ 200 ]
	            },
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {},
	            onSend: function(id) {},
	            onComplete: function(id, xhrOrXdr, isError) {},
	            onProgress: null
	        };
	        qq.extend(options, o);
	        log = options.log;
	        if (qq.indexOf(options.validMethods, options.method) < 0) {
	            throw new Error("'" + options.method + "' is not a supported method for this type of request!");
	        }
	        function isSimpleMethod() {
	            return qq.indexOf([ "GET", "POST", "HEAD" ], options.method) >= 0;
	        }
	        function containsNonSimpleHeaders(headers) {
	            var containsNonSimple = false;
	            qq.each(containsNonSimple, function(idx, header) {
	                if (qq.indexOf([ "Accept", "Accept-Language", "Content-Language", "Content-Type" ], header) < 0) {
	                    containsNonSimple = true;
	                    return false;
	                }
	            });
	            return containsNonSimple;
	        }
	        function isXdr(xhr) {
	            return options.cors.expected && xhr.withCredentials === undefined;
	        }
	        function getCorsAjaxTransport() {
	            var xhrOrXdr;
	            if (window.XMLHttpRequest || window.ActiveXObject) {
	                xhrOrXdr = qq.createXhrInstance();
	                if (xhrOrXdr.withCredentials === undefined) {
	                    xhrOrXdr = new XDomainRequest();
	                    xhrOrXdr.onload = function() {};
	                    xhrOrXdr.onerror = function() {};
	                    xhrOrXdr.ontimeout = function() {};
	                    xhrOrXdr.onprogress = function() {};
	                }
	            }
	            return xhrOrXdr;
	        }
	        function getXhrOrXdr(id, suppliedXhr) {
	            var xhrOrXdr = requestData[id].xhr;
	            if (!xhrOrXdr) {
	                if (suppliedXhr) {
	                    xhrOrXdr = suppliedXhr;
	                } else {
	                    if (options.cors.expected) {
	                        xhrOrXdr = getCorsAjaxTransport();
	                    } else {
	                        xhrOrXdr = qq.createXhrInstance();
	                    }
	                }
	                requestData[id].xhr = xhrOrXdr;
	            }
	            return xhrOrXdr;
	        }
	        function dequeue(id) {
	            var i = qq.indexOf(queue, id), max = options.maxConnections, nextId;
	            delete requestData[id];
	            queue.splice(i, 1);
	            if (queue.length >= max && i < max) {
	                nextId = queue[max - 1];
	                sendRequest(nextId);
	            }
	        }
	        function onComplete(id, xdrError) {
	            var xhr = getXhrOrXdr(id), method = options.method, isError = xdrError === true;
	            dequeue(id);
	            if (isError) {
	                log(method + " request for " + id + " has failed", "error");
	            } else if (!isXdr(xhr) && !isResponseSuccessful(xhr.status)) {
	                isError = true;
	                log(method + " request for " + id + " has failed - response code " + xhr.status, "error");
	            }
	            options.onComplete(id, xhr, isError);
	        }
	        function getParams(id) {
	            var onDemandParams = requestData[id].additionalParams, mandatedParams = options.mandatedParams, params;
	            if (options.paramsStore.get) {
	                params = options.paramsStore.get(id);
	            }
	            if (onDemandParams) {
	                qq.each(onDemandParams, function(name, val) {
	                    params = params || {};
	                    params[name] = val;
	                });
	            }
	            if (mandatedParams) {
	                qq.each(mandatedParams, function(name, val) {
	                    params = params || {};
	                    params[name] = val;
	                });
	            }
	            return params;
	        }
	        function sendRequest(id, optXhr) {
	            var xhr = getXhrOrXdr(id, optXhr), method = options.method, params = getParams(id), payload = requestData[id].payload, url;
	            options.onSend(id);
	            url = createUrl(id, params, requestData[id].additionalQueryParams);
	            if (isXdr(xhr)) {
	                xhr.onload = getXdrLoadHandler(id);
	                xhr.onerror = getXdrErrorHandler(id);
	            } else {
	                xhr.onreadystatechange = getXhrReadyStateChangeHandler(id);
	            }
	            registerForUploadProgress(id);
	            xhr.open(method, url, true);
	            if (options.cors.expected && options.cors.sendCredentials && !isXdr(xhr)) {
	                xhr.withCredentials = true;
	            }
	            setHeaders(id);
	            log("Sending " + method + " request for " + id);
	            if (payload) {
	                xhr.send(payload);
	            } else if (shouldParamsBeInQueryString || !params) {
	                xhr.send();
	            } else if (params && options.contentType && options.contentType.toLowerCase().indexOf("application/x-www-form-urlencoded") >= 0) {
	                xhr.send(qq.obj2url(params, ""));
	            } else if (params && options.contentType && options.contentType.toLowerCase().indexOf("application/json") >= 0) {
	                xhr.send(JSON.stringify(params));
	            } else {
	                xhr.send(params);
	            }
	            return xhr;
	        }
	        function createUrl(id, params, additionalQueryParams) {
	            var endpoint = options.endpointStore.get(id), addToPath = requestData[id].addToPath;
	            if (addToPath != undefined) {
	                endpoint += "/" + addToPath;
	            }
	            if (shouldParamsBeInQueryString && params) {
	                endpoint = qq.obj2url(params, endpoint);
	            }
	            if (additionalQueryParams) {
	                endpoint = qq.obj2url(additionalQueryParams, endpoint);
	            }
	            return endpoint;
	        }
	        function getXhrReadyStateChangeHandler(id) {
	            return function() {
	                if (getXhrOrXdr(id).readyState === 4) {
	                    onComplete(id);
	                }
	            };
	        }
	        function registerForUploadProgress(id) {
	            var onProgress = options.onProgress;
	            if (onProgress) {
	                getXhrOrXdr(id).upload.onprogress = function(e) {
	                    if (e.lengthComputable) {
	                        onProgress(id, e.loaded, e.total);
	                    }
	                };
	            }
	        }
	        function getXdrLoadHandler(id) {
	            return function() {
	                onComplete(id);
	            };
	        }
	        function getXdrErrorHandler(id) {
	            return function() {
	                onComplete(id, true);
	            };
	        }
	        function setHeaders(id) {
	            var xhr = getXhrOrXdr(id), customHeaders = options.customHeaders, onDemandHeaders = requestData[id].additionalHeaders || {}, method = options.method, allHeaders = {};
	            if (!isXdr(xhr)) {
	                options.acceptHeader && xhr.setRequestHeader("Accept", options.acceptHeader);
	                if (options.allowXRequestedWithAndCacheControl) {
	                    if (!options.cors.expected || (!isSimpleMethod() || containsNonSimpleHeaders(customHeaders))) {
	                        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	                        xhr.setRequestHeader("Cache-Control", "no-cache");
	                    }
	                }
	                if (options.contentType && (method === "POST" || method === "PUT")) {
	                    xhr.setRequestHeader("Content-Type", options.contentType);
	                }
	                qq.extend(allHeaders, qq.isFunction(customHeaders) ? customHeaders(id) : customHeaders);
	                qq.extend(allHeaders, onDemandHeaders);
	                qq.each(allHeaders, function(name, val) {
	                    xhr.setRequestHeader(name, val);
	                });
	            }
	        }
	        function isResponseSuccessful(responseCode) {
	            return qq.indexOf(options.successfulResponseCodes[options.method], responseCode) >= 0;
	        }
	        function prepareToSend(id, optXhr, addToPath, additionalParams, additionalQueryParams, additionalHeaders, payload) {
	            requestData[id] = {
	                addToPath: addToPath,
	                additionalParams: additionalParams,
	                additionalQueryParams: additionalQueryParams,
	                additionalHeaders: additionalHeaders,
	                payload: payload
	            };
	            var len = queue.push(id);
	            if (len <= options.maxConnections) {
	                return sendRequest(id, optXhr);
	            }
	        }
	        shouldParamsBeInQueryString = options.method === "GET" || options.method === "DELETE";
	        qq.extend(this, {
	            initTransport: function(id) {
	                var path, params, headers, payload, cacheBuster, additionalQueryParams;
	                return {
	                    withPath: function(appendToPath) {
	                        path = appendToPath;
	                        return this;
	                    },
	                    withParams: function(additionalParams) {
	                        params = additionalParams;
	                        return this;
	                    },
	                    withQueryParams: function(_additionalQueryParams_) {
	                        additionalQueryParams = _additionalQueryParams_;
	                        return this;
	                    },
	                    withHeaders: function(additionalHeaders) {
	                        headers = additionalHeaders;
	                        return this;
	                    },
	                    withPayload: function(thePayload) {
	                        payload = thePayload;
	                        return this;
	                    },
	                    withCacheBuster: function() {
	                        cacheBuster = true;
	                        return this;
	                    },
	                    send: function(optXhr) {
	                        if (cacheBuster && qq.indexOf([ "GET", "DELETE" ], options.method) >= 0) {
	                            params.qqtimestamp = new Date().getTime();
	                        }
	                        return prepareToSend(id, optXhr, path, params, additionalQueryParams, headers, payload);
	                    }
	                };
	            },
	            canceled: function(id) {
	                dequeue(id);
	            }
	        });
	    };
	    qq.UploadHandler = function(spec) {
	        "use strict";
	        var proxy = spec.proxy, fileState = {}, onCancel = proxy.onCancel, getName = proxy.getName;
	        qq.extend(this, {
	            add: function(id, fileItem) {
	                fileState[id] = fileItem;
	                fileState[id].temp = {};
	            },
	            cancel: function(id) {
	                var self = this, cancelFinalizationEffort = new qq.Promise(), onCancelRetVal = onCancel(id, getName(id), cancelFinalizationEffort);
	                onCancelRetVal.then(function() {
	                    if (self.isValid(id)) {
	                        fileState[id].canceled = true;
	                        self.expunge(id);
	                    }
	                    cancelFinalizationEffort.success();
	                });
	            },
	            expunge: function(id) {
	                delete fileState[id];
	            },
	            getThirdPartyFileId: function(id) {
	                return fileState[id].key;
	            },
	            isValid: function(id) {
	                return fileState[id] !== undefined;
	            },
	            reset: function() {
	                fileState = {};
	            },
	            _getFileState: function(id) {
	                return fileState[id];
	            },
	            _setThirdPartyFileId: function(id, thirdPartyFileId) {
	                fileState[id].key = thirdPartyFileId;
	            },
	            _wasCanceled: function(id) {
	                return !!fileState[id].canceled;
	            }
	        });
	    };
	    qq.UploadHandlerController = function(o, namespace) {
	        "use strict";
	        var controller = this, chunkingPossible = false, concurrentChunkingPossible = false, chunking, preventRetryResponse, log, handler, options = {
	            paramsStore: {},
	            maxConnections: 3,
	            chunking: {
	                enabled: false,
	                multiple: {
	                    enabled: false
	                }
	            },
	            log: function(str, level) {},
	            onProgress: function(id, fileName, loaded, total) {},
	            onComplete: function(id, fileName, response, xhr) {},
	            onCancel: function(id, fileName) {},
	            onUploadPrep: function(id) {},
	            onUpload: function(id, fileName) {},
	            onUploadChunk: function(id, fileName, chunkData) {},
	            onUploadChunkSuccess: function(id, chunkData, response, xhr) {},
	            onAutoRetry: function(id, fileName, response, xhr) {},
	            onResume: function(id, fileName, chunkData) {},
	            onUuidChanged: function(id, newUuid) {},
	            getName: function(id) {},
	            setSize: function(id, newSize) {},
	            isQueued: function(id) {},
	            getIdsInProxyGroup: function(id) {},
	            getIdsInBatch: function(id) {}
	        }, chunked = {
	            done: function(id, chunkIdx, response, xhr) {
	                var chunkData = handler._getChunkData(id, chunkIdx);
	                handler._getFileState(id).attemptingResume = false;
	                delete handler._getFileState(id).temp.chunkProgress[chunkIdx];
	                handler._getFileState(id).loaded += chunkData.size;
	                options.onUploadChunkSuccess(id, handler._getChunkDataForCallback(chunkData), response, xhr);
	            },
	            finalize: function(id) {
	                var size = options.getSize(id), name = options.getName(id);
	                log("All chunks have been uploaded for " + id + " - finalizing....");
	                handler.finalizeChunks(id).then(function(response, xhr) {
	                    log("Finalize successful for " + id);
	                    var normaizedResponse = upload.normalizeResponse(response, true);
	                    options.onProgress(id, name, size, size);
	                    handler._maybeDeletePersistedChunkData(id);
	                    upload.cleanup(id, normaizedResponse, xhr);
	                }, function(response, xhr) {
	                    var normaizedResponse = upload.normalizeResponse(response, false);
	                    log("Problem finalizing chunks for file ID " + id + " - " + normaizedResponse.error, "error");
	                    if (normaizedResponse.reset) {
	                        chunked.reset(id);
	                    }
	                    if (!options.onAutoRetry(id, name, normaizedResponse, xhr)) {
	                        upload.cleanup(id, normaizedResponse, xhr);
	                    }
	                });
	            },
	            handleFailure: function(chunkIdx, id, response, xhr) {
	                var name = options.getName(id);
	                log("Chunked upload request failed for " + id + ", chunk " + chunkIdx);
	                handler.clearCachedChunk(id, chunkIdx);
	                var responseToReport = upload.normalizeResponse(response, false), inProgressIdx;
	                if (responseToReport.reset) {
	                    chunked.reset(id);
	                } else {
	                    inProgressIdx = qq.indexOf(handler._getFileState(id).chunking.inProgress, chunkIdx);
	                    if (inProgressIdx >= 0) {
	                        handler._getFileState(id).chunking.inProgress.splice(inProgressIdx, 1);
	                        handler._getFileState(id).chunking.remaining.unshift(chunkIdx);
	                    }
	                }
	                if (!handler._getFileState(id).temp.ignoreFailure) {
	                    if (concurrentChunkingPossible) {
	                        handler._getFileState(id).temp.ignoreFailure = true;
	                        log(qq.format("Going to attempt to abort these chunks: {}. These are currently in-progress: {}.", JSON.stringify(Object.keys(handler._getXhrs(id))), JSON.stringify(handler._getFileState(id).chunking.inProgress)));
	                        qq.each(handler._getXhrs(id), function(ckid, ckXhr) {
	                            log(qq.format("Attempting to abort file {}.{}. XHR readyState {}. ", id, ckid, ckXhr.readyState));
	                            ckXhr.abort();
	                            ckXhr._cancelled = true;
	                        });
	                        handler.moveInProgressToRemaining(id);
	                        connectionManager.free(id, true);
	                    }
	                    if (!options.onAutoRetry(id, name, responseToReport, xhr)) {
	                        upload.cleanup(id, responseToReport, xhr);
	                    }
	                }
	            },
	            hasMoreParts: function(id) {
	                return !!handler._getFileState(id).chunking.remaining.length;
	            },
	            nextPart: function(id) {
	                var nextIdx = handler._getFileState(id).chunking.remaining.shift();
	                if (nextIdx >= handler._getTotalChunks(id)) {
	                    nextIdx = null;
	                }
	                return nextIdx;
	            },
	            reset: function(id) {
	                log("Server or callback has ordered chunking effort to be restarted on next attempt for item ID " + id, "error");
	                handler._maybeDeletePersistedChunkData(id);
	                handler.reevaluateChunking(id);
	                handler._getFileState(id).loaded = 0;
	            },
	            sendNext: function(id) {
	                var size = options.getSize(id), name = options.getName(id), chunkIdx = chunked.nextPart(id), chunkData = handler._getChunkData(id, chunkIdx), resuming = handler._getFileState(id).attemptingResume, inProgressChunks = handler._getFileState(id).chunking.inProgress || [];
	                if (handler._getFileState(id).loaded == null) {
	                    handler._getFileState(id).loaded = 0;
	                }
	                if (resuming && options.onResume(id, name, chunkData) === false) {
	                    chunked.reset(id);
	                    chunkIdx = chunked.nextPart(id);
	                    chunkData = handler._getChunkData(id, chunkIdx);
	                    resuming = false;
	                }
	                if (chunkIdx == null && inProgressChunks.length === 0) {
	                    chunked.finalize(id);
	                } else {
	                    log(qq.format("Sending chunked upload request for item {}.{}, bytes {}-{} of {}.", id, chunkIdx, chunkData.start + 1, chunkData.end, size));
	                    options.onUploadChunk(id, name, handler._getChunkDataForCallback(chunkData));
	                    inProgressChunks.push(chunkIdx);
	                    handler._getFileState(id).chunking.inProgress = inProgressChunks;
	                    if (concurrentChunkingPossible) {
	                        connectionManager.open(id, chunkIdx);
	                    }
	                    if (concurrentChunkingPossible && connectionManager.available() && handler._getFileState(id).chunking.remaining.length) {
	                        chunked.sendNext(id);
	                    }
	                    if (chunkData.blob.size === 0) {
	                        log(qq.format("Chunk {} for file {} will not be uploaded, zero sized chunk.", chunkIdx, id), "error");
	                        chunked.handleFailure(chunkIdx, id, "File is no longer available", null);
	                    } else {
	                        handler.uploadChunk(id, chunkIdx, resuming).then(function success(response, xhr) {
	                            log("Chunked upload request succeeded for " + id + ", chunk " + chunkIdx);
	                            handler.clearCachedChunk(id, chunkIdx);
	                            var inProgressChunks = handler._getFileState(id).chunking.inProgress || [], responseToReport = upload.normalizeResponse(response, true), inProgressChunkIdx = qq.indexOf(inProgressChunks, chunkIdx);
	                            log(qq.format("Chunk {} for file {} uploaded successfully.", chunkIdx, id));
	                            chunked.done(id, chunkIdx, responseToReport, xhr);
	                            if (inProgressChunkIdx >= 0) {
	                                inProgressChunks.splice(inProgressChunkIdx, 1);
	                            }
	                            handler._maybePersistChunkedState(id);
	                            if (!chunked.hasMoreParts(id) && inProgressChunks.length === 0) {
	                                chunked.finalize(id);
	                            } else if (chunked.hasMoreParts(id)) {
	                                chunked.sendNext(id);
	                            } else {
	                                log(qq.format("File ID {} has no more chunks to send and these chunk indexes are still marked as in-progress: {}", id, JSON.stringify(inProgressChunks)));
	                            }
	                        }, function failure(response, xhr) {
	                            chunked.handleFailure(chunkIdx, id, response, xhr);
	                        }).done(function() {
	                            handler.clearXhr(id, chunkIdx);
	                        });
	                    }
	                }
	            }
	        }, connectionManager = {
	            _open: [],
	            _openChunks: {},
	            _waiting: [],
	            available: function() {
	                var max = options.maxConnections, openChunkEntriesCount = 0, openChunksCount = 0;
	                qq.each(connectionManager._openChunks, function(fileId, openChunkIndexes) {
	                    openChunkEntriesCount++;
	                    openChunksCount += openChunkIndexes.length;
	                });
	                return max - (connectionManager._open.length - openChunkEntriesCount + openChunksCount);
	            },
	            free: function(id, dontAllowNext) {
	                var allowNext = !dontAllowNext, waitingIndex = qq.indexOf(connectionManager._waiting, id), connectionsIndex = qq.indexOf(connectionManager._open, id), nextId;
	                delete connectionManager._openChunks[id];
	                if (upload.getProxyOrBlob(id) instanceof qq.BlobProxy) {
	                    log("Generated blob upload has ended for " + id + ", disposing generated blob.");
	                    delete handler._getFileState(id).file;
	                }
	                if (waitingIndex >= 0) {
	                    connectionManager._waiting.splice(waitingIndex, 1);
	                } else if (allowNext && connectionsIndex >= 0) {
	                    connectionManager._open.splice(connectionsIndex, 1);
	                    nextId = connectionManager._waiting.shift();
	                    if (nextId >= 0) {
	                        connectionManager._open.push(nextId);
	                        upload.start(nextId);
	                    }
	                }
	            },
	            getWaitingOrConnected: function() {
	                var waitingOrConnected = [];
	                qq.each(connectionManager._openChunks, function(fileId, chunks) {
	                    if (chunks && chunks.length) {
	                        waitingOrConnected.push(parseInt(fileId));
	                    }
	                });
	                qq.each(connectionManager._open, function(idx, fileId) {
	                    if (!connectionManager._openChunks[fileId]) {
	                        waitingOrConnected.push(parseInt(fileId));
	                    }
	                });
	                waitingOrConnected = waitingOrConnected.concat(connectionManager._waiting);
	                return waitingOrConnected;
	            },
	            isUsingConnection: function(id) {
	                return qq.indexOf(connectionManager._open, id) >= 0;
	            },
	            open: function(id, chunkIdx) {
	                if (chunkIdx == null) {
	                    connectionManager._waiting.push(id);
	                }
	                if (connectionManager.available()) {
	                    if (chunkIdx == null) {
	                        connectionManager._waiting.pop();
	                        connectionManager._open.push(id);
	                    } else {
	                        (function() {
	                            var openChunksEntry = connectionManager._openChunks[id] || [];
	                            openChunksEntry.push(chunkIdx);
	                            connectionManager._openChunks[id] = openChunksEntry;
	                        })();
	                    }
	                    return true;
	                }
	                return false;
	            },
	            reset: function() {
	                connectionManager._waiting = [];
	                connectionManager._open = [];
	            }
	        }, simple = {
	            send: function(id, name) {
	                handler._getFileState(id).loaded = 0;
	                log("Sending simple upload request for " + id);
	                handler.uploadFile(id).then(function(response, optXhr) {
	                    log("Simple upload request succeeded for " + id);
	                    var responseToReport = upload.normalizeResponse(response, true), size = options.getSize(id);
	                    options.onProgress(id, name, size, size);
	                    upload.maybeNewUuid(id, responseToReport);
	                    upload.cleanup(id, responseToReport, optXhr);
	                }, function(response, optXhr) {
	                    log("Simple upload request failed for " + id);
	                    var responseToReport = upload.normalizeResponse(response, false);
	                    if (!options.onAutoRetry(id, name, responseToReport, optXhr)) {
	                        upload.cleanup(id, responseToReport, optXhr);
	                    }
	                });
	            }
	        }, upload = {
	            cancel: function(id) {
	                log("Cancelling " + id);
	                options.paramsStore.remove(id);
	                connectionManager.free(id);
	            },
	            cleanup: function(id, response, optXhr) {
	                var name = options.getName(id);
	                options.onComplete(id, name, response, optXhr);
	                if (handler._getFileState(id)) {
	                    handler._clearXhrs && handler._clearXhrs(id);
	                }
	                connectionManager.free(id);
	            },
	            getProxyOrBlob: function(id) {
	                return handler.getProxy && handler.getProxy(id) || handler.getFile && handler.getFile(id);
	            },
	            initHandler: function() {
	                var handlerType = namespace ? qq[namespace] : qq.traditional, handlerModuleSubtype = qq.supportedFeatures.ajaxUploading ? "Xhr" : "Form";
	                handler = new handlerType[handlerModuleSubtype + "UploadHandler"](options, {
	                    getDataByUuid: options.getDataByUuid,
	                    getName: options.getName,
	                    getSize: options.getSize,
	                    getUuid: options.getUuid,
	                    log: log,
	                    onCancel: options.onCancel,
	                    onProgress: options.onProgress,
	                    onUuidChanged: options.onUuidChanged
	                });
	                if (handler._removeExpiredChunkingRecords) {
	                    handler._removeExpiredChunkingRecords();
	                }
	            },
	            isDeferredEligibleForUpload: function(id) {
	                return options.isQueued(id);
	            },
	            maybeDefer: function(id, blob) {
	                if (blob && !handler.getFile(id) && blob instanceof qq.BlobProxy) {
	                    options.onUploadPrep(id);
	                    log("Attempting to generate a blob on-demand for " + id);
	                    blob.create().then(function(generatedBlob) {
	                        log("Generated an on-demand blob for " + id);
	                        handler.updateBlob(id, generatedBlob);
	                        options.setSize(id, generatedBlob.size);
	                        handler.reevaluateChunking(id);
	                        upload.maybeSendDeferredFiles(id);
	                    }, function(errorMessage) {
	                        var errorResponse = {};
	                        if (errorMessage) {
	                            errorResponse.error = errorMessage;
	                        }
	                        log(qq.format("Failed to generate blob for ID {}.  Error message: {}.", id, errorMessage), "error");
	                        options.onComplete(id, options.getName(id), qq.extend(errorResponse, preventRetryResponse), null);
	                        upload.maybeSendDeferredFiles(id);
	                        connectionManager.free(id);
	                    });
	                } else {
	                    return upload.maybeSendDeferredFiles(id);
	                }
	                return false;
	            },
	            maybeSendDeferredFiles: function(id) {
	                var idsInGroup = options.getIdsInProxyGroup(id), uploadedThisId = false;
	                if (idsInGroup && idsInGroup.length) {
	                    log("Maybe ready to upload proxy group file " + id);
	                    qq.each(idsInGroup, function(idx, idInGroup) {
	                        if (upload.isDeferredEligibleForUpload(idInGroup) && !!handler.getFile(idInGroup)) {
	                            uploadedThisId = idInGroup === id;
	                            upload.now(idInGroup);
	                        } else if (upload.isDeferredEligibleForUpload(idInGroup)) {
	                            return false;
	                        }
	                    });
	                } else {
	                    uploadedThisId = true;
	                    upload.now(id);
	                }
	                return uploadedThisId;
	            },
	            maybeNewUuid: function(id, response) {
	                if (response.newUuid !== undefined) {
	                    options.onUuidChanged(id, response.newUuid);
	                }
	            },
	            normalizeResponse: function(originalResponse, successful) {
	                var response = originalResponse;
	                if (!qq.isObject(originalResponse)) {
	                    response = {};
	                    if (qq.isString(originalResponse) && !successful) {
	                        response.error = originalResponse;
	                    }
	                }
	                response.success = successful;
	                return response;
	            },
	            now: function(id) {
	                var name = options.getName(id);
	                if (!controller.isValid(id)) {
	                    throw new qq.Error(id + " is not a valid file ID to upload!");
	                }
	                options.onUpload(id, name);
	                if (chunkingPossible && handler._shouldChunkThisFile(id)) {
	                    chunked.sendNext(id);
	                } else {
	                    simple.send(id, name);
	                }
	            },
	            start: function(id) {
	                var blobToUpload = upload.getProxyOrBlob(id);
	                if (blobToUpload) {
	                    return upload.maybeDefer(id, blobToUpload);
	                } else {
	                    upload.now(id);
	                    return true;
	                }
	            }
	        };
	        qq.extend(this, {
	            add: function(id, file) {
	                handler.add.apply(this, arguments);
	            },
	            upload: function(id) {
	                if (connectionManager.open(id)) {
	                    return upload.start(id);
	                }
	                return false;
	            },
	            retry: function(id) {
	                if (concurrentChunkingPossible) {
	                    handler._getFileState(id).temp.ignoreFailure = false;
	                }
	                if (connectionManager.isUsingConnection(id)) {
	                    return upload.start(id);
	                } else {
	                    return controller.upload(id);
	                }
	            },
	            cancel: function(id) {
	                var cancelRetVal = handler.cancel(id);
	                if (qq.isGenericPromise(cancelRetVal)) {
	                    cancelRetVal.then(function() {
	                        upload.cancel(id);
	                    });
	                } else if (cancelRetVal !== false) {
	                    upload.cancel(id);
	                }
	            },
	            cancelAll: function() {
	                var waitingOrConnected = connectionManager.getWaitingOrConnected(), i;
	                if (waitingOrConnected.length) {
	                    for (i = waitingOrConnected.length - 1; i >= 0; i--) {
	                        controller.cancel(waitingOrConnected[i]);
	                    }
	                }
	                connectionManager.reset();
	            },
	            getFile: function(id) {
	                if (handler.getProxy && handler.getProxy(id)) {
	                    return handler.getProxy(id).referenceBlob;
	                }
	                return handler.getFile && handler.getFile(id);
	            },
	            isProxied: function(id) {
	                return !!(handler.getProxy && handler.getProxy(id));
	            },
	            getInput: function(id) {
	                if (handler.getInput) {
	                    return handler.getInput(id);
	                }
	            },
	            reset: function() {
	                log("Resetting upload handler");
	                controller.cancelAll();
	                connectionManager.reset();
	                handler.reset();
	            },
	            expunge: function(id) {
	                if (controller.isValid(id)) {
	                    return handler.expunge(id);
	                }
	            },
	            isValid: function(id) {
	                return handler.isValid(id);
	            },
	            getResumableFilesData: function() {
	                if (handler.getResumableFilesData) {
	                    return handler.getResumableFilesData();
	                }
	                return [];
	            },
	            getThirdPartyFileId: function(id) {
	                if (controller.isValid(id)) {
	                    return handler.getThirdPartyFileId(id);
	                }
	            },
	            pause: function(id) {
	                if (controller.isResumable(id) && handler.pause && controller.isValid(id) && handler.pause(id)) {
	                    connectionManager.free(id);
	                    handler.moveInProgressToRemaining(id);
	                    return true;
	                }
	                return false;
	            },
	            isResumable: function(id) {
	                return !!handler.isResumable && handler.isResumable(id);
	            }
	        });
	        qq.extend(options, o);
	        log = options.log;
	        chunkingPossible = options.chunking.enabled && qq.supportedFeatures.chunking;
	        concurrentChunkingPossible = chunkingPossible && options.chunking.concurrent.enabled;
	        preventRetryResponse = function() {
	            var response = {};
	            response[options.preventRetryParam] = true;
	            return response;
	        }();
	        upload.initHandler();
	    };
	    qq.WindowReceiveMessage = function(o) {
	        "use strict";
	        var options = {
	            log: function(message, level) {}
	        }, callbackWrapperDetachers = {};
	        qq.extend(options, o);
	        qq.extend(this, {
	            receiveMessage: function(id, callback) {
	                var onMessageCallbackWrapper = function(event) {
	                    callback(event.data);
	                };
	                if (window.postMessage) {
	                    callbackWrapperDetachers[id] = qq(window).attach("message", onMessageCallbackWrapper);
	                } else {
	                    log("iframe message passing not supported in this browser!", "error");
	                }
	            },
	            stopReceivingMessages: function(id) {
	                if (window.postMessage) {
	                    var detacher = callbackWrapperDetachers[id];
	                    if (detacher) {
	                        detacher();
	                    }
	                }
	            }
	        });
	    };
	    qq.FormUploadHandler = function(spec) {
	        "use strict";
	        var options = spec.options, handler = this, proxy = spec.proxy, formHandlerInstanceId = qq.getUniqueId(), onloadCallbacks = {}, detachLoadEvents = {}, postMessageCallbackTimers = {}, isCors = options.isCors, inputName = options.inputName, getUuid = proxy.getUuid, log = proxy.log, corsMessageReceiver = new qq.WindowReceiveMessage({
	            log: log
	        });
	        function expungeFile(id) {
	            delete detachLoadEvents[id];
	            if (isCors) {
	                clearTimeout(postMessageCallbackTimers[id]);
	                delete postMessageCallbackTimers[id];
	                corsMessageReceiver.stopReceivingMessages(id);
	            }
	            var iframe = document.getElementById(handler._getIframeName(id));
	            if (iframe) {
	                iframe.setAttribute("src", "javascript:false;");
	                qq(iframe).remove();
	            }
	        }
	        function getFileIdForIframeName(iframeName) {
	            return iframeName.split("_")[0];
	        }
	        function initIframeForUpload(name) {
	            var iframe = qq.toElement("<iframe src='javascript:false;' name='" + name + "' />");
	            iframe.setAttribute("id", name);
	            iframe.style.display = "none";
	            document.body.appendChild(iframe);
	            return iframe;
	        }
	        function registerPostMessageCallback(iframe, callback) {
	            var iframeName = iframe.id, fileId = getFileIdForIframeName(iframeName), uuid = getUuid(fileId);
	            onloadCallbacks[uuid] = callback;
	            detachLoadEvents[fileId] = qq(iframe).attach("load", function() {
	                if (handler.getInput(fileId)) {
	                    log("Received iframe load event for CORS upload request (iframe name " + iframeName + ")");
	                    postMessageCallbackTimers[iframeName] = setTimeout(function() {
	                        var errorMessage = "No valid message received from loaded iframe for iframe name " + iframeName;
	                        log(errorMessage, "error");
	                        callback({
	                            error: errorMessage
	                        });
	                    }, 1e3);
	                }
	            });
	            corsMessageReceiver.receiveMessage(iframeName, function(message) {
	                log("Received the following window message: '" + message + "'");
	                var fileId = getFileIdForIframeName(iframeName), response = handler._parseJsonResponse(message), uuid = response.uuid, onloadCallback;
	                if (uuid && onloadCallbacks[uuid]) {
	                    log("Handling response for iframe name " + iframeName);
	                    clearTimeout(postMessageCallbackTimers[iframeName]);
	                    delete postMessageCallbackTimers[iframeName];
	                    handler._detachLoadEvent(iframeName);
	                    onloadCallback = onloadCallbacks[uuid];
	                    delete onloadCallbacks[uuid];
	                    corsMessageReceiver.stopReceivingMessages(iframeName);
	                    onloadCallback(response);
	                } else if (!uuid) {
	                    log("'" + message + "' does not contain a UUID - ignoring.");
	                }
	            });
	        }
	        qq.extend(this, new qq.UploadHandler(spec));
	        qq.override(this, function(super_) {
	            return {
	                add: function(id, fileInput) {
	                    super_.add(id, {
	                        input: fileInput
	                    });
	                    fileInput.setAttribute("name", inputName);
	                    if (fileInput.parentNode) {
	                        qq(fileInput).remove();
	                    }
	                },
	                expunge: function(id) {
	                    expungeFile(id);
	                    super_.expunge(id);
	                },
	                isValid: function(id) {
	                    return super_.isValid(id) && handler._getFileState(id).input !== undefined;
	                }
	            };
	        });
	        qq.extend(this, {
	            getInput: function(id) {
	                return handler._getFileState(id).input;
	            },
	            _attachLoadEvent: function(iframe, callback) {
	                var responseDescriptor;
	                if (isCors) {
	                    registerPostMessageCallback(iframe, callback);
	                } else {
	                    detachLoadEvents[iframe.id] = qq(iframe).attach("load", function() {
	                        log("Received response for " + iframe.id);
	                        if (!iframe.parentNode) {
	                            return;
	                        }
	                        try {
	                            if (iframe.contentDocument && iframe.contentDocument.body && iframe.contentDocument.body.innerHTML == "false") {
	                                return;
	                            }
	                        } catch (error) {
	                            log("Error when attempting to access iframe during handling of upload response (" + error.message + ")", "error");
	                            responseDescriptor = {
	                                success: false
	                            };
	                        }
	                        callback(responseDescriptor);
	                    });
	                }
	            },
	            _createIframe: function(id) {
	                var iframeName = handler._getIframeName(id);
	                return initIframeForUpload(iframeName);
	            },
	            _detachLoadEvent: function(id) {
	                if (detachLoadEvents[id] !== undefined) {
	                    detachLoadEvents[id]();
	                    delete detachLoadEvents[id];
	                }
	            },
	            _getIframeName: function(fileId) {
	                return fileId + "_" + formHandlerInstanceId;
	            },
	            _initFormForUpload: function(spec) {
	                var method = spec.method, endpoint = spec.endpoint, params = spec.params, paramsInBody = spec.paramsInBody, targetName = spec.targetName, form = qq.toElement("<form method='" + method + "' enctype='multipart/form-data'></form>"), url = endpoint;
	                if (paramsInBody) {
	                    qq.obj2Inputs(params, form);
	                } else {
	                    url = qq.obj2url(params, endpoint);
	                }
	                form.setAttribute("action", url);
	                form.setAttribute("target", targetName);
	                form.style.display = "none";
	                document.body.appendChild(form);
	                return form;
	            },
	            _parseJsonResponse: function(innerHtmlOrMessage) {
	                var response = {};
	                try {
	                    response = qq.parseJson(innerHtmlOrMessage);
	                } catch (error) {
	                    log("Error when attempting to parse iframe upload response (" + error.message + ")", "error");
	                }
	                return response;
	            }
	        });
	    };
	    qq.XhrUploadHandler = function(spec) {
	        "use strict";
	        var handler = this, namespace = spec.options.namespace, proxy = spec.proxy, chunking = spec.options.chunking, resume = spec.options.resume, chunkFiles = chunking && spec.options.chunking.enabled && qq.supportedFeatures.chunking, resumeEnabled = resume && spec.options.resume.enabled && chunkFiles && qq.supportedFeatures.resume, getName = proxy.getName, getSize = proxy.getSize, getUuid = proxy.getUuid, getEndpoint = proxy.getEndpoint, getDataByUuid = proxy.getDataByUuid, onUuidChanged = proxy.onUuidChanged, onProgress = proxy.onProgress, log = proxy.log;
	        function abort(id) {
	            qq.each(handler._getXhrs(id), function(xhrId, xhr) {
	                var ajaxRequester = handler._getAjaxRequester(id, xhrId);
	                xhr.onreadystatechange = null;
	                xhr.upload.onprogress = null;
	                xhr.abort();
	                ajaxRequester && ajaxRequester.canceled && ajaxRequester.canceled(id);
	            });
	        }
	        qq.extend(this, new qq.UploadHandler(spec));
	        qq.override(this, function(super_) {
	            return {
	                add: function(id, blobOrProxy) {
	                    if (qq.isFile(blobOrProxy) || qq.isBlob(blobOrProxy)) {
	                        super_.add(id, {
	                            file: blobOrProxy
	                        });
	                    } else if (blobOrProxy instanceof qq.BlobProxy) {
	                        super_.add(id, {
	                            proxy: blobOrProxy
	                        });
	                    } else {
	                        throw new Error("Passed obj is not a File, Blob, or proxy");
	                    }
	                    handler._initTempState(id);
	                    resumeEnabled && handler._maybePrepareForResume(id);
	                },
	                expunge: function(id) {
	                    abort(id);
	                    handler._maybeDeletePersistedChunkData(id);
	                    handler._clearXhrs(id);
	                    super_.expunge(id);
	                }
	            };
	        });
	        qq.extend(this, {
	            clearCachedChunk: function(id, chunkIdx) {
	                delete handler._getFileState(id).temp.cachedChunks[chunkIdx];
	            },
	            clearXhr: function(id, chunkIdx) {
	                var tempState = handler._getFileState(id).temp;
	                if (tempState.xhrs) {
	                    delete tempState.xhrs[chunkIdx];
	                }
	                if (tempState.ajaxRequesters) {
	                    delete tempState.ajaxRequesters[chunkIdx];
	                }
	            },
	            finalizeChunks: function(id, responseParser) {
	                var lastChunkIdx = handler._getTotalChunks(id) - 1, xhr = handler._getXhr(id, lastChunkIdx);
	                if (responseParser) {
	                    return new qq.Promise().success(responseParser(xhr), xhr);
	                }
	                return new qq.Promise().success({}, xhr);
	            },
	            getFile: function(id) {
	                return handler.isValid(id) && handler._getFileState(id).file;
	            },
	            getProxy: function(id) {
	                return handler.isValid(id) && handler._getFileState(id).proxy;
	            },
	            getResumableFilesData: function() {
	                var resumableFilesData = [];
	                handler._iterateResumeRecords(function(key, uploadData) {
	                    handler.moveInProgressToRemaining(null, uploadData.chunking.inProgress, uploadData.chunking.remaining);
	                    var data = {
	                        name: uploadData.name,
	                        remaining: uploadData.chunking.remaining,
	                        size: uploadData.size,
	                        uuid: uploadData.uuid
	                    };
	                    if (uploadData.key) {
	                        data.key = uploadData.key;
	                    }
	                    resumableFilesData.push(data);
	                });
	                return resumableFilesData;
	            },
	            isResumable: function(id) {
	                return !!chunking && handler.isValid(id) && !handler._getFileState(id).notResumable;
	            },
	            moveInProgressToRemaining: function(id, optInProgress, optRemaining) {
	                var inProgress = optInProgress || handler._getFileState(id).chunking.inProgress, remaining = optRemaining || handler._getFileState(id).chunking.remaining;
	                if (inProgress) {
	                    log(qq.format("Moving these chunks from in-progress {}, to remaining.", JSON.stringify(inProgress)));
	                    inProgress.reverse();
	                    qq.each(inProgress, function(idx, chunkIdx) {
	                        remaining.unshift(chunkIdx);
	                    });
	                    inProgress.length = 0;
	                }
	            },
	            pause: function(id) {
	                if (handler.isValid(id)) {
	                    log(qq.format("Aborting XHR upload for {} '{}' due to pause instruction.", id, getName(id)));
	                    handler._getFileState(id).paused = true;
	                    abort(id);
	                    return true;
	                }
	            },
	            reevaluateChunking: function(id) {
	                if (chunking && handler.isValid(id)) {
	                    var state = handler._getFileState(id), totalChunks, i;
	                    delete state.chunking;
	                    state.chunking = {};
	                    totalChunks = handler._getTotalChunks(id);
	                    if (totalChunks > 1 || chunking.mandatory) {
	                        state.chunking.enabled = true;
	                        state.chunking.parts = totalChunks;
	                        state.chunking.remaining = [];
	                        for (i = 0; i < totalChunks; i++) {
	                            state.chunking.remaining.push(i);
	                        }
	                        handler._initTempState(id);
	                    } else {
	                        state.chunking.enabled = false;
	                    }
	                }
	            },
	            updateBlob: function(id, newBlob) {
	                if (handler.isValid(id)) {
	                    handler._getFileState(id).file = newBlob;
	                }
	            },
	            _clearXhrs: function(id) {
	                var tempState = handler._getFileState(id).temp;
	                qq.each(tempState.ajaxRequesters, function(chunkId) {
	                    delete tempState.ajaxRequesters[chunkId];
	                });
	                qq.each(tempState.xhrs, function(chunkId) {
	                    delete tempState.xhrs[chunkId];
	                });
	            },
	            _createXhr: function(id, optChunkIdx) {
	                return handler._registerXhr(id, optChunkIdx, qq.createXhrInstance());
	            },
	            _getAjaxRequester: function(id, optChunkIdx) {
	                var chunkIdx = optChunkIdx == null ? -1 : optChunkIdx;
	                return handler._getFileState(id).temp.ajaxRequesters[chunkIdx];
	            },
	            _getChunkData: function(id, chunkIndex) {
	                var chunkSize = chunking.partSize, fileSize = getSize(id), fileOrBlob = handler.getFile(id), startBytes = chunkSize * chunkIndex, endBytes = startBytes + chunkSize >= fileSize ? fileSize : startBytes + chunkSize, totalChunks = handler._getTotalChunks(id), cachedChunks = this._getFileState(id).temp.cachedChunks, blob = cachedChunks[chunkIndex] || qq.sliceBlob(fileOrBlob, startBytes, endBytes);
	                cachedChunks[chunkIndex] = blob;
	                return {
	                    part: chunkIndex,
	                    start: startBytes,
	                    end: endBytes,
	                    count: totalChunks,
	                    blob: blob,
	                    size: endBytes - startBytes
	                };
	            },
	            _getChunkDataForCallback: function(chunkData) {
	                return {
	                    partIndex: chunkData.part,
	                    startByte: chunkData.start + 1,
	                    endByte: chunkData.end,
	                    totalParts: chunkData.count
	                };
	            },
	            _getLocalStorageId: function(id) {
	                var formatVersion = "5.0", name = getName(id), size = getSize(id), chunkSize = chunking.partSize, endpoint = getEndpoint(id);
	                return qq.format("qq{}resume{}-{}-{}-{}-{}", namespace, formatVersion, name, size, chunkSize, endpoint);
	            },
	            _getMimeType: function(id) {
	                return handler.getFile(id).type;
	            },
	            _getPersistableData: function(id) {
	                return handler._getFileState(id).chunking;
	            },
	            _getTotalChunks: function(id) {
	                if (chunking) {
	                    var fileSize = getSize(id), chunkSize = chunking.partSize;
	                    return Math.ceil(fileSize / chunkSize);
	                }
	            },
	            _getXhr: function(id, optChunkIdx) {
	                var chunkIdx = optChunkIdx == null ? -1 : optChunkIdx;
	                return handler._getFileState(id).temp.xhrs[chunkIdx];
	            },
	            _getXhrs: function(id) {
	                return handler._getFileState(id).temp.xhrs;
	            },
	            _iterateResumeRecords: function(callback) {
	                if (resumeEnabled) {
	                    qq.each(localStorage, function(key, item) {
	                        if (key.indexOf(qq.format("qq{}resume", namespace)) === 0) {
	                            var uploadData = JSON.parse(item);
	                            callback(key, uploadData);
	                        }
	                    });
	                }
	            },
	            _initTempState: function(id) {
	                handler._getFileState(id).temp = {
	                    ajaxRequesters: {},
	                    chunkProgress: {},
	                    xhrs: {},
	                    cachedChunks: {}
	                };
	            },
	            _markNotResumable: function(id) {
	                handler._getFileState(id).notResumable = true;
	            },
	            _maybeDeletePersistedChunkData: function(id) {
	                var localStorageId;
	                if (resumeEnabled && handler.isResumable(id)) {
	                    localStorageId = handler._getLocalStorageId(id);
	                    if (localStorageId && localStorage.getItem(localStorageId)) {
	                        localStorage.removeItem(localStorageId);
	                        return true;
	                    }
	                }
	                return false;
	            },
	            _maybePrepareForResume: function(id) {
	                var state = handler._getFileState(id), localStorageId, persistedData;
	                if (resumeEnabled && state.key === undefined) {
	                    localStorageId = handler._getLocalStorageId(id);
	                    persistedData = localStorage.getItem(localStorageId);
	                    if (persistedData) {
	                        persistedData = JSON.parse(persistedData);
	                        if (getDataByUuid(persistedData.uuid)) {
	                            handler._markNotResumable(id);
	                        } else {
	                            log(qq.format("Identified file with ID {} and name of {} as resumable.", id, getName(id)));
	                            onUuidChanged(id, persistedData.uuid);
	                            state.key = persistedData.key;
	                            state.chunking = persistedData.chunking;
	                            state.loaded = persistedData.loaded;
	                            state.attemptingResume = true;
	                            handler.moveInProgressToRemaining(id);
	                        }
	                    }
	                }
	            },
	            _maybePersistChunkedState: function(id) {
	                var state = handler._getFileState(id), localStorageId, persistedData;
	                if (resumeEnabled && handler.isResumable(id)) {
	                    localStorageId = handler._getLocalStorageId(id);
	                    persistedData = {
	                        name: getName(id),
	                        size: getSize(id),
	                        uuid: getUuid(id),
	                        key: state.key,
	                        chunking: state.chunking,
	                        loaded: state.loaded,
	                        lastUpdated: Date.now()
	                    };
	                    try {
	                        localStorage.setItem(localStorageId, JSON.stringify(persistedData));
	                    } catch (error) {
	                        log(qq.format("Unable to save resume data for '{}' due to error: '{}'.", id, error.toString()), "warn");
	                    }
	                }
	            },
	            _registerProgressHandler: function(id, chunkIdx, chunkSize) {
	                var xhr = handler._getXhr(id, chunkIdx), name = getName(id), progressCalculator = {
	                    simple: function(loaded, total) {
	                        var fileSize = getSize(id);
	                        if (loaded === total) {
	                            onProgress(id, name, fileSize, fileSize);
	                        } else {
	                            onProgress(id, name, loaded >= fileSize ? fileSize - 1 : loaded, fileSize);
	                        }
	                    },
	                    chunked: function(loaded, total) {
	                        var chunkProgress = handler._getFileState(id).temp.chunkProgress, totalSuccessfullyLoadedForFile = handler._getFileState(id).loaded, loadedForRequest = loaded, totalForRequest = total, totalFileSize = getSize(id), estActualChunkLoaded = loadedForRequest - (totalForRequest - chunkSize), totalLoadedForFile = totalSuccessfullyLoadedForFile;
	                        chunkProgress[chunkIdx] = estActualChunkLoaded;
	                        qq.each(chunkProgress, function(chunkIdx, chunkLoaded) {
	                            totalLoadedForFile += chunkLoaded;
	                        });
	                        onProgress(id, name, totalLoadedForFile, totalFileSize);
	                    }
	                };
	                xhr.upload.onprogress = function(e) {
	                    if (e.lengthComputable) {
	                        var type = chunkSize == null ? "simple" : "chunked";
	                        progressCalculator[type](e.loaded, e.total);
	                    }
	                };
	            },
	            _registerXhr: function(id, optChunkIdx, xhr, optAjaxRequester) {
	                var xhrsId = optChunkIdx == null ? -1 : optChunkIdx, tempState = handler._getFileState(id).temp;
	                tempState.xhrs = tempState.xhrs || {};
	                tempState.ajaxRequesters = tempState.ajaxRequesters || {};
	                tempState.xhrs[xhrsId] = xhr;
	                if (optAjaxRequester) {
	                    tempState.ajaxRequesters[xhrsId] = optAjaxRequester;
	                }
	                return xhr;
	            },
	            _removeExpiredChunkingRecords: function() {
	                var expirationDays = resume.recordsExpireIn;
	                handler._iterateResumeRecords(function(key, uploadData) {
	                    var expirationDate = new Date(uploadData.lastUpdated);
	                    expirationDate.setDate(expirationDate.getDate() + expirationDays);
	                    if (expirationDate.getTime() <= Date.now()) {
	                        log("Removing expired resume record with key " + key);
	                        localStorage.removeItem(key);
	                    }
	                });
	            },
	            _shouldChunkThisFile: function(id) {
	                var state = handler._getFileState(id);
	                if (!state.chunking) {
	                    handler.reevaluateChunking(id);
	                }
	                return state.chunking.enabled;
	            }
	        });
	    };
	    qq.DeleteFileAjaxRequester = function(o) {
	        "use strict";
	        var requester, options = {
	            method: "DELETE",
	            uuidParamName: "qquuid",
	            endpointStore: {},
	            maxConnections: 3,
	            customHeaders: function(id) {
	                return {};
	            },
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {},
	            onDelete: function(id) {},
	            onDeleteComplete: function(id, xhrOrXdr, isError) {}
	        };
	        qq.extend(options, o);
	        function getMandatedParams() {
	            if (options.method.toUpperCase() === "POST") {
	                return {
	                    _method: "DELETE"
	                };
	            }
	            return {};
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            validMethods: [ "POST", "DELETE" ],
	            method: options.method,
	            endpointStore: options.endpointStore,
	            paramsStore: options.paramsStore,
	            mandatedParams: getMandatedParams(),
	            maxConnections: options.maxConnections,
	            customHeaders: function(id) {
	                return options.customHeaders.get(id);
	            },
	            log: options.log,
	            onSend: options.onDelete,
	            onComplete: options.onDeleteComplete,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            sendDelete: function(id, uuid, additionalMandatedParams) {
	                var additionalOptions = additionalMandatedParams || {};
	                options.log("Submitting delete file request for " + id);
	                if (options.method === "DELETE") {
	                    requester.initTransport(id).withPath(uuid).withParams(additionalOptions).send();
	                } else {
	                    additionalOptions[options.uuidParamName] = uuid;
	                    requester.initTransport(id).withParams(additionalOptions).send();
	                }
	            }
	        });
	    };
	    (function() {
	        function detectSubsampling(img) {
	            var iw = img.naturalWidth, ih = img.naturalHeight, canvas = document.createElement("canvas"), ctx;
	            if (iw * ih > 1024 * 1024) {
	                canvas.width = canvas.height = 1;
	                ctx = canvas.getContext("2d");
	                ctx.drawImage(img, -iw + 1, 0);
	                return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
	            } else {
	                return false;
	            }
	        }
	        function detectVerticalSquash(img, iw, ih) {
	            var canvas = document.createElement("canvas"), sy = 0, ey = ih, py = ih, ctx, data, alpha, ratio;
	            canvas.width = 1;
	            canvas.height = ih;
	            ctx = canvas.getContext("2d");
	            ctx.drawImage(img, 0, 0);
	            data = ctx.getImageData(0, 0, 1, ih).data;
	            while (py > sy) {
	                alpha = data[(py - 1) * 4 + 3];
	                if (alpha === 0) {
	                    ey = py;
	                } else {
	                    sy = py;
	                }
	                py = ey + sy >> 1;
	            }
	            ratio = py / ih;
	            return ratio === 0 ? 1 : ratio;
	        }
	        function renderImageToDataURL(img, blob, options, doSquash) {
	            var canvas = document.createElement("canvas"), mime = options.mime || "image/jpeg", promise = new qq.Promise();
	            renderImageToCanvas(img, blob, canvas, options, doSquash).then(function() {
	                promise.success(canvas.toDataURL(mime, options.quality || .8));
	            });
	            return promise;
	        }
	        function maybeCalculateDownsampledDimensions(spec) {
	            var maxPixels = 5241e3;
	            if (!qq.ios()) {
	                throw new qq.Error("Downsampled dimensions can only be reliably calculated for iOS!");
	            }
	            if (spec.origHeight * spec.origWidth > maxPixels) {
	                return {
	                    newHeight: Math.round(Math.sqrt(maxPixels * (spec.origHeight / spec.origWidth))),
	                    newWidth: Math.round(Math.sqrt(maxPixels * (spec.origWidth / spec.origHeight)))
	                };
	            }
	        }
	        function renderImageToCanvas(img, blob, canvas, options, doSquash) {
	            var iw = img.naturalWidth, ih = img.naturalHeight, width = options.width, height = options.height, ctx = canvas.getContext("2d"), promise = new qq.Promise(), modifiedDimensions;
	            ctx.save();
	            if (options.resize) {
	                return renderImageToCanvasWithCustomResizer({
	                    blob: blob,
	                    canvas: canvas,
	                    image: img,
	                    imageHeight: ih,
	                    imageWidth: iw,
	                    orientation: options.orientation,
	                    resize: options.resize,
	                    targetHeight: height,
	                    targetWidth: width
	                });
	            }
	            if (!qq.supportedFeatures.unlimitedScaledImageSize) {
	                modifiedDimensions = maybeCalculateDownsampledDimensions({
	                    origWidth: width,
	                    origHeight: height
	                });
	                if (modifiedDimensions) {
	                    qq.log(qq.format("Had to reduce dimensions due to device limitations from {}w / {}h to {}w / {}h", width, height, modifiedDimensions.newWidth, modifiedDimensions.newHeight), "warn");
	                    width = modifiedDimensions.newWidth;
	                    height = modifiedDimensions.newHeight;
	                }
	            }
	            transformCoordinate(canvas, width, height, options.orientation);
	            if (qq.ios()) {
	                (function() {
	                    if (detectSubsampling(img)) {
	                        iw /= 2;
	                        ih /= 2;
	                    }
	                    var d = 1024, tmpCanvas = document.createElement("canvas"), vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1, dw = Math.ceil(d * width / iw), dh = Math.ceil(d * height / ih / vertSquashRatio), sy = 0, dy = 0, tmpCtx, sx, dx;
	                    tmpCanvas.width = tmpCanvas.height = d;
	                    tmpCtx = tmpCanvas.getContext("2d");
	                    while (sy < ih) {
	                        sx = 0;
	                        dx = 0;
	                        while (sx < iw) {
	                            tmpCtx.clearRect(0, 0, d, d);
	                            tmpCtx.drawImage(img, -sx, -sy);
	                            ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
	                            sx += d;
	                            dx += dw;
	                        }
	                        sy += d;
	                        dy += dh;
	                    }
	                    ctx.restore();
	                    tmpCanvas = tmpCtx = null;
	                })();
	            } else {
	                ctx.drawImage(img, 0, 0, width, height);
	            }
	            canvas.qqImageRendered && canvas.qqImageRendered();
	            promise.success();
	            return promise;
	        }
	        function renderImageToCanvasWithCustomResizer(resizeInfo) {
	            var blob = resizeInfo.blob, image = resizeInfo.image, imageHeight = resizeInfo.imageHeight, imageWidth = resizeInfo.imageWidth, orientation = resizeInfo.orientation, promise = new qq.Promise(), resize = resizeInfo.resize, sourceCanvas = document.createElement("canvas"), sourceCanvasContext = sourceCanvas.getContext("2d"), targetCanvas = resizeInfo.canvas, targetHeight = resizeInfo.targetHeight, targetWidth = resizeInfo.targetWidth;
	            transformCoordinate(sourceCanvas, imageWidth, imageHeight, orientation);
	            targetCanvas.height = targetHeight;
	            targetCanvas.width = targetWidth;
	            sourceCanvasContext.drawImage(image, 0, 0);
	            resize({
	                blob: blob,
	                height: targetHeight,
	                image: image,
	                sourceCanvas: sourceCanvas,
	                targetCanvas: targetCanvas,
	                width: targetWidth
	            }).then(function success() {
	                targetCanvas.qqImageRendered && targetCanvas.qqImageRendered();
	                promise.success();
	            }, promise.failure);
	            return promise;
	        }
	        function transformCoordinate(canvas, width, height, orientation) {
	            switch (orientation) {
	              case 5:
	              case 6:
	              case 7:
	              case 8:
	                canvas.width = height;
	                canvas.height = width;
	                break;
	
	              default:
	                canvas.width = width;
	                canvas.height = height;
	            }
	            var ctx = canvas.getContext("2d");
	            switch (orientation) {
	              case 2:
	                ctx.translate(width, 0);
	                ctx.scale(-1, 1);
	                break;
	
	              case 3:
	                ctx.translate(width, height);
	                ctx.rotate(Math.PI);
	                break;
	
	              case 4:
	                ctx.translate(0, height);
	                ctx.scale(1, -1);
	                break;
	
	              case 5:
	                ctx.rotate(.5 * Math.PI);
	                ctx.scale(1, -1);
	                break;
	
	              case 6:
	                ctx.rotate(.5 * Math.PI);
	                ctx.translate(0, -height);
	                break;
	
	              case 7:
	                ctx.rotate(.5 * Math.PI);
	                ctx.translate(width, -height);
	                ctx.scale(-1, 1);
	                break;
	
	              case 8:
	                ctx.rotate(-.5 * Math.PI);
	                ctx.translate(-width, 0);
	                break;
	
	              default:
	                break;
	            }
	        }
	        function MegaPixImage(srcImage, errorCallback) {
	            var self = this;
	            if (window.Blob && srcImage instanceof Blob) {
	                (function() {
	                    var img = new Image(), URL = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;
	                    if (!URL) {
	                        throw Error("No createObjectURL function found to create blob url");
	                    }
	                    img.src = URL.createObjectURL(srcImage);
	                    self.blob = srcImage;
	                    srcImage = img;
	                })();
	            }
	            if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
	                srcImage.onload = function() {
	                    var listeners = self.imageLoadListeners;
	                    if (listeners) {
	                        self.imageLoadListeners = null;
	                        setTimeout(function() {
	                            for (var i = 0, len = listeners.length; i < len; i++) {
	                                listeners[i]();
	                            }
	                        }, 0);
	                    }
	                };
	                srcImage.onerror = errorCallback;
	                this.imageLoadListeners = [];
	            }
	            this.srcImage = srcImage;
	        }
	        MegaPixImage.prototype.render = function(target, options) {
	            options = options || {};
	            var self = this, imgWidth = this.srcImage.naturalWidth, imgHeight = this.srcImage.naturalHeight, width = options.width, height = options.height, maxWidth = options.maxWidth, maxHeight = options.maxHeight, doSquash = !this.blob || this.blob.type === "image/jpeg", tagName = target.tagName.toLowerCase(), opt;
	            if (this.imageLoadListeners) {
	                this.imageLoadListeners.push(function() {
	                    self.render(target, options);
	                });
	                return;
	            }
	            if (width && !height) {
	                height = imgHeight * width / imgWidth << 0;
	            } else if (height && !width) {
	                width = imgWidth * height / imgHeight << 0;
	            } else {
	                width = imgWidth;
	                height = imgHeight;
	            }
	            if (maxWidth && width > maxWidth) {
	                width = maxWidth;
	                height = imgHeight * width / imgWidth << 0;
	            }
	            if (maxHeight && height > maxHeight) {
	                height = maxHeight;
	                width = imgWidth * height / imgHeight << 0;
	            }
	            opt = {
	                width: width,
	                height: height
	            }, qq.each(options, function(optionsKey, optionsValue) {
	                opt[optionsKey] = optionsValue;
	            });
	            if (tagName === "img") {
	                (function() {
	                    var oldTargetSrc = target.src;
	                    renderImageToDataURL(self.srcImage, self.blob, opt, doSquash).then(function(dataUri) {
	                        target.src = dataUri;
	                        oldTargetSrc === target.src && target.onload();
	                    });
	                })();
	            } else if (tagName === "canvas") {
	                renderImageToCanvas(this.srcImage, this.blob, target, opt, doSquash);
	            }
	            if (typeof this.onrender === "function") {
	                this.onrender(target);
	            }
	        };
	        qq.MegaPixImage = MegaPixImage;
	    })();
	    qq.ImageGenerator = function(log) {
	        "use strict";
	        function isImg(el) {
	            return el.tagName.toLowerCase() === "img";
	        }
	        function isCanvas(el) {
	            return el.tagName.toLowerCase() === "canvas";
	        }
	        function isImgCorsSupported() {
	            return new Image().crossOrigin !== undefined;
	        }
	        function isCanvasSupported() {
	            var canvas = document.createElement("canvas");
	            return canvas.getContext && canvas.getContext("2d");
	        }
	        function determineMimeOfFileName(nameWithPath) {
	            var pathSegments = nameWithPath.split("/"), name = pathSegments[pathSegments.length - 1].split("?")[0], extension = qq.getExtension(name);
	            extension = extension && extension.toLowerCase();
	            switch (extension) {
	              case "jpeg":
	              case "jpg":
	                return "image/jpeg";
	
	              case "png":
	                return "image/png";
	
	              case "bmp":
	                return "image/bmp";
	
	              case "gif":
	                return "image/gif";
	
	              case "tiff":
	              case "tif":
	                return "image/tiff";
	            }
	        }
	        function isCrossOrigin(url) {
	            var targetAnchor = document.createElement("a"), targetProtocol, targetHostname, targetPort;
	            targetAnchor.href = url;
	            targetProtocol = targetAnchor.protocol;
	            targetPort = targetAnchor.port;
	            targetHostname = targetAnchor.hostname;
	            if (targetProtocol.toLowerCase() !== window.location.protocol.toLowerCase()) {
	                return true;
	            }
	            if (targetHostname.toLowerCase() !== window.location.hostname.toLowerCase()) {
	                return true;
	            }
	            if (targetPort !== window.location.port && !qq.ie()) {
	                return true;
	            }
	            return false;
	        }
	        function registerImgLoadListeners(img, promise) {
	            img.onload = function() {
	                img.onload = null;
	                img.onerror = null;
	                promise.success(img);
	            };
	            img.onerror = function() {
	                img.onload = null;
	                img.onerror = null;
	                log("Problem drawing thumbnail!", "error");
	                promise.failure(img, "Problem drawing thumbnail!");
	            };
	        }
	        function registerCanvasDrawImageListener(canvas, promise) {
	            canvas.qqImageRendered = function() {
	                promise.success(canvas);
	            };
	        }
	        function registerThumbnailRenderedListener(imgOrCanvas, promise) {
	            var registered = isImg(imgOrCanvas) || isCanvas(imgOrCanvas);
	            if (isImg(imgOrCanvas)) {
	                registerImgLoadListeners(imgOrCanvas, promise);
	            } else if (isCanvas(imgOrCanvas)) {
	                registerCanvasDrawImageListener(imgOrCanvas, promise);
	            } else {
	                promise.failure(imgOrCanvas);
	                log(qq.format("Element container of type {} is not supported!", imgOrCanvas.tagName), "error");
	            }
	            return registered;
	        }
	        function draw(fileOrBlob, container, options) {
	            var drawPreview = new qq.Promise(), identifier = new qq.Identify(fileOrBlob, log), maxSize = options.maxSize, orient = options.orient == null ? true : options.orient, megapixErrorHandler = function() {
	                container.onerror = null;
	                container.onload = null;
	                log("Could not render preview, file may be too large!", "error");
	                drawPreview.failure(container, "Browser cannot render image!");
	            };
	            identifier.isPreviewable().then(function(mime) {
	                var dummyExif = {
	                    parse: function() {
	                        return new qq.Promise().success();
	                    }
	                }, exif = orient ? new qq.Exif(fileOrBlob, log) : dummyExif, mpImg = new qq.MegaPixImage(fileOrBlob, megapixErrorHandler);
	                if (registerThumbnailRenderedListener(container, drawPreview)) {
	                    exif.parse().then(function(exif) {
	                        var orientation = exif && exif.Orientation;
	                        mpImg.render(container, {
	                            maxWidth: maxSize,
	                            maxHeight: maxSize,
	                            orientation: orientation,
	                            mime: mime,
	                            resize: options.customResizeFunction
	                        });
	                    }, function(failureMsg) {
	                        log(qq.format("EXIF data could not be parsed ({}).  Assuming orientation = 1.", failureMsg));
	                        mpImg.render(container, {
	                            maxWidth: maxSize,
	                            maxHeight: maxSize,
	                            mime: mime,
	                            resize: options.customResizeFunction
	                        });
	                    });
	                }
	            }, function() {
	                log("Not previewable");
	                drawPreview.failure(container, "Not previewable");
	            });
	            return drawPreview;
	        }
	        function drawOnCanvasOrImgFromUrl(url, canvasOrImg, draw, maxSize, customResizeFunction) {
	            var tempImg = new Image(), tempImgRender = new qq.Promise();
	            registerThumbnailRenderedListener(tempImg, tempImgRender);
	            if (isCrossOrigin(url)) {
	                tempImg.crossOrigin = "anonymous";
	            }
	            tempImg.src = url;
	            tempImgRender.then(function rendered() {
	                registerThumbnailRenderedListener(canvasOrImg, draw);
	                var mpImg = new qq.MegaPixImage(tempImg);
	                mpImg.render(canvasOrImg, {
	                    maxWidth: maxSize,
	                    maxHeight: maxSize,
	                    mime: determineMimeOfFileName(url),
	                    resize: customResizeFunction
	                });
	            }, draw.failure);
	        }
	        function drawOnImgFromUrlWithCssScaling(url, img, draw, maxSize) {
	            registerThumbnailRenderedListener(img, draw);
	            qq(img).css({
	                maxWidth: maxSize + "px",
	                maxHeight: maxSize + "px"
	            });
	            img.src = url;
	        }
	        function drawFromUrl(url, container, options) {
	            var draw = new qq.Promise(), scale = options.scale, maxSize = scale ? options.maxSize : null;
	            if (scale && isImg(container)) {
	                if (isCanvasSupported()) {
	                    if (isCrossOrigin(url) && !isImgCorsSupported()) {
	                        drawOnImgFromUrlWithCssScaling(url, container, draw, maxSize);
	                    } else {
	                        drawOnCanvasOrImgFromUrl(url, container, draw, maxSize);
	                    }
	                } else {
	                    drawOnImgFromUrlWithCssScaling(url, container, draw, maxSize);
	                }
	            } else if (isCanvas(container)) {
	                drawOnCanvasOrImgFromUrl(url, container, draw, maxSize);
	            } else if (registerThumbnailRenderedListener(container, draw)) {
	                container.src = url;
	            }
	            return draw;
	        }
	        qq.extend(this, {
	            generate: function(fileBlobOrUrl, container, options) {
	                if (qq.isString(fileBlobOrUrl)) {
	                    log("Attempting to update thumbnail based on server response.");
	                    return drawFromUrl(fileBlobOrUrl, container, options || {});
	                } else {
	                    log("Attempting to draw client-side image preview.");
	                    return draw(fileBlobOrUrl, container, options || {});
	                }
	            }
	        });
	        this._testing = {};
	        this._testing.isImg = isImg;
	        this._testing.isCanvas = isCanvas;
	        this._testing.isCrossOrigin = isCrossOrigin;
	        this._testing.determineMimeOfFileName = determineMimeOfFileName;
	    };
	    qq.Exif = function(fileOrBlob, log) {
	        "use strict";
	        var TAG_IDS = [ 274 ], TAG_INFO = {
	            274: {
	                name: "Orientation",
	                bytes: 2
	            }
	        };
	        function parseLittleEndian(hex) {
	            var result = 0, pow = 0;
	            while (hex.length > 0) {
	                result += parseInt(hex.substring(0, 2), 16) * Math.pow(2, pow);
	                hex = hex.substring(2, hex.length);
	                pow += 8;
	            }
	            return result;
	        }
	        function seekToApp1(offset, promise) {
	            var theOffset = offset, thePromise = promise;
	            if (theOffset === undefined) {
	                theOffset = 2;
	                thePromise = new qq.Promise();
	            }
	            qq.readBlobToHex(fileOrBlob, theOffset, 4).then(function(hex) {
	                var match = /^ffe([0-9])/.exec(hex), segmentLength;
	                if (match) {
	                    if (match[1] !== "1") {
	                        segmentLength = parseInt(hex.slice(4, 8), 16);
	                        seekToApp1(theOffset + segmentLength + 2, thePromise);
	                    } else {
	                        thePromise.success(theOffset);
	                    }
	                } else {
	                    thePromise.failure("No EXIF header to be found!");
	                }
	            });
	            return thePromise;
	        }
	        function getApp1Offset() {
	            var promise = new qq.Promise();
	            qq.readBlobToHex(fileOrBlob, 0, 6).then(function(hex) {
	                if (hex.indexOf("ffd8") !== 0) {
	                    promise.failure("Not a valid JPEG!");
	                } else {
	                    seekToApp1().then(function(offset) {
	                        promise.success(offset);
	                    }, function(error) {
	                        promise.failure(error);
	                    });
	                }
	            });
	            return promise;
	        }
	        function isLittleEndian(app1Start) {
	            var promise = new qq.Promise();
	            qq.readBlobToHex(fileOrBlob, app1Start + 10, 2).then(function(hex) {
	                promise.success(hex === "4949");
	            });
	            return promise;
	        }
	        function getDirEntryCount(app1Start, littleEndian) {
	            var promise = new qq.Promise();
	            qq.readBlobToHex(fileOrBlob, app1Start + 18, 2).then(function(hex) {
	                if (littleEndian) {
	                    return promise.success(parseLittleEndian(hex));
	                } else {
	                    promise.success(parseInt(hex, 16));
	                }
	            });
	            return promise;
	        }
	        function getIfd(app1Start, dirEntries) {
	            var offset = app1Start + 20, bytes = dirEntries * 12;
	            return qq.readBlobToHex(fileOrBlob, offset, bytes);
	        }
	        function getDirEntries(ifdHex) {
	            var entries = [], offset = 0;
	            while (offset + 24 <= ifdHex.length) {
	                entries.push(ifdHex.slice(offset, offset + 24));
	                offset += 24;
	            }
	            return entries;
	        }
	        function getTagValues(littleEndian, dirEntries) {
	            var TAG_VAL_OFFSET = 16, tagsToFind = qq.extend([], TAG_IDS), vals = {};
	            qq.each(dirEntries, function(idx, entry) {
	                var idHex = entry.slice(0, 4), id = littleEndian ? parseLittleEndian(idHex) : parseInt(idHex, 16), tagsToFindIdx = tagsToFind.indexOf(id), tagValHex, tagName, tagValLength;
	                if (tagsToFindIdx >= 0) {
	                    tagName = TAG_INFO[id].name;
	                    tagValLength = TAG_INFO[id].bytes;
	                    tagValHex = entry.slice(TAG_VAL_OFFSET, TAG_VAL_OFFSET + tagValLength * 2);
	                    vals[tagName] = littleEndian ? parseLittleEndian(tagValHex) : parseInt(tagValHex, 16);
	                    tagsToFind.splice(tagsToFindIdx, 1);
	                }
	                if (tagsToFind.length === 0) {
	                    return false;
	                }
	            });
	            return vals;
	        }
	        qq.extend(this, {
	            parse: function() {
	                var parser = new qq.Promise(), onParseFailure = function(message) {
	                    log(qq.format("EXIF header parse failed: '{}' ", message));
	                    parser.failure(message);
	                };
	                getApp1Offset().then(function(app1Offset) {
	                    log(qq.format("Moving forward with EXIF header parsing for '{}'", fileOrBlob.name === undefined ? "blob" : fileOrBlob.name));
	                    isLittleEndian(app1Offset).then(function(littleEndian) {
	                        log(qq.format("EXIF Byte order is {} endian", littleEndian ? "little" : "big"));
	                        getDirEntryCount(app1Offset, littleEndian).then(function(dirEntryCount) {
	                            log(qq.format("Found {} APP1 directory entries", dirEntryCount));
	                            getIfd(app1Offset, dirEntryCount).then(function(ifdHex) {
	                                var dirEntries = getDirEntries(ifdHex), tagValues = getTagValues(littleEndian, dirEntries);
	                                log("Successfully parsed some EXIF tags");
	                                parser.success(tagValues);
	                            }, onParseFailure);
	                        }, onParseFailure);
	                    }, onParseFailure);
	                }, onParseFailure);
	                return parser;
	            }
	        });
	        this._testing = {};
	        this._testing.parseLittleEndian = parseLittleEndian;
	    };
	    qq.Identify = function(fileOrBlob, log) {
	        "use strict";
	        function isIdentifiable(magicBytes, questionableBytes) {
	            var identifiable = false, magicBytesEntries = [].concat(magicBytes);
	            qq.each(magicBytesEntries, function(idx, magicBytesArrayEntry) {
	                if (questionableBytes.indexOf(magicBytesArrayEntry) === 0) {
	                    identifiable = true;
	                    return false;
	                }
	            });
	            return identifiable;
	        }
	        qq.extend(this, {
	            isPreviewable: function() {
	                var self = this, identifier = new qq.Promise(), previewable = false, name = fileOrBlob.name === undefined ? "blob" : fileOrBlob.name;
	                log(qq.format("Attempting to determine if {} can be rendered in this browser", name));
	                log("First pass: check type attribute of blob object.");
	                if (this.isPreviewableSync()) {
	                    log("Second pass: check for magic bytes in file header.");
	                    qq.readBlobToHex(fileOrBlob, 0, 4).then(function(hex) {
	                        qq.each(self.PREVIEWABLE_MIME_TYPES, function(mime, bytes) {
	                            if (isIdentifiable(bytes, hex)) {
	                                if (mime !== "image/tiff" || qq.supportedFeatures.tiffPreviews) {
	                                    previewable = true;
	                                    identifier.success(mime);
	                                }
	                                return false;
	                            }
	                        });
	                        log(qq.format("'{}' is {} able to be rendered in this browser", name, previewable ? "" : "NOT"));
	                        if (!previewable) {
	                            identifier.failure();
	                        }
	                    }, function() {
	                        log("Error reading file w/ name '" + name + "'.  Not able to be rendered in this browser.");
	                        identifier.failure();
	                    });
	                } else {
	                    identifier.failure();
	                }
	                return identifier;
	            },
	            isPreviewableSync: function() {
	                var fileMime = fileOrBlob.type, isRecognizedImage = qq.indexOf(Object.keys(this.PREVIEWABLE_MIME_TYPES), fileMime) >= 0, previewable = false, name = fileOrBlob.name === undefined ? "blob" : fileOrBlob.name;
	                if (isRecognizedImage) {
	                    if (fileMime === "image/tiff") {
	                        previewable = qq.supportedFeatures.tiffPreviews;
	                    } else {
	                        previewable = true;
	                    }
	                }
	                !previewable && log(name + " is not previewable in this browser per the blob's type attr");
	                return previewable;
	            }
	        });
	    };
	    qq.Identify.prototype.PREVIEWABLE_MIME_TYPES = {
	        "image/jpeg": "ffd8ff",
	        "image/gif": "474946",
	        "image/png": "89504e",
	        "image/bmp": "424d",
	        "image/tiff": [ "49492a00", "4d4d002a" ]
	    };
	    qq.ImageValidation = function(blob, log) {
	        "use strict";
	        function hasNonZeroLimits(limits) {
	            var atLeastOne = false;
	            qq.each(limits, function(limit, value) {
	                if (value > 0) {
	                    atLeastOne = true;
	                    return false;
	                }
	            });
	            return atLeastOne;
	        }
	        function getWidthHeight() {
	            var sizeDetermination = new qq.Promise();
	            new qq.Identify(blob, log).isPreviewable().then(function() {
	                var image = new Image(), url = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;
	                if (url) {
	                    image.onerror = function() {
	                        log("Cannot determine dimensions for image.  May be too large.", "error");
	                        sizeDetermination.failure();
	                    };
	                    image.onload = function() {
	                        sizeDetermination.success({
	                            width: this.width,
	                            height: this.height
	                        });
	                    };
	                    image.src = url.createObjectURL(blob);
	                } else {
	                    log("No createObjectURL function available to generate image URL!", "error");
	                    sizeDetermination.failure();
	                }
	            }, sizeDetermination.failure);
	            return sizeDetermination;
	        }
	        function getFailingLimit(limits, dimensions) {
	            var failingLimit;
	            qq.each(limits, function(limitName, limitValue) {
	                if (limitValue > 0) {
	                    var limitMatcher = /(max|min)(Width|Height)/.exec(limitName), dimensionPropName = limitMatcher[2].charAt(0).toLowerCase() + limitMatcher[2].slice(1), actualValue = dimensions[dimensionPropName];
	                    switch (limitMatcher[1]) {
	                      case "min":
	                        if (actualValue < limitValue) {
	                            failingLimit = limitName;
	                            return false;
	                        }
	                        break;
	
	                      case "max":
	                        if (actualValue > limitValue) {
	                            failingLimit = limitName;
	                            return false;
	                        }
	                        break;
	                    }
	                }
	            });
	            return failingLimit;
	        }
	        this.validate = function(limits) {
	            var validationEffort = new qq.Promise();
	            log("Attempting to validate image.");
	            if (hasNonZeroLimits(limits)) {
	                getWidthHeight().then(function(dimensions) {
	                    var failingLimit = getFailingLimit(limits, dimensions);
	                    if (failingLimit) {
	                        validationEffort.failure(failingLimit);
	                    } else {
	                        validationEffort.success();
	                    }
	                }, validationEffort.success);
	            } else {
	                validationEffort.success();
	            }
	            return validationEffort;
	        };
	    };
	    qq.Session = function(spec) {
	        "use strict";
	        var options = {
	            endpoint: null,
	            params: {},
	            customHeaders: {},
	            cors: {},
	            addFileRecord: function(sessionData) {},
	            log: function(message, level) {}
	        };
	        qq.extend(options, spec, true);
	        function isJsonResponseValid(response) {
	            if (qq.isArray(response)) {
	                return true;
	            }
	            options.log("Session response is not an array.", "error");
	        }
	        function handleFileItems(fileItems, success, xhrOrXdr, promise) {
	            var someItemsIgnored = false;
	            success = success && isJsonResponseValid(fileItems);
	            if (success) {
	                qq.each(fileItems, function(idx, fileItem) {
	                    if (fileItem.uuid == null) {
	                        someItemsIgnored = true;
	                        options.log(qq.format("Session response item {} did not include a valid UUID - ignoring.", idx), "error");
	                    } else if (fileItem.name == null) {
	                        someItemsIgnored = true;
	                        options.log(qq.format("Session response item {} did not include a valid name - ignoring.", idx), "error");
	                    } else {
	                        try {
	                            options.addFileRecord(fileItem);
	                            return true;
	                        } catch (err) {
	                            someItemsIgnored = true;
	                            options.log(err.message, "error");
	                        }
	                    }
	                    return false;
	                });
	            }
	            promise[success && !someItemsIgnored ? "success" : "failure"](fileItems, xhrOrXdr);
	        }
	        this.refresh = function() {
	            var refreshEffort = new qq.Promise(), refreshCompleteCallback = function(response, success, xhrOrXdr) {
	                handleFileItems(response, success, xhrOrXdr, refreshEffort);
	            }, requesterOptions = qq.extend({}, options), requester = new qq.SessionAjaxRequester(qq.extend(requesterOptions, {
	                onComplete: refreshCompleteCallback
	            }));
	            requester.queryServer();
	            return refreshEffort;
	        };
	    };
	    qq.SessionAjaxRequester = function(spec) {
	        "use strict";
	        var requester, options = {
	            endpoint: null,
	            customHeaders: {},
	            params: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            onComplete: function(response, success, xhrOrXdr) {},
	            log: function(str, level) {}
	        };
	        qq.extend(options, spec);
	        function onComplete(id, xhrOrXdr, isError) {
	            var response = null;
	            if (xhrOrXdr.responseText != null) {
	                try {
	                    response = qq.parseJson(xhrOrXdr.responseText);
	                } catch (err) {
	                    options.log("Problem parsing session response: " + err.message, "error");
	                    isError = true;
	                }
	            }
	            options.onComplete(response, !isError, xhrOrXdr);
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            validMethods: [ "GET" ],
	            method: "GET",
	            endpointStore: {
	                get: function() {
	                    return options.endpoint;
	                }
	            },
	            customHeaders: options.customHeaders,
	            log: options.log,
	            onComplete: onComplete,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            queryServer: function() {
	                var params = qq.extend({}, options.params);
	                options.log("Session query request.");
	                requester.initTransport("sessionRefresh").withParams(params).withCacheBuster().send();
	            }
	        });
	    };
	    qq.Scaler = function(spec, log) {
	        "use strict";
	        var self = this, customResizeFunction = spec.customResizer, includeOriginal = spec.sendOriginal, orient = spec.orient, defaultType = spec.defaultType, defaultQuality = spec.defaultQuality / 100, failedToScaleText = spec.failureText, includeExif = spec.includeExif, sizes = this._getSortedSizes(spec.sizes);
	        qq.extend(this, {
	            enabled: qq.supportedFeatures.scaling && sizes.length > 0,
	            getFileRecords: function(originalFileUuid, originalFileName, originalBlobOrBlobData) {
	                var self = this, records = [], originalBlob = originalBlobOrBlobData.blob ? originalBlobOrBlobData.blob : originalBlobOrBlobData, identifier = new qq.Identify(originalBlob, log);
	                if (identifier.isPreviewableSync()) {
	                    qq.each(sizes, function(idx, sizeRecord) {
	                        var outputType = self._determineOutputType({
	                            defaultType: defaultType,
	                            requestedType: sizeRecord.type,
	                            refType: originalBlob.type
	                        });
	                        records.push({
	                            uuid: qq.getUniqueId(),
	                            name: self._getName(originalFileName, {
	                                name: sizeRecord.name,
	                                type: outputType,
	                                refType: originalBlob.type
	                            }),
	                            blob: new qq.BlobProxy(originalBlob, qq.bind(self._generateScaledImage, self, {
	                                customResizeFunction: customResizeFunction,
	                                maxSize: sizeRecord.maxSize,
	                                orient: orient,
	                                type: outputType,
	                                quality: defaultQuality,
	                                failedText: failedToScaleText,
	                                includeExif: includeExif,
	                                log: log
	                            }))
	                        });
	                    });
	                    records.push({
	                        uuid: originalFileUuid,
	                        name: originalFileName,
	                        size: originalBlob.size,
	                        blob: includeOriginal ? originalBlob : null
	                    });
	                } else {
	                    records.push({
	                        uuid: originalFileUuid,
	                        name: originalFileName,
	                        size: originalBlob.size,
	                        blob: originalBlob
	                    });
	                }
	                return records;
	            },
	            handleNewFile: function(file, name, uuid, size, fileList, batchId, uuidParamName, api) {
	                var self = this, buttonId = file.qqButtonId || file.blob && file.blob.qqButtonId, scaledIds = [], originalId = null, addFileToHandler = api.addFileToHandler, uploadData = api.uploadData, paramsStore = api.paramsStore, proxyGroupId = qq.getUniqueId();
	                qq.each(self.getFileRecords(uuid, name, file), function(idx, record) {
	                    var blobSize = record.size, id;
	                    if (record.blob instanceof qq.BlobProxy) {
	                        blobSize = -1;
	                    }
	                    id = uploadData.addFile({
	                        uuid: record.uuid,
	                        name: record.name,
	                        size: blobSize,
	                        batchId: batchId,
	                        proxyGroupId: proxyGroupId
	                    });
	                    if (record.blob instanceof qq.BlobProxy) {
	                        scaledIds.push(id);
	                    } else {
	                        originalId = id;
	                    }
	                    if (record.blob) {
	                        addFileToHandler(id, record.blob);
	                        fileList.push({
	                            id: id,
	                            file: record.blob
	                        });
	                    } else {
	                        uploadData.setStatus(id, qq.status.REJECTED);
	                    }
	                });
	                if (originalId !== null) {
	                    qq.each(scaledIds, function(idx, scaledId) {
	                        var params = {
	                            qqparentuuid: uploadData.retrieve({
	                                id: originalId
	                            }).uuid,
	                            qqparentsize: uploadData.retrieve({
	                                id: originalId
	                            }).size
	                        };
	                        params[uuidParamName] = uploadData.retrieve({
	                            id: scaledId
	                        }).uuid;
	                        uploadData.setParentId(scaledId, originalId);
	                        paramsStore.addReadOnly(scaledId, params);
	                    });
	                    if (scaledIds.length) {
	                        (function() {
	                            var param = {};
	                            param[uuidParamName] = uploadData.retrieve({
	                                id: originalId
	                            }).uuid;
	                            paramsStore.addReadOnly(originalId, param);
	                        })();
	                    }
	                }
	            }
	        });
	    };
	    qq.extend(qq.Scaler.prototype, {
	        scaleImage: function(id, specs, api) {
	            "use strict";
	            if (!qq.supportedFeatures.scaling) {
	                throw new qq.Error("Scaling is not supported in this browser!");
	            }
	            var scalingEffort = new qq.Promise(), log = api.log, file = api.getFile(id), uploadData = api.uploadData.retrieve({
	                id: id
	            }), name = uploadData && uploadData.name, uuid = uploadData && uploadData.uuid, scalingOptions = {
	                customResizer: specs.customResizer,
	                sendOriginal: false,
	                orient: specs.orient,
	                defaultType: specs.type || null,
	                defaultQuality: specs.quality,
	                failedToScaleText: "Unable to scale",
	                sizes: [ {
	                    name: "",
	                    maxSize: specs.maxSize
	                } ]
	            }, scaler = new qq.Scaler(scalingOptions, log);
	            if (!qq.Scaler || !qq.supportedFeatures.imagePreviews || !file) {
	                scalingEffort.failure();
	                log("Could not generate requested scaled image for " + id + ".  " + "Scaling is either not possible in this browser, or the file could not be located.", "error");
	            } else {
	                qq.bind(function() {
	                    var record = scaler.getFileRecords(uuid, name, file)[0];
	                    if (record && record.blob instanceof qq.BlobProxy) {
	                        record.blob.create().then(scalingEffort.success, scalingEffort.failure);
	                    } else {
	                        log(id + " is not a scalable image!", "error");
	                        scalingEffort.failure();
	                    }
	                }, this)();
	            }
	            return scalingEffort;
	        },
	        _determineOutputType: function(spec) {
	            "use strict";
	            var requestedType = spec.requestedType, defaultType = spec.defaultType, referenceType = spec.refType;
	            if (!defaultType && !requestedType) {
	                if (referenceType !== "image/jpeg") {
	                    return "image/png";
	                }
	                return referenceType;
	            }
	            if (!requestedType) {
	                return defaultType;
	            }
	            if (qq.indexOf(Object.keys(qq.Identify.prototype.PREVIEWABLE_MIME_TYPES), requestedType) >= 0) {
	                if (requestedType === "image/tiff") {
	                    return qq.supportedFeatures.tiffPreviews ? requestedType : defaultType;
	                }
	                return requestedType;
	            }
	            return defaultType;
	        },
	        _getName: function(originalName, scaledVersionProperties) {
	            "use strict";
	            var startOfExt = originalName.lastIndexOf("."), versionType = scaledVersionProperties.type || "image/png", referenceType = scaledVersionProperties.refType, scaledName = "", scaledExt = qq.getExtension(originalName), nameAppendage = "";
	            if (scaledVersionProperties.name && scaledVersionProperties.name.trim().length) {
	                nameAppendage = " (" + scaledVersionProperties.name + ")";
	            }
	            if (startOfExt >= 0) {
	                scaledName = originalName.substr(0, startOfExt);
	                if (referenceType !== versionType) {
	                    scaledExt = versionType.split("/")[1];
	                }
	                scaledName += nameAppendage + "." + scaledExt;
	            } else {
	                scaledName = originalName + nameAppendage;
	            }
	            return scaledName;
	        },
	        _getSortedSizes: function(sizes) {
	            "use strict";
	            sizes = qq.extend([], sizes);
	            return sizes.sort(function(a, b) {
	                if (a.maxSize > b.maxSize) {
	                    return 1;
	                }
	                if (a.maxSize < b.maxSize) {
	                    return -1;
	                }
	                return 0;
	            });
	        },
	        _generateScaledImage: function(spec, sourceFile) {
	            "use strict";
	            var self = this, customResizeFunction = spec.customResizeFunction, log = spec.log, maxSize = spec.maxSize, orient = spec.orient, type = spec.type, quality = spec.quality, failedText = spec.failedText, includeExif = spec.includeExif && sourceFile.type === "image/jpeg" && type === "image/jpeg", scalingEffort = new qq.Promise(), imageGenerator = new qq.ImageGenerator(log), canvas = document.createElement("canvas");
	            log("Attempting to generate scaled version for " + sourceFile.name);
	            imageGenerator.generate(sourceFile, canvas, {
	                maxSize: maxSize,
	                orient: orient,
	                customResizeFunction: customResizeFunction
	            }).then(function() {
	                var scaledImageDataUri = canvas.toDataURL(type, quality), signalSuccess = function() {
	                    log("Success generating scaled version for " + sourceFile.name);
	                    var blob = qq.dataUriToBlob(scaledImageDataUri);
	                    scalingEffort.success(blob);
	                };
	                if (includeExif) {
	                    self._insertExifHeader(sourceFile, scaledImageDataUri, log).then(function(scaledImageDataUriWithExif) {
	                        scaledImageDataUri = scaledImageDataUriWithExif;
	                        signalSuccess();
	                    }, function() {
	                        log("Problem inserting EXIF header into scaled image.  Using scaled image w/out EXIF data.", "error");
	                        signalSuccess();
	                    });
	                } else {
	                    signalSuccess();
	                }
	            }, function() {
	                log("Failed attempt to generate scaled version for " + sourceFile.name, "error");
	                scalingEffort.failure(failedText);
	            });
	            return scalingEffort;
	        },
	        _insertExifHeader: function(originalImage, scaledImageDataUri, log) {
	            "use strict";
	            var reader = new FileReader(), insertionEffort = new qq.Promise(), originalImageDataUri = "";
	            reader.onload = function() {
	                originalImageDataUri = reader.result;
	                insertionEffort.success(qq.ExifRestorer.restore(originalImageDataUri, scaledImageDataUri));
	            };
	            reader.onerror = function() {
	                log("Problem reading " + originalImage.name + " during attempt to transfer EXIF data to scaled version.", "error");
	                insertionEffort.failure();
	            };
	            reader.readAsDataURL(originalImage);
	            return insertionEffort;
	        },
	        _dataUriToBlob: function(dataUri) {
	            "use strict";
	            var byteString, mimeString, arrayBuffer, intArray;
	            if (dataUri.split(",")[0].indexOf("base64") >= 0) {
	                byteString = atob(dataUri.split(",")[1]);
	            } else {
	                byteString = decodeURI(dataUri.split(",")[1]);
	            }
	            mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
	            arrayBuffer = new ArrayBuffer(byteString.length);
	            intArray = new Uint8Array(arrayBuffer);
	            qq.each(byteString, function(idx, character) {
	                intArray[idx] = character.charCodeAt(0);
	            });
	            return this._createBlob(arrayBuffer, mimeString);
	        },
	        _createBlob: function(data, mime) {
	            "use strict";
	            var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder, blobBuilder = BlobBuilder && new BlobBuilder();
	            if (blobBuilder) {
	                blobBuilder.append(data);
	                return blobBuilder.getBlob(mime);
	            } else {
	                return new Blob([ data ], {
	                    type: mime
	                });
	            }
	        }
	    });
	    qq.ExifRestorer = function() {
	        var ExifRestorer = {};
	        ExifRestorer.KEY_STR = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv" + "wxyz0123456789+/" + "=";
	        ExifRestorer.encode64 = function(input) {
	            var output = "", chr1, chr2, chr3 = "", enc1, enc2, enc3, enc4 = "", i = 0;
	            do {
	                chr1 = input[i++];
	                chr2 = input[i++];
	                chr3 = input[i++];
	                enc1 = chr1 >> 2;
	                enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	                enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	                enc4 = chr3 & 63;
	                if (isNaN(chr2)) {
	                    enc3 = enc4 = 64;
	                } else if (isNaN(chr3)) {
	                    enc4 = 64;
	                }
	                output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
	                chr1 = chr2 = chr3 = "";
	                enc1 = enc2 = enc3 = enc4 = "";
	            } while (i < input.length);
	            return output;
	        };
	        ExifRestorer.restore = function(origFileBase64, resizedFileBase64) {
	            var expectedBase64Header = "data:image/jpeg;base64,";
	            if (!origFileBase64.match(expectedBase64Header)) {
	                return resizedFileBase64;
	            }
	            var rawImage = this.decode64(origFileBase64.replace(expectedBase64Header, ""));
	            var segments = this.slice2Segments(rawImage);
	            var image = this.exifManipulation(resizedFileBase64, segments);
	            return expectedBase64Header + this.encode64(image);
	        };
	        ExifRestorer.exifManipulation = function(resizedFileBase64, segments) {
	            var exifArray = this.getExifArray(segments), newImageArray = this.insertExif(resizedFileBase64, exifArray), aBuffer = new Uint8Array(newImageArray);
	            return aBuffer;
	        };
	        ExifRestorer.getExifArray = function(segments) {
	            var seg;
	            for (var x = 0; x < segments.length; x++) {
	                seg = segments[x];
	                if (seg[0] == 255 & seg[1] == 225) {
	                    return seg;
	                }
	            }
	            return [];
	        };
	        ExifRestorer.insertExif = function(resizedFileBase64, exifArray) {
	            var imageData = resizedFileBase64.replace("data:image/jpeg;base64,", ""), buf = this.decode64(imageData), separatePoint = buf.indexOf(255, 3), mae = buf.slice(0, separatePoint), ato = buf.slice(separatePoint), array = mae;
	            array = array.concat(exifArray);
	            array = array.concat(ato);
	            return array;
	        };
	        ExifRestorer.slice2Segments = function(rawImageArray) {
	            var head = 0, segments = [];
	            while (1) {
	                if (rawImageArray[head] == 255 & rawImageArray[head + 1] == 218) {
	                    break;
	                }
	                if (rawImageArray[head] == 255 & rawImageArray[head + 1] == 216) {
	                    head += 2;
	                } else {
	                    var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3], endPoint = head + length + 2, seg = rawImageArray.slice(head, endPoint);
	                    segments.push(seg);
	                    head = endPoint;
	                }
	                if (head > rawImageArray.length) {
	                    break;
	                }
	            }
	            return segments;
	        };
	        ExifRestorer.decode64 = function(input) {
	            var output = "", chr1, chr2, chr3 = "", enc1, enc2, enc3, enc4 = "", i = 0, buf = [];
	            var base64test = /[^A-Za-z0-9\+\/\=]/g;
	            if (base64test.exec(input)) {
	                throw new Error("There were invalid base64 characters in the input text.  " + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='");
	            }
	            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	            do {
	                enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	                enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	                enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	                enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	                chr1 = enc1 << 2 | enc2 >> 4;
	                chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	                chr3 = (enc3 & 3) << 6 | enc4;
	                buf.push(chr1);
	                if (enc3 != 64) {
	                    buf.push(chr2);
	                }
	                if (enc4 != 64) {
	                    buf.push(chr3);
	                }
	                chr1 = chr2 = chr3 = "";
	                enc1 = enc2 = enc3 = enc4 = "";
	            } while (i < input.length);
	            return buf;
	        };
	        return ExifRestorer;
	    }();
	    qq.TotalProgress = function(callback, getSize) {
	        "use strict";
	        var perFileProgress = {}, totalLoaded = 0, totalSize = 0, lastLoadedSent = -1, lastTotalSent = -1, callbackProxy = function(loaded, total) {
	            if (loaded !== lastLoadedSent || total !== lastTotalSent) {
	                callback(loaded, total);
	            }
	            lastLoadedSent = loaded;
	            lastTotalSent = total;
	        }, noRetryableFiles = function(failed, retryable) {
	            var none = true;
	            qq.each(failed, function(idx, failedId) {
	                if (qq.indexOf(retryable, failedId) >= 0) {
	                    none = false;
	                    return false;
	                }
	            });
	            return none;
	        }, onCancel = function(id) {
	            updateTotalProgress(id, -1, -1);
	            delete perFileProgress[id];
	        }, onAllComplete = function(successful, failed, retryable) {
	            if (failed.length === 0 || noRetryableFiles(failed, retryable)) {
	                callbackProxy(totalSize, totalSize);
	                this.reset();
	            }
	        }, onNew = function(id) {
	            var size = getSize(id);
	            if (size > 0) {
	                updateTotalProgress(id, 0, size);
	                perFileProgress[id] = {
	                    loaded: 0,
	                    total: size
	                };
	            }
	        }, updateTotalProgress = function(id, newLoaded, newTotal) {
	            var oldLoaded = perFileProgress[id] ? perFileProgress[id].loaded : 0, oldTotal = perFileProgress[id] ? perFileProgress[id].total : 0;
	            if (newLoaded === -1 && newTotal === -1) {
	                totalLoaded -= oldLoaded;
	                totalSize -= oldTotal;
	            } else {
	                if (newLoaded) {
	                    totalLoaded += newLoaded - oldLoaded;
	                }
	                if (newTotal) {
	                    totalSize += newTotal - oldTotal;
	                }
	            }
	            callbackProxy(totalLoaded, totalSize);
	        };
	        qq.extend(this, {
	            onAllComplete: onAllComplete,
	            onStatusChange: function(id, oldStatus, newStatus) {
	                if (newStatus === qq.status.CANCELED || newStatus === qq.status.REJECTED) {
	                    onCancel(id);
	                } else if (newStatus === qq.status.SUBMITTING) {
	                    onNew(id);
	                }
	            },
	            onIndividualProgress: function(id, loaded, total) {
	                updateTotalProgress(id, loaded, total);
	                perFileProgress[id] = {
	                    loaded: loaded,
	                    total: total
	                };
	            },
	            onNewSize: function(id) {
	                onNew(id);
	            },
	            reset: function() {
	                perFileProgress = {};
	                totalLoaded = 0;
	                totalSize = 0;
	            }
	        });
	    };
	    qq.PasteSupport = function(o) {
	        "use strict";
	        var options, detachPasteHandler;
	        options = {
	            targetElement: null,
	            callbacks: {
	                log: function(message, level) {},
	                pasteReceived: function(blob) {}
	            }
	        };
	        function isImage(item) {
	            return item.type && item.type.indexOf("image/") === 0;
	        }
	        function registerPasteHandler() {
	            detachPasteHandler = qq(options.targetElement).attach("paste", function(event) {
	                var clipboardData = event.clipboardData;
	                if (clipboardData) {
	                    qq.each(clipboardData.items, function(idx, item) {
	                        if (isImage(item)) {
	                            var blob = item.getAsFile();
	                            options.callbacks.pasteReceived(blob);
	                        }
	                    });
	                }
	            });
	        }
	        function unregisterPasteHandler() {
	            if (detachPasteHandler) {
	                detachPasteHandler();
	            }
	        }
	        qq.extend(options, o);
	        registerPasteHandler();
	        qq.extend(this, {
	            reset: function() {
	                unregisterPasteHandler();
	            }
	        });
	    };
	    qq.FormSupport = function(options, startUpload, log) {
	        "use strict";
	        var self = this, interceptSubmit = options.interceptSubmit, formEl = options.element, autoUpload = options.autoUpload;
	        qq.extend(this, {
	            newEndpoint: null,
	            newAutoUpload: autoUpload,
	            attachedToForm: false,
	            getFormInputsAsObject: function() {
	                if (formEl == null) {
	                    return null;
	                }
	                return self._form2Obj(formEl);
	            }
	        });
	        function determineNewEndpoint(formEl) {
	            if (formEl.getAttribute("action")) {
	                self.newEndpoint = formEl.getAttribute("action");
	            }
	        }
	        function validateForm(formEl, nativeSubmit) {
	            if (formEl.checkValidity && !formEl.checkValidity()) {
	                log("Form did not pass validation checks - will not upload.", "error");
	                nativeSubmit();
	            } else {
	                return true;
	            }
	        }
	        function maybeUploadOnSubmit(formEl) {
	            var nativeSubmit = formEl.submit;
	            qq(formEl).attach("submit", function(event) {
	                event = event || window.event;
	                if (event.preventDefault) {
	                    event.preventDefault();
	                } else {
	                    event.returnValue = false;
	                }
	                validateForm(formEl, nativeSubmit) && startUpload();
	            });
	            formEl.submit = function() {
	                validateForm(formEl, nativeSubmit) && startUpload();
	            };
	        }
	        function determineFormEl(formEl) {
	            if (formEl) {
	                if (qq.isString(formEl)) {
	                    formEl = document.getElementById(formEl);
	                }
	                if (formEl) {
	                    log("Attaching to form element.");
	                    determineNewEndpoint(formEl);
	                    interceptSubmit && maybeUploadOnSubmit(formEl);
	                }
	            }
	            return formEl;
	        }
	        formEl = determineFormEl(formEl);
	        this.attachedToForm = !!formEl;
	    };
	    qq.extend(qq.FormSupport.prototype, {
	        _form2Obj: function(form) {
	            "use strict";
	            var obj = {}, notIrrelevantType = function(type) {
	                var irrelevantTypes = [ "button", "image", "reset", "submit" ];
	                return qq.indexOf(irrelevantTypes, type.toLowerCase()) < 0;
	            }, radioOrCheckbox = function(type) {
	                return qq.indexOf([ "checkbox", "radio" ], type.toLowerCase()) >= 0;
	            }, ignoreValue = function(el) {
	                if (radioOrCheckbox(el.type) && !el.checked) {
	                    return true;
	                }
	                return el.disabled && el.type.toLowerCase() !== "hidden";
	            }, selectValue = function(select) {
	                var value = null;
	                qq.each(qq(select).children(), function(idx, child) {
	                    if (child.tagName.toLowerCase() === "option" && child.selected) {
	                        value = child.value;
	                        return false;
	                    }
	                });
	                return value;
	            };
	            qq.each(form.elements, function(idx, el) {
	                if ((qq.isInput(el, true) || el.tagName.toLowerCase() === "textarea") && notIrrelevantType(el.type) && !ignoreValue(el)) {
	                    obj[el.name] = el.value;
	                } else if (el.tagName.toLowerCase() === "select" && !ignoreValue(el)) {
	                    var value = selectValue(el);
	                    if (value !== null) {
	                        obj[el.name] = value;
	                    }
	                }
	            });
	            return obj;
	        }
	    });
	    qq.traditional = qq.traditional || {};
	    qq.traditional.FormUploadHandler = function(options, proxy) {
	        "use strict";
	        var handler = this, getName = proxy.getName, getUuid = proxy.getUuid, log = proxy.log;
	        function getIframeContentJson(id, iframe) {
	            var response, doc, innerHtml;
	            try {
	                doc = iframe.contentDocument || iframe.contentWindow.document;
	                innerHtml = doc.body.innerHTML;
	                log("converting iframe's innerHTML to JSON");
	                log("innerHTML = " + innerHtml);
	                if (innerHtml && innerHtml.match(/^<pre/i)) {
	                    innerHtml = doc.body.firstChild.firstChild.nodeValue;
	                }
	                response = handler._parseJsonResponse(innerHtml);
	            } catch (error) {
	                log("Error when attempting to parse form upload response (" + error.message + ")", "error");
	                response = {
	                    success: false
	                };
	            }
	            return response;
	        }
	        function createForm(id, iframe) {
	            var params = options.paramsStore.get(id), method = options.method.toLowerCase() === "get" ? "GET" : "POST", endpoint = options.endpointStore.get(id), name = getName(id);
	            params[options.uuidName] = getUuid(id);
	            params[options.filenameParam] = name;
	            return handler._initFormForUpload({
	                method: method,
	                endpoint: endpoint,
	                params: params,
	                paramsInBody: options.paramsInBody,
	                targetName: iframe.name
	            });
	        }
	        this.uploadFile = function(id) {
	            var input = handler.getInput(id), iframe = handler._createIframe(id), promise = new qq.Promise(), form;
	            form = createForm(id, iframe);
	            form.appendChild(input);
	            handler._attachLoadEvent(iframe, function(responseFromMessage) {
	                log("iframe loaded");
	                var response = responseFromMessage ? responseFromMessage : getIframeContentJson(id, iframe);
	                handler._detachLoadEvent(id);
	                if (!options.cors.expected) {
	                    qq(iframe).remove();
	                }
	                if (response.success) {
	                    promise.success(response);
	                } else {
	                    promise.failure(response);
	                }
	            });
	            log("Sending upload request for " + id);
	            form.submit();
	            qq(form).remove();
	            return promise;
	        };
	        qq.extend(this, new qq.FormUploadHandler({
	            options: {
	                isCors: options.cors.expected,
	                inputName: options.inputName
	            },
	            proxy: {
	                onCancel: options.onCancel,
	                getName: getName,
	                getUuid: getUuid,
	                log: log
	            }
	        }));
	    };
	    qq.traditional = qq.traditional || {};
	    qq.traditional.XhrUploadHandler = function(spec, proxy) {
	        "use strict";
	        var handler = this, getName = proxy.getName, getSize = proxy.getSize, getUuid = proxy.getUuid, log = proxy.log, multipart = spec.forceMultipart || spec.paramsInBody, addChunkingSpecificParams = function(id, params, chunkData) {
	            var size = getSize(id), name = getName(id);
	            params[spec.chunking.paramNames.partIndex] = chunkData.part;
	            params[spec.chunking.paramNames.partByteOffset] = chunkData.start;
	            params[spec.chunking.paramNames.chunkSize] = chunkData.size;
	            params[spec.chunking.paramNames.totalParts] = chunkData.count;
	            params[spec.totalFileSizeName] = size;
	            if (multipart) {
	                params[spec.filenameParam] = name;
	            }
	        }, allChunksDoneRequester = new qq.traditional.AllChunksDoneAjaxRequester({
	            cors: spec.cors,
	            endpoint: spec.chunking.success.endpoint,
	            log: log
	        }), createReadyStateChangedHandler = function(id, xhr) {
	            var promise = new qq.Promise();
	            xhr.onreadystatechange = function() {
	                if (xhr.readyState === 4) {
	                    var result = onUploadOrChunkComplete(id, xhr);
	                    if (result.success) {
	                        promise.success(result.response, xhr);
	                    } else {
	                        promise.failure(result.response, xhr);
	                    }
	                }
	            };
	            return promise;
	        }, getChunksCompleteParams = function(id) {
	            var params = spec.paramsStore.get(id), name = getName(id), size = getSize(id);
	            params[spec.uuidName] = getUuid(id);
	            params[spec.filenameParam] = name;
	            params[spec.totalFileSizeName] = size;
	            params[spec.chunking.paramNames.totalParts] = handler._getTotalChunks(id);
	            return params;
	        }, isErrorUploadResponse = function(xhr, response) {
	            return qq.indexOf([ 200, 201, 202, 203, 204 ], xhr.status) < 0 || !response.success || response.reset;
	        }, onUploadOrChunkComplete = function(id, xhr) {
	            var response;
	            log("xhr - server response received for " + id);
	            log("responseText = " + xhr.responseText);
	            response = parseResponse(true, xhr);
	            return {
	                success: !isErrorUploadResponse(xhr, response),
	                response: response
	            };
	        }, parseResponse = function(upload, xhr) {
	            var response = {};
	            try {
	                log(qq.format("Received response status {} with body: {}", xhr.status, xhr.responseText));
	                response = qq.parseJson(xhr.responseText);
	            } catch (error) {
	                upload && log("Error when attempting to parse xhr response text (" + error.message + ")", "error");
	            }
	            return response;
	        }, sendChunksCompleteRequest = function(id) {
	            var promise = new qq.Promise();
	            allChunksDoneRequester.complete(id, handler._createXhr(id), getChunksCompleteParams(id), spec.customHeaders.get(id)).then(function(xhr) {
	                promise.success(parseResponse(false, xhr), xhr);
	            }, function(xhr) {
	                promise.failure(parseResponse(false, xhr), xhr);
	            });
	            return promise;
	        }, setParamsAndGetEntityToSend = function(params, xhr, fileOrBlob, id) {
	            var formData = new FormData(), method = spec.method, endpoint = spec.endpointStore.get(id), name = getName(id), size = getSize(id);
	            params[spec.uuidName] = getUuid(id);
	            params[spec.filenameParam] = name;
	            if (multipart) {
	                params[spec.totalFileSizeName] = size;
	            }
	            if (!spec.paramsInBody) {
	                if (!multipart) {
	                    params[spec.inputName] = name;
	                }
	                endpoint = qq.obj2url(params, endpoint);
	            }
	            xhr.open(method, endpoint, true);
	            if (spec.cors.expected && spec.cors.sendCredentials) {
	                xhr.withCredentials = true;
	            }
	            if (multipart) {
	                if (spec.paramsInBody) {
	                    qq.obj2FormData(params, formData);
	                }
	                formData.append(spec.inputName, fileOrBlob);
	                return formData;
	            }
	            return fileOrBlob;
	        }, setUploadHeaders = function(id, xhr) {
	            var extraHeaders = spec.customHeaders.get(id), fileOrBlob = handler.getFile(id);
	            xhr.setRequestHeader("Accept", "application/json");
	            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	            xhr.setRequestHeader("Cache-Control", "no-cache");
	            if (!multipart) {
	                xhr.setRequestHeader("Content-Type", "application/octet-stream");
	                xhr.setRequestHeader("X-Mime-Type", fileOrBlob.type);
	            }
	            qq.each(extraHeaders, function(name, val) {
	                xhr.setRequestHeader(name, val);
	            });
	        };
	        qq.extend(this, {
	            uploadChunk: function(id, chunkIdx, resuming) {
	                var chunkData = handler._getChunkData(id, chunkIdx), xhr = handler._createXhr(id, chunkIdx), size = getSize(id), promise, toSend, params;
	                promise = createReadyStateChangedHandler(id, xhr);
	                handler._registerProgressHandler(id, chunkIdx, chunkData.size);
	                params = spec.paramsStore.get(id);
	                addChunkingSpecificParams(id, params, chunkData);
	                if (resuming) {
	                    params[spec.resume.paramNames.resuming] = true;
	                }
	                toSend = setParamsAndGetEntityToSend(params, xhr, chunkData.blob, id);
	                setUploadHeaders(id, xhr);
	                xhr.send(toSend);
	                return promise;
	            },
	            uploadFile: function(id) {
	                var fileOrBlob = handler.getFile(id), promise, xhr, params, toSend;
	                xhr = handler._createXhr(id);
	                handler._registerProgressHandler(id);
	                promise = createReadyStateChangedHandler(id, xhr);
	                params = spec.paramsStore.get(id);
	                toSend = setParamsAndGetEntityToSend(params, xhr, fileOrBlob, id);
	                setUploadHeaders(id, xhr);
	                xhr.send(toSend);
	                return promise;
	            }
	        });
	        qq.extend(this, new qq.XhrUploadHandler({
	            options: qq.extend({
	                namespace: "traditional"
	            }, spec),
	            proxy: qq.extend({
	                getEndpoint: spec.endpointStore.get
	            }, proxy)
	        }));
	        qq.override(this, function(super_) {
	            return {
	                finalizeChunks: function(id) {
	                    if (spec.chunking.success.endpoint) {
	                        return sendChunksCompleteRequest(id);
	                    } else {
	                        return super_.finalizeChunks(id, qq.bind(parseResponse, this, true));
	                    }
	                }
	            };
	        });
	    };
	    qq.traditional.AllChunksDoneAjaxRequester = function(o) {
	        "use strict";
	        var requester, method = "POST", options = {
	            cors: {
	                allowXdr: false,
	                expected: false,
	                sendCredentials: false
	            },
	            endpoint: null,
	            log: function(str, level) {}
	        }, promises = {}, endpointHandler = {
	            get: function(id) {
	                return options.endpoint;
	            }
	        };
	        qq.extend(options, o);
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            validMethods: [ method ],
	            method: method,
	            endpointStore: endpointHandler,
	            allowXRequestedWithAndCacheControl: false,
	            cors: options.cors,
	            log: options.log,
	            onComplete: function(id, xhr, isError) {
	                var promise = promises[id];
	                delete promises[id];
	                if (isError) {
	                    promise.failure(xhr);
	                } else {
	                    promise.success(xhr);
	                }
	            }
	        }));
	        qq.extend(this, {
	            complete: function(id, xhr, params, headers) {
	                var promise = new qq.Promise();
	                options.log("Submitting All Chunks Done request for " + id);
	                promises[id] = promise;
	                requester.initTransport(id).withParams(params).withHeaders(headers).send(xhr);
	                return promise;
	            }
	        });
	    };
	    qq.DragAndDrop = function(o) {
	        "use strict";
	        var options, HIDE_ZONES_EVENT_NAME = "qq-hidezones", HIDE_BEFORE_ENTER_ATTR = "qq-hide-dropzone", uploadDropZones = [], droppedFiles = [], disposeSupport = new qq.DisposeSupport();
	        options = {
	            dropZoneElements: [],
	            allowMultipleItems: true,
	            classes: {
	                dropActive: null
	            },
	            callbacks: new qq.DragAndDrop.callbacks()
	        };
	        qq.extend(options, o, true);
	        function uploadDroppedFiles(files, uploadDropZone) {
	            var filesAsArray = Array.prototype.slice.call(files);
	            options.callbacks.dropLog("Grabbed " + files.length + " dropped files.");
	            uploadDropZone.dropDisabled(false);
	            options.callbacks.processingDroppedFilesComplete(filesAsArray, uploadDropZone.getElement());
	        }
	        function traverseFileTree(entry) {
	            var parseEntryPromise = new qq.Promise();
	            if (entry.isFile) {
	                entry.file(function(file) {
	                    var name = entry.name, fullPath = entry.fullPath, indexOfNameInFullPath = fullPath.indexOf(name);
	                    fullPath = fullPath.substr(0, indexOfNameInFullPath);
	                    if (fullPath.charAt(0) === "/") {
	                        fullPath = fullPath.substr(1);
	                    }
	                    file.qqPath = fullPath;
	                    droppedFiles.push(file);
	                    parseEntryPromise.success();
	                }, function(fileError) {
	                    options.callbacks.dropLog("Problem parsing '" + entry.fullPath + "'.  FileError code " + fileError.code + ".", "error");
	                    parseEntryPromise.failure();
	                });
	            } else if (entry.isDirectory) {
	                getFilesInDirectory(entry).then(function allEntriesRead(entries) {
	                    var entriesLeft = entries.length;
	                    qq.each(entries, function(idx, entry) {
	                        traverseFileTree(entry).done(function() {
	                            entriesLeft -= 1;
	                            if (entriesLeft === 0) {
	                                parseEntryPromise.success();
	                            }
	                        });
	                    });
	                    if (!entries.length) {
	                        parseEntryPromise.success();
	                    }
	                }, function readFailure(fileError) {
	                    options.callbacks.dropLog("Problem parsing '" + entry.fullPath + "'.  FileError code " + fileError.code + ".", "error");
	                    parseEntryPromise.failure();
	                });
	            }
	            return parseEntryPromise;
	        }
	        function getFilesInDirectory(entry, reader, accumEntries, existingPromise) {
	            var promise = existingPromise || new qq.Promise(), dirReader = reader || entry.createReader();
	            dirReader.readEntries(function readSuccess(entries) {
	                var newEntries = accumEntries ? accumEntries.concat(entries) : entries;
	                if (entries.length) {
	                    setTimeout(function() {
	                        getFilesInDirectory(entry, dirReader, newEntries, promise);
	                    }, 0);
	                } else {
	                    promise.success(newEntries);
	                }
	            }, promise.failure);
	            return promise;
	        }
	        function handleDataTransfer(dataTransfer, uploadDropZone) {
	            var pendingFolderPromises = [], handleDataTransferPromise = new qq.Promise();
	            options.callbacks.processingDroppedFiles();
	            uploadDropZone.dropDisabled(true);
	            if (dataTransfer.files.length > 1 && !options.allowMultipleItems) {
	                options.callbacks.processingDroppedFilesComplete([]);
	                options.callbacks.dropError("tooManyFilesError", "");
	                uploadDropZone.dropDisabled(false);
	                handleDataTransferPromise.failure();
	            } else {
	                droppedFiles = [];
	                if (qq.isFolderDropSupported(dataTransfer)) {
	                    qq.each(dataTransfer.items, function(idx, item) {
	                        var entry = item.webkitGetAsEntry();
	                        if (entry) {
	                            if (entry.isFile) {
	                                droppedFiles.push(item.getAsFile());
	                            } else {
	                                pendingFolderPromises.push(traverseFileTree(entry).done(function() {
	                                    pendingFolderPromises.pop();
	                                    if (pendingFolderPromises.length === 0) {
	                                        handleDataTransferPromise.success();
	                                    }
	                                }));
	                            }
	                        }
	                    });
	                } else {
	                    droppedFiles = dataTransfer.files;
	                }
	                if (pendingFolderPromises.length === 0) {
	                    handleDataTransferPromise.success();
	                }
	            }
	            return handleDataTransferPromise;
	        }
	        function setupDropzone(dropArea) {
	            var dropZone = new qq.UploadDropZone({
	                HIDE_ZONES_EVENT_NAME: HIDE_ZONES_EVENT_NAME,
	                element: dropArea,
	                onEnter: function(e) {
	                    qq(dropArea).addClass(options.classes.dropActive);
	                    e.stopPropagation();
	                },
	                onLeaveNotDescendants: function(e) {
	                    qq(dropArea).removeClass(options.classes.dropActive);
	                },
	                onDrop: function(e) {
	                    handleDataTransfer(e.dataTransfer, dropZone).then(function() {
	                        uploadDroppedFiles(droppedFiles, dropZone);
	                    }, function() {
	                        options.callbacks.dropLog("Drop event DataTransfer parsing failed.  No files will be uploaded.", "error");
	                    });
	                }
	            });
	            disposeSupport.addDisposer(function() {
	                dropZone.dispose();
	            });
	            qq(dropArea).hasAttribute(HIDE_BEFORE_ENTER_ATTR) && qq(dropArea).hide();
	            uploadDropZones.push(dropZone);
	            return dropZone;
	        }
	        function isFileDrag(dragEvent) {
	            var fileDrag;
	            qq.each(dragEvent.dataTransfer.types, function(key, val) {
	                if (val === "Files") {
	                    fileDrag = true;
	                    return false;
	                }
	            });
	            return fileDrag;
	        }
	        function leavingDocumentOut(e) {
	            if (qq.firefox()) {
	                return !e.relatedTarget;
	            }
	            if (qq.safari()) {
	                return e.x < 0 || e.y < 0;
	            }
	            return e.x === 0 && e.y === 0;
	        }
	        function setupDragDrop() {
	            var dropZones = options.dropZoneElements, maybeHideDropZones = function() {
	                setTimeout(function() {
	                    qq.each(dropZones, function(idx, dropZone) {
	                        qq(dropZone).hasAttribute(HIDE_BEFORE_ENTER_ATTR) && qq(dropZone).hide();
	                        qq(dropZone).removeClass(options.classes.dropActive);
	                    });
	                }, 10);
	            };
	            qq.each(dropZones, function(idx, dropZone) {
	                var uploadDropZone = setupDropzone(dropZone);
	                if (dropZones.length && qq.supportedFeatures.fileDrop) {
	                    disposeSupport.attach(document, "dragenter", function(e) {
	                        if (!uploadDropZone.dropDisabled() && isFileDrag(e)) {
	                            qq.each(dropZones, function(idx, dropZone) {
	                                if (dropZone instanceof HTMLElement && qq(dropZone).hasAttribute(HIDE_BEFORE_ENTER_ATTR)) {
	                                    qq(dropZone).css({
	                                        display: "block"
	                                    });
	                                }
	                            });
	                        }
	                    });
	                }
	            });
	            disposeSupport.attach(document, "dragleave", function(e) {
	                if (leavingDocumentOut(e)) {
	                    maybeHideDropZones();
	                }
	            });
	            disposeSupport.attach(qq(document).children()[0], "mouseenter", function(e) {
	                maybeHideDropZones();
	            });
	            disposeSupport.attach(document, "drop", function(e) {
	                e.preventDefault();
	                maybeHideDropZones();
	            });
	            disposeSupport.attach(document, HIDE_ZONES_EVENT_NAME, maybeHideDropZones);
	        }
	        setupDragDrop();
	        qq.extend(this, {
	            setupExtraDropzone: function(element) {
	                options.dropZoneElements.push(element);
	                setupDropzone(element);
	            },
	            removeDropzone: function(element) {
	                var i, dzs = options.dropZoneElements;
	                for (i in dzs) {
	                    if (dzs[i] === element) {
	                        return dzs.splice(i, 1);
	                    }
	                }
	            },
	            dispose: function() {
	                disposeSupport.dispose();
	                qq.each(uploadDropZones, function(idx, dropZone) {
	                    dropZone.dispose();
	                });
	            }
	        });
	    };
	    qq.DragAndDrop.callbacks = function() {
	        "use strict";
	        return {
	            processingDroppedFiles: function() {},
	            processingDroppedFilesComplete: function(files, targetEl) {},
	            dropError: function(code, errorSpecifics) {
	                qq.log("Drag & drop error code '" + code + " with these specifics: '" + errorSpecifics + "'", "error");
	            },
	            dropLog: function(message, level) {
	                qq.log(message, level);
	            }
	        };
	    };
	    qq.UploadDropZone = function(o) {
	        "use strict";
	        var disposeSupport = new qq.DisposeSupport(), options, element, preventDrop, dropOutsideDisabled;
	        options = {
	            element: null,
	            onEnter: function(e) {},
	            onLeave: function(e) {},
	            onLeaveNotDescendants: function(e) {},
	            onDrop: function(e) {}
	        };
	        qq.extend(options, o);
	        element = options.element;
	        function dragoverShouldBeCanceled() {
	            return qq.safari() || qq.firefox() && qq.windows();
	        }
	        function disableDropOutside(e) {
	            if (!dropOutsideDisabled) {
	                if (dragoverShouldBeCanceled) {
	                    disposeSupport.attach(document, "dragover", function(e) {
	                        e.preventDefault();
	                    });
	                } else {
	                    disposeSupport.attach(document, "dragover", function(e) {
	                        if (e.dataTransfer) {
	                            e.dataTransfer.dropEffect = "none";
	                            e.preventDefault();
	                        }
	                    });
	                }
	                dropOutsideDisabled = true;
	            }
	        }
	        function isValidFileDrag(e) {
	            if (!qq.supportedFeatures.fileDrop) {
	                return false;
	            }
	            var effectTest, dt = e.dataTransfer, isSafari = qq.safari();
	            effectTest = qq.ie() && qq.supportedFeatures.fileDrop ? true : dt.effectAllowed !== "none";
	            return dt && effectTest && (dt.files || !isSafari && dt.types.contains && dt.types.contains("Files"));
	        }
	        function isOrSetDropDisabled(isDisabled) {
	            if (isDisabled !== undefined) {
	                preventDrop = isDisabled;
	            }
	            return preventDrop;
	        }
	        function triggerHidezonesEvent() {
	            var hideZonesEvent;
	            function triggerUsingOldApi() {
	                hideZonesEvent = document.createEvent("Event");
	                hideZonesEvent.initEvent(options.HIDE_ZONES_EVENT_NAME, true, true);
	            }
	            if (window.CustomEvent) {
	                try {
	                    hideZonesEvent = new CustomEvent(options.HIDE_ZONES_EVENT_NAME);
	                } catch (err) {
	                    triggerUsingOldApi();
	                }
	            } else {
	                triggerUsingOldApi();
	            }
	            document.dispatchEvent(hideZonesEvent);
	        }
	        function attachEvents() {
	            disposeSupport.attach(element, "dragover", function(e) {
	                if (!isValidFileDrag(e)) {
	                    return;
	                }
	                var effect = qq.ie() && qq.supportedFeatures.fileDrop ? null : e.dataTransfer.effectAllowed;
	                if (effect === "move" || effect === "linkMove") {
	                    e.dataTransfer.dropEffect = "move";
	                } else {
	                    e.dataTransfer.dropEffect = "copy";
	                }
	                e.stopPropagation();
	                e.preventDefault();
	            });
	            disposeSupport.attach(element, "dragenter", function(e) {
	                if (!isOrSetDropDisabled()) {
	                    if (!isValidFileDrag(e)) {
	                        return;
	                    }
	                    options.onEnter(e);
	                }
	            });
	            disposeSupport.attach(element, "dragleave", function(e) {
	                if (!isValidFileDrag(e)) {
	                    return;
	                }
	                options.onLeave(e);
	                var relatedTarget = document.elementFromPoint(e.clientX, e.clientY);
	                if (qq(this).contains(relatedTarget)) {
	                    return;
	                }
	                options.onLeaveNotDescendants(e);
	            });
	            disposeSupport.attach(element, "drop", function(e) {
	                if (!isOrSetDropDisabled()) {
	                    if (!isValidFileDrag(e)) {
	                        return;
	                    }
	                    e.preventDefault();
	                    e.stopPropagation();
	                    options.onDrop(e);
	                    triggerHidezonesEvent();
	                }
	            });
	        }
	        disableDropOutside();
	        attachEvents();
	        qq.extend(this, {
	            dropDisabled: function(isDisabled) {
	                return isOrSetDropDisabled(isDisabled);
	            },
	            dispose: function() {
	                disposeSupport.dispose();
	            },
	            getElement: function() {
	                return element;
	            }
	        });
	    };
	    (function() {
	        "use strict";
	        qq.uiPublicApi = {
	            addInitialFiles: function(cannedFileList) {
	                this._parent.prototype.addInitialFiles.apply(this, arguments);
	                this._templating.addCacheToDom();
	            },
	            clearStoredFiles: function() {
	                this._parent.prototype.clearStoredFiles.apply(this, arguments);
	                this._templating.clearFiles();
	            },
	            addExtraDropzone: function(element) {
	                this._dnd && this._dnd.setupExtraDropzone(element);
	            },
	            removeExtraDropzone: function(element) {
	                if (this._dnd) {
	                    return this._dnd.removeDropzone(element);
	                }
	            },
	            getItemByFileId: function(id) {
	                if (!this._templating.isHiddenForever(id)) {
	                    return this._templating.getFileContainer(id);
	                }
	            },
	            reset: function() {
	                this._parent.prototype.reset.apply(this, arguments);
	                this._templating.reset();
	                if (!this._options.button && this._templating.getButton()) {
	                    this._defaultButtonId = this._createUploadButton({
	                        element: this._templating.getButton(),
	                        title: this._options.text.fileInputTitle
	                    }).getButtonId();
	                }
	                if (this._dnd) {
	                    this._dnd.dispose();
	                    this._dnd = this._setupDragAndDrop();
	                }
	                this._totalFilesInBatch = 0;
	                this._filesInBatchAddedToUi = 0;
	                this._setupClickAndEditEventHandlers();
	            },
	            setName: function(id, newName) {
	                var formattedFilename = this._options.formatFileName(newName);
	                this._parent.prototype.setName.apply(this, arguments);
	                this._templating.updateFilename(id, formattedFilename);
	            },
	            pauseUpload: function(id) {
	                var paused = this._parent.prototype.pauseUpload.apply(this, arguments);
	                paused && this._templating.uploadPaused(id);
	                return paused;
	            },
	            continueUpload: function(id) {
	                var continued = this._parent.prototype.continueUpload.apply(this, arguments);
	                continued && this._templating.uploadContinued(id);
	                return continued;
	            },
	            getId: function(fileContainerOrChildEl) {
	                return this._templating.getFileId(fileContainerOrChildEl);
	            },
	            getDropTarget: function(fileId) {
	                var file = this.getFile(fileId);
	                return file.qqDropTarget;
	            }
	        };
	        qq.uiPrivateApi = {
	            _getButton: function(buttonId) {
	                var button = this._parent.prototype._getButton.apply(this, arguments);
	                if (!button) {
	                    if (buttonId === this._defaultButtonId) {
	                        button = this._templating.getButton();
	                    }
	                }
	                return button;
	            },
	            _removeFileItem: function(fileId) {
	                this._templating.removeFile(fileId);
	            },
	            _setupClickAndEditEventHandlers: function() {
	                this._fileButtonsClickHandler = qq.FileButtonsClickHandler && this._bindFileButtonsClickEvent();
	                this._focusinEventSupported = !qq.firefox();
	                if (this._isEditFilenameEnabled()) {
	                    this._filenameClickHandler = this._bindFilenameClickEvent();
	                    this._filenameInputFocusInHandler = this._bindFilenameInputFocusInEvent();
	                    this._filenameInputFocusHandler = this._bindFilenameInputFocusEvent();
	                }
	            },
	            _setupDragAndDrop: function() {
	                var self = this, dropZoneElements = this._options.dragAndDrop.extraDropzones, templating = this._templating, defaultDropZone = templating.getDropZone();
	                defaultDropZone && dropZoneElements.push(defaultDropZone);
	                return new qq.DragAndDrop({
	                    dropZoneElements: dropZoneElements,
	                    allowMultipleItems: this._options.multiple,
	                    classes: {
	                        dropActive: this._options.classes.dropActive
	                    },
	                    callbacks: {
	                        processingDroppedFiles: function() {
	                            templating.showDropProcessing();
	                        },
	                        processingDroppedFilesComplete: function(files, targetEl) {
	                            templating.hideDropProcessing();
	                            qq.each(files, function(idx, file) {
	                                file.qqDropTarget = targetEl;
	                            });
	                            if (files.length) {
	                                self.addFiles(files, null, null);
	                            }
	                        },
	                        dropError: function(code, errorData) {
	                            self._itemError(code, errorData);
	                        },
	                        dropLog: function(message, level) {
	                            self.log(message, level);
	                        }
	                    }
	                });
	            },
	            _bindFileButtonsClickEvent: function() {
	                var self = this;
	                return new qq.FileButtonsClickHandler({
	                    templating: this._templating,
	                    log: function(message, lvl) {
	                        self.log(message, lvl);
	                    },
	                    onDeleteFile: function(fileId) {
	                        self.deleteFile(fileId);
	                    },
	                    onCancel: function(fileId) {
	                        self.cancel(fileId);
	                    },
	                    onRetry: function(fileId) {
	                        self.retry(fileId);
	                    },
	                    onPause: function(fileId) {
	                        self.pauseUpload(fileId);
	                    },
	                    onContinue: function(fileId) {
	                        self.continueUpload(fileId);
	                    },
	                    onGetName: function(fileId) {
	                        return self.getName(fileId);
	                    }
	                });
	            },
	            _isEditFilenameEnabled: function() {
	                return this._templating.isEditFilenamePossible() && !this._options.autoUpload && qq.FilenameClickHandler && qq.FilenameInputFocusHandler && qq.FilenameInputFocusHandler;
	            },
	            _filenameEditHandler: function() {
	                var self = this, templating = this._templating;
	                return {
	                    templating: templating,
	                    log: function(message, lvl) {
	                        self.log(message, lvl);
	                    },
	                    onGetUploadStatus: function(fileId) {
	                        return self.getUploads({
	                            id: fileId
	                        }).status;
	                    },
	                    onGetName: function(fileId) {
	                        return self.getName(fileId);
	                    },
	                    onSetName: function(id, newName) {
	                        self.setName(id, newName);
	                    },
	                    onEditingStatusChange: function(id, isEditing) {
	                        var qqInput = qq(templating.getEditInput(id)), qqFileContainer = qq(templating.getFileContainer(id));
	                        if (isEditing) {
	                            qqInput.addClass("qq-editing");
	                            templating.hideFilename(id);
	                            templating.hideEditIcon(id);
	                        } else {
	                            qqInput.removeClass("qq-editing");
	                            templating.showFilename(id);
	                            templating.showEditIcon(id);
	                        }
	                        qqFileContainer.addClass("qq-temp").removeClass("qq-temp");
	                    }
	                };
	            },
	            _onUploadStatusChange: function(id, oldStatus, newStatus) {
	                this._parent.prototype._onUploadStatusChange.apply(this, arguments);
	                if (this._isEditFilenameEnabled()) {
	                    if (this._templating.getFileContainer(id) && newStatus !== qq.status.SUBMITTED) {
	                        this._templating.markFilenameEditable(id);
	                        this._templating.hideEditIcon(id);
	                    }
	                }
	                if (oldStatus === qq.status.UPLOAD_RETRYING && newStatus === qq.status.UPLOADING) {
	                    this._templating.hideRetry(id);
	                    this._templating.setStatusText(id);
	                    qq(this._templating.getFileContainer(id)).removeClass(this._classes.retrying);
	                } else if (newStatus === qq.status.UPLOAD_FAILED) {
	                    this._templating.hidePause(id);
	                }
	            },
	            _bindFilenameInputFocusInEvent: function() {
	                var spec = qq.extend({}, this._filenameEditHandler());
	                return new qq.FilenameInputFocusInHandler(spec);
	            },
	            _bindFilenameInputFocusEvent: function() {
	                var spec = qq.extend({}, this._filenameEditHandler());
	                return new qq.FilenameInputFocusHandler(spec);
	            },
	            _bindFilenameClickEvent: function() {
	                var spec = qq.extend({}, this._filenameEditHandler());
	                return new qq.FilenameClickHandler(spec);
	            },
	            _storeForLater: function(id) {
	                this._parent.prototype._storeForLater.apply(this, arguments);
	                this._templating.hideSpinner(id);
	            },
	            _onAllComplete: function(successful, failed) {
	                this._parent.prototype._onAllComplete.apply(this, arguments);
	                this._templating.resetTotalProgress();
	            },
	            _onSubmit: function(id, name) {
	                var file = this.getFile(id);
	                if (file && file.qqPath && this._options.dragAndDrop.reportDirectoryPaths) {
	                    this._paramsStore.addReadOnly(id, {
	                        qqpath: file.qqPath
	                    });
	                }
	                this._parent.prototype._onSubmit.apply(this, arguments);
	                this._addToList(id, name);
	            },
	            _onSubmitted: function(id) {
	                if (this._isEditFilenameEnabled()) {
	                    this._templating.markFilenameEditable(id);
	                    this._templating.showEditIcon(id);
	                    if (!this._focusinEventSupported) {
	                        this._filenameInputFocusHandler.addHandler(this._templating.getEditInput(id));
	                    }
	                }
	            },
	            _onProgress: function(id, name, loaded, total) {
	                this._parent.prototype._onProgress.apply(this, arguments);
	                this._templating.updateProgress(id, loaded, total);
	                if (Math.round(loaded / total * 100) === 100) {
	                    this._templating.hideCancel(id);
	                    this._templating.hidePause(id);
	                    this._templating.hideProgress(id);
	                    this._templating.setStatusText(id, this._options.text.waitingForResponse);
	                    this._displayFileSize(id);
	                } else {
	                    this._displayFileSize(id, loaded, total);
	                }
	            },
	            _onTotalProgress: function(loaded, total) {
	                this._parent.prototype._onTotalProgress.apply(this, arguments);
	                this._templating.updateTotalProgress(loaded, total);
	            },
	            _onComplete: function(id, name, result, xhr) {
	                var parentRetVal = this._parent.prototype._onComplete.apply(this, arguments), templating = this._templating, fileContainer = templating.getFileContainer(id), self = this;
	                function completeUpload(result) {
	                    if (!fileContainer) {
	                        return;
	                    }
	                    templating.setStatusText(id);
	                    qq(fileContainer).removeClass(self._classes.retrying);
	                    templating.hideProgress(id);
	                    if (self.getUploads({
	                        id: id
	                    }).status !== qq.status.UPLOAD_FAILED) {
	                        templating.hideCancel(id);
	                    }
	                    templating.hideSpinner(id);
	                    if (result.success) {
	                        self._markFileAsSuccessful(id);
	                    } else {
	                        qq(fileContainer).addClass(self._classes.fail);
	                        templating.showCancel(id);
	                        if (templating.isRetryPossible() && !self._preventRetries[id]) {
	                            qq(fileContainer).addClass(self._classes.retryable);
	                            templating.showRetry(id);
	                        }
	                        self._controlFailureTextDisplay(id, result);
	                    }
	                }
	                if (parentRetVal instanceof qq.Promise) {
	                    parentRetVal.done(function(newResult) {
	                        completeUpload(newResult);
	                    });
	                } else {
	                    completeUpload(result);
	                }
	                return parentRetVal;
	            },
	            _markFileAsSuccessful: function(id) {
	                var templating = this._templating;
	                if (this._isDeletePossible()) {
	                    templating.showDeleteButton(id);
	                }
	                qq(templating.getFileContainer(id)).addClass(this._classes.success);
	                this._maybeUpdateThumbnail(id);
	            },
	            _onUploadPrep: function(id) {
	                this._parent.prototype._onUploadPrep.apply(this, arguments);
	                this._templating.showSpinner(id);
	            },
	            _onUpload: function(id, name) {
	                var parentRetVal = this._parent.prototype._onUpload.apply(this, arguments);
	                this._templating.showSpinner(id);
	                return parentRetVal;
	            },
	            _onUploadChunk: function(id, chunkData) {
	                this._parent.prototype._onUploadChunk.apply(this, arguments);
	                if (chunkData.partIndex > 0 && this._handler.isResumable(id)) {
	                    this._templating.allowPause(id);
	                }
	            },
	            _onCancel: function(id, name) {
	                this._parent.prototype._onCancel.apply(this, arguments);
	                this._removeFileItem(id);
	                if (this._getNotFinished() === 0) {
	                    this._templating.resetTotalProgress();
	                }
	            },
	            _onBeforeAutoRetry: function(id) {
	                var retryNumForDisplay, maxAuto, retryNote;
	                this._parent.prototype._onBeforeAutoRetry.apply(this, arguments);
	                this._showCancelLink(id);
	                if (this._options.retry.showAutoRetryNote) {
	                    retryNumForDisplay = this._autoRetries[id];
	                    maxAuto = this._options.retry.maxAutoAttempts;
	                    retryNote = this._options.retry.autoRetryNote.replace(/\{retryNum\}/g, retryNumForDisplay);
	                    retryNote = retryNote.replace(/\{maxAuto\}/g, maxAuto);
	                    this._templating.setStatusText(id, retryNote);
	                    qq(this._templating.getFileContainer(id)).addClass(this._classes.retrying);
	                }
	            },
	            _onBeforeManualRetry: function(id) {
	                if (this._parent.prototype._onBeforeManualRetry.apply(this, arguments)) {
	                    this._templating.resetProgress(id);
	                    qq(this._templating.getFileContainer(id)).removeClass(this._classes.fail);
	                    this._templating.setStatusText(id);
	                    this._templating.showSpinner(id);
	                    this._showCancelLink(id);
	                    return true;
	                } else {
	                    qq(this._templating.getFileContainer(id)).addClass(this._classes.retryable);
	                    this._templating.showRetry(id);
	                    return false;
	                }
	            },
	            _onSubmitDelete: function(id) {
	                var onSuccessCallback = qq.bind(this._onSubmitDeleteSuccess, this);
	                this._parent.prototype._onSubmitDelete.call(this, id, onSuccessCallback);
	            },
	            _onSubmitDeleteSuccess: function(id, uuid, additionalMandatedParams) {
	                if (this._options.deleteFile.forceConfirm) {
	                    this._showDeleteConfirm.apply(this, arguments);
	                } else {
	                    this._sendDeleteRequest.apply(this, arguments);
	                }
	            },
	            _onDeleteComplete: function(id, xhr, isError) {
	                this._parent.prototype._onDeleteComplete.apply(this, arguments);
	                this._templating.hideSpinner(id);
	                if (isError) {
	                    this._templating.setStatusText(id, this._options.deleteFile.deletingFailedText);
	                    this._templating.showDeleteButton(id);
	                } else {
	                    this._removeFileItem(id);
	                }
	            },
	            _sendDeleteRequest: function(id, uuid, additionalMandatedParams) {
	                this._templating.hideDeleteButton(id);
	                this._templating.showSpinner(id);
	                this._templating.setStatusText(id, this._options.deleteFile.deletingStatusText);
	                this._deleteHandler.sendDelete.apply(this, arguments);
	            },
	            _showDeleteConfirm: function(id, uuid, mandatedParams) {
	                var fileName = this.getName(id), confirmMessage = this._options.deleteFile.confirmMessage.replace(/\{filename\}/g, fileName), uuid = this.getUuid(id), deleteRequestArgs = arguments, self = this, retVal;
	                retVal = this._options.showConfirm(confirmMessage);
	                if (qq.isGenericPromise(retVal)) {
	                    retVal.then(function() {
	                        self._sendDeleteRequest.apply(self, deleteRequestArgs);
	                    });
	                } else if (retVal !== false) {
	                    self._sendDeleteRequest.apply(self, deleteRequestArgs);
	                }
	            },
	            _addToList: function(id, name, canned) {
	                var prependData, prependIndex = 0, dontDisplay = this._handler.isProxied(id) && this._options.scaling.hideScaled, record;
	                if (this._options.display.prependFiles) {
	                    if (this._totalFilesInBatch > 1 && this._filesInBatchAddedToUi > 0) {
	                        prependIndex = this._filesInBatchAddedToUi - 1;
	                    }
	                    prependData = {
	                        index: prependIndex
	                    };
	                }
	                if (!canned) {
	                    if (this._options.disableCancelForFormUploads && !qq.supportedFeatures.ajaxUploading) {
	                        this._templating.disableCancel();
	                    }
	                    if (!this._options.multiple) {
	                        record = this.getUploads({
	                            id: id
	                        });
	                        this._handledProxyGroup = this._handledProxyGroup || record.proxyGroupId;
	                        if (record.proxyGroupId !== this._handledProxyGroup || !record.proxyGroupId) {
	                            this._handler.cancelAll();
	                            this._clearList();
	                            this._handledProxyGroup = null;
	                        }
	                    }
	                }
	                if (canned) {
	                    this._templating.addFileToCache(id, this._options.formatFileName(name), prependData, dontDisplay);
	                    this._templating.updateThumbnail(id, this._thumbnailUrls[id], true, this._options.thumbnails.customResizer);
	                } else {
	                    this._templating.addFile(id, this._options.formatFileName(name), prependData, dontDisplay);
	                    this._templating.generatePreview(id, this.getFile(id), this._options.thumbnails.customResizer);
	                }
	                this._filesInBatchAddedToUi += 1;
	                if (canned || this._options.display.fileSizeOnSubmit && qq.supportedFeatures.ajaxUploading) {
	                    this._displayFileSize(id);
	                }
	            },
	            _clearList: function() {
	                this._templating.clearFiles();
	                this.clearStoredFiles();
	            },
	            _displayFileSize: function(id, loadedSize, totalSize) {
	                var size = this.getSize(id), sizeForDisplay = this._formatSize(size);
	                if (size >= 0) {
	                    if (loadedSize !== undefined && totalSize !== undefined) {
	                        sizeForDisplay = this._formatProgress(loadedSize, totalSize);
	                    }
	                    this._templating.updateSize(id, sizeForDisplay);
	                }
	            },
	            _formatProgress: function(uploadedSize, totalSize) {
	                var message = this._options.text.formatProgress;
	                function r(name, replacement) {
	                    message = message.replace(name, replacement);
	                }
	                r("{percent}", Math.round(uploadedSize / totalSize * 100));
	                r("{total_size}", this._formatSize(totalSize));
	                return message;
	            },
	            _controlFailureTextDisplay: function(id, response) {
	                var mode, responseProperty, failureReason;
	                mode = this._options.failedUploadTextDisplay.mode;
	                responseProperty = this._options.failedUploadTextDisplay.responseProperty;
	                if (mode === "custom") {
	                    failureReason = response[responseProperty];
	                    if (!failureReason) {
	                        failureReason = this._options.text.failUpload;
	                    }
	                    this._templating.setStatusText(id, failureReason);
	                    if (this._options.failedUploadTextDisplay.enableTooltip) {
	                        this._showTooltip(id, failureReason);
	                    }
	                } else if (mode === "default") {
	                    this._templating.setStatusText(id, this._options.text.failUpload);
	                } else if (mode !== "none") {
	                    this.log("failedUploadTextDisplay.mode value of '" + mode + "' is not valid", "warn");
	                }
	            },
	            _showTooltip: function(id, text) {
	                this._templating.getFileContainer(id).title = text;
	            },
	            _showCancelLink: function(id) {
	                if (!this._options.disableCancelForFormUploads || qq.supportedFeatures.ajaxUploading) {
	                    this._templating.showCancel(id);
	                }
	            },
	            _itemError: function(code, name, item) {
	                var message = this._parent.prototype._itemError.apply(this, arguments);
	                this._options.showMessage(message);
	            },
	            _batchError: function(message) {
	                this._parent.prototype._batchError.apply(this, arguments);
	                this._options.showMessage(message);
	            },
	            _setupPastePrompt: function() {
	                var self = this;
	                this._options.callbacks.onPasteReceived = function() {
	                    var message = self._options.paste.namePromptMessage, defaultVal = self._options.paste.defaultName;
	                    return self._options.showPrompt(message, defaultVal);
	                };
	            },
	            _fileOrBlobRejected: function(id, name) {
	                this._totalFilesInBatch -= 1;
	                this._parent.prototype._fileOrBlobRejected.apply(this, arguments);
	            },
	            _prepareItemsForUpload: function(items, params, endpoint) {
	                this._totalFilesInBatch = items.length;
	                this._filesInBatchAddedToUi = 0;
	                this._parent.prototype._prepareItemsForUpload.apply(this, arguments);
	            },
	            _maybeUpdateThumbnail: function(fileId) {
	                var thumbnailUrl = this._thumbnailUrls[fileId], fileStatus = this.getUploads({
	                    id: fileId
	                }).status;
	                if (fileStatus !== qq.status.DELETED && (thumbnailUrl || this._options.thumbnails.placeholders.waitUntilResponse || !qq.supportedFeatures.imagePreviews)) {
	                    this._templating.updateThumbnail(fileId, thumbnailUrl, this._options.thumbnails.customResizer);
	                }
	            },
	            _addCannedFile: function(sessionData) {
	                var id = this._parent.prototype._addCannedFile.apply(this, arguments);
	                this._addToList(id, this.getName(id), true);
	                this._templating.hideSpinner(id);
	                this._templating.hideCancel(id);
	                this._markFileAsSuccessful(id);
	                return id;
	            },
	            _setSize: function(id, newSize) {
	                this._parent.prototype._setSize.apply(this, arguments);
	                this._templating.updateSize(id, this._formatSize(newSize));
	            },
	            _sessionRequestComplete: function() {
	                this._templating.addCacheToDom();
	                this._parent.prototype._sessionRequestComplete.apply(this, arguments);
	            }
	        };
	    })();
	    qq.FineUploader = function(o, namespace) {
	        "use strict";
	        var self = this;
	        this._parent = namespace ? qq[namespace].FineUploaderBasic : qq.FineUploaderBasic;
	        this._parent.apply(this, arguments);
	        qq.extend(this._options, {
	            element: null,
	            button: null,
	            listElement: null,
	            dragAndDrop: {
	                extraDropzones: [],
	                reportDirectoryPaths: false
	            },
	            text: {
	                formatProgress: "{percent}% of {total_size}",
	                failUpload: "Upload failed",
	                waitingForResponse: "Processing...",
	                paused: "Paused"
	            },
	            template: "qq-template",
	            classes: {
	                retrying: "qq-upload-retrying",
	                retryable: "qq-upload-retryable",
	                success: "qq-upload-success",
	                fail: "qq-upload-fail",
	                editable: "qq-editable",
	                hide: "qq-hide",
	                dropActive: "qq-upload-drop-area-active"
	            },
	            failedUploadTextDisplay: {
	                mode: "default",
	                responseProperty: "error",
	                enableTooltip: true
	            },
	            messages: {
	                tooManyFilesError: "You may only drop one file",
	                unsupportedBrowser: "Unrecoverable error - this browser does not permit file uploading of any kind."
	            },
	            retry: {
	                showAutoRetryNote: true,
	                autoRetryNote: "Retrying {retryNum}/{maxAuto}..."
	            },
	            deleteFile: {
	                forceConfirm: false,
	                confirmMessage: "Are you sure you want to delete {filename}?",
	                deletingStatusText: "Deleting...",
	                deletingFailedText: "Delete failed"
	            },
	            display: {
	                fileSizeOnSubmit: false,
	                prependFiles: false
	            },
	            paste: {
	                promptForName: false,
	                namePromptMessage: "Please name this image"
	            },
	            thumbnails: {
	                customResizer: null,
	                maxCount: 0,
	                placeholders: {
	                    waitUntilResponse: false,
	                    notAvailablePath: null,
	                    waitingPath: null
	                },
	                timeBetweenThumbs: 750
	            },
	            scaling: {
	                hideScaled: false
	            },
	            showMessage: function(message) {
	                if (self._templating.hasDialog("alert")) {
	                    return self._templating.showDialog("alert", message);
	                } else {
	                    setTimeout(function() {
	                        window.alert(message);
	                    }, 0);
	                }
	            },
	            showConfirm: function(message) {
	                if (self._templating.hasDialog("confirm")) {
	                    return self._templating.showDialog("confirm", message);
	                } else {
	                    return window.confirm(message);
	                }
	            },
	            showPrompt: function(message, defaultValue) {
	                if (self._templating.hasDialog("prompt")) {
	                    return self._templating.showDialog("prompt", message, defaultValue);
	                } else {
	                    return window.prompt(message, defaultValue);
	                }
	            }
	        }, true);
	        qq.extend(this._options, o, true);
	        this._templating = new qq.Templating({
	            log: qq.bind(this.log, this),
	            templateIdOrEl: this._options.template,
	            containerEl: this._options.element,
	            fileContainerEl: this._options.listElement,
	            button: this._options.button,
	            imageGenerator: this._imageGenerator,
	            classes: {
	                hide: this._options.classes.hide,
	                editable: this._options.classes.editable
	            },
	            limits: {
	                maxThumbs: this._options.thumbnails.maxCount,
	                timeBetweenThumbs: this._options.thumbnails.timeBetweenThumbs
	            },
	            placeholders: {
	                waitUntilUpdate: this._options.thumbnails.placeholders.waitUntilResponse,
	                thumbnailNotAvailable: this._options.thumbnails.placeholders.notAvailablePath,
	                waitingForThumbnail: this._options.thumbnails.placeholders.waitingPath
	            },
	            text: this._options.text
	        });
	        if (this._options.workarounds.ios8SafariUploads && qq.ios800() && qq.iosSafari()) {
	            this._templating.renderFailure(this._options.messages.unsupportedBrowserIos8Safari);
	        } else if (!qq.supportedFeatures.uploading || this._options.cors.expected && !qq.supportedFeatures.uploadCors) {
	            this._templating.renderFailure(this._options.messages.unsupportedBrowser);
	        } else {
	            this._wrapCallbacks();
	            this._templating.render();
	            this._classes = this._options.classes;
	            if (!this._options.button && this._templating.getButton()) {
	                this._defaultButtonId = this._createUploadButton({
	                    element: this._templating.getButton(),
	                    title: this._options.text.fileInputTitle
	                }).getButtonId();
	            }
	            this._setupClickAndEditEventHandlers();
	            if (qq.DragAndDrop && qq.supportedFeatures.fileDrop) {
	                this._dnd = this._setupDragAndDrop();
	            }
	            if (this._options.paste.targetElement && this._options.paste.promptForName) {
	                if (qq.PasteSupport) {
	                    this._setupPastePrompt();
	                } else {
	                    this.log("Paste support module not found.", "error");
	                }
	            }
	            this._totalFilesInBatch = 0;
	            this._filesInBatchAddedToUi = 0;
	        }
	    };
	    qq.extend(qq.FineUploader.prototype, qq.basePublicApi);
	    qq.extend(qq.FineUploader.prototype, qq.basePrivateApi);
	    qq.extend(qq.FineUploader.prototype, qq.uiPublicApi);
	    qq.extend(qq.FineUploader.prototype, qq.uiPrivateApi);
	    qq.Templating = function(spec) {
	        "use strict";
	        var FILE_ID_ATTR = "qq-file-id", FILE_CLASS_PREFIX = "qq-file-id-", THUMBNAIL_MAX_SIZE_ATTR = "qq-max-size", THUMBNAIL_SERVER_SCALE_ATTR = "qq-server-scale", HIDE_DROPZONE_ATTR = "qq-hide-dropzone", DROPZPONE_TEXT_ATTR = "qq-drop-area-text", IN_PROGRESS_CLASS = "qq-in-progress", HIDDEN_FOREVER_CLASS = "qq-hidden-forever", fileBatch = {
	            content: document.createDocumentFragment(),
	            map: {}
	        }, isCancelDisabled = false, generatedThumbnails = 0, thumbnailQueueMonitorRunning = false, thumbGenerationQueue = [], thumbnailMaxSize = -1, options = {
	            log: null,
	            limits: {
	                maxThumbs: 0,
	                timeBetweenThumbs: 750
	            },
	            templateIdOrEl: "qq-template",
	            containerEl: null,
	            fileContainerEl: null,
	            button: null,
	            imageGenerator: null,
	            classes: {
	                hide: "qq-hide",
	                editable: "qq-editable"
	            },
	            placeholders: {
	                waitUntilUpdate: false,
	                thumbnailNotAvailable: null,
	                waitingForThumbnail: null
	            },
	            text: {
	                paused: "Paused"
	            }
	        }, selectorClasses = {
	            button: "qq-upload-button-selector",
	            alertDialog: "qq-alert-dialog-selector",
	            dialogCancelButton: "qq-cancel-button-selector",
	            confirmDialog: "qq-confirm-dialog-selector",
	            dialogMessage: "qq-dialog-message-selector",
	            dialogOkButton: "qq-ok-button-selector",
	            promptDialog: "qq-prompt-dialog-selector",
	            uploader: "qq-uploader-selector",
	            drop: "qq-upload-drop-area-selector",
	            list: "qq-upload-list-selector",
	            progressBarContainer: "qq-progress-bar-container-selector",
	            progressBar: "qq-progress-bar-selector",
	            totalProgressBarContainer: "qq-total-progress-bar-container-selector",
	            totalProgressBar: "qq-total-progress-bar-selector",
	            file: "qq-upload-file-selector",
	            spinner: "qq-upload-spinner-selector",
	            size: "qq-upload-size-selector",
	            cancel: "qq-upload-cancel-selector",
	            pause: "qq-upload-pause-selector",
	            continueButton: "qq-upload-continue-selector",
	            deleteButton: "qq-upload-delete-selector",
	            retry: "qq-upload-retry-selector",
	            statusText: "qq-upload-status-text-selector",
	            editFilenameInput: "qq-edit-filename-selector",
	            editNameIcon: "qq-edit-filename-icon-selector",
	            dropText: "qq-upload-drop-area-text-selector",
	            dropProcessing: "qq-drop-processing-selector",
	            dropProcessingSpinner: "qq-drop-processing-spinner-selector",
	            thumbnail: "qq-thumbnail-selector"
	        }, previewGeneration = {}, cachedThumbnailNotAvailableImg = new qq.Promise(), cachedWaitingForThumbnailImg = new qq.Promise(), log, isEditElementsExist, isRetryElementExist, templateHtml, container, fileList, showThumbnails, serverScale, cacheThumbnailPlaceholders = function() {
	            var notAvailableUrl = options.placeholders.thumbnailNotAvailable, waitingUrl = options.placeholders.waitingForThumbnail, spec = {
	                maxSize: thumbnailMaxSize,
	                scale: serverScale
	            };
	            if (showThumbnails) {
	                if (notAvailableUrl) {
	                    options.imageGenerator.generate(notAvailableUrl, new Image(), spec).then(function(updatedImg) {
	                        cachedThumbnailNotAvailableImg.success(updatedImg);
	                    }, function() {
	                        cachedThumbnailNotAvailableImg.failure();
	                        log("Problem loading 'not available' placeholder image at " + notAvailableUrl, "error");
	                    });
	                } else {
	                    cachedThumbnailNotAvailableImg.failure();
	                }
	                if (waitingUrl) {
	                    options.imageGenerator.generate(waitingUrl, new Image(), spec).then(function(updatedImg) {
	                        cachedWaitingForThumbnailImg.success(updatedImg);
	                    }, function() {
	                        cachedWaitingForThumbnailImg.failure();
	                        log("Problem loading 'waiting for thumbnail' placeholder image at " + waitingUrl, "error");
	                    });
	                } else {
	                    cachedWaitingForThumbnailImg.failure();
	                }
	            }
	        }, displayWaitingImg = function(thumbnail) {
	            var waitingImgPlacement = new qq.Promise();
	            cachedWaitingForThumbnailImg.then(function(img) {
	                maybeScalePlaceholderViaCss(img, thumbnail);
	                if (!thumbnail.src) {
	                    thumbnail.src = img.src;
	                    thumbnail.onload = function() {
	                        thumbnail.onload = null;
	                        show(thumbnail);
	                        waitingImgPlacement.success();
	                    };
	                } else {
	                    waitingImgPlacement.success();
	                }
	            }, function() {
	                hide(thumbnail);
	                waitingImgPlacement.success();
	            });
	            return waitingImgPlacement;
	        }, generateNewPreview = function(id, blob, spec) {
	            var thumbnail = getThumbnail(id);
	            log("Generating new thumbnail for " + id);
	            blob.qqThumbnailId = id;
	            return options.imageGenerator.generate(blob, thumbnail, spec).then(function() {
	                generatedThumbnails++;
	                show(thumbnail);
	                previewGeneration[id].success();
	            }, function() {
	                previewGeneration[id].failure();
	                if (!options.placeholders.waitUntilUpdate) {
	                    maybeSetDisplayNotAvailableImg(id, thumbnail);
	                }
	            });
	        }, generateNextQueuedPreview = function() {
	            if (thumbGenerationQueue.length) {
	                thumbnailQueueMonitorRunning = true;
	                var queuedThumbRequest = thumbGenerationQueue.shift();
	                if (queuedThumbRequest.update) {
	                    processUpdateQueuedPreviewRequest(queuedThumbRequest);
	                } else {
	                    processNewQueuedPreviewRequest(queuedThumbRequest);
	                }
	            } else {
	                thumbnailQueueMonitorRunning = false;
	            }
	        }, getCancel = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.cancel);
	        }, getContinue = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.continueButton);
	        }, getDialog = function(type) {
	            return getTemplateEl(container, selectorClasses[type + "Dialog"]);
	        }, getDelete = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.deleteButton);
	        }, getDropProcessing = function() {
	            return getTemplateEl(container, selectorClasses.dropProcessing);
	        }, getEditIcon = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.editNameIcon);
	        }, getFile = function(id) {
	            return fileBatch.map[id] || qq(fileList).getFirstByClass(FILE_CLASS_PREFIX + id);
	        }, getFilename = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.file);
	        }, getPause = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.pause);
	        }, getProgress = function(id) {
	            if (id == null) {
	                return getTemplateEl(container, selectorClasses.totalProgressBarContainer) || getTemplateEl(container, selectorClasses.totalProgressBar);
	            }
	            return getTemplateEl(getFile(id), selectorClasses.progressBarContainer) || getTemplateEl(getFile(id), selectorClasses.progressBar);
	        }, getRetry = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.retry);
	        }, getSize = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.size);
	        }, getSpinner = function(id) {
	            return getTemplateEl(getFile(id), selectorClasses.spinner);
	        }, getTemplateEl = function(context, cssClass) {
	            return context && qq(context).getFirstByClass(cssClass);
	        }, getThumbnail = function(id) {
	            return showThumbnails && getTemplateEl(getFile(id), selectorClasses.thumbnail);
	        }, hide = function(el) {
	            el && qq(el).addClass(options.classes.hide);
	        }, maybeScalePlaceholderViaCss = function(placeholder, thumbnail) {
	            var maxWidth = placeholder.style.maxWidth, maxHeight = placeholder.style.maxHeight;
	            if (maxHeight && maxWidth && !thumbnail.style.maxWidth && !thumbnail.style.maxHeight) {
	                qq(thumbnail).css({
	                    maxWidth: maxWidth,
	                    maxHeight: maxHeight
	                });
	            }
	        }, maybeSetDisplayNotAvailableImg = function(id, thumbnail) {
	            var previewing = previewGeneration[id] || new qq.Promise().failure(), notAvailableImgPlacement = new qq.Promise();
	            cachedThumbnailNotAvailableImg.then(function(img) {
	                previewing.then(function() {
	                    notAvailableImgPlacement.success();
	                }, function() {
	                    maybeScalePlaceholderViaCss(img, thumbnail);
	                    thumbnail.onload = function() {
	                        thumbnail.onload = null;
	                        notAvailableImgPlacement.success();
	                    };
	                    thumbnail.src = img.src;
	                    show(thumbnail);
	                });
	            });
	            return notAvailableImgPlacement;
	        }, parseAndGetTemplate = function() {
	            var scriptEl, scriptHtml, fileListNode, tempTemplateEl, fileListHtml, defaultButton, dropArea, thumbnail, dropProcessing, dropTextEl, uploaderEl;
	            log("Parsing template");
	            if (options.templateIdOrEl == null) {
	                throw new Error("You MUST specify either a template element or ID!");
	            }
	            if (qq.isString(options.templateIdOrEl)) {
	                scriptEl = document.getElementById(options.templateIdOrEl);
	                if (scriptEl === null) {
	                    throw new Error(qq.format("Cannot find template script at ID '{}'!", options.templateIdOrEl));
	                }
	                scriptHtml = scriptEl.innerHTML;
	            } else {
	                if (options.templateIdOrEl.innerHTML === undefined) {
	                    throw new Error("You have specified an invalid value for the template option!  " + "It must be an ID or an Element.");
	                }
	                scriptHtml = options.templateIdOrEl.innerHTML;
	            }
	            scriptHtml = qq.trimStr(scriptHtml);
	            tempTemplateEl = document.createElement("div");
	            tempTemplateEl.appendChild(qq.toElement(scriptHtml));
	            uploaderEl = qq(tempTemplateEl).getFirstByClass(selectorClasses.uploader);
	            if (options.button) {
	                defaultButton = qq(tempTemplateEl).getFirstByClass(selectorClasses.button);
	                if (defaultButton) {
	                    qq(defaultButton).remove();
	                }
	            }
	            if (!qq.DragAndDrop || !qq.supportedFeatures.fileDrop) {
	                dropProcessing = qq(tempTemplateEl).getFirstByClass(selectorClasses.dropProcessing);
	                if (dropProcessing) {
	                    qq(dropProcessing).remove();
	                }
	            }
	            dropArea = qq(tempTemplateEl).getFirstByClass(selectorClasses.drop);
	            if (dropArea && !qq.DragAndDrop) {
	                log("DnD module unavailable.", "info");
	                qq(dropArea).remove();
	            }
	            if (!qq.supportedFeatures.fileDrop) {
	                uploaderEl.removeAttribute(DROPZPONE_TEXT_ATTR);
	                if (dropArea && qq(dropArea).hasAttribute(HIDE_DROPZONE_ATTR)) {
	                    qq(dropArea).css({
	                        display: "none"
	                    });
	                }
	            } else if (qq(uploaderEl).hasAttribute(DROPZPONE_TEXT_ATTR) && dropArea) {
	                dropTextEl = qq(dropArea).getFirstByClass(selectorClasses.dropText);
	                dropTextEl && qq(dropTextEl).remove();
	            }
	            thumbnail = qq(tempTemplateEl).getFirstByClass(selectorClasses.thumbnail);
	            if (!showThumbnails) {
	                thumbnail && qq(thumbnail).remove();
	            } else if (thumbnail) {
	                thumbnailMaxSize = parseInt(thumbnail.getAttribute(THUMBNAIL_MAX_SIZE_ATTR));
	                thumbnailMaxSize = thumbnailMaxSize > 0 ? thumbnailMaxSize : null;
	                serverScale = qq(thumbnail).hasAttribute(THUMBNAIL_SERVER_SCALE_ATTR);
	            }
	            showThumbnails = showThumbnails && thumbnail;
	            isEditElementsExist = qq(tempTemplateEl).getByClass(selectorClasses.editFilenameInput).length > 0;
	            isRetryElementExist = qq(tempTemplateEl).getByClass(selectorClasses.retry).length > 0;
	            fileListNode = qq(tempTemplateEl).getFirstByClass(selectorClasses.list);
	            if (fileListNode == null) {
	                throw new Error("Could not find the file list container in the template!");
	            }
	            fileListHtml = fileListNode.innerHTML;
	            fileListNode.innerHTML = "";
	            if (tempTemplateEl.getElementsByTagName("DIALOG").length) {
	                document.createElement("dialog");
	            }
	            log("Template parsing complete");
	            return {
	                template: qq.trimStr(tempTemplateEl.innerHTML),
	                fileTemplate: qq.trimStr(fileListHtml)
	            };
	        }, prependFile = function(el, index, fileList) {
	            var parentEl = fileList, beforeEl = parentEl.firstChild;
	            if (index > 0) {
	                beforeEl = qq(parentEl).children()[index].nextSibling;
	            }
	            parentEl.insertBefore(el, beforeEl);
	        }, processNewQueuedPreviewRequest = function(queuedThumbRequest) {
	            var id = queuedThumbRequest.id, optFileOrBlob = queuedThumbRequest.optFileOrBlob, relatedThumbnailId = optFileOrBlob && optFileOrBlob.qqThumbnailId, thumbnail = getThumbnail(id), spec = {
	                customResizeFunction: queuedThumbRequest.customResizeFunction,
	                maxSize: thumbnailMaxSize,
	                orient: true,
	                scale: true
	            };
	            if (qq.supportedFeatures.imagePreviews) {
	                if (thumbnail) {
	                    if (options.limits.maxThumbs && options.limits.maxThumbs <= generatedThumbnails) {
	                        maybeSetDisplayNotAvailableImg(id, thumbnail);
	                        generateNextQueuedPreview();
	                    } else {
	                        displayWaitingImg(thumbnail).done(function() {
	                            previewGeneration[id] = new qq.Promise();
	                            previewGeneration[id].done(function() {
	                                setTimeout(generateNextQueuedPreview, options.limits.timeBetweenThumbs);
	                            });
	                            if (relatedThumbnailId != null) {
	                                useCachedPreview(id, relatedThumbnailId);
	                            } else {
	                                generateNewPreview(id, optFileOrBlob, spec);
	                            }
	                        });
	                    }
	                } else {
	                    generateNextQueuedPreview();
	                }
	            } else if (thumbnail) {
	                displayWaitingImg(thumbnail);
	                generateNextQueuedPreview();
	            }
	        }, processUpdateQueuedPreviewRequest = function(queuedThumbRequest) {
	            var id = queuedThumbRequest.id, thumbnailUrl = queuedThumbRequest.thumbnailUrl, showWaitingImg = queuedThumbRequest.showWaitingImg, thumbnail = getThumbnail(id), spec = {
	                customResizeFunction: queuedThumbRequest.customResizeFunction,
	                scale: serverScale,
	                maxSize: thumbnailMaxSize
	            };
	            if (thumbnail) {
	                if (thumbnailUrl) {
	                    if (options.limits.maxThumbs && options.limits.maxThumbs <= generatedThumbnails) {
	                        maybeSetDisplayNotAvailableImg(id, thumbnail);
	                        generateNextQueuedPreview();
	                    } else {
	                        if (showWaitingImg) {
	                            displayWaitingImg(thumbnail);
	                        }
	                        return options.imageGenerator.generate(thumbnailUrl, thumbnail, spec).then(function() {
	                            show(thumbnail);
	                            generatedThumbnails++;
	                            setTimeout(generateNextQueuedPreview, options.limits.timeBetweenThumbs);
	                        }, function() {
	                            maybeSetDisplayNotAvailableImg(id, thumbnail);
	                            setTimeout(generateNextQueuedPreview, options.limits.timeBetweenThumbs);
	                        });
	                    }
	                } else {
	                    maybeSetDisplayNotAvailableImg(id, thumbnail);
	                    generateNextQueuedPreview();
	                }
	            }
	        }, setProgressBarWidth = function(id, percent) {
	            var bar = getProgress(id), progressBarSelector = id == null ? selectorClasses.totalProgressBar : selectorClasses.progressBar;
	            if (bar && !qq(bar).hasClass(progressBarSelector)) {
	                bar = qq(bar).getFirstByClass(progressBarSelector);
	            }
	            if (bar) {
	                qq(bar).css({
	                    width: percent + "%"
	                });
	                bar.setAttribute("aria-valuenow", percent);
	            }
	        }, show = function(el) {
	            el && qq(el).removeClass(options.classes.hide);
	        }, useCachedPreview = function(targetThumbnailId, cachedThumbnailId) {
	            var targetThumbnail = getThumbnail(targetThumbnailId), cachedThumbnail = getThumbnail(cachedThumbnailId);
	            log(qq.format("ID {} is the same file as ID {}.  Will use generated thumbnail from ID {} instead.", targetThumbnailId, cachedThumbnailId, cachedThumbnailId));
	            previewGeneration[cachedThumbnailId].then(function() {
	                generatedThumbnails++;
	                previewGeneration[targetThumbnailId].success();
	                log(qq.format("Now using previously generated thumbnail created for ID {} on ID {}.", cachedThumbnailId, targetThumbnailId));
	                targetThumbnail.src = cachedThumbnail.src;
	                show(targetThumbnail);
	            }, function() {
	                previewGeneration[targetThumbnailId].failure();
	                if (!options.placeholders.waitUntilUpdate) {
	                    maybeSetDisplayNotAvailableImg(targetThumbnailId, targetThumbnail);
	                }
	            });
	        };
	        qq.extend(options, spec);
	        log = options.log;
	        if (!qq.supportedFeatures.imagePreviews) {
	            options.limits.timeBetweenThumbs = 0;
	            options.limits.maxThumbs = 0;
	        }
	        container = options.containerEl;
	        showThumbnails = options.imageGenerator !== undefined;
	        templateHtml = parseAndGetTemplate();
	        cacheThumbnailPlaceholders();
	        qq.extend(this, {
	            render: function() {
	                log("Rendering template in DOM.");
	                generatedThumbnails = 0;
	                container.innerHTML = templateHtml.template;
	                hide(getDropProcessing());
	                this.hideTotalProgress();
	                fileList = options.fileContainerEl || getTemplateEl(container, selectorClasses.list);
	                log("Template rendering complete");
	            },
	            renderFailure: function(message) {
	                var cantRenderEl = qq.toElement(message);
	                container.innerHTML = "";
	                container.appendChild(cantRenderEl);
	            },
	            reset: function() {
	                this.render();
	            },
	            clearFiles: function() {
	                fileList.innerHTML = "";
	            },
	            disableCancel: function() {
	                isCancelDisabled = true;
	            },
	            addFile: function(id, name, prependInfo, hideForever, batch) {
	                var fileEl = qq.toElement(templateHtml.fileTemplate), fileNameEl = getTemplateEl(fileEl, selectorClasses.file), uploaderEl = getTemplateEl(container, selectorClasses.uploader), fileContainer = batch ? fileBatch.content : fileList, thumb;
	                if (batch) {
	                    fileBatch.map[id] = fileEl;
	                }
	                qq(fileEl).addClass(FILE_CLASS_PREFIX + id);
	                uploaderEl.removeAttribute(DROPZPONE_TEXT_ATTR);
	                if (fileNameEl) {
	                    qq(fileNameEl).setText(name);
	                    fileNameEl.setAttribute("title", name);
	                }
	                fileEl.setAttribute(FILE_ID_ATTR, id);
	                if (prependInfo) {
	                    prependFile(fileEl, prependInfo.index, fileContainer);
	                } else {
	                    fileContainer.appendChild(fileEl);
	                }
	                if (hideForever) {
	                    fileEl.style.display = "none";
	                    qq(fileEl).addClass(HIDDEN_FOREVER_CLASS);
	                } else {
	                    hide(getProgress(id));
	                    hide(getSize(id));
	                    hide(getDelete(id));
	                    hide(getRetry(id));
	                    hide(getPause(id));
	                    hide(getContinue(id));
	                    if (isCancelDisabled) {
	                        this.hideCancel(id);
	                    }
	                    thumb = getThumbnail(id);
	                    if (thumb && !thumb.src) {
	                        cachedWaitingForThumbnailImg.then(function(waitingImg) {
	                            thumb.src = waitingImg.src;
	                            if (waitingImg.style.maxHeight && waitingImg.style.maxWidth) {
	                                qq(thumb).css({
	                                    maxHeight: waitingImg.style.maxHeight,
	                                    maxWidth: waitingImg.style.maxWidth
	                                });
	                            }
	                            show(thumb);
	                        });
	                    }
	                }
	            },
	            addFileToCache: function(id, name, prependInfo, hideForever) {
	                this.addFile(id, name, prependInfo, hideForever, true);
	            },
	            addCacheToDom: function() {
	                fileList.appendChild(fileBatch.content);
	                fileBatch.content = document.createDocumentFragment();
	                fileBatch.map = {};
	            },
	            removeFile: function(id) {
	                qq(getFile(id)).remove();
	            },
	            getFileId: function(el) {
	                var currentNode = el;
	                if (currentNode) {
	                    while (currentNode.getAttribute(FILE_ID_ATTR) == null) {
	                        currentNode = currentNode.parentNode;
	                    }
	                    return parseInt(currentNode.getAttribute(FILE_ID_ATTR));
	                }
	            },
	            getFileList: function() {
	                return fileList;
	            },
	            markFilenameEditable: function(id) {
	                var filename = getFilename(id);
	                filename && qq(filename).addClass(options.classes.editable);
	            },
	            updateFilename: function(id, name) {
	                var filenameEl = getFilename(id);
	                if (filenameEl) {
	                    qq(filenameEl).setText(name);
	                    filenameEl.setAttribute("title", name);
	                }
	            },
	            hideFilename: function(id) {
	                hide(getFilename(id));
	            },
	            showFilename: function(id) {
	                show(getFilename(id));
	            },
	            isFileName: function(el) {
	                return qq(el).hasClass(selectorClasses.file);
	            },
	            getButton: function() {
	                return options.button || getTemplateEl(container, selectorClasses.button);
	            },
	            hideDropProcessing: function() {
	                hide(getDropProcessing());
	            },
	            showDropProcessing: function() {
	                show(getDropProcessing());
	            },
	            getDropZone: function() {
	                return getTemplateEl(container, selectorClasses.drop);
	            },
	            isEditFilenamePossible: function() {
	                return isEditElementsExist;
	            },
	            hideRetry: function(id) {
	                hide(getRetry(id));
	            },
	            isRetryPossible: function() {
	                return isRetryElementExist;
	            },
	            showRetry: function(id) {
	                show(getRetry(id));
	            },
	            getFileContainer: function(id) {
	                return getFile(id);
	            },
	            showEditIcon: function(id) {
	                var icon = getEditIcon(id);
	                icon && qq(icon).addClass(options.classes.editable);
	            },
	            isHiddenForever: function(id) {
	                return qq(getFile(id)).hasClass(HIDDEN_FOREVER_CLASS);
	            },
	            hideEditIcon: function(id) {
	                var icon = getEditIcon(id);
	                icon && qq(icon).removeClass(options.classes.editable);
	            },
	            isEditIcon: function(el) {
	                return qq(el).hasClass(selectorClasses.editNameIcon, true);
	            },
	            getEditInput: function(id) {
	                return getTemplateEl(getFile(id), selectorClasses.editFilenameInput);
	            },
	            isEditInput: function(el) {
	                return qq(el).hasClass(selectorClasses.editFilenameInput, true);
	            },
	            updateProgress: function(id, loaded, total) {
	                var bar = getProgress(id), percent;
	                if (bar && total > 0) {
	                    percent = Math.round(loaded / total * 100);
	                    if (percent === 100) {
	                        hide(bar);
	                    } else {
	                        show(bar);
	                    }
	                    setProgressBarWidth(id, percent);
	                }
	            },
	            updateTotalProgress: function(loaded, total) {
	                this.updateProgress(null, loaded, total);
	            },
	            hideProgress: function(id) {
	                var bar = getProgress(id);
	                bar && hide(bar);
	            },
	            hideTotalProgress: function() {
	                this.hideProgress();
	            },
	            resetProgress: function(id) {
	                setProgressBarWidth(id, 0);
	                this.hideTotalProgress(id);
	            },
	            resetTotalProgress: function() {
	                this.resetProgress();
	            },
	            showCancel: function(id) {
	                if (!isCancelDisabled) {
	                    var cancel = getCancel(id);
	                    cancel && qq(cancel).removeClass(options.classes.hide);
	                }
	            },
	            hideCancel: function(id) {
	                hide(getCancel(id));
	            },
	            isCancel: function(el) {
	                return qq(el).hasClass(selectorClasses.cancel, true);
	            },
	            allowPause: function(id) {
	                show(getPause(id));
	                hide(getContinue(id));
	            },
	            uploadPaused: function(id) {
	                this.setStatusText(id, options.text.paused);
	                this.allowContinueButton(id);
	                hide(getSpinner(id));
	            },
	            hidePause: function(id) {
	                hide(getPause(id));
	            },
	            isPause: function(el) {
	                return qq(el).hasClass(selectorClasses.pause, true);
	            },
	            isContinueButton: function(el) {
	                return qq(el).hasClass(selectorClasses.continueButton, true);
	            },
	            allowContinueButton: function(id) {
	                show(getContinue(id));
	                hide(getPause(id));
	            },
	            uploadContinued: function(id) {
	                this.setStatusText(id, "");
	                this.allowPause(id);
	                show(getSpinner(id));
	            },
	            showDeleteButton: function(id) {
	                show(getDelete(id));
	            },
	            hideDeleteButton: function(id) {
	                hide(getDelete(id));
	            },
	            isDeleteButton: function(el) {
	                return qq(el).hasClass(selectorClasses.deleteButton, true);
	            },
	            isRetry: function(el) {
	                return qq(el).hasClass(selectorClasses.retry, true);
	            },
	            updateSize: function(id, text) {
	                var size = getSize(id);
	                if (size) {
	                    show(size);
	                    qq(size).setText(text);
	                }
	            },
	            setStatusText: function(id, text) {
	                var textEl = getTemplateEl(getFile(id), selectorClasses.statusText);
	                if (textEl) {
	                    if (text == null) {
	                        qq(textEl).clearText();
	                    } else {
	                        qq(textEl).setText(text);
	                    }
	                }
	            },
	            hideSpinner: function(id) {
	                qq(getFile(id)).removeClass(IN_PROGRESS_CLASS);
	                hide(getSpinner(id));
	            },
	            showSpinner: function(id) {
	                qq(getFile(id)).addClass(IN_PROGRESS_CLASS);
	                show(getSpinner(id));
	            },
	            generatePreview: function(id, optFileOrBlob, customResizeFunction) {
	                if (!this.isHiddenForever(id)) {
	                    thumbGenerationQueue.push({
	                        id: id,
	                        customResizeFunction: customResizeFunction,
	                        optFileOrBlob: optFileOrBlob
	                    });
	                    !thumbnailQueueMonitorRunning && generateNextQueuedPreview();
	                }
	            },
	            updateThumbnail: function(id, thumbnailUrl, showWaitingImg, customResizeFunction) {
	                if (!this.isHiddenForever(id)) {
	                    thumbGenerationQueue.push({
	                        customResizeFunction: customResizeFunction,
	                        update: true,
	                        id: id,
	                        thumbnailUrl: thumbnailUrl,
	                        showWaitingImg: showWaitingImg
	                    });
	                    !thumbnailQueueMonitorRunning && generateNextQueuedPreview();
	                }
	            },
	            hasDialog: function(type) {
	                return qq.supportedFeatures.dialogElement && !!getDialog(type);
	            },
	            showDialog: function(type, message, defaultValue) {
	                var dialog = getDialog(type), messageEl = getTemplateEl(dialog, selectorClasses.dialogMessage), inputEl = dialog.getElementsByTagName("INPUT")[0], cancelBtn = getTemplateEl(dialog, selectorClasses.dialogCancelButton), okBtn = getTemplateEl(dialog, selectorClasses.dialogOkButton), promise = new qq.Promise(), closeHandler = function() {
	                    cancelBtn.removeEventListener("click", cancelClickHandler);
	                    okBtn && okBtn.removeEventListener("click", okClickHandler);
	                    promise.failure();
	                }, cancelClickHandler = function() {
	                    cancelBtn.removeEventListener("click", cancelClickHandler);
	                    dialog.close();
	                }, okClickHandler = function() {
	                    dialog.removeEventListener("close", closeHandler);
	                    okBtn.removeEventListener("click", okClickHandler);
	                    dialog.close();
	                    promise.success(inputEl && inputEl.value);
	                };
	                dialog.addEventListener("close", closeHandler);
	                cancelBtn.addEventListener("click", cancelClickHandler);
	                okBtn && okBtn.addEventListener("click", okClickHandler);
	                if (inputEl) {
	                    inputEl.value = defaultValue;
	                }
	                messageEl.textContent = message;
	                dialog.showModal();
	                return promise;
	            }
	        });
	    };
	    qq.UiEventHandler = function(s, protectedApi) {
	        "use strict";
	        var disposer = new qq.DisposeSupport(), spec = {
	            eventType: "click",
	            attachTo: null,
	            onHandled: function(target, event) {}
	        };
	        qq.extend(this, {
	            addHandler: function(element) {
	                addHandler(element);
	            },
	            dispose: function() {
	                disposer.dispose();
	            }
	        });
	        function addHandler(element) {
	            disposer.attach(element, spec.eventType, function(event) {
	                event = event || window.event;
	                var target = event.target || event.srcElement;
	                spec.onHandled(target, event);
	            });
	        }
	        qq.extend(protectedApi, {
	            getFileIdFromItem: function(item) {
	                return item.qqFileId;
	            },
	            getDisposeSupport: function() {
	                return disposer;
	            }
	        });
	        qq.extend(spec, s);
	        if (spec.attachTo) {
	            addHandler(spec.attachTo);
	        }
	    };
	    qq.FileButtonsClickHandler = function(s) {
	        "use strict";
	        var inheritedInternalApi = {}, spec = {
	            templating: null,
	            log: function(message, lvl) {},
	            onDeleteFile: function(fileId) {},
	            onCancel: function(fileId) {},
	            onRetry: function(fileId) {},
	            onPause: function(fileId) {},
	            onContinue: function(fileId) {},
	            onGetName: function(fileId) {}
	        }, buttonHandlers = {
	            cancel: function(id) {
	                spec.onCancel(id);
	            },
	            retry: function(id) {
	                spec.onRetry(id);
	            },
	            deleteButton: function(id) {
	                spec.onDeleteFile(id);
	            },
	            pause: function(id) {
	                spec.onPause(id);
	            },
	            continueButton: function(id) {
	                spec.onContinue(id);
	            }
	        };
	        function examineEvent(target, event) {
	            qq.each(buttonHandlers, function(buttonType, handler) {
	                var firstLetterCapButtonType = buttonType.charAt(0).toUpperCase() + buttonType.slice(1), fileId;
	                if (spec.templating["is" + firstLetterCapButtonType](target)) {
	                    fileId = spec.templating.getFileId(target);
	                    qq.preventDefault(event);
	                    spec.log(qq.format("Detected valid file button click event on file '{}', ID: {}.", spec.onGetName(fileId), fileId));
	                    handler(fileId);
	                    return false;
	                }
	            });
	        }
	        qq.extend(spec, s);
	        spec.eventType = "click";
	        spec.onHandled = examineEvent;
	        spec.attachTo = spec.templating.getFileList();
	        qq.extend(this, new qq.UiEventHandler(spec, inheritedInternalApi));
	    };
	    qq.FilenameClickHandler = function(s) {
	        "use strict";
	        var inheritedInternalApi = {}, spec = {
	            templating: null,
	            log: function(message, lvl) {},
	            classes: {
	                file: "qq-upload-file",
	                editNameIcon: "qq-edit-filename-icon"
	            },
	            onGetUploadStatus: function(fileId) {},
	            onGetName: function(fileId) {}
	        };
	        qq.extend(spec, s);
	        function examineEvent(target, event) {
	            if (spec.templating.isFileName(target) || spec.templating.isEditIcon(target)) {
	                var fileId = spec.templating.getFileId(target), status = spec.onGetUploadStatus(fileId);
	                if (status === qq.status.SUBMITTED) {
	                    spec.log(qq.format("Detected valid filename click event on file '{}', ID: {}.", spec.onGetName(fileId), fileId));
	                    qq.preventDefault(event);
	                    inheritedInternalApi.handleFilenameEdit(fileId, target, true);
	                }
	            }
	        }
	        spec.eventType = "click";
	        spec.onHandled = examineEvent;
	        qq.extend(this, new qq.FilenameEditHandler(spec, inheritedInternalApi));
	    };
	    qq.FilenameInputFocusInHandler = function(s, inheritedInternalApi) {
	        "use strict";
	        var spec = {
	            templating: null,
	            onGetUploadStatus: function(fileId) {},
	            log: function(message, lvl) {}
	        };
	        if (!inheritedInternalApi) {
	            inheritedInternalApi = {};
	        }
	        function handleInputFocus(target, event) {
	            if (spec.templating.isEditInput(target)) {
	                var fileId = spec.templating.getFileId(target), status = spec.onGetUploadStatus(fileId);
	                if (status === qq.status.SUBMITTED) {
	                    spec.log(qq.format("Detected valid filename input focus event on file '{}', ID: {}.", spec.onGetName(fileId), fileId));
	                    inheritedInternalApi.handleFilenameEdit(fileId, target);
	                }
	            }
	        }
	        spec.eventType = "focusin";
	        spec.onHandled = handleInputFocus;
	        qq.extend(spec, s);
	        qq.extend(this, new qq.FilenameEditHandler(spec, inheritedInternalApi));
	    };
	    qq.FilenameInputFocusHandler = function(spec) {
	        "use strict";
	        spec.eventType = "focus";
	        spec.attachTo = null;
	        qq.extend(this, new qq.FilenameInputFocusInHandler(spec, {}));
	    };
	    qq.FilenameEditHandler = function(s, inheritedInternalApi) {
	        "use strict";
	        var spec = {
	            templating: null,
	            log: function(message, lvl) {},
	            onGetUploadStatus: function(fileId) {},
	            onGetName: function(fileId) {},
	            onSetName: function(fileId, newName) {},
	            onEditingStatusChange: function(fileId, isEditing) {}
	        };
	        function getFilenameSansExtension(fileId) {
	            var filenameSansExt = spec.onGetName(fileId), extIdx = filenameSansExt.lastIndexOf(".");
	            if (extIdx > 0) {
	                filenameSansExt = filenameSansExt.substr(0, extIdx);
	            }
	            return filenameSansExt;
	        }
	        function getOriginalExtension(fileId) {
	            var origName = spec.onGetName(fileId);
	            return qq.getExtension(origName);
	        }
	        function handleNameUpdate(newFilenameInputEl, fileId) {
	            var newName = newFilenameInputEl.value, origExtension;
	            if (newName !== undefined && qq.trimStr(newName).length > 0) {
	                origExtension = getOriginalExtension(fileId);
	                if (origExtension !== undefined) {
	                    newName = newName + "." + origExtension;
	                }
	                spec.onSetName(fileId, newName);
	            }
	            spec.onEditingStatusChange(fileId, false);
	        }
	        function registerInputBlurHandler(inputEl, fileId) {
	            inheritedInternalApi.getDisposeSupport().attach(inputEl, "blur", function() {
	                handleNameUpdate(inputEl, fileId);
	            });
	        }
	        function registerInputEnterKeyHandler(inputEl, fileId) {
	            inheritedInternalApi.getDisposeSupport().attach(inputEl, "keyup", function(event) {
	                var code = event.keyCode || event.which;
	                if (code === 13) {
	                    handleNameUpdate(inputEl, fileId);
	                }
	            });
	        }
	        qq.extend(spec, s);
	        spec.attachTo = spec.templating.getFileList();
	        qq.extend(this, new qq.UiEventHandler(spec, inheritedInternalApi));
	        qq.extend(inheritedInternalApi, {
	            handleFilenameEdit: function(id, target, focusInput) {
	                var newFilenameInputEl = spec.templating.getEditInput(id);
	                spec.onEditingStatusChange(id, true);
	                newFilenameInputEl.value = getFilenameSansExtension(id);
	                if (focusInput) {
	                    newFilenameInputEl.focus();
	                }
	                registerInputBlurHandler(newFilenameInputEl, id);
	                registerInputEnterKeyHandler(newFilenameInputEl, id);
	            }
	        });
	    };
	    qq.CryptoJS = function(Math, undefined) {
	        var C = {};
	        var C_lib = C.lib = {};
	        var Base = C_lib.Base = function() {
	            function F() {}
	            return {
	                extend: function(overrides) {
	                    F.prototype = this;
	                    var subtype = new F();
	                    if (overrides) {
	                        subtype.mixIn(overrides);
	                    }
	                    if (!subtype.hasOwnProperty("init")) {
	                        subtype.init = function() {
	                            subtype.$super.init.apply(this, arguments);
	                        };
	                    }
	                    subtype.init.prototype = subtype;
	                    subtype.$super = this;
	                    return subtype;
	                },
	                create: function() {
	                    var instance = this.extend();
	                    instance.init.apply(instance, arguments);
	                    return instance;
	                },
	                init: function() {},
	                mixIn: function(properties) {
	                    for (var propertyName in properties) {
	                        if (properties.hasOwnProperty(propertyName)) {
	                            this[propertyName] = properties[propertyName];
	                        }
	                    }
	                    if (properties.hasOwnProperty("toString")) {
	                        this.toString = properties.toString;
	                    }
	                },
	                clone: function() {
	                    return this.init.prototype.extend(this);
	                }
	            };
	        }();
	        var WordArray = C_lib.WordArray = Base.extend({
	            init: function(words, sigBytes) {
	                words = this.words = words || [];
	                if (sigBytes != undefined) {
	                    this.sigBytes = sigBytes;
	                } else {
	                    this.sigBytes = words.length * 4;
	                }
	            },
	            toString: function(encoder) {
	                return (encoder || Hex).stringify(this);
	            },
	            concat: function(wordArray) {
	                var thisWords = this.words;
	                var thatWords = wordArray.words;
	                var thisSigBytes = this.sigBytes;
	                var thatSigBytes = wordArray.sigBytes;
	                this.clamp();
	                if (thisSigBytes % 4) {
	                    for (var i = 0; i < thatSigBytes; i++) {
	                        var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                        thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
	                    }
	                } else if (thatWords.length > 65535) {
	                    for (var i = 0; i < thatSigBytes; i += 4) {
	                        thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
	                    }
	                } else {
	                    thisWords.push.apply(thisWords, thatWords);
	                }
	                this.sigBytes += thatSigBytes;
	                return this;
	            },
	            clamp: function() {
	                var words = this.words;
	                var sigBytes = this.sigBytes;
	                words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
	                words.length = Math.ceil(sigBytes / 4);
	            },
	            clone: function() {
	                var clone = Base.clone.call(this);
	                clone.words = this.words.slice(0);
	                return clone;
	            },
	            random: function(nBytes) {
	                var words = [];
	                for (var i = 0; i < nBytes; i += 4) {
	                    words.push(Math.random() * 4294967296 | 0);
	                }
	                return new WordArray.init(words, nBytes);
	            }
	        });
	        var C_enc = C.enc = {};
	        var Hex = C_enc.Hex = {
	            stringify: function(wordArray) {
	                var words = wordArray.words;
	                var sigBytes = wordArray.sigBytes;
	                var hexChars = [];
	                for (var i = 0; i < sigBytes; i++) {
	                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                    hexChars.push((bite >>> 4).toString(16));
	                    hexChars.push((bite & 15).toString(16));
	                }
	                return hexChars.join("");
	            },
	            parse: function(hexStr) {
	                var hexStrLength = hexStr.length;
	                var words = [];
	                for (var i = 0; i < hexStrLength; i += 2) {
	                    words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
	                }
	                return new WordArray.init(words, hexStrLength / 2);
	            }
	        };
	        var Latin1 = C_enc.Latin1 = {
	            stringify: function(wordArray) {
	                var words = wordArray.words;
	                var sigBytes = wordArray.sigBytes;
	                var latin1Chars = [];
	                for (var i = 0; i < sigBytes; i++) {
	                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                    latin1Chars.push(String.fromCharCode(bite));
	                }
	                return latin1Chars.join("");
	            },
	            parse: function(latin1Str) {
	                var latin1StrLength = latin1Str.length;
	                var words = [];
	                for (var i = 0; i < latin1StrLength; i++) {
	                    words[i >>> 2] |= (latin1Str.charCodeAt(i) & 255) << 24 - i % 4 * 8;
	                }
	                return new WordArray.init(words, latin1StrLength);
	            }
	        };
	        var Utf8 = C_enc.Utf8 = {
	            stringify: function(wordArray) {
	                try {
	                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	                } catch (e) {
	                    throw new Error("Malformed UTF-8 data");
	                }
	            },
	            parse: function(utf8Str) {
	                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	            }
	        };
	        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	            reset: function() {
	                this._data = new WordArray.init();
	                this._nDataBytes = 0;
	            },
	            _append: function(data) {
	                if (typeof data == "string") {
	                    data = Utf8.parse(data);
	                }
	                this._data.concat(data);
	                this._nDataBytes += data.sigBytes;
	            },
	            _process: function(doFlush) {
	                var data = this._data;
	                var dataWords = data.words;
	                var dataSigBytes = data.sigBytes;
	                var blockSize = this.blockSize;
	                var blockSizeBytes = blockSize * 4;
	                var nBlocksReady = dataSigBytes / blockSizeBytes;
	                if (doFlush) {
	                    nBlocksReady = Math.ceil(nBlocksReady);
	                } else {
	                    nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	                }
	                var nWordsReady = nBlocksReady * blockSize;
	                var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	                if (nWordsReady) {
	                    for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                        this._doProcessBlock(dataWords, offset);
	                    }
	                    var processedWords = dataWords.splice(0, nWordsReady);
	                    data.sigBytes -= nBytesReady;
	                }
	                return new WordArray.init(processedWords, nBytesReady);
	            },
	            clone: function() {
	                var clone = Base.clone.call(this);
	                clone._data = this._data.clone();
	                return clone;
	            },
	            _minBufferSize: 0
	        });
	        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	            cfg: Base.extend(),
	            init: function(cfg) {
	                this.cfg = this.cfg.extend(cfg);
	                this.reset();
	            },
	            reset: function() {
	                BufferedBlockAlgorithm.reset.call(this);
	                this._doReset();
	            },
	            update: function(messageUpdate) {
	                this._append(messageUpdate);
	                this._process();
	                return this;
	            },
	            finalize: function(messageUpdate) {
	                if (messageUpdate) {
	                    this._append(messageUpdate);
	                }
	                var hash = this._doFinalize();
	                return hash;
	            },
	            blockSize: 512 / 32,
	            _createHelper: function(hasher) {
	                return function(message, cfg) {
	                    return new hasher.init(cfg).finalize(message);
	                };
	            },
	            _createHmacHelper: function(hasher) {
	                return function(message, key) {
	                    return new C_algo.HMAC.init(hasher, key).finalize(message);
	                };
	            }
	        });
	        var C_algo = C.algo = {};
	        return C;
	    }(Math);
	    (function() {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var C_enc = C.enc;
	        var Base64 = C_enc.Base64 = {
	            stringify: function(wordArray) {
	                var words = wordArray.words;
	                var sigBytes = wordArray.sigBytes;
	                var map = this._map;
	                wordArray.clamp();
	                var base64Chars = [];
	                for (var i = 0; i < sigBytes; i += 3) {
	                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255;
	                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255;
	                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
	                    for (var j = 0; j < 4 && i + j * .75 < sigBytes; j++) {
	                        base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 63));
	                    }
	                }
	                var paddingChar = map.charAt(64);
	                if (paddingChar) {
	                    while (base64Chars.length % 4) {
	                        base64Chars.push(paddingChar);
	                    }
	                }
	                return base64Chars.join("");
	            },
	            parse: function(base64Str) {
	                var base64StrLength = base64Str.length;
	                var map = this._map;
	                var paddingChar = map.charAt(64);
	                if (paddingChar) {
	                    var paddingIndex = base64Str.indexOf(paddingChar);
	                    if (paddingIndex != -1) {
	                        base64StrLength = paddingIndex;
	                    }
	                }
	                var words = [];
	                var nBytes = 0;
	                for (var i = 0; i < base64StrLength; i++) {
	                    if (i % 4) {
	                        var bits1 = map.indexOf(base64Str.charAt(i - 1)) << i % 4 * 2;
	                        var bits2 = map.indexOf(base64Str.charAt(i)) >>> 6 - i % 4 * 2;
	                        words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
	                        nBytes++;
	                    }
	                }
	                return WordArray.create(words, nBytes);
	            },
	            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
	        };
	    })();
	    (function() {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var Base = C_lib.Base;
	        var C_enc = C.enc;
	        var Utf8 = C_enc.Utf8;
	        var C_algo = C.algo;
	        var HMAC = C_algo.HMAC = Base.extend({
	            init: function(hasher, key) {
	                hasher = this._hasher = new hasher.init();
	                if (typeof key == "string") {
	                    key = Utf8.parse(key);
	                }
	                var hasherBlockSize = hasher.blockSize;
	                var hasherBlockSizeBytes = hasherBlockSize * 4;
	                if (key.sigBytes > hasherBlockSizeBytes) {
	                    key = hasher.finalize(key);
	                }
	                key.clamp();
	                var oKey = this._oKey = key.clone();
	                var iKey = this._iKey = key.clone();
	                var oKeyWords = oKey.words;
	                var iKeyWords = iKey.words;
	                for (var i = 0; i < hasherBlockSize; i++) {
	                    oKeyWords[i] ^= 1549556828;
	                    iKeyWords[i] ^= 909522486;
	                }
	                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	                this.reset();
	            },
	            reset: function() {
	                var hasher = this._hasher;
	                hasher.reset();
	                hasher.update(this._iKey);
	            },
	            update: function(messageUpdate) {
	                this._hasher.update(messageUpdate);
	                return this;
	            },
	            finalize: function(messageUpdate) {
	                var hasher = this._hasher;
	                var innerHash = hasher.finalize(messageUpdate);
	                hasher.reset();
	                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	                return hmac;
	            }
	        });
	    })();
	    (function() {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var Hasher = C_lib.Hasher;
	        var C_algo = C.algo;
	        var W = [];
	        var SHA1 = C_algo.SHA1 = Hasher.extend({
	            _doReset: function() {
	                this._hash = new WordArray.init([ 1732584193, 4023233417, 2562383102, 271733878, 3285377520 ]);
	            },
	            _doProcessBlock: function(M, offset) {
	                var H = this._hash.words;
	                var a = H[0];
	                var b = H[1];
	                var c = H[2];
	                var d = H[3];
	                var e = H[4];
	                for (var i = 0; i < 80; i++) {
	                    if (i < 16) {
	                        W[i] = M[offset + i] | 0;
	                    } else {
	                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                        W[i] = n << 1 | n >>> 31;
	                    }
	                    var t = (a << 5 | a >>> 27) + e + W[i];
	                    if (i < 20) {
	                        t += (b & c | ~b & d) + 1518500249;
	                    } else if (i < 40) {
	                        t += (b ^ c ^ d) + 1859775393;
	                    } else if (i < 60) {
	                        t += (b & c | b & d | c & d) - 1894007588;
	                    } else {
	                        t += (b ^ c ^ d) - 899497514;
	                    }
	                    e = d;
	                    d = c;
	                    c = b << 30 | b >>> 2;
	                    b = a;
	                    a = t;
	                }
	                H[0] = H[0] + a | 0;
	                H[1] = H[1] + b | 0;
	                H[2] = H[2] + c | 0;
	                H[3] = H[3] + d | 0;
	                H[4] = H[4] + e | 0;
	            },
	            _doFinalize: function() {
	                var data = this._data;
	                var dataWords = data.words;
	                var nBitsTotal = this._nDataBytes * 8;
	                var nBitsLeft = data.sigBytes * 8;
	                dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 4294967296);
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
	                data.sigBytes = dataWords.length * 4;
	                this._process();
	                return this._hash;
	            },
	            clone: function() {
	                var clone = Hasher.clone.call(this);
	                clone._hash = this._hash.clone();
	                return clone;
	            }
	        });
	        C.SHA1 = Hasher._createHelper(SHA1);
	        C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	    })();
	    (function(Math) {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var Hasher = C_lib.Hasher;
	        var C_algo = C.algo;
	        var H = [];
	        var K = [];
	        (function() {
	            function isPrime(n) {
	                var sqrtN = Math.sqrt(n);
	                for (var factor = 2; factor <= sqrtN; factor++) {
	                    if (!(n % factor)) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	            function getFractionalBits(n) {
	                return (n - (n | 0)) * 4294967296 | 0;
	            }
	            var n = 2;
	            var nPrime = 0;
	            while (nPrime < 64) {
	                if (isPrime(n)) {
	                    if (nPrime < 8) {
	                        H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                    }
	                    K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	                    nPrime++;
	                }
	                n++;
	            }
	        })();
	        var W = [];
	        var SHA256 = C_algo.SHA256 = Hasher.extend({
	            _doReset: function() {
	                this._hash = new WordArray.init(H.slice(0));
	            },
	            _doProcessBlock: function(M, offset) {
	                var H = this._hash.words;
	                var a = H[0];
	                var b = H[1];
	                var c = H[2];
	                var d = H[3];
	                var e = H[4];
	                var f = H[5];
	                var g = H[6];
	                var h = H[7];
	                for (var i = 0; i < 64; i++) {
	                    if (i < 16) {
	                        W[i] = M[offset + i] | 0;
	                    } else {
	                        var gamma0x = W[i - 15];
	                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
	                        var gamma1x = W[i - 2];
	                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
	                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                    }
	                    var ch = e & f ^ ~e & g;
	                    var maj = a & b ^ a & c ^ b & c;
	                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
	                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
	                    var t1 = h + sigma1 + ch + K[i] + W[i];
	                    var t2 = sigma0 + maj;
	                    h = g;
	                    g = f;
	                    f = e;
	                    e = d + t1 | 0;
	                    d = c;
	                    c = b;
	                    b = a;
	                    a = t1 + t2 | 0;
	                }
	                H[0] = H[0] + a | 0;
	                H[1] = H[1] + b | 0;
	                H[2] = H[2] + c | 0;
	                H[3] = H[3] + d | 0;
	                H[4] = H[4] + e | 0;
	                H[5] = H[5] + f | 0;
	                H[6] = H[6] + g | 0;
	                H[7] = H[7] + h | 0;
	            },
	            _doFinalize: function() {
	                var data = this._data;
	                var dataWords = data.words;
	                var nBitsTotal = this._nDataBytes * 8;
	                var nBitsLeft = data.sigBytes * 8;
	                dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 4294967296);
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
	                data.sigBytes = dataWords.length * 4;
	                this._process();
	                return this._hash;
	            },
	            clone: function() {
	                var clone = Hasher.clone.call(this);
	                clone._hash = this._hash.clone();
	                return clone;
	            }
	        });
	        C.SHA256 = Hasher._createHelper(SHA256);
	        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	    })(Math);
	    (function() {
	        if (typeof ArrayBuffer != "function") {
	            return;
	        }
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var superInit = WordArray.init;
	        var subInit = WordArray.init = function(typedArray) {
	            if (typedArray instanceof ArrayBuffer) {
	                typedArray = new Uint8Array(typedArray);
	            }
	            if (typedArray instanceof Int8Array || typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
	                typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	            }
	            if (typedArray instanceof Uint8Array) {
	                var typedArrayByteLength = typedArray.byteLength;
	                var words = [];
	                for (var i = 0; i < typedArrayByteLength; i++) {
	                    words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
	                }
	                superInit.call(this, words, typedArrayByteLength);
	            } else {
	                superInit.apply(this, arguments);
	            }
	        };
	        subInit.prototype = WordArray;
	    })();
	    qq.s3 = qq.s3 || {};
	    qq.s3.util = qq.s3.util || function() {
	        "use strict";
	        return {
	            ALGORITHM_PARAM_NAME: "x-amz-algorithm",
	            AWS_PARAM_PREFIX: "x-amz-meta-",
	            CREDENTIAL_PARAM_NAME: "x-amz-credential",
	            DATE_PARAM_NAME: "x-amz-date",
	            REDUCED_REDUNDANCY_PARAM_NAME: "x-amz-storage-class",
	            REDUCED_REDUNDANCY_PARAM_VALUE: "REDUCED_REDUNDANCY",
	            SERVER_SIDE_ENCRYPTION_PARAM_NAME: "x-amz-server-side-encryption",
	            SERVER_SIDE_ENCRYPTION_PARAM_VALUE: "AES256",
	            SESSION_TOKEN_PARAM_NAME: "x-amz-security-token",
	            V4_ALGORITHM_PARAM_VALUE: "AWS4-HMAC-SHA256",
	            V4_SIGNATURE_PARAM_NAME: "x-amz-signature",
	            CASE_SENSITIVE_PARAM_NAMES: [ "Cache-Control", "Content-Disposition", "Content-Encoding", "Content-MD5" ],
	            UNSIGNABLE_REST_HEADER_NAMES: [ "Cache-Control", "Content-Disposition", "Content-Encoding", "Content-MD5" ],
	            UNPREFIXED_PARAM_NAMES: [ "Cache-Control", "Content-Disposition", "Content-Encoding", "Content-MD5", "x-amz-server-side-encryption-customer-algorithm", "x-amz-server-side-encryption-customer-key", "x-amz-server-side-encryption-customer-key-MD5" ],
	            getBucket: function(endpoint) {
	                var patterns = [ /^(?:https?:\/\/)?([a-z0-9.\-_]+)\.s3(?:-[a-z0-9\-]+)?\.amazonaws\.com/i, /^(?:https?:\/\/)?s3(?:-[a-z0-9\-]+)?\.amazonaws\.com\/([a-z0-9.\-_]+)/i, /^(?:https?:\/\/)?([a-z0-9.\-_]+)/i ], bucket;
	                qq.each(patterns, function(idx, pattern) {
	                    var match = pattern.exec(endpoint);
	                    if (match) {
	                        bucket = match[1];
	                        return false;
	                    }
	                });
	                return bucket;
	            },
	            _getPrefixedParamName: function(name) {
	                if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, name) >= 0) {
	                    return name;
	                }
	                return qq.s3.util.AWS_PARAM_PREFIX + name;
	            },
	            getPolicy: function(spec) {
	                var policy = {}, conditions = [], bucket = spec.bucket, date = spec.date, drift = spec.clockDrift, key = spec.key, accessKey = spec.accessKey, acl = spec.acl, type = spec.type, expectedStatus = spec.expectedStatus, sessionToken = spec.sessionToken, params = spec.params, successRedirectUrl = qq.s3.util.getSuccessRedirectAbsoluteUrl(spec.successRedirectUrl), minFileSize = spec.minFileSize, maxFileSize = spec.maxFileSize, reducedRedundancy = spec.reducedRedundancy, region = spec.region, serverSideEncryption = spec.serverSideEncryption, signatureVersion = spec.signatureVersion;
	                policy.expiration = qq.s3.util.getPolicyExpirationDate(date, drift);
	                conditions.push({
	                    acl: acl
	                });
	                conditions.push({
	                    bucket: bucket
	                });
	                if (type) {
	                    conditions.push({
	                        "Content-Type": type
	                    });
	                }
	                if (expectedStatus) {
	                    conditions.push({
	                        success_action_status: expectedStatus.toString()
	                    });
	                }
	                if (successRedirectUrl) {
	                    conditions.push({
	                        success_action_redirect: successRedirectUrl
	                    });
	                }
	                if (reducedRedundancy) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
	                }
	                if (sessionToken) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken;
	                }
	                if (serverSideEncryption) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
	                }
	                if (signatureVersion === 2) {
	                    conditions.push({
	                        key: key
	                    });
	                } else if (signatureVersion === 4) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.ALGORITHM_PARAM_NAME] = qq.s3.util.V4_ALGORITHM_PARAM_VALUE;
	                    conditions.push({});
	                    conditions[conditions.length - 1].key = key;
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.CREDENTIAL_PARAM_NAME] = qq.s3.util.getV4CredentialsString({
	                        date: date,
	                        key: accessKey,
	                        region: region
	                    });
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.DATE_PARAM_NAME] = qq.s3.util.getV4PolicyDate(date, drift);
	                }
	                qq.each(params, function(name, val) {
	                    var awsParamName = qq.s3.util._getPrefixedParamName(name), param = {};
	                    if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, awsParamName) >= 0) {
	                        param[awsParamName] = val;
	                    } else {
	                        param[awsParamName] = encodeURIComponent(val);
	                    }
	                    conditions.push(param);
	                });
	                policy.conditions = conditions;
	                qq.s3.util.enforceSizeLimits(policy, minFileSize, maxFileSize);
	                return policy;
	            },
	            refreshPolicyCredentials: function(policy, newSessionToken) {
	                var sessionTokenFound = false;
	                qq.each(policy.conditions, function(oldCondIdx, oldCondObj) {
	                    qq.each(oldCondObj, function(oldCondName, oldCondVal) {
	                        if (oldCondName === qq.s3.util.SESSION_TOKEN_PARAM_NAME) {
	                            oldCondObj[oldCondName] = newSessionToken;
	                            sessionTokenFound = true;
	                        }
	                    });
	                });
	                if (!sessionTokenFound) {
	                    policy.conditions.push({});
	                    policy.conditions[policy.conditions.length - 1][qq.s3.util.SESSION_TOKEN_PARAM_NAME] = newSessionToken;
	                }
	            },
	            generateAwsParams: function(spec, signPolicyCallback) {
	                var awsParams = {}, customParams = spec.params, promise = new qq.Promise(), sessionToken = spec.sessionToken, drift = spec.clockDrift, type = spec.type, key = spec.key, accessKey = spec.accessKey, acl = spec.acl, expectedStatus = spec.expectedStatus, successRedirectUrl = qq.s3.util.getSuccessRedirectAbsoluteUrl(spec.successRedirectUrl), reducedRedundancy = spec.reducedRedundancy, region = spec.region, serverSideEncryption = spec.serverSideEncryption, signatureVersion = spec.signatureVersion, now = new Date(), log = spec.log, policyJson;
	                spec.date = now;
	                policyJson = qq.s3.util.getPolicy(spec);
	                awsParams.key = key;
	                if (type) {
	                    awsParams["Content-Type"] = type;
	                }
	                if (expectedStatus) {
	                    awsParams.success_action_status = expectedStatus;
	                }
	                if (successRedirectUrl) {
	                    awsParams.success_action_redirect = successRedirectUrl;
	                }
	                if (reducedRedundancy) {
	                    awsParams[qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
	                }
	                if (serverSideEncryption) {
	                    awsParams[qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
	                }
	                if (sessionToken) {
	                    awsParams[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken;
	                }
	                awsParams.acl = acl;
	                qq.each(customParams, function(name, val) {
	                    var awsParamName = qq.s3.util._getPrefixedParamName(name);
	                    if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, awsParamName) >= 0) {
	                        awsParams[awsParamName] = val;
	                    } else {
	                        awsParams[awsParamName] = encodeURIComponent(val);
	                    }
	                });
	                if (signatureVersion === 2) {
	                    awsParams.AWSAccessKeyId = accessKey;
	                } else if (signatureVersion === 4) {
	                    awsParams[qq.s3.util.ALGORITHM_PARAM_NAME] = qq.s3.util.V4_ALGORITHM_PARAM_VALUE;
	                    awsParams[qq.s3.util.CREDENTIAL_PARAM_NAME] = qq.s3.util.getV4CredentialsString({
	                        date: now,
	                        key: accessKey,
	                        region: region
	                    });
	                    awsParams[qq.s3.util.DATE_PARAM_NAME] = qq.s3.util.getV4PolicyDate(now, drift);
	                }
	                signPolicyCallback(policyJson).then(function(policyAndSignature, updatedAccessKey, updatedSessionToken) {
	                    awsParams.policy = policyAndSignature.policy;
	                    if (spec.signatureVersion === 2) {
	                        awsParams.signature = policyAndSignature.signature;
	                        if (updatedAccessKey) {
	                            awsParams.AWSAccessKeyId = updatedAccessKey;
	                        }
	                    } else if (spec.signatureVersion === 4) {
	                        awsParams[qq.s3.util.V4_SIGNATURE_PARAM_NAME] = policyAndSignature.signature;
	                    }
	                    if (updatedSessionToken) {
	                        awsParams[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = updatedSessionToken;
	                    }
	                    promise.success(awsParams);
	                }, function(errorMessage) {
	                    errorMessage = errorMessage || "Can't continue further with request to S3 as we did not receive " + "a valid signature and policy from the server.";
	                    log("Policy signing failed.  " + errorMessage, "error");
	                    promise.failure(errorMessage);
	                });
	                return promise;
	            },
	            enforceSizeLimits: function(policy, minSize, maxSize) {
	                var adjustedMinSize = minSize < 0 ? 0 : minSize, adjustedMaxSize = maxSize <= 0 ? 9007199254740992 : maxSize;
	                if (minSize > 0 || maxSize > 0) {
	                    policy.conditions.push([ "content-length-range", adjustedMinSize.toString(), adjustedMaxSize.toString() ]);
	                }
	            },
	            getPolicyExpirationDate: function(date, drift) {
	                var adjustedDate = new Date(date.getTime() + drift);
	                return qq.s3.util.getPolicyDate(adjustedDate, 5);
	            },
	            getCredentialsDate: function(date) {
	                return date.getUTCFullYear() + "" + ("0" + (date.getUTCMonth() + 1)).slice(-2) + ("0" + date.getUTCDate()).slice(-2);
	            },
	            getPolicyDate: function(date, _minutesToAdd_) {
	                var minutesToAdd = _minutesToAdd_ || 0, pad, r;
	                date.setMinutes(date.getMinutes() + (minutesToAdd || 0));
	                if (Date.prototype.toISOString) {
	                    return date.toISOString();
	                } else {
	                    pad = function(number) {
	                        r = String(number);
	                        if (r.length === 1) {
	                            r = "0" + r;
	                        }
	                        return r;
	                    };
	                    return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
	                }
	            },
	            parseIframeResponse: function(iframe) {
	                var doc = iframe.contentDocument || iframe.contentWindow.document, queryString = doc.location.search, match = /bucket=(.+)&key=(.+)&etag=(.+)/.exec(queryString);
	                if (match) {
	                    return {
	                        bucket: match[1],
	                        key: match[2],
	                        etag: match[3].replace(/%22/g, "")
	                    };
	                }
	            },
	            getSuccessRedirectAbsoluteUrl: function(successRedirectUrl) {
	                if (successRedirectUrl) {
	                    var targetAnchorContainer = document.createElement("div"), targetAnchor;
	                    if (qq.ie7()) {
	                        targetAnchorContainer.innerHTML = "<a href='" + successRedirectUrl + "'></a>";
	                        targetAnchor = targetAnchorContainer.firstChild;
	                        return targetAnchor.href;
	                    } else {
	                        targetAnchor = document.createElement("a");
	                        targetAnchor.href = successRedirectUrl;
	                        targetAnchor.href = targetAnchor.href;
	                        return targetAnchor.href;
	                    }
	                }
	            },
	            getV4CredentialsString: function(spec) {
	                return spec.key + "/" + qq.s3.util.getCredentialsDate(spec.date) + "/" + spec.region + "/s3/aws4_request";
	            },
	            getV4PolicyDate: function(date, drift) {
	                var adjustedDate = new Date(date.getTime() + drift);
	                return qq.s3.util.getCredentialsDate(adjustedDate) + "T" + ("0" + adjustedDate.getUTCHours()).slice(-2) + ("0" + adjustedDate.getUTCMinutes()).slice(-2) + ("0" + adjustedDate.getUTCSeconds()).slice(-2) + "Z";
	            },
	            encodeQueryStringParam: function(param) {
	                var percentEncoded = encodeURIComponent(param);
	                percentEncoded = percentEncoded.replace(/[!'()]/g, escape);
	                percentEncoded = percentEncoded.replace(/\*/g, "%2A");
	                return percentEncoded.replace(/%20/g, "+");
	            },
	            uriEscape: function(string) {
	                var output = encodeURIComponent(string);
	                output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	                output = output.replace(/[*]/g, function(ch) {
	                    return "%" + ch.charCodeAt(0).toString(16).toUpperCase();
	                });
	                return output;
	            },
	            uriEscapePath: function(path) {
	                var parts = [];
	                qq.each(path.split("/"), function(idx, item) {
	                    parts.push(qq.s3.util.uriEscape(item));
	                });
	                return parts.join("/");
	            }
	        };
	    }();
	    (function() {
	        "use strict";
	        qq.nonTraditionalBasePublicApi = {
	            setUploadSuccessParams: function(params, id) {
	                this._uploadSuccessParamsStore.set(params, id);
	            },
	            setUploadSuccessEndpoint: function(endpoint, id) {
	                this._uploadSuccessEndpointStore.set(endpoint, id);
	            }
	        };
	        qq.nonTraditionalBasePrivateApi = {
	            _onComplete: function(id, name, result, xhr) {
	                var success = result.success ? true : false, self = this, onCompleteArgs = arguments, successEndpoint = this._uploadSuccessEndpointStore.get(id), successCustomHeaders = this._options.uploadSuccess.customHeaders, successMethod = this._options.uploadSuccess.method, cors = this._options.cors, promise = new qq.Promise(), uploadSuccessParams = this._uploadSuccessParamsStore.get(id), fileParams = this._paramsStore.get(id), onSuccessFromServer = function(successRequestResult) {
	                    delete self._failedSuccessRequestCallbacks[id];
	                    qq.extend(result, successRequestResult);
	                    qq.FineUploaderBasic.prototype._onComplete.apply(self, onCompleteArgs);
	                    promise.success(successRequestResult);
	                }, onFailureFromServer = function(successRequestResult) {
	                    var callback = submitSuccessRequest;
	                    qq.extend(result, successRequestResult);
	                    if (result && result.reset) {
	                        callback = null;
	                    }
	                    if (!callback) {
	                        delete self._failedSuccessRequestCallbacks[id];
	                    } else {
	                        self._failedSuccessRequestCallbacks[id] = callback;
	                    }
	                    if (!self._onAutoRetry(id, name, result, xhr, callback)) {
	                        qq.FineUploaderBasic.prototype._onComplete.apply(self, onCompleteArgs);
	                        promise.failure(successRequestResult);
	                    }
	                }, submitSuccessRequest, successAjaxRequester;
	                if (success && successEndpoint) {
	                    successAjaxRequester = new qq.UploadSuccessAjaxRequester({
	                        endpoint: successEndpoint,
	                        method: successMethod,
	                        customHeaders: successCustomHeaders,
	                        cors: cors,
	                        log: qq.bind(this.log, this)
	                    });
	                    qq.extend(uploadSuccessParams, self._getEndpointSpecificParams(id, result, xhr), true);
	                    fileParams && qq.extend(uploadSuccessParams, fileParams, true);
	                    submitSuccessRequest = qq.bind(function() {
	                        successAjaxRequester.sendSuccessRequest(id, uploadSuccessParams).then(onSuccessFromServer, onFailureFromServer);
	                    }, self);
	                    submitSuccessRequest();
	                    return promise;
	                }
	                return qq.FineUploaderBasic.prototype._onComplete.apply(this, arguments);
	            },
	            _manualRetry: function(id) {
	                var successRequestCallback = this._failedSuccessRequestCallbacks[id];
	                return qq.FineUploaderBasic.prototype._manualRetry.call(this, id, successRequestCallback);
	            }
	        };
	    })();
	    (function() {
	        "use strict";
	        qq.s3.FineUploaderBasic = function(o) {
	            var options = {
	                request: {
	                    accessKey: null,
	                    clockDrift: 0
	                },
	                objectProperties: {
	                    acl: "private",
	                    bucket: qq.bind(function(id) {
	                        return qq.s3.util.getBucket(this.getEndpoint(id));
	                    }, this),
	                    host: qq.bind(function(id) {
	                        return /(?:http|https):\/\/(.+)(?:\/.+)?/.exec(this._endpointStore.get(id))[1];
	                    }, this),
	                    key: "uuid",
	                    reducedRedundancy: false,
	                    region: "us-east-1",
	                    serverSideEncryption: false
	                },
	                credentials: {
	                    accessKey: null,
	                    secretKey: null,
	                    expiration: null,
	                    sessionToken: null
	                },
	                signature: {
	                    customHeaders: {},
	                    endpoint: null,
	                    version: 2
	                },
	                uploadSuccess: {
	                    endpoint: null,
	                    method: "POST",
	                    params: {},
	                    customHeaders: {}
	                },
	                iframeSupport: {
	                    localBlankPagePath: null
	                },
	                chunking: {
	                    partSize: 5242880
	                },
	                cors: {
	                    allowXdr: true
	                },
	                callbacks: {
	                    onCredentialsExpired: function() {}
	                }
	            };
	            qq.extend(options, o, true);
	            if (!this.setCredentials(options.credentials, true)) {
	                this._currentCredentials.accessKey = options.request.accessKey;
	            }
	            this._aclStore = this._createStore(options.objectProperties.acl);
	            qq.FineUploaderBasic.call(this, options);
	            this._uploadSuccessParamsStore = this._createStore(this._options.uploadSuccess.params);
	            this._uploadSuccessEndpointStore = this._createStore(this._options.uploadSuccess.endpoint);
	            this._failedSuccessRequestCallbacks = {};
	            this._cannedKeys = {};
	            this._cannedBuckets = {};
	            this._buckets = {};
	            this._hosts = {};
	        };
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.basePublicApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.basePrivateApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.nonTraditionalBasePublicApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.nonTraditionalBasePrivateApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, {
	            getBucket: function(id) {
	                if (this._cannedBuckets[id] == null) {
	                    return this._buckets[id];
	                }
	                return this._cannedBuckets[id];
	            },
	            getKey: function(id) {
	                if (this._cannedKeys[id] == null) {
	                    return this._handler.getThirdPartyFileId(id);
	                }
	                return this._cannedKeys[id];
	            },
	            reset: function() {
	                qq.FineUploaderBasic.prototype.reset.call(this);
	                this._failedSuccessRequestCallbacks = [];
	                this._buckets = {};
	                this._hosts = {};
	            },
	            setCredentials: function(credentials, ignoreEmpty) {
	                if (credentials && credentials.secretKey) {
	                    if (!credentials.accessKey) {
	                        throw new qq.Error("Invalid credentials: no accessKey");
	                    } else if (!credentials.expiration) {
	                        throw new qq.Error("Invalid credentials: no expiration");
	                    } else {
	                        this._currentCredentials = qq.extend({}, credentials);
	                        if (qq.isString(credentials.expiration)) {
	                            this._currentCredentials.expiration = new Date(credentials.expiration);
	                        }
	                    }
	                    return true;
	                } else if (!ignoreEmpty) {
	                    throw new qq.Error("Invalid credentials parameter!");
	                } else {
	                    this._currentCredentials = {};
	                }
	            },
	            setAcl: function(acl, id) {
	                this._aclStore.set(acl, id);
	            },
	            _createUploadHandler: function() {
	                var self = this, additionalOptions = {
	                    aclStore: this._aclStore,
	                    getBucket: qq.bind(this._determineBucket, this),
	                    getHost: qq.bind(this._determineHost, this),
	                    getKeyName: qq.bind(this._determineKeyName, this),
	                    iframeSupport: this._options.iframeSupport,
	                    objectProperties: this._options.objectProperties,
	                    signature: this._options.signature,
	                    clockDrift: this._options.request.clockDrift,
	                    validation: {
	                        minSizeLimit: this._options.validation.minSizeLimit,
	                        maxSizeLimit: this._options.validation.sizeLimit
	                    }
	                };
	                qq.override(this._endpointStore, function(super_) {
	                    return {
	                        get: function(id) {
	                            var endpoint = super_.get(id);
	                            if (endpoint.indexOf("http") < 0) {
	                                return "http://" + endpoint;
	                            }
	                            return endpoint;
	                        }
	                    };
	                });
	                qq.override(this._paramsStore, function(super_) {
	                    return {
	                        get: function(id) {
	                            var oldParams = super_.get(id), modifiedParams = {};
	                            qq.each(oldParams, function(name, val) {
	                                var paramName = name;
	                                if (qq.indexOf(qq.s3.util.CASE_SENSITIVE_PARAM_NAMES, paramName) < 0) {
	                                    paramName = paramName.toLowerCase();
	                                }
	                                modifiedParams[paramName] = qq.isFunction(val) ? val() : val;
	                            });
	                            return modifiedParams;
	                        }
	                    };
	                });
	                additionalOptions.signature.credentialsProvider = {
	                    get: function() {
	                        return self._currentCredentials;
	                    },
	                    onExpired: function() {
	                        var updateCredentials = new qq.Promise(), callbackRetVal = self._options.callbacks.onCredentialsExpired();
	                        if (qq.isGenericPromise(callbackRetVal)) {
	                            callbackRetVal.then(function(credentials) {
	                                try {
	                                    self.setCredentials(credentials);
	                                    updateCredentials.success();
	                                } catch (error) {
	                                    self.log("Invalid credentials returned from onCredentialsExpired callback! (" + error.message + ")", "error");
	                                    updateCredentials.failure("onCredentialsExpired did not return valid credentials.");
	                                }
	                            }, function(errorMsg) {
	                                self.log("onCredentialsExpired callback indicated failure! (" + errorMsg + ")", "error");
	                                updateCredentials.failure("onCredentialsExpired callback failed.");
	                            });
	                        } else {
	                            self.log("onCredentialsExpired callback did not return a promise!", "error");
	                            updateCredentials.failure("Unexpected return value for onCredentialsExpired.");
	                        }
	                        return updateCredentials;
	                    }
	                };
	                return qq.FineUploaderBasic.prototype._createUploadHandler.call(this, additionalOptions, "s3");
	            },
	            _determineObjectPropertyValue: function(id, property) {
	                var maybe = this._options.objectProperties[property], promise = new qq.Promise(), self = this;
	                if (qq.isFunction(maybe)) {
	                    maybe = maybe(id);
	                    if (qq.isGenericPromise(maybe)) {
	                        promise = maybe;
	                    } else {
	                        promise.success(maybe);
	                    }
	                } else if (qq.isString(maybe)) {
	                    promise.success(maybe);
	                }
	                promise.then(function success(value) {
	                    self["_" + property + "s"][id] = value;
	                }, function failure(errorMsg) {
	                    qq.log("Problem determining " + property + " for ID " + id + " (" + errorMsg + ")", "error");
	                });
	                return promise;
	            },
	            _determineBucket: function(id) {
	                return this._determineObjectPropertyValue(id, "bucket");
	            },
	            _determineHost: function(id) {
	                return this._determineObjectPropertyValue(id, "host");
	            },
	            _determineKeyName: function(id, filename) {
	                var promise = new qq.Promise(), keynameLogic = this._options.objectProperties.key, extension = qq.getExtension(filename), onGetKeynameFailure = promise.failure, onGetKeynameSuccess = function(keyname, extension) {
	                    var keynameToUse = keyname;
	                    if (extension !== undefined) {
	                        keynameToUse += "." + extension;
	                    }
	                    promise.success(keynameToUse);
	                };
	                switch (keynameLogic) {
	                  case "uuid":
	                    onGetKeynameSuccess(this.getUuid(id), extension);
	                    break;
	
	                  case "filename":
	                    onGetKeynameSuccess(filename);
	                    break;
	
	                  default:
	                    if (qq.isFunction(keynameLogic)) {
	                        this._handleKeynameFunction(keynameLogic, id, onGetKeynameSuccess, onGetKeynameFailure);
	                    } else {
	                        this.log(keynameLogic + " is not a valid value for the s3.keyname option!", "error");
	                        onGetKeynameFailure();
	                    }
	                }
	                return promise;
	            },
	            _handleKeynameFunction: function(keynameFunc, id, successCallback, failureCallback) {
	                var self = this, onSuccess = function(keyname) {
	                    successCallback(keyname);
	                }, onFailure = function(reason) {
	                    self.log(qq.format("Failed to retrieve key name for {}.  Reason: {}", id, reason || "null"), "error");
	                    failureCallback(reason);
	                }, keyname = keynameFunc.call(this, id);
	                if (qq.isGenericPromise(keyname)) {
	                    keyname.then(onSuccess, onFailure);
	                } else if (keyname == null) {
	                    onFailure();
	                } else {
	                    onSuccess(keyname);
	                }
	            },
	            _getEndpointSpecificParams: function(id, response, maybeXhr) {
	                var params = {
	                    key: this.getKey(id),
	                    uuid: this.getUuid(id),
	                    name: this.getName(id),
	                    bucket: this.getBucket(id)
	                };
	                if (maybeXhr && maybeXhr.getResponseHeader("ETag")) {
	                    params.etag = maybeXhr.getResponseHeader("ETag");
	                } else if (response.etag) {
	                    params.etag = response.etag;
	                }
	                return params;
	            },
	            _onSubmitDelete: function(id, onSuccessCallback) {
	                var additionalMandatedParams = {
	                    key: this.getKey(id),
	                    bucket: this.getBucket(id)
	                };
	                return qq.FineUploaderBasic.prototype._onSubmitDelete.call(this, id, onSuccessCallback, additionalMandatedParams);
	            },
	            _addCannedFile: function(sessionData) {
	                var id;
	                if (sessionData.s3Key == null) {
	                    throw new qq.Error("Did not find s3Key property in server session response.  This is required!");
	                } else {
	                    id = qq.FineUploaderBasic.prototype._addCannedFile.apply(this, arguments);
	                    this._cannedKeys[id] = sessionData.s3Key;
	                    this._cannedBuckets[id] = sessionData.s3Bucket;
	                }
	                return id;
	            }
	        });
	    })();
	    if (!window.Uint8ClampedArray) {
	        window.Uint8ClampedArray = function() {};
	    }
	    qq.s3.RequestSigner = function(o) {
	        "use strict";
	        var requester, thisSignatureRequester = this, pendingSignatures = {}, options = {
	            expectingPolicy: false,
	            method: "POST",
	            signatureSpec: {
	                drift: 0,
	                credentialsProvider: {},
	                endpoint: null,
	                customHeaders: {},
	                version: 2
	            },
	            maxConnections: 3,
	            endpointStore: {},
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {}
	        }, credentialsProvider, generateHeaders = function(signatureConstructor, signature, promise) {
	            var headers = signatureConstructor.getHeaders();
	            if (options.signatureSpec.version === 4) {
	                headers.Authorization = qq.s3.util.V4_ALGORITHM_PARAM_VALUE + " Credential=" + options.signatureSpec.credentialsProvider.get().accessKey + "/" + qq.s3.util.getCredentialsDate(signatureConstructor.getRequestDate()) + "/" + options.signatureSpec.region + "/" + "s3/aws4_request," + "SignedHeaders=" + signatureConstructor.getSignedHeaders() + "," + "Signature=" + signature;
	            } else {
	                headers.Authorization = "AWS " + options.signatureSpec.credentialsProvider.get().accessKey + ":" + signature;
	            }
	            promise.success(headers, signatureConstructor.getEndOfUrl());
	        }, v2 = {
	            getStringToSign: function(signatureSpec) {
	                return qq.format("{}\n{}\n{}\n\n{}/{}/{}", signatureSpec.method, signatureSpec.contentMd5 || "", signatureSpec.contentType || "", signatureSpec.headersStr || "\n", signatureSpec.bucket, signatureSpec.endOfUrl);
	            },
	            signApiRequest: function(signatureConstructor, headersStr, signatureEffort) {
	                var headersWordArray = qq.CryptoJS.enc.Utf8.parse(headersStr), headersHmacSha1 = qq.CryptoJS.HmacSHA1(headersWordArray, credentialsProvider.get().secretKey), headersHmacSha1Base64 = qq.CryptoJS.enc.Base64.stringify(headersHmacSha1);
	                generateHeaders(signatureConstructor, headersHmacSha1Base64, signatureEffort);
	            },
	            signPolicy: function(policy, signatureEffort, updatedAccessKey, updatedSessionToken) {
	                var policyStr = JSON.stringify(policy), policyWordArray = qq.CryptoJS.enc.Utf8.parse(policyStr), base64Policy = qq.CryptoJS.enc.Base64.stringify(policyWordArray), policyHmacSha1 = qq.CryptoJS.HmacSHA1(base64Policy, credentialsProvider.get().secretKey), policyHmacSha1Base64 = qq.CryptoJS.enc.Base64.stringify(policyHmacSha1);
	                signatureEffort.success({
	                    policy: base64Policy,
	                    signature: policyHmacSha1Base64
	                }, updatedAccessKey, updatedSessionToken);
	            }
	        }, v4 = {
	            getCanonicalQueryString: function(endOfUri) {
	                var queryParamIdx = endOfUri.indexOf("?"), canonicalQueryString = "", encodedQueryParams, encodedQueryParamNames, queryStrings;
	                if (queryParamIdx >= 0) {
	                    encodedQueryParams = {};
	                    queryStrings = endOfUri.substr(queryParamIdx + 1).split("&");
	                    qq.each(queryStrings, function(idx, queryString) {
	                        var nameAndVal = queryString.split("="), paramVal = nameAndVal[1];
	                        if (paramVal == null) {
	                            paramVal = "";
	                        }
	                        encodedQueryParams[encodeURIComponent(nameAndVal[0])] = encodeURIComponent(paramVal);
	                    });
	                    encodedQueryParamNames = Object.keys(encodedQueryParams).sort();
	                    encodedQueryParamNames.forEach(function(encodedQueryParamName, idx) {
	                        canonicalQueryString += encodedQueryParamName + "=" + encodedQueryParams[encodedQueryParamName];
	                        if (idx < encodedQueryParamNames.length - 1) {
	                            canonicalQueryString += "&";
	                        }
	                    });
	                }
	                return canonicalQueryString;
	            },
	            getCanonicalRequest: function(signatureSpec) {
	                return qq.format("{}\n{}\n{}\n{}\n{}\n{}", signatureSpec.method, v4.getCanonicalUri(signatureSpec.endOfUrl), v4.getCanonicalQueryString(signatureSpec.endOfUrl), signatureSpec.headersStr || "\n", v4.getSignedHeaders(signatureSpec.headerNames), signatureSpec.hashedContent);
	            },
	            getCanonicalUri: function(endOfUri) {
	                var path = endOfUri, queryParamIdx = endOfUri.indexOf("?");
	                if (queryParamIdx > 0) {
	                    path = endOfUri.substr(0, queryParamIdx);
	                }
	                return "/" + path;
	            },
	            getEncodedHashedPayload: function(body) {
	                var promise = new qq.Promise(), reader;
	                if (qq.isBlob(body)) {
	                    reader = new FileReader();
	                    reader.onloadend = function(e) {
	                        if (e.target.readyState === FileReader.DONE) {
	                            if (e.target.error) {
	                                promise.failure(e.target.error);
	                            } else {
	                                var wordArray = qq.CryptoJS.lib.WordArray.create(e.target.result);
	                                promise.success(qq.CryptoJS.SHA256(wordArray).toString());
	                            }
	                        }
	                    };
	                    reader.readAsArrayBuffer(body);
	                } else {
	                    body = body || "";
	                    promise.success(qq.CryptoJS.SHA256(body).toString());
	                }
	                return promise;
	            },
	            getScope: function(date, region) {
	                return qq.s3.util.getCredentialsDate(date) + "/" + region + "/s3/aws4_request";
	            },
	            getStringToSign: function(signatureSpec) {
	                var canonicalRequest = v4.getCanonicalRequest(signatureSpec), date = qq.s3.util.getV4PolicyDate(signatureSpec.date, signatureSpec.drift), hashedRequest = qq.CryptoJS.SHA256(canonicalRequest).toString(), scope = v4.getScope(signatureSpec.date, options.signatureSpec.region), stringToSignTemplate = "AWS4-HMAC-SHA256\n{}\n{}\n{}";
	                return {
	                    hashed: qq.format(stringToSignTemplate, date, scope, hashedRequest),
	                    raw: qq.format(stringToSignTemplate, date, scope, canonicalRequest)
	                };
	            },
	            getSignedHeaders: function(headerNames) {
	                var signedHeaders = "";
	                headerNames.forEach(function(headerName, idx) {
	                    signedHeaders += headerName.toLowerCase();
	                    if (idx < headerNames.length - 1) {
	                        signedHeaders += ";";
	                    }
	                });
	                return signedHeaders;
	            },
	            signApiRequest: function(signatureConstructor, headersStr, signatureEffort) {
	                var secretKey = credentialsProvider.get().secretKey, headersPattern = /.+\n.+\n(\d+)\/(.+)\/s3\/.+\n(.+)/, matches = headersPattern.exec(headersStr), dateKey, dateRegionKey, dateRegionServiceKey, signingKey;
	                dateKey = qq.CryptoJS.HmacSHA256(matches[1], "AWS4" + secretKey);
	                dateRegionKey = qq.CryptoJS.HmacSHA256(matches[2], dateKey);
	                dateRegionServiceKey = qq.CryptoJS.HmacSHA256("s3", dateRegionKey);
	                signingKey = qq.CryptoJS.HmacSHA256("aws4_request", dateRegionServiceKey);
	                generateHeaders(signatureConstructor, qq.CryptoJS.HmacSHA256(headersStr, signingKey), signatureEffort);
	            },
	            signPolicy: function(policy, signatureEffort, updatedAccessKey, updatedSessionToken) {
	                var policyStr = JSON.stringify(policy), policyWordArray = qq.CryptoJS.enc.Utf8.parse(policyStr), base64Policy = qq.CryptoJS.enc.Base64.stringify(policyWordArray), secretKey = credentialsProvider.get().secretKey, credentialPattern = /.+\/(.+)\/(.+)\/s3\/aws4_request/, credentialCondition = function() {
	                    var credential = null;
	                    qq.each(policy.conditions, function(key, condition) {
	                        var val = condition["x-amz-credential"];
	                        if (val) {
	                            credential = val;
	                            return false;
	                        }
	                    });
	                    return credential;
	                }(), matches, dateKey, dateRegionKey, dateRegionServiceKey, signingKey;
	                matches = credentialPattern.exec(credentialCondition);
	                dateKey = qq.CryptoJS.HmacSHA256(matches[1], "AWS4" + secretKey);
	                dateRegionKey = qq.CryptoJS.HmacSHA256(matches[2], dateKey);
	                dateRegionServiceKey = qq.CryptoJS.HmacSHA256("s3", dateRegionKey);
	                signingKey = qq.CryptoJS.HmacSHA256("aws4_request", dateRegionServiceKey);
	                signatureEffort.success({
	                    policy: base64Policy,
	                    signature: qq.CryptoJS.HmacSHA256(base64Policy, signingKey).toString()
	                }, updatedAccessKey, updatedSessionToken);
	            }
	        };
	        qq.extend(options, o, true);
	        credentialsProvider = options.signatureSpec.credentialsProvider;
	        function handleSignatureReceived(id, xhrOrXdr, isError) {
	            var responseJson = xhrOrXdr.responseText, pendingSignatureData = pendingSignatures[id], promise = pendingSignatureData.promise, signatureConstructor = pendingSignatureData.signatureConstructor, errorMessage, response;
	            delete pendingSignatures[id];
	            if (responseJson) {
	                try {
	                    response = qq.parseJson(responseJson);
	                } catch (error) {
	                    options.log("Error attempting to parse signature response: " + error, "error");
	                }
	            }
	            if (response && response.invalid) {
	                isError = true;
	                errorMessage = "Invalid policy document or request headers!";
	            } else if (response) {
	                if (options.expectingPolicy && !response.policy) {
	                    isError = true;
	                    errorMessage = "Response does not include the base64 encoded policy!";
	                } else if (!response.signature) {
	                    isError = true;
	                    errorMessage = "Response does not include the signature!";
	                }
	            } else {
	                isError = true;
	                errorMessage = "Received an empty or invalid response from the server!";
	            }
	            if (isError) {
	                if (errorMessage) {
	                    options.log(errorMessage, "error");
	                }
	                promise.failure(errorMessage);
	            } else if (signatureConstructor) {
	                generateHeaders(signatureConstructor, response.signature, promise);
	            } else {
	                promise.success(response);
	            }
	        }
	        function getStringToSignArtifacts(id, version, requestInfo) {
	            var promise = new qq.Promise(), method = "POST", headerNames = [], headersStr = "", now = new Date(), endOfUrl, signatureSpec, toSign, generateStringToSign = function(requestInfo) {
	                var contentMd5, headerIndexesToRemove = [];
	                qq.each(requestInfo.headers, function(name) {
	                    headerNames.push(name);
	                });
	                headerNames.sort();
	                qq.each(headerNames, function(idx, headerName) {
	                    if (qq.indexOf(qq.s3.util.UNSIGNABLE_REST_HEADER_NAMES, headerName) < 0) {
	                        headersStr += headerName.toLowerCase() + ":" + requestInfo.headers[headerName].trim() + "\n";
	                    } else if (headerName === "Content-MD5") {
	                        contentMd5 = requestInfo.headers[headerName];
	                    } else {
	                        headerIndexesToRemove.unshift(idx);
	                    }
	                });
	                qq.each(headerIndexesToRemove, function(idx, headerIdx) {
	                    headerNames.splice(headerIdx, 1);
	                });
	                signatureSpec = {
	                    bucket: requestInfo.bucket,
	                    contentMd5: contentMd5,
	                    contentType: requestInfo.contentType,
	                    date: now,
	                    drift: options.signatureSpec.drift,
	                    endOfUrl: endOfUrl,
	                    hashedContent: requestInfo.hashedContent,
	                    headerNames: headerNames,
	                    headersStr: headersStr,
	                    method: method
	                };
	                toSign = version === 2 ? v2.getStringToSign(signatureSpec) : v4.getStringToSign(signatureSpec);
	                return {
	                    date: now,
	                    endOfUrl: endOfUrl,
	                    signedHeaders: version === 4 ? v4.getSignedHeaders(signatureSpec.headerNames) : null,
	                    toSign: version === 4 ? toSign.hashed : toSign,
	                    toSignRaw: version === 4 ? toSign.raw : toSign
	                };
	            };
	            switch (requestInfo.type) {
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_ABORT:
	                method = "DELETE";
	                endOfUrl = qq.format("uploadId={}", requestInfo.uploadId);
	                break;
	
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_INITIATE:
	                endOfUrl = "uploads";
	                break;
	
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_COMPLETE:
	                endOfUrl = qq.format("uploadId={}", requestInfo.uploadId);
	                break;
	
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_UPLOAD:
	                method = "PUT";
	                endOfUrl = qq.format("partNumber={}&uploadId={}", requestInfo.partNum, requestInfo.uploadId);
	                break;
	            }
	            endOfUrl = requestInfo.key + "?" + endOfUrl;
	            if (version === 4) {
	                v4.getEncodedHashedPayload(requestInfo.content).then(function(hashedContent) {
	                    requestInfo.headers["x-amz-content-sha256"] = hashedContent;
	                    requestInfo.headers.Host = requestInfo.host;
	                    requestInfo.headers["x-amz-date"] = qq.s3.util.getV4PolicyDate(now, options.signatureSpec.drift);
	                    requestInfo.hashedContent = hashedContent;
	                    promise.success(generateStringToSign(requestInfo));
	                }, function(err) {
	                    promise.failure(err);
	                });
	            } else {
	                promise.success(generateStringToSign(requestInfo));
	            }
	            return promise;
	        }
	        function determineSignatureClientSide(id, toBeSigned, signatureEffort, updatedAccessKey, updatedSessionToken) {
	            var updatedHeaders;
	            if (toBeSigned.signatureConstructor) {
	                if (updatedSessionToken) {
	                    updatedHeaders = toBeSigned.signatureConstructor.getHeaders();
	                    updatedHeaders[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = updatedSessionToken;
	                    toBeSigned.signatureConstructor.withHeaders(updatedHeaders);
	                }
	                toBeSigned.signatureConstructor.getToSign(id).then(function(signatureArtifacts) {
	                    signApiRequest(toBeSigned.signatureConstructor, signatureArtifacts.stringToSign, signatureEffort);
	                }, function(err) {
	                    signatureEffort.failure(err);
	                });
	            } else {
	                updatedSessionToken && qq.s3.util.refreshPolicyCredentials(toBeSigned, updatedSessionToken);
	                signPolicy(toBeSigned, signatureEffort, updatedAccessKey, updatedSessionToken);
	            }
	        }
	        function signPolicy(policy, signatureEffort, updatedAccessKey, updatedSessionToken) {
	            if (options.signatureSpec.version === 4) {
	                v4.signPolicy(policy, signatureEffort, updatedAccessKey, updatedSessionToken);
	            } else {
	                v2.signPolicy(policy, signatureEffort, updatedAccessKey, updatedSessionToken);
	            }
	        }
	        function signApiRequest(signatureConstructor, headersStr, signatureEffort) {
	            if (options.signatureSpec.version === 4) {
	                v4.signApiRequest(signatureConstructor, headersStr, signatureEffort);
	            } else {
	                v2.signApiRequest(signatureConstructor, headersStr, signatureEffort);
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            method: options.method,
	            contentType: "application/json; charset=utf-8",
	            endpointStore: {
	                get: function() {
	                    return options.signatureSpec.endpoint;
	                }
	            },
	            paramsStore: options.paramsStore,
	            maxConnections: options.maxConnections,
	            customHeaders: options.signatureSpec.customHeaders,
	            log: options.log,
	            onComplete: handleSignatureReceived,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            getSignature: function(id, toBeSigned) {
	                var params = toBeSigned, signatureConstructor = toBeSigned.signatureConstructor, signatureEffort = new qq.Promise(), queryParams;
	                if (options.signatureSpec.version === 4) {
	                    queryParams = {
	                        v4: true
	                    };
	                }
	                if (credentialsProvider.get().secretKey && qq.CryptoJS) {
	                    if (credentialsProvider.get().expiration.getTime() > Date.now()) {
	                        determineSignatureClientSide(id, toBeSigned, signatureEffort);
	                    } else {
	                        credentialsProvider.onExpired().then(function() {
	                            determineSignatureClientSide(id, toBeSigned, signatureEffort, credentialsProvider.get().accessKey, credentialsProvider.get().sessionToken);
	                        }, function(errorMsg) {
	                            options.log("Attempt to update expired credentials apparently failed! Unable to sign request.  ", "error");
	                            signatureEffort.failure("Unable to sign request - expired credentials.");
	                        });
	                    }
	                } else {
	                    options.log("Submitting S3 signature request for " + id);
	                    if (signatureConstructor) {
	                        signatureConstructor.getToSign(id).then(function(signatureArtifacts) {
	                            params = {
	                                headers: signatureArtifacts.stringToSignRaw
	                            };
	                            requester.initTransport(id).withParams(params).withQueryParams(queryParams).send();
	                        }, function(err) {
	                            options.log("Failed to construct signature. ", "error");
	                            signatureEffort.failure("Failed to construct signature.");
	                        });
	                    } else {
	                        requester.initTransport(id).withParams(params).withQueryParams(queryParams).send();
	                    }
	                    pendingSignatures[id] = {
	                        promise: signatureEffort,
	                        signatureConstructor: signatureConstructor
	                    };
	                }
	                return signatureEffort;
	            },
	            constructStringToSign: function(type, bucket, host, key) {
	                var headers = {}, uploadId, content, contentType, partNum, artifacts;
	                return {
	                    withHeaders: function(theHeaders) {
	                        headers = theHeaders;
	                        return this;
	                    },
	                    withUploadId: function(theUploadId) {
	                        uploadId = theUploadId;
	                        return this;
	                    },
	                    withContent: function(theContent) {
	                        content = theContent;
	                        return this;
	                    },
	                    withContentType: function(theContentType) {
	                        contentType = theContentType;
	                        return this;
	                    },
	                    withPartNum: function(thePartNum) {
	                        partNum = thePartNum;
	                        return this;
	                    },
	                    getToSign: function(id) {
	                        var sessionToken = credentialsProvider.get().sessionToken, promise = new qq.Promise(), adjustedDate = new Date(Date.now() + options.signatureSpec.drift);
	                        headers["x-amz-date"] = adjustedDate.toUTCString();
	                        if (sessionToken) {
	                            headers[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken;
	                        }
	                        getStringToSignArtifacts(id, options.signatureSpec.version, {
	                            bucket: bucket,
	                            content: content,
	                            contentType: contentType,
	                            headers: headers,
	                            host: host,
	                            key: key,
	                            partNum: partNum,
	                            type: type,
	                            uploadId: uploadId
	                        }).then(function(_artifacts_) {
	                            artifacts = _artifacts_;
	                            promise.success({
	                                headers: function() {
	                                    if (contentType) {
	                                        headers["Content-Type"] = contentType;
	                                    }
	                                    delete headers.Host;
	                                    return headers;
	                                }(),
	                                date: artifacts.date,
	                                endOfUrl: artifacts.endOfUrl,
	                                signedHeaders: artifacts.signedHeaders,
	                                stringToSign: artifacts.toSign,
	                                stringToSignRaw: artifacts.toSignRaw
	                            });
	                        }, function(err) {
	                            promise.failure(err);
	                        });
	                        return promise;
	                    },
	                    getHeaders: function() {
	                        return qq.extend({}, headers);
	                    },
	                    getEndOfUrl: function() {
	                        return artifacts && artifacts.endOfUrl;
	                    },
	                    getRequestDate: function() {
	                        return artifacts && artifacts.date;
	                    },
	                    getSignedHeaders: function() {
	                        return artifacts && artifacts.signedHeaders;
	                    }
	                };
	            }
	        });
	    };
	    qq.s3.RequestSigner.prototype.REQUEST_TYPE = {
	        MULTIPART_INITIATE: "multipart_initiate",
	        MULTIPART_COMPLETE: "multipart_complete",
	        MULTIPART_ABORT: "multipart_abort",
	        MULTIPART_UPLOAD: "multipart_upload"
	    };
	    qq.UploadSuccessAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingRequests = [], options = {
	            method: "POST",
	            endpoint: null,
	            maxConnections: 3,
	            customHeaders: {},
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {}
	        };
	        qq.extend(options, o);
	        function handleSuccessResponse(id, xhrOrXdr, isError) {
	            var promise = pendingRequests[id], responseJson = xhrOrXdr.responseText, successIndicator = {
	                success: true
	            }, failureIndicator = {
	                success: false
	            }, parsedResponse;
	            delete pendingRequests[id];
	            options.log(qq.format("Received the following response body to an upload success request for id {}: {}", id, responseJson));
	            try {
	                parsedResponse = qq.parseJson(responseJson);
	                if (isError || parsedResponse && (parsedResponse.error || parsedResponse.success === false)) {
	                    options.log("Upload success request was rejected by the server.", "error");
	                    promise.failure(qq.extend(parsedResponse, failureIndicator));
	                } else {
	                    options.log("Upload success was acknowledged by the server.");
	                    promise.success(qq.extend(parsedResponse, successIndicator));
	                }
	            } catch (error) {
	                if (isError) {
	                    options.log(qq.format("Your server indicated failure in its upload success request response for id {}!", id), "error");
	                    promise.failure(failureIndicator);
	                } else {
	                    options.log("Upload success was acknowledged by the server.");
	                    promise.success(successIndicator);
	                }
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            method: options.method,
	            endpointStore: {
	                get: function() {
	                    return options.endpoint;
	                }
	            },
	            paramsStore: options.paramsStore,
	            maxConnections: options.maxConnections,
	            customHeaders: options.customHeaders,
	            log: options.log,
	            onComplete: handleSuccessResponse,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            sendSuccessRequest: function(id, spec) {
	                var promise = new qq.Promise();
	                options.log("Submitting upload success request/notification for " + id);
	                requester.initTransport(id).withParams(spec).send();
	                pendingRequests[id] = promise;
	                return promise;
	            }
	        });
	    };
	    qq.s3.InitiateMultipartAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingInitiateRequests = {}, options = {
	            filenameParam: "qqfilename",
	            method: "POST",
	            endpointStore: null,
	            paramsStore: null,
	            signatureSpec: null,
	            aclStore: null,
	            reducedRedundancy: false,
	            serverSideEncryption: false,
	            maxConnections: 3,
	            getContentType: function(id) {},
	            getBucket: function(id) {},
	            getHost: function(id) {},
	            getKey: function(id) {},
	            getName: function(id) {},
	            log: function(str, level) {}
	        }, getSignatureAjaxRequester;
	        qq.extend(options, o);
	        getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            endpointStore: options.endpointStore,
	            signatureSpec: options.signatureSpec,
	            cors: options.cors,
	            log: options.log
	        });
	        function getHeaders(id) {
	            var bucket = options.getBucket(id), host = options.getHost(id), headers = {}, promise = new qq.Promise(), key = options.getKey(id), signatureConstructor;
	            headers["x-amz-acl"] = options.aclStore.get(id);
	            if (options.reducedRedundancy) {
	                headers[qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
	            }
	            if (options.serverSideEncryption) {
	                headers[qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
	            }
	            headers[qq.s3.util.AWS_PARAM_PREFIX + options.filenameParam] = encodeURIComponent(options.getName(id));
	            qq.each(options.paramsStore.get(id), function(name, val) {
	                if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, name) >= 0) {
	                    headers[name] = val;
	                } else {
	                    headers[qq.s3.util.AWS_PARAM_PREFIX + name] = encodeURIComponent(val);
	                }
	            });
	            signatureConstructor = getSignatureAjaxRequester.constructStringToSign(getSignatureAjaxRequester.REQUEST_TYPE.MULTIPART_INITIATE, bucket, host, key).withContentType(options.getContentType(id)).withHeaders(headers);
	            getSignatureAjaxRequester.getSignature(id, {
	                signatureConstructor: signatureConstructor
	            }).then(promise.success, promise.failure);
	            return promise;
	        }
	        function handleInitiateRequestComplete(id, xhr, isError) {
	            var promise = pendingInitiateRequests[id], domParser = new DOMParser(), responseDoc = domParser.parseFromString(xhr.responseText, "application/xml"), uploadIdElements, messageElements, uploadId, errorMessage, status;
	            delete pendingInitiateRequests[id];
	            if (isError) {
	                status = xhr.status;
	                messageElements = responseDoc.getElementsByTagName("Message");
	                if (messageElements.length > 0) {
	                    errorMessage = messageElements[0].textContent;
	                }
	            } else {
	                uploadIdElements = responseDoc.getElementsByTagName("UploadId");
	                if (uploadIdElements.length > 0) {
	                    uploadId = uploadIdElements[0].textContent;
	                } else {
	                    errorMessage = "Upload ID missing from request";
	                }
	            }
	            if (uploadId === undefined) {
	                if (errorMessage) {
	                    options.log(qq.format("Specific problem detected initiating multipart upload request for {}: '{}'.", id, errorMessage), "error");
	                } else {
	                    options.log(qq.format("Unexplained error with initiate multipart upload request for {}.  Status code {}.", id, status), "error");
	                }
	                promise.failure("Problem initiating upload request.", xhr);
	            } else {
	                options.log(qq.format("Initiate multipart upload request successful for {}.  Upload ID is {}", id, uploadId));
	                promise.success(uploadId, xhr);
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            method: options.method,
	            contentType: null,
	            endpointStore: options.endpointStore,
	            maxConnections: options.maxConnections,
	            allowXRequestedWithAndCacheControl: false,
	            log: options.log,
	            onComplete: handleInitiateRequestComplete,
	            successfulResponseCodes: {
	                POST: [ 200 ]
	            }
	        }));
	        qq.extend(this, {
	            send: function(id) {
	                var promise = new qq.Promise();
	                getHeaders(id).then(function(headers, endOfUrl) {
	                    options.log("Submitting S3 initiate multipart upload request for " + id);
	                    pendingInitiateRequests[id] = promise;
	                    requester.initTransport(id).withPath(endOfUrl).withHeaders(headers).send();
	                }, promise.failure);
	                return promise;
	            }
	        });
	    };
	    qq.s3.CompleteMultipartAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingCompleteRequests = {}, options = {
	            method: "POST",
	            contentType: "text/xml",
	            endpointStore: null,
	            signatureSpec: null,
	            maxConnections: 3,
	            getBucket: function(id) {},
	            getHost: function(id) {},
	            getKey: function(id) {},
	            log: function(str, level) {}
	        }, getSignatureAjaxRequester;
	        qq.extend(options, o);
	        getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            endpointStore: options.endpointStore,
	            signatureSpec: options.signatureSpec,
	            cors: options.cors,
	            log: options.log
	        });
	        function getHeaders(id, uploadId, body) {
	            var headers = {}, promise = new qq.Promise(), bucket = options.getBucket(id), host = options.getHost(id), signatureConstructor = getSignatureAjaxRequester.constructStringToSign(getSignatureAjaxRequester.REQUEST_TYPE.MULTIPART_COMPLETE, bucket, host, options.getKey(id)).withUploadId(uploadId).withContent(body).withContentType("application/xml; charset=UTF-8");
	            getSignatureAjaxRequester.getSignature(id, {
	                signatureConstructor: signatureConstructor
	            }).then(promise.success, promise.failure);
	            return promise;
	        }
	        function handleCompleteRequestComplete(id, xhr, isError) {
	            var promise = pendingCompleteRequests[id], domParser = new DOMParser(), bucket = options.getBucket(id), key = options.getKey(id), responseDoc = domParser.parseFromString(xhr.responseText, "application/xml"), bucketEls = responseDoc.getElementsByTagName("Bucket"), keyEls = responseDoc.getElementsByTagName("Key");
	            delete pendingCompleteRequests[id];
	            options.log(qq.format("Complete response status {}, body = {}", xhr.status, xhr.responseText));
	            if (isError) {
	                options.log(qq.format("Complete Multipart Upload request for {} failed with status {}.", id, xhr.status), "error");
	            } else {
	                if (bucketEls.length && keyEls.length) {
	                    if (bucketEls[0].textContent !== bucket) {
	                        isError = true;
	                        options.log(qq.format("Wrong bucket in response to Complete Multipart Upload request for {}.", id), "error");
	                    }
	                } else {
	                    isError = true;
	                    options.log(qq.format("Missing bucket and/or key in response to Complete Multipart Upload request for {}.", id), "error");
	                }
	            }
	            if (isError) {
	                promise.failure("Problem combining the file parts!", xhr);
	            } else {
	                promise.success({}, xhr);
	            }
	        }
	        function getCompleteRequestBody(etagEntries) {
	            var doc = document.implementation.createDocument(null, "CompleteMultipartUpload", null);
	            etagEntries.sort(function(a, b) {
	                return a.part - b.part;
	            });
	            qq.each(etagEntries, function(idx, etagEntry) {
	                var part = etagEntry.part, etag = etagEntry.etag, partEl = doc.createElement("Part"), partNumEl = doc.createElement("PartNumber"), partNumTextEl = doc.createTextNode(part), etagTextEl = doc.createTextNode(etag), etagEl = doc.createElement("ETag");
	                etagEl.appendChild(etagTextEl);
	                partNumEl.appendChild(partNumTextEl);
	                partEl.appendChild(partNumEl);
	                partEl.appendChild(etagEl);
	                qq(doc).children()[0].appendChild(partEl);
	            });
	            return new XMLSerializer().serializeToString(doc);
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            method: options.method,
	            contentType: "application/xml; charset=UTF-8",
	            endpointStore: options.endpointStore,
	            maxConnections: options.maxConnections,
	            allowXRequestedWithAndCacheControl: false,
	            log: options.log,
	            onComplete: handleCompleteRequestComplete,
	            successfulResponseCodes: {
	                POST: [ 200 ]
	            }
	        }));
	        qq.extend(this, {
	            send: function(id, uploadId, etagEntries) {
	                var promise = new qq.Promise(), body = getCompleteRequestBody(etagEntries);
	                getHeaders(id, uploadId, body).then(function(headers, endOfUrl) {
	                    options.log("Submitting S3 complete multipart upload request for " + id);
	                    pendingCompleteRequests[id] = promise;
	                    delete headers["Content-Type"];
	                    requester.initTransport(id).withPath(endOfUrl).withHeaders(headers).withPayload(body).send();
	                }, promise.failure);
	                return promise;
	            }
	        });
	    };
	    qq.s3.AbortMultipartAjaxRequester = function(o) {
	        "use strict";
	        var requester, options = {
	            method: "DELETE",
	            endpointStore: null,
	            signatureSpec: null,
	            maxConnections: 3,
	            getBucket: function(id) {},
	            getHost: function(id) {},
	            getKey: function(id) {},
	            log: function(str, level) {}
	        }, getSignatureAjaxRequester;
	        qq.extend(options, o);
	        getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            endpointStore: options.endpointStore,
	            signatureSpec: options.signatureSpec,
	            cors: options.cors,
	            log: options.log
	        });
	        function getHeaders(id, uploadId) {
	            var headers = {}, promise = new qq.Promise(), bucket = options.getBucket(id), host = options.getHost(id), signatureConstructor = getSignatureAjaxRequester.constructStringToSign(getSignatureAjaxRequester.REQUEST_TYPE.MULTIPART_ABORT, bucket, host, options.getKey(id)).withUploadId(uploadId);
	            getSignatureAjaxRequester.getSignature(id, {
	                signatureConstructor: signatureConstructor
	            }).then(promise.success, promise.failure);
	            return promise;
	        }
	        function handleAbortRequestComplete(id, xhr, isError) {
	            var domParser = new DOMParser(), responseDoc = domParser.parseFromString(xhr.responseText, "application/xml"), errorEls = responseDoc.getElementsByTagName("Error"), awsErrorMsg;
	            options.log(qq.format("Abort response status {}, body = {}", xhr.status, xhr.responseText));
	            if (isError) {
	                options.log(qq.format("Abort Multipart Upload request for {} failed with status {}.", id, xhr.status), "error");
	            } else {
	                if (errorEls.length) {
	                    isError = true;
	                    awsErrorMsg = responseDoc.getElementsByTagName("Message")[0].textContent;
	                    options.log(qq.format("Failed to Abort Multipart Upload request for {}.  Error: {}", id, awsErrorMsg), "error");
	                } else {
	                    options.log(qq.format("Abort MPU request succeeded for file ID {}.", id));
	                }
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            validMethods: [ "DELETE" ],
	            method: options.method,
	            contentType: null,
	            endpointStore: options.endpointStore,
	            maxConnections: options.maxConnections,
	            allowXRequestedWithAndCacheControl: false,
	            log: options.log,
	            onComplete: handleAbortRequestComplete,
	            successfulResponseCodes: {
	                DELETE: [ 204 ]
	            }
	        }));
	        qq.extend(this, {
	            send: function(id, uploadId) {
	                getHeaders(id, uploadId).then(function(headers, endOfUrl) {
	                    options.log("Submitting S3 Abort multipart upload request for " + id);
	                    requester.initTransport(id).withPath(endOfUrl).withHeaders(headers).send();
	                });
	            }
	        });
	    };
	    qq.s3.XhrUploadHandler = function(spec, proxy) {
	        "use strict";
	        var getName = proxy.getName, log = proxy.log, clockDrift = spec.clockDrift, expectedStatus = 200, onGetBucket = spec.getBucket, onGetHost = spec.getHost, onGetKeyName = spec.getKeyName, filenameParam = spec.filenameParam, paramsStore = spec.paramsStore, endpointStore = spec.endpointStore, aclStore = spec.aclStore, reducedRedundancy = spec.objectProperties.reducedRedundancy, region = spec.objectProperties.region, serverSideEncryption = spec.objectProperties.serverSideEncryption, validation = spec.validation, signature = qq.extend({
	            region: region,
	            drift: clockDrift
	        }, spec.signature), handler = this, credentialsProvider = spec.signature.credentialsProvider, chunked = {
	            combine: function(id) {
	                var uploadId = handler._getPersistableData(id).uploadId, etagMap = handler._getPersistableData(id).etags, result = new qq.Promise();
	                requesters.completeMultipart.send(id, uploadId, etagMap).then(result.success, function failure(reason, xhr) {
	                    result.failure(upload.done(id, xhr).response, xhr);
	                });
	                return result;
	            },
	            done: function(id, xhr, chunkIdx) {
	                var response = upload.response.parse(id, xhr), etag;
	                if (response.success) {
	                    etag = xhr.getResponseHeader("ETag");
	                    if (!handler._getPersistableData(id).etags) {
	                        handler._getPersistableData(id).etags = [];
	                    }
	                    handler._getPersistableData(id).etags.push({
	                        part: chunkIdx + 1,
	                        etag: etag
	                    });
	                }
	            },
	            initHeaders: function(id, chunkIdx, blob) {
	                var headers = {}, bucket = upload.bucket.getName(id), host = upload.host.getName(id), key = upload.key.urlSafe(id), promise = new qq.Promise(), signatureConstructor = requesters.restSignature.constructStringToSign(requesters.restSignature.REQUEST_TYPE.MULTIPART_UPLOAD, bucket, host, key).withPartNum(chunkIdx + 1).withContent(blob).withUploadId(handler._getPersistableData(id).uploadId);
	                requesters.restSignature.getSignature(id + "." + chunkIdx, {
	                    signatureConstructor: signatureConstructor
	                }).then(promise.success, promise.failure);
	                return promise;
	            },
	            put: function(id, chunkIdx) {
	                var xhr = handler._createXhr(id, chunkIdx), chunkData = handler._getChunkData(id, chunkIdx), domain = spec.endpointStore.get(id), promise = new qq.Promise();
	                chunked.initHeaders(id, chunkIdx, chunkData.blob).then(function(headers, endOfUrl) {
	                    if (xhr._cancelled) {
	                        log(qq.format("Upload of item {}.{} cancelled. Upload will not start after successful signature request.", id, chunkIdx));
	                        promise.failure({
	                            error: "Chunk upload cancelled"
	                        });
	                    } else {
	                        var url = domain + "/" + endOfUrl;
	                        handler._registerProgressHandler(id, chunkIdx, chunkData.size);
	                        upload.track(id, xhr, chunkIdx).then(promise.success, promise.failure);
	                        xhr.open("PUT", url, true);
	                        qq.each(headers, function(name, val) {
	                            xhr.setRequestHeader(name, val);
	                        });
	                        xhr.send(chunkData.blob);
	                    }
	                }, function() {
	                    promise.failure({
	                        error: "Problem signing the chunk!"
	                    }, xhr);
	                });
	                return promise;
	            },
	            send: function(id, chunkIdx) {
	                var promise = new qq.Promise();
	                chunked.setup(id).then(function() {
	                    chunked.put(id, chunkIdx).then(promise.success, promise.failure);
	                }, function(errorMessage, xhr) {
	                    promise.failure({
	                        error: errorMessage
	                    }, xhr);
	                });
	                return promise;
	            },
	            setup: function(id) {
	                var promise = new qq.Promise(), uploadId = handler._getPersistableData(id).uploadId, uploadIdPromise = new qq.Promise();
	                if (!uploadId) {
	                    handler._getPersistableData(id).uploadId = uploadIdPromise;
	                    requesters.initiateMultipart.send(id).then(function(uploadId) {
	                        handler._getPersistableData(id).uploadId = uploadId;
	                        uploadIdPromise.success(uploadId);
	                        promise.success(uploadId);
	                    }, function(errorMsg, xhr) {
	                        handler._getPersistableData(id).uploadId = null;
	                        promise.failure(errorMsg, xhr);
	                        uploadIdPromise.failure(errorMsg, xhr);
	                    });
	                } else if (uploadId instanceof qq.Promise) {
	                    uploadId.then(function(uploadId) {
	                        promise.success(uploadId);
	                    });
	                } else {
	                    promise.success(uploadId);
	                }
	                return promise;
	            }
	        }, requesters = {
	            abortMultipart: new qq.s3.AbortMultipartAjaxRequester({
	                endpointStore: endpointStore,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log,
	                getBucket: function(id) {
	                    return upload.bucket.getName(id);
	                },
	                getHost: function(id) {
	                    return upload.host.getName(id);
	                },
	                getKey: function(id) {
	                    return upload.key.urlSafe(id);
	                }
	            }),
	            completeMultipart: new qq.s3.CompleteMultipartAjaxRequester({
	                endpointStore: endpointStore,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log,
	                getBucket: function(id) {
	                    return upload.bucket.getName(id);
	                },
	                getHost: function(id) {
	                    return upload.host.getName(id);
	                },
	                getKey: function(id) {
	                    return upload.key.urlSafe(id);
	                }
	            }),
	            initiateMultipart: new qq.s3.InitiateMultipartAjaxRequester({
	                filenameParam: filenameParam,
	                endpointStore: endpointStore,
	                paramsStore: paramsStore,
	                signatureSpec: signature,
	                aclStore: aclStore,
	                reducedRedundancy: reducedRedundancy,
	                serverSideEncryption: serverSideEncryption,
	                cors: spec.cors,
	                log: log,
	                getContentType: function(id) {
	                    return handler._getMimeType(id);
	                },
	                getBucket: function(id) {
	                    return upload.bucket.getName(id);
	                },
	                getHost: function(id) {
	                    return upload.host.getName(id);
	                },
	                getKey: function(id) {
	                    return upload.key.urlSafe(id);
	                },
	                getName: function(id) {
	                    return getName(id);
	                }
	            }),
	            policySignature: new qq.s3.RequestSigner({
	                expectingPolicy: true,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log
	            }),
	            restSignature: new qq.s3.RequestSigner({
	                endpointStore: endpointStore,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log
	            })
	        }, simple = {
	            initParams: function(id) {
	                var customParams = paramsStore.get(id);
	                customParams[filenameParam] = getName(id);
	                return qq.s3.util.generateAwsParams({
	                    endpoint: endpointStore.get(id),
	                    clockDrift: clockDrift,
	                    params: customParams,
	                    type: handler._getMimeType(id),
	                    bucket: upload.bucket.getName(id),
	                    key: handler.getThirdPartyFileId(id),
	                    accessKey: credentialsProvider.get().accessKey,
	                    sessionToken: credentialsProvider.get().sessionToken,
	                    acl: aclStore.get(id),
	                    expectedStatus: expectedStatus,
	                    minFileSize: validation.minSizeLimit,
	                    maxFileSize: validation.maxSizeLimit,
	                    reducedRedundancy: reducedRedundancy,
	                    region: region,
	                    serverSideEncryption: serverSideEncryption,
	                    signatureVersion: signature.version,
	                    log: log
	                }, qq.bind(requesters.policySignature.getSignature, this, id));
	            },
	            send: function(id) {
	                var promise = new qq.Promise(), xhr = handler._createXhr(id), fileOrBlob = handler.getFile(id);
	                handler._registerProgressHandler(id);
	                upload.track(id, xhr).then(promise.success, promise.failure);
	                simple.setup(id, xhr, fileOrBlob).then(function(toSend) {
	                    log("Sending upload request for " + id);
	                    xhr.send(toSend);
	                }, promise.failure);
	                return promise;
	            },
	            setup: function(id, xhr, fileOrBlob) {
	                var formData = new FormData(), endpoint = endpointStore.get(id), url = endpoint, promise = new qq.Promise();
	                simple.initParams(id).then(function(awsParams) {
	                    xhr.open("POST", url, true);
	                    qq.obj2FormData(awsParams, formData);
	                    formData.append("file", fileOrBlob);
	                    promise.success(formData);
	                }, function(errorMessage) {
	                    promise.failure({
	                        error: errorMessage
	                    });
	                });
	                return promise;
	            }
	        }, upload = {
	            bucket: {
	                promise: function(id) {
	                    var promise = new qq.Promise(), cachedBucket = handler._getFileState(id).bucket;
	                    if (cachedBucket) {
	                        promise.success(cachedBucket);
	                    } else {
	                        onGetBucket(id).then(function(bucket) {
	                            handler._getFileState(id).bucket = bucket;
	                            promise.success(bucket);
	                        }, promise.failure);
	                    }
	                    return promise;
	                },
	                getName: function(id) {
	                    return handler._getFileState(id).bucket;
	                }
	            },
	            host: {
	                promise: function(id) {
	                    var promise = new qq.Promise(), cachedHost = handler._getFileState(id).host;
	                    if (cachedHost) {
	                        promise.success(cachedHost);
	                    } else {
	                        onGetHost(id).then(function(host) {
	                            handler._getFileState(id).host = host;
	                            promise.success(host);
	                        }, promise.failure);
	                    }
	                    return promise;
	                },
	                getName: function(id) {
	                    return handler._getFileState(id).host;
	                }
	            },
	            done: function(id, xhr) {
	                var response = upload.response.parse(id, xhr), isError = response.success !== true;
	                if (isError && upload.response.shouldReset(response.code)) {
	                    log("This is an unrecoverable error, we must restart the upload entirely on the next retry attempt.", "error");
	                    response.reset = true;
	                }
	                return {
	                    success: !isError,
	                    response: response
	                };
	            },
	            key: {
	                promise: function(id) {
	                    var promise = new qq.Promise(), key = handler.getThirdPartyFileId(id);
	                    if (key == null) {
	                        handler._setThirdPartyFileId(id, promise);
	                        onGetKeyName(id, getName(id)).then(function(keyName) {
	                            handler._setThirdPartyFileId(id, keyName);
	                            promise.success(keyName);
	                        }, function(errorReason) {
	                            handler._setThirdPartyFileId(id, null);
	                            promise.failure(errorReason);
	                        });
	                    } else if (qq.isGenericPromise(key)) {
	                        key.then(promise.success, promise.failure);
	                    } else {
	                        promise.success(key);
	                    }
	                    return promise;
	                },
	                urlSafe: function(id) {
	                    var encodedKey = handler.getThirdPartyFileId(id);
	                    return qq.s3.util.uriEscapePath(encodedKey);
	                }
	            },
	            response: {
	                parse: function(id, xhr) {
	                    var response = {}, parsedErrorProps;
	                    try {
	                        log(qq.format("Received response status {} with body: {}", xhr.status, xhr.responseText));
	                        if (xhr.status === expectedStatus) {
	                            response.success = true;
	                        } else {
	                            parsedErrorProps = upload.response.parseError(xhr.responseText);
	                            if (parsedErrorProps) {
	                                response.error = parsedErrorProps.message;
	                                response.code = parsedErrorProps.code;
	                            }
	                        }
	                    } catch (error) {
	                        log("Error when attempting to parse xhr response text (" + error.message + ")", "error");
	                    }
	                    return response;
	                },
	                parseError: function(awsResponseXml) {
	                    var parser = new DOMParser(), parsedDoc = parser.parseFromString(awsResponseXml, "application/xml"), errorEls = parsedDoc.getElementsByTagName("Error"), errorDetails = {}, codeEls, messageEls;
	                    if (errorEls.length) {
	                        codeEls = parsedDoc.getElementsByTagName("Code");
	                        messageEls = parsedDoc.getElementsByTagName("Message");
	                        if (messageEls.length) {
	                            errorDetails.message = messageEls[0].textContent;
	                        }
	                        if (codeEls.length) {
	                            errorDetails.code = codeEls[0].textContent;
	                        }
	                        return errorDetails;
	                    }
	                },
	                shouldReset: function(errorCode) {
	                    return errorCode === "EntityTooSmall" || errorCode === "InvalidPart" || errorCode === "InvalidPartOrder" || errorCode === "NoSuchUpload";
	                }
	            },
	            start: function(id, optChunkIdx) {
	                var promise = new qq.Promise();
	                upload.key.promise(id).then(function() {
	                    upload.bucket.promise(id).then(function() {
	                        upload.host.promise(id).then(function() {
	                            if (optChunkIdx == null) {
	                                simple.send(id).then(promise.success, promise.failure);
	                            } else {
	                                chunked.send(id, optChunkIdx).then(promise.success, promise.failure);
	                            }
	                        });
	                    });
	                }, function(errorReason) {
	                    promise.failure({
	                        error: errorReason
	                    });
	                });
	                return promise;
	            },
	            track: function(id, xhr, optChunkIdx) {
	                var promise = new qq.Promise();
	                xhr.onreadystatechange = function() {
	                    if (xhr.readyState === 4) {
	                        var result;
	                        if (optChunkIdx == null) {
	                            result = upload.done(id, xhr);
	                            promise[result.success ? "success" : "failure"](result.response, xhr);
	                        } else {
	                            chunked.done(id, xhr, optChunkIdx);
	                            result = upload.done(id, xhr);
	                            promise[result.success ? "success" : "failure"](result.response, xhr);
	                        }
	                    }
	                };
	                return promise;
	            }
	        };
	        qq.extend(this, {
	            uploadChunk: upload.start,
	            uploadFile: upload.start
	        });
	        qq.extend(this, new qq.XhrUploadHandler({
	            options: qq.extend({
	                namespace: "s3"
	            }, spec),
	            proxy: qq.extend({
	                getEndpoint: spec.endpointStore.get
	            }, proxy)
	        }));
	        qq.override(this, function(super_) {
	            return {
	                expunge: function(id) {
	                    var uploadId = handler._getPersistableData(id) && handler._getPersistableData(id).uploadId, existedInLocalStorage = handler._maybeDeletePersistedChunkData(id);
	                    if (uploadId !== undefined && existedInLocalStorage) {
	                        requesters.abortMultipart.send(id, uploadId);
	                    }
	                    super_.expunge(id);
	                },
	                finalizeChunks: function(id) {
	                    return chunked.combine(id);
	                },
	                _getLocalStorageId: function(id) {
	                    var baseStorageId = super_._getLocalStorageId(id), bucketName = upload.bucket.getName(id);
	                    return baseStorageId + "-" + bucketName;
	                }
	            };
	        });
	    };
	    qq.s3.FormUploadHandler = function(options, proxy) {
	        "use strict";
	        var handler = this, clockDrift = options.clockDrift, onUuidChanged = proxy.onUuidChanged, getName = proxy.getName, getUuid = proxy.getUuid, log = proxy.log, onGetBucket = options.getBucket, onGetKeyName = options.getKeyName, filenameParam = options.filenameParam, paramsStore = options.paramsStore, endpointStore = options.endpointStore, aclStore = options.aclStore, reducedRedundancy = options.objectProperties.reducedRedundancy, region = options.objectProperties.region, serverSideEncryption = options.objectProperties.serverSideEncryption, validation = options.validation, signature = options.signature, successRedirectUrl = options.iframeSupport.localBlankPagePath, credentialsProvider = options.signature.credentialsProvider, getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            signatureSpec: signature,
	            cors: options.cors,
	            log: log
	        });
	        if (successRedirectUrl === undefined) {
	            throw new Error("successRedirectEndpoint MUST be defined if you intend to use browsers that do not support the File API!");
	        }
	        function isValidResponse(id, iframe) {
	            var response, endpoint = options.endpointStore.get(id), bucket = handler._getFileState(id).bucket, doc, innerHtml, responseData;
	            try {
	                doc = iframe.contentDocument || iframe.contentWindow.document;
	                innerHtml = doc.body.innerHTML;
	                responseData = qq.s3.util.parseIframeResponse(iframe);
	                if (responseData.bucket === bucket && responseData.key === qq.s3.util.encodeQueryStringParam(handler.getThirdPartyFileId(id))) {
	                    return true;
	                }
	                log("Response from AWS included an unexpected bucket or key name.", "error");
	            } catch (error) {
	                log("Error when attempting to parse form upload response (" + error.message + ")", "error");
	            }
	            return false;
	        }
	        function generateAwsParams(id) {
	            var customParams = paramsStore.get(id);
	            customParams[filenameParam] = getName(id);
	            return qq.s3.util.generateAwsParams({
	                endpoint: endpointStore.get(id),
	                clockDrift: clockDrift,
	                params: customParams,
	                bucket: handler._getFileState(id).bucket,
	                key: handler.getThirdPartyFileId(id),
	                accessKey: credentialsProvider.get().accessKey,
	                sessionToken: credentialsProvider.get().sessionToken,
	                acl: aclStore.get(id),
	                minFileSize: validation.minSizeLimit,
	                maxFileSize: validation.maxSizeLimit,
	                successRedirectUrl: successRedirectUrl,
	                reducedRedundancy: reducedRedundancy,
	                region: region,
	                serverSideEncryption: serverSideEncryption,
	                signatureVersion: signature.version,
	                log: log
	            }, qq.bind(getSignatureAjaxRequester.getSignature, this, id));
	        }
	        function createForm(id, iframe) {
	            var promise = new qq.Promise(), method = "POST", endpoint = options.endpointStore.get(id), fileName = getName(id);
	            generateAwsParams(id).then(function(params) {
	                var form = handler._initFormForUpload({
	                    method: method,
	                    endpoint: endpoint,
	                    params: params,
	                    paramsInBody: true,
	                    targetName: iframe.name
	                });
	                promise.success(form);
	            }, function(errorMessage) {
	                promise.failure(errorMessage);
	                handleFinishedUpload(id, iframe, fileName, {
	                    error: errorMessage
	                });
	            });
	            return promise;
	        }
	        function handleUpload(id) {
	            var iframe = handler._createIframe(id), input = handler.getInput(id), promise = new qq.Promise();
	            createForm(id, iframe).then(function(form) {
	                form.appendChild(input);
	                handler._attachLoadEvent(iframe, function(response) {
	                    log("iframe loaded");
	                    if (response) {
	                        if (response.success === false) {
	                            log("Amazon likely rejected the upload request", "error");
	                            promise.failure(response);
	                        }
	                    } else {
	                        response = {};
	                        response.success = isValidResponse(id, iframe);
	                        if (response.success === false) {
	                            log("A success response was received by Amazon, but it was invalid in some way.", "error");
	                            promise.failure(response);
	                        } else {
	                            qq.extend(response, qq.s3.util.parseIframeResponse(iframe));
	                            promise.success(response);
	                        }
	                    }
	                    handleFinishedUpload(id, iframe);
	                });
	                log("Sending upload request for " + id);
	                form.submit();
	                qq(form).remove();
	            }, promise.failure);
	            return promise;
	        }
	        function handleFinishedUpload(id, iframe) {
	            handler._detachLoadEvent(id);
	            iframe && qq(iframe).remove();
	        }
	        qq.extend(this, new qq.FormUploadHandler({
	            options: {
	                isCors: false,
	                inputName: "file"
	            },
	            proxy: {
	                onCancel: options.onCancel,
	                onUuidChanged: onUuidChanged,
	                getName: getName,
	                getUuid: getUuid,
	                log: log
	            }
	        }));
	        qq.extend(this, {
	            uploadFile: function(id) {
	                var name = getName(id), promise = new qq.Promise();
	                if (handler.getThirdPartyFileId(id)) {
	                    if (handler._getFileState(id).bucket) {
	                        handleUpload(id).then(promise.success, promise.failure);
	                    } else {
	                        onGetBucket(id).then(function(bucket) {
	                            handler._getFileState(id).bucket = bucket;
	                            handleUpload(id).then(promise.success, promise.failure);
	                        });
	                    }
	                } else {
	                    onGetKeyName(id, name).then(function(key) {
	                        onGetBucket(id).then(function(bucket) {
	                            handler._getFileState(id).bucket = bucket;
	                            handler._setThirdPartyFileId(id, key);
	                            handleUpload(id).then(promise.success, promise.failure);
	                        }, function(errorReason) {
	                            promise.failure({
	                                error: errorReason
	                            });
	                        });
	                    }, function(errorReason) {
	                        promise.failure({
	                            error: errorReason
	                        });
	                    });
	                }
	                return promise;
	            }
	        });
	    };
	    (function() {
	        "use strict";
	        qq.s3.FineUploader = function(o) {
	            var options = {
	                failedUploadTextDisplay: {
	                    mode: "custom"
	                }
	            };
	            qq.extend(options, o, true);
	            qq.FineUploader.call(this, options, "s3");
	            if (!qq.supportedFeatures.ajaxUploading && options.iframeSupport.localBlankPagePath === undefined) {
	                this._options.element.innerHTML = "<div>You MUST set the <code>localBlankPagePath</code> property " + "of the <code>iframeSupport</code> option since this browser does not support the File API!</div>";
	            }
	        };
	        qq.extend(qq.s3.FineUploader.prototype, qq.s3.FineUploaderBasic.prototype);
	        qq.extend(qq.s3.FineUploader.prototype, qq.uiPublicApi);
	        qq.extend(qq.s3.FineUploader.prototype, qq.uiPrivateApi);
	    })();
	    qq.azure = qq.azure || {};
	    qq.azure.util = qq.azure.util || function() {
	        "use strict";
	        return {
	            AZURE_PARAM_PREFIX: "x-ms-meta-",
	            _paramNameMatchesAzureParameter: function(name) {
	                switch (name) {
	                  case "Cache-Control":
	                  case "Content-Disposition":
	                  case "Content-Encoding":
	                  case "Content-MD5":
	                  case "x-ms-blob-content-encoding":
	                  case "x-ms-blob-content-disposition":
	                  case "x-ms-blob-content-md5":
	                  case "x-ms-blob-cache-control":
	                    return true;
	
	                  default:
	                    return false;
	                }
	            },
	            _getPrefixedParamName: function(name) {
	                if (qq.azure.util._paramNameMatchesAzureParameter(name)) {
	                    return name;
	                } else {
	                    return qq.azure.util.AZURE_PARAM_PREFIX + name;
	                }
	            },
	            getParamsAsHeaders: function(params) {
	                var headers = {};
	                qq.each(params, function(name, val) {
	                    var headerName = qq.azure.util._getPrefixedParamName(name), value = null;
	                    if (qq.isFunction(val)) {
	                        value = String(val());
	                    } else if (qq.isObject(val)) {
	                        qq.extend(headers, qq.azure.util.getParamsAsHeaders(val));
	                    } else {
	                        value = String(val);
	                    }
	                    if (value !== null) {
	                        if (qq.azure.util._paramNameMatchesAzureParameter(name)) {
	                            headers[headerName] = value;
	                        } else {
	                            headers[headerName] = encodeURIComponent(value);
	                        }
	                    }
	                });
	                return headers;
	            },
	            parseAzureError: function(responseText, log) {
	                var domParser = new DOMParser(), responseDoc = domParser.parseFromString(responseText, "application/xml"), errorTag = responseDoc.getElementsByTagName("Error")[0], errorDetails = {}, codeTag, messageTag;
	                log("Received error response: " + responseText, "error");
	                if (errorTag) {
	                    messageTag = errorTag.getElementsByTagName("Message")[0];
	                    if (messageTag) {
	                        errorDetails.message = messageTag.textContent;
	                    }
	                    codeTag = errorTag.getElementsByTagName("Code")[0];
	                    if (codeTag) {
	                        errorDetails.code = codeTag.textContent;
	                    }
	                    log("Parsed Azure error: " + JSON.stringify(errorDetails), "error");
	                    return errorDetails;
	                }
	            }
	        };
	    }();
	    (function() {
	        "use strict";
	        qq.nonTraditionalBasePublicApi = {
	            setUploadSuccessParams: function(params, id) {
	                this._uploadSuccessParamsStore.set(params, id);
	            },
	            setUploadSuccessEndpoint: function(endpoint, id) {
	                this._uploadSuccessEndpointStore.set(endpoint, id);
	            }
	        };
	        qq.nonTraditionalBasePrivateApi = {
	            _onComplete: function(id, name, result, xhr) {
	                var success = result.success ? true : false, self = this, onCompleteArgs = arguments, successEndpoint = this._uploadSuccessEndpointStore.get(id), successCustomHeaders = this._options.uploadSuccess.customHeaders, successMethod = this._options.uploadSuccess.method, cors = this._options.cors, promise = new qq.Promise(), uploadSuccessParams = this._uploadSuccessParamsStore.get(id), fileParams = this._paramsStore.get(id), onSuccessFromServer = function(successRequestResult) {
	                    delete self._failedSuccessRequestCallbacks[id];
	                    qq.extend(result, successRequestResult);
	                    qq.FineUploaderBasic.prototype._onComplete.apply(self, onCompleteArgs);
	                    promise.success(successRequestResult);
	                }, onFailureFromServer = function(successRequestResult) {
	                    var callback = submitSuccessRequest;
	                    qq.extend(result, successRequestResult);
	                    if (result && result.reset) {
	                        callback = null;
	                    }
	                    if (!callback) {
	                        delete self._failedSuccessRequestCallbacks[id];
	                    } else {
	                        self._failedSuccessRequestCallbacks[id] = callback;
	                    }
	                    if (!self._onAutoRetry(id, name, result, xhr, callback)) {
	                        qq.FineUploaderBasic.prototype._onComplete.apply(self, onCompleteArgs);
	                        promise.failure(successRequestResult);
	                    }
	                }, submitSuccessRequest, successAjaxRequester;
	                if (success && successEndpoint) {
	                    successAjaxRequester = new qq.UploadSuccessAjaxRequester({
	                        endpoint: successEndpoint,
	                        method: successMethod,
	                        customHeaders: successCustomHeaders,
	                        cors: cors,
	                        log: qq.bind(this.log, this)
	                    });
	                    qq.extend(uploadSuccessParams, self._getEndpointSpecificParams(id, result, xhr), true);
	                    fileParams && qq.extend(uploadSuccessParams, fileParams, true);
	                    submitSuccessRequest = qq.bind(function() {
	                        successAjaxRequester.sendSuccessRequest(id, uploadSuccessParams).then(onSuccessFromServer, onFailureFromServer);
	                    }, self);
	                    submitSuccessRequest();
	                    return promise;
	                }
	                return qq.FineUploaderBasic.prototype._onComplete.apply(this, arguments);
	            },
	            _manualRetry: function(id) {
	                var successRequestCallback = this._failedSuccessRequestCallbacks[id];
	                return qq.FineUploaderBasic.prototype._manualRetry.call(this, id, successRequestCallback);
	            }
	        };
	    })();
	    (function() {
	        "use strict";
	        qq.azure.FineUploaderBasic = function(o) {
	            if (!qq.supportedFeatures.ajaxUploading) {
	                throw new qq.Error("Uploading directly to Azure is not possible in this browser.");
	            }
	            var options = {
	                signature: {
	                    endpoint: null,
	                    customHeaders: {}
	                },
	                blobProperties: {
	                    name: "uuid"
	                },
	                uploadSuccess: {
	                    endpoint: null,
	                    method: "POST",
	                    params: {},
	                    customHeaders: {}
	                },
	                chunking: {
	                    partSize: 4e6,
	                    minFileSize: 4000001
	                }
	            };
	            qq.extend(options, o, true);
	            qq.FineUploaderBasic.call(this, options);
	            this._uploadSuccessParamsStore = this._createStore(this._options.uploadSuccess.params);
	            this._uploadSuccessEndpointStore = this._createStore(this._options.uploadSuccess.endpoint);
	            this._failedSuccessRequestCallbacks = {};
	            this._cannedBlobNames = {};
	        };
	        qq.extend(qq.azure.FineUploaderBasic.prototype, qq.basePublicApi);
	        qq.extend(qq.azure.FineUploaderBasic.prototype, qq.basePrivateApi);
	        qq.extend(qq.azure.FineUploaderBasic.prototype, qq.nonTraditionalBasePublicApi);
	        qq.extend(qq.azure.FineUploaderBasic.prototype, qq.nonTraditionalBasePrivateApi);
	        qq.extend(qq.azure.FineUploaderBasic.prototype, {
	            getBlobName: function(id) {
	                if (this._cannedBlobNames[id] == null) {
	                    return this._handler.getThirdPartyFileId(id);
	                }
	                return this._cannedBlobNames[id];
	            },
	            _getEndpointSpecificParams: function(id) {
	                return {
	                    blob: this.getBlobName(id),
	                    uuid: this.getUuid(id),
	                    name: this.getName(id),
	                    container: this._endpointStore.get(id)
	                };
	            },
	            _createUploadHandler: function() {
	                return qq.FineUploaderBasic.prototype._createUploadHandler.call(this, {
	                    signature: this._options.signature,
	                    onGetBlobName: qq.bind(this._determineBlobName, this),
	                    deleteBlob: qq.bind(this._deleteBlob, this, true)
	                }, "azure");
	            },
	            _determineBlobName: function(id) {
	                var self = this, blobNameOptionValue = this._options.blobProperties.name, uuid = this.getUuid(id), filename = this.getName(id), fileExtension = qq.getExtension(filename), blobNameToUse = uuid;
	                if (qq.isString(blobNameOptionValue)) {
	                    switch (blobNameOptionValue) {
	                      case "uuid":
	                        if (fileExtension !== undefined) {
	                            blobNameToUse += "." + fileExtension;
	                        }
	                        return new qq.Promise().success(blobNameToUse);
	
	                      case "filename":
	                        return new qq.Promise().success(filename);
	
	                      default:
	                        return new qq.Promise.failure("Invalid blobName option value - " + blobNameOptionValue);
	                    }
	                } else {
	                    return blobNameOptionValue.call(this, id);
	                }
	            },
	            _addCannedFile: function(sessionData) {
	                var id;
	                if (sessionData.blobName == null) {
	                    throw new qq.Error("Did not find blob name property in server session response.  This is required!");
	                } else {
	                    id = qq.FineUploaderBasic.prototype._addCannedFile.apply(this, arguments);
	                    this._cannedBlobNames[id] = sessionData.blobName;
	                }
	                return id;
	            },
	            _deleteBlob: function(relatedToCancel, id) {
	                var self = this, deleteBlobSasUri = {}, blobUriStore = {
	                    get: function(id) {
	                        return self._endpointStore.get(id) + "/" + self.getBlobName(id);
	                    }
	                }, deleteFileEndpointStore = {
	                    get: function(id) {
	                        return deleteBlobSasUri[id];
	                    }
	                }, getSasSuccess = function(id, sasUri) {
	                    deleteBlobSasUri[id] = sasUri;
	                    deleteBlob.send(id);
	                }, getSasFailure = function(id, reason, xhr) {
	                    if (relatedToCancel) {
	                        self.log("Will cancel upload, but cannot remove uncommitted parts from Azure due to issue retrieving SAS", "error");
	                        qq.FineUploaderBasic.prototype._onCancel.call(self, id, self.getName(id));
	                    } else {
	                        self._onDeleteComplete(id, xhr, true);
	                        self._options.callbacks.onDeleteComplete(id, xhr, true);
	                    }
	                }, deleteBlob = new qq.azure.DeleteBlob({
	                    endpointStore: deleteFileEndpointStore,
	                    log: qq.bind(self.log, self),
	                    onDelete: function(id) {
	                        self._onDelete(id);
	                        self._options.callbacks.onDelete(id);
	                    },
	                    onDeleteComplete: function(id, xhrOrXdr, isError) {
	                        delete deleteBlobSasUri[id];
	                        if (isError) {
	                            if (relatedToCancel) {
	                                self.log("Will cancel upload, but failed to remove uncommitted parts from Azure.", "error");
	                            } else {
	                                qq.azure.util.parseAzureError(xhrOrXdr.responseText, qq.bind(self.log, self));
	                            }
	                        }
	                        if (relatedToCancel) {
	                            qq.FineUploaderBasic.prototype._onCancel.call(self, id, self.getName(id));
	                            self.log("Deleted uncommitted blob chunks for " + id);
	                        } else {
	                            self._onDeleteComplete(id, xhrOrXdr, isError);
	                            self._options.callbacks.onDeleteComplete(id, xhrOrXdr, isError);
	                        }
	                    }
	                }), getSas = new qq.azure.GetSas({
	                    cors: this._options.cors,
	                    customHeaders: this._options.signature.customHeaders,
	                    endpointStore: {
	                        get: function() {
	                            return self._options.signature.endpoint;
	                        }
	                    },
	                    restRequestVerb: deleteBlob.method,
	                    log: qq.bind(self.log, self)
	                });
	                getSas.request(id, blobUriStore.get(id)).then(qq.bind(getSasSuccess, self, id), qq.bind(getSasFailure, self, id));
	            },
	            _createDeleteHandler: function() {
	                var self = this;
	                return {
	                    sendDelete: function(id, uuid) {
	                        self._deleteBlob(false, id);
	                    }
	                };
	            }
	        });
	    })();
	    qq.azure.XhrUploadHandler = function(spec, proxy) {
	        "use strict";
	        var handler = this, log = proxy.log, cors = spec.cors, endpointStore = spec.endpointStore, paramsStore = spec.paramsStore, signature = spec.signature, filenameParam = spec.filenameParam, minFileSizeForChunking = spec.chunking.minFileSize, deleteBlob = spec.deleteBlob, onGetBlobName = spec.onGetBlobName, getName = proxy.getName, getSize = proxy.getSize, getBlobMetadata = function(id) {
	            var params = paramsStore.get(id);
	            params[filenameParam] = getName(id);
	            return params;
	        }, api = {
	            putBlob: new qq.azure.PutBlob({
	                getBlobMetadata: getBlobMetadata,
	                log: log
	            }),
	            putBlock: new qq.azure.PutBlock({
	                log: log
	            }),
	            putBlockList: new qq.azure.PutBlockList({
	                getBlobMetadata: getBlobMetadata,
	                log: log
	            }),
	            getSasForPutBlobOrBlock: new qq.azure.GetSas({
	                cors: cors,
	                customHeaders: signature.customHeaders,
	                endpointStore: {
	                    get: function() {
	                        return signature.endpoint;
	                    }
	                },
	                log: log,
	                restRequestVerb: "PUT"
	            })
	        };
	        function combineChunks(id) {
	            var promise = new qq.Promise();
	            getSignedUrl(id).then(function(sasUri) {
	                var mimeType = handler._getMimeType(id), blockIdEntries = handler._getPersistableData(id).blockIdEntries;
	                api.putBlockList.send(id, sasUri, blockIdEntries, mimeType, function(xhr) {
	                    handler._registerXhr(id, null, xhr, api.putBlockList);
	                }).then(function(xhr) {
	                    log("Success combining chunks for id " + id);
	                    promise.success({}, xhr);
	                }, function(xhr) {
	                    log("Attempt to combine chunks failed for id " + id, "error");
	                    handleFailure(xhr, promise);
	                });
	            }, promise.failure);
	            return promise;
	        }
	        function determineBlobUrl(id) {
	            var containerUrl = endpointStore.get(id), promise = new qq.Promise(), getBlobNameSuccess = function(blobName) {
	                handler._setThirdPartyFileId(id, blobName);
	                promise.success(containerUrl + "/" + blobName);
	            }, getBlobNameFailure = function(reason) {
	                promise.failure(reason);
	            };
	            onGetBlobName(id).then(getBlobNameSuccess, getBlobNameFailure);
	            return promise;
	        }
	        function getSignedUrl(id, optChunkIdx) {
	            var getSasId = optChunkIdx == null ? id : id + "." + optChunkIdx, promise = new qq.Promise(), getSasSuccess = function(sasUri) {
	                log("GET SAS request succeeded.");
	                promise.success(sasUri);
	            }, getSasFailure = function(reason, getSasXhr) {
	                log("GET SAS request failed: " + reason, "error");
	                promise.failure({
	                    error: "Problem communicating with local server"
	                }, getSasXhr);
	            }, determineBlobUrlSuccess = function(blobUrl) {
	                api.getSasForPutBlobOrBlock.request(getSasId, blobUrl).then(getSasSuccess, getSasFailure);
	            }, determineBlobUrlFailure = function(reason) {
	                log(qq.format("Failed to determine blob name for ID {} - {}", id, reason), "error");
	                promise.failure({
	                    error: reason
	                });
	            };
	            determineBlobUrl(id).then(determineBlobUrlSuccess, determineBlobUrlFailure);
	            return promise;
	        }
	        function handleFailure(xhr, promise) {
	            var azureError = qq.azure.util.parseAzureError(xhr.responseText, log), errorMsg = "Problem sending file to Azure";
	            promise.failure({
	                error: errorMsg,
	                azureError: azureError && azureError.message,
	                reset: xhr.status === 403
	            });
	        }
	        qq.extend(this, {
	            uploadChunk: function(id, chunkIdx) {
	                var promise = new qq.Promise();
	                getSignedUrl(id, chunkIdx).then(function(sasUri) {
	                    var xhr = handler._createXhr(id, chunkIdx), chunkData = handler._getChunkData(id, chunkIdx);
	                    handler._registerProgressHandler(id, chunkIdx, chunkData.size);
	                    handler._registerXhr(id, chunkIdx, xhr, api.putBlock);
	                    api.putBlock.upload(id + "." + chunkIdx, xhr, sasUri, chunkIdx, chunkData.blob).then(function(blockIdEntry) {
	                        if (!handler._getPersistableData(id).blockIdEntries) {
	                            handler._getPersistableData(id).blockIdEntries = [];
	                        }
	                        handler._getPersistableData(id).blockIdEntries.push(blockIdEntry);
	                        log("Put Block call succeeded for " + id);
	                        promise.success({}, xhr);
	                    }, function() {
	                        log(qq.format("Put Block call failed for ID {} on part {}", id, chunkIdx), "error");
	                        handleFailure(xhr, promise);
	                    });
	                }, promise.failure);
	                return promise;
	            },
	            uploadFile: function(id) {
	                var promise = new qq.Promise(), fileOrBlob = handler.getFile(id);
	                getSignedUrl(id).then(function(sasUri) {
	                    var xhr = handler._createXhr(id);
	                    handler._registerProgressHandler(id);
	                    api.putBlob.upload(id, xhr, sasUri, fileOrBlob).then(function() {
	                        log("Put Blob call succeeded for " + id);
	                        promise.success({}, xhr);
	                    }, function() {
	                        log("Put Blob call failed for " + id, "error");
	                        handleFailure(xhr, promise);
	                    });
	                }, promise.failure);
	                return promise;
	            }
	        });
	        qq.extend(this, new qq.XhrUploadHandler({
	            options: qq.extend({
	                namespace: "azure"
	            }, spec),
	            proxy: qq.extend({
	                getEndpoint: spec.endpointStore.get
	            }, proxy)
	        }));
	        qq.override(this, function(super_) {
	            return {
	                expunge: function(id) {
	                    var relatedToCancel = handler._wasCanceled(id), chunkingData = handler._getPersistableData(id), blockIdEntries = chunkingData && chunkingData.blockIdEntries || [];
	                    if (relatedToCancel && blockIdEntries.length > 0) {
	                        deleteBlob(id);
	                    }
	                    super_.expunge(id);
	                },
	                finalizeChunks: function(id) {
	                    return combineChunks(id);
	                },
	                _shouldChunkThisFile: function(id) {
	                    var maybePossible = super_._shouldChunkThisFile(id);
	                    return maybePossible && getSize(id) >= minFileSizeForChunking;
	                }
	            };
	        });
	    };
	    qq.azure.GetSas = function(o) {
	        "use strict";
	        var requester, options = {
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            customHeaders: {},
	            restRequestVerb: "PUT",
	            endpointStore: null,
	            log: function(str, level) {}
	        }, requestPromises = {};
	        qq.extend(options, o);
	        function sasResponseReceived(id, xhr, isError) {
	            var promise = requestPromises[id];
	            if (isError) {
	                promise.failure("Received response code " + xhr.status, xhr);
	            } else {
	                if (xhr.responseText.length) {
	                    promise.success(xhr.responseText);
	                } else {
	                    promise.failure("Empty response.", xhr);
	                }
	            }
	            delete requestPromises[id];
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            validMethods: [ "GET" ],
	            method: "GET",
	            successfulResponseCodes: {
	                GET: [ 200 ]
	            },
	            contentType: null,
	            customHeaders: options.customHeaders,
	            endpointStore: options.endpointStore,
	            cors: options.cors,
	            log: options.log,
	            onComplete: sasResponseReceived
	        }));
	        qq.extend(this, {
	            request: function(id, blobUri) {
	                var requestPromise = new qq.Promise(), restVerb = options.restRequestVerb;
	                options.log(qq.format("Submitting GET SAS request for a {} REST request related to file ID {}.", restVerb, id));
	                requestPromises[id] = requestPromise;
	                requester.initTransport(id).withParams({
	                    bloburi: blobUri,
	                    _method: restVerb
	                }).withCacheBuster().send();
	                return requestPromise;
	            }
	        });
	    };
	    qq.UploadSuccessAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingRequests = [], options = {
	            method: "POST",
	            endpoint: null,
	            maxConnections: 3,
	            customHeaders: {},
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {}
	        };
	        qq.extend(options, o);
	        function handleSuccessResponse(id, xhrOrXdr, isError) {
	            var promise = pendingRequests[id], responseJson = xhrOrXdr.responseText, successIndicator = {
	                success: true
	            }, failureIndicator = {
	                success: false
	            }, parsedResponse;
	            delete pendingRequests[id];
	            options.log(qq.format("Received the following response body to an upload success request for id {}: {}", id, responseJson));
	            try {
	                parsedResponse = qq.parseJson(responseJson);
	                if (isError || parsedResponse && (parsedResponse.error || parsedResponse.success === false)) {
	                    options.log("Upload success request was rejected by the server.", "error");
	                    promise.failure(qq.extend(parsedResponse, failureIndicator));
	                } else {
	                    options.log("Upload success was acknowledged by the server.");
	                    promise.success(qq.extend(parsedResponse, successIndicator));
	                }
	            } catch (error) {
	                if (isError) {
	                    options.log(qq.format("Your server indicated failure in its upload success request response for id {}!", id), "error");
	                    promise.failure(failureIndicator);
	                } else {
	                    options.log("Upload success was acknowledged by the server.");
	                    promise.success(successIndicator);
	                }
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            method: options.method,
	            endpointStore: {
	                get: function() {
	                    return options.endpoint;
	                }
	            },
	            paramsStore: options.paramsStore,
	            maxConnections: options.maxConnections,
	            customHeaders: options.customHeaders,
	            log: options.log,
	            onComplete: handleSuccessResponse,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            sendSuccessRequest: function(id, spec) {
	                var promise = new qq.Promise();
	                options.log("Submitting upload success request/notification for " + id);
	                requester.initTransport(id).withParams(spec).send();
	                pendingRequests[id] = promise;
	                return promise;
	            }
	        });
	    };
	    qq.azure.DeleteBlob = function(o) {
	        "use strict";
	        var requester, method = "DELETE", options = {
	            endpointStore: {},
	            onDelete: function(id) {},
	            onDeleteComplete: function(id, xhr, isError) {},
	            log: function(str, level) {}
	        };
	        qq.extend(options, o);
	        requester = qq.extend(this, new qq.AjaxRequester({
	            validMethods: [ method ],
	            method: method,
	            successfulResponseCodes: function() {
	                var codes = {};
	                codes[method] = [ 202 ];
	                return codes;
	            }(),
	            contentType: null,
	            endpointStore: options.endpointStore,
	            allowXRequestedWithAndCacheControl: false,
	            cors: {
	                expected: true
	            },
	            log: options.log,
	            onSend: options.onDelete,
	            onComplete: options.onDeleteComplete
	        }));
	        qq.extend(this, {
	            method: method,
	            send: function(id) {
	                options.log("Submitting Delete Blob request for " + id);
	                return requester.initTransport(id).send();
	            }
	        });
	    };
	    qq.azure.PutBlob = function(o) {
	        "use strict";
	        var requester, method = "PUT", options = {
	            getBlobMetadata: function(id) {},
	            log: function(str, level) {}
	        }, endpoints = {}, promises = {}, endpointHandler = {
	            get: function(id) {
	                return endpoints[id];
	            }
	        };
	        qq.extend(options, o);
	        requester = qq.extend(this, new qq.AjaxRequester({
	            validMethods: [ method ],
	            method: method,
	            successfulResponseCodes: function() {
	                var codes = {};
	                codes[method] = [ 201 ];
	                return codes;
	            }(),
	            contentType: null,
	            customHeaders: function(id) {
	                var params = options.getBlobMetadata(id), headers = qq.azure.util.getParamsAsHeaders(params);
	                headers["x-ms-blob-type"] = "BlockBlob";
	                return headers;
	            },
	            endpointStore: endpointHandler,
	            allowXRequestedWithAndCacheControl: false,
	            cors: {
	                expected: true
	            },
	            log: options.log,
	            onComplete: function(id, xhr, isError) {
	                var promise = promises[id];
	                delete endpoints[id];
	                delete promises[id];
	                if (isError) {
	                    promise.failure();
	                } else {
	                    promise.success();
	                }
	            }
	        }));
	        qq.extend(this, {
	            method: method,
	            upload: function(id, xhr, url, file) {
	                var promise = new qq.Promise();
	                options.log("Submitting Put Blob request for " + id);
	                promises[id] = promise;
	                endpoints[id] = url;
	                requester.initTransport(id).withPayload(file).withHeaders({
	                    "Content-Type": file.type
	                }).send(xhr);
	                return promise;
	            }
	        });
	    };
	    qq.azure.PutBlock = function(o) {
	        "use strict";
	        var requester, method = "PUT", blockIdEntries = {}, promises = {}, options = {
	            log: function(str, level) {}
	        }, endpoints = {}, endpointHandler = {
	            get: function(id) {
	                return endpoints[id];
	            }
	        };
	        qq.extend(options, o);
	        requester = qq.extend(this, new qq.AjaxRequester({
	            validMethods: [ method ],
	            method: method,
	            successfulResponseCodes: function() {
	                var codes = {};
	                codes[method] = [ 201 ];
	                return codes;
	            }(),
	            contentType: null,
	            endpointStore: endpointHandler,
	            allowXRequestedWithAndCacheControl: false,
	            cors: {
	                expected: true
	            },
	            log: options.log,
	            onComplete: function(id, xhr, isError) {
	                var promise = promises[id], blockIdEntry = blockIdEntries[id];
	                delete endpoints[id];
	                delete promises[id];
	                delete blockIdEntries[id];
	                if (isError) {
	                    promise.failure();
	                } else {
	                    promise.success(blockIdEntry);
	                }
	            }
	        }));
	        function createBlockId(partNum) {
	            var digits = 5, zeros = new Array(digits + 1).join("0"), paddedPartNum = (zeros + partNum).slice(-digits);
	            return btoa(paddedPartNum);
	        }
	        qq.extend(this, {
	            method: method,
	            upload: function(id, xhr, sasUri, partNum, blob) {
	                var promise = new qq.Promise(), blockId = createBlockId(partNum);
	                promises[id] = promise;
	                options.log(qq.format("Submitting Put Block request for {} = part {}", id, partNum));
	                endpoints[id] = qq.format("{}&comp=block&blockid={}", sasUri, encodeURIComponent(blockId));
	                blockIdEntries[id] = {
	                    part: partNum,
	                    id: blockId
	                };
	                requester.initTransport(id).withPayload(blob).send(xhr);
	                return promise;
	            }
	        });
	    };
	    qq.azure.PutBlockList = function(o) {
	        "use strict";
	        var requester, method = "PUT", promises = {}, options = {
	            getBlobMetadata: function(id) {},
	            log: function(str, level) {}
	        }, endpoints = {}, endpointHandler = {
	            get: function(id) {
	                return endpoints[id];
	            }
	        };
	        qq.extend(options, o);
	        requester = qq.extend(this, new qq.AjaxRequester({
	            validMethods: [ method ],
	            method: method,
	            successfulResponseCodes: function() {
	                var codes = {};
	                codes[method] = [ 201 ];
	                return codes;
	            }(),
	            customHeaders: function(id) {
	                var params = options.getBlobMetadata(id);
	                return qq.azure.util.getParamsAsHeaders(params);
	            },
	            contentType: "text/plain",
	            endpointStore: endpointHandler,
	            allowXRequestedWithAndCacheControl: false,
	            cors: {
	                expected: true
	            },
	            log: options.log,
	            onSend: function() {},
	            onComplete: function(id, xhr, isError) {
	                var promise = promises[id];
	                delete endpoints[id];
	                delete promises[id];
	                if (isError) {
	                    promise.failure(xhr);
	                } else {
	                    promise.success(xhr);
	                }
	            }
	        }));
	        function createRequestBody(blockIdEntries) {
	            var doc = document.implementation.createDocument(null, "BlockList", null);
	            blockIdEntries.sort(function(a, b) {
	                return a.part - b.part;
	            });
	            qq.each(blockIdEntries, function(idx, blockIdEntry) {
	                var latestEl = doc.createElement("Latest"), latestTextEl = doc.createTextNode(blockIdEntry.id);
	                latestEl.appendChild(latestTextEl);
	                qq(doc).children()[0].appendChild(latestEl);
	            });
	            return new XMLSerializer().serializeToString(doc);
	        }
	        qq.extend(this, {
	            method: method,
	            send: function(id, sasUri, blockIdEntries, fileMimeType, registerXhrCallback) {
	                var promise = new qq.Promise(), blockIdsXml = createRequestBody(blockIdEntries), xhr;
	                promises[id] = promise;
	                options.log(qq.format("Submitting Put Block List request for {}", id));
	                endpoints[id] = qq.format("{}&comp=blocklist", sasUri);
	                xhr = requester.initTransport(id).withPayload(blockIdsXml).withHeaders({
	                    "x-ms-blob-content-type": fileMimeType
	                }).send();
	                registerXhrCallback(xhr);
	                return promise;
	            }
	        });
	    };
	    (function() {
	        "use strict";
	        qq.azure.FineUploader = function(o) {
	            var options = {
	                failedUploadTextDisplay: {
	                    mode: "custom"
	                }
	            };
	            qq.extend(options, o, true);
	            qq.FineUploader.call(this, options, "azure");
	        };
	        qq.extend(qq.azure.FineUploader.prototype, qq.azure.FineUploaderBasic.prototype);
	        qq.extend(qq.azure.FineUploader.prototype, qq.uiPublicApi);
	        qq.extend(qq.azure.FineUploader.prototype, qq.uiPrivateApi);
	        qq.extend(qq.azure.FineUploader.prototype, {});
	    })();
	})(window);
	//# sourceMappingURL=all.fine-uploader.js.map

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(70);


/***/ },
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }
]);


// WEBPACK FOOTER //
// static/js/vendor.3e1f2576aadeeb10b05b.js